import { generateId, IconClass, IconName, removeWhiteSpaces, badgeData, PopoverUtils, calculatePosition, adjustToViewport, getPages, buildImageSrcUsingSourceImg, buildImageSrcUsingProductImageData, svgValues, variantColors, ringSize, ringVariants, ZipCodeUtil, PhoneNumberUtil, normalizeNumberInput, sizeClassesStar, setStars, DATE_FORMAT_PATTERN, DATE_PICKER_ERROR_MESSAGES, DATE_PICKER_ARIA_LABELS, TIME_FORMAT_PATTERN, TIME_24H_FORMAT_PATTERN, TIME_12H_FORMAT_PATTERN, MAX_HOUR_12H_FORMAT, DECIMAL_RADIX, MIN_TIME_VALUE, getValidationErrorMessage, MAX_MINUTES, MAX_HOUR_24H_FORMAT, TIME_MENU_CONSTANTS, COMPONENT_SIZES, DEFAULT_TIME_ZONE, DEFAULT_INTERVAL_MINUTES, FORM_CONTROL_UPDATE_ON } from '@dsg-tech/homefield-utils';
import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, Component, HostBinding, SecurityContext, Pipe, input, computed, output, viewChild, HostListener, ViewEncapsulation, ViewChild, Inject, inject, PLATFORM_ID, ElementRef, effect, ChangeDetectionStrategy, Injectable, forwardRef, QueryList, booleanAttribute, ContentChildren, numberAttribute, Optional, Directive, Self, ChangeDetectorRef, DestroyRef, TemplateRef, ViewChildren, signal, APP_BOOTSTRAP_LISTENER, ViewContainerRef } from '@angular/core';
import * as i1 from '@dsg-tech/homefield-angular-icons';
import { homefieldIconChevronUp, homefieldIconChevronDown, HomefieldIconLibraryModule, homefieldIconLocationPinFilled, homefieldIconArrowRight, homefieldIconAlertInfoFilled, homefieldIconAlertReportFilled, homefieldIconAlertWarningFilled, homefieldIconSignCircledCheck, homefieldIconSignCheck, homefieldIconSignCancel, homefieldIconAlertNewreleases, homefieldIconSignCircledSubtractOutlined, homefieldIconSignCircledAddFilled, homefieldIconAlertWarningOutlined, homefieldIconChevronLeft, homefieldIconChevronRight, homefieldIconAlertHighpriority, completeIconSet, HomefieldIconsLibraryService, homefieldIconAlertInfoOutlined, homefieldIconAlertReportOutlined, homefieldIconSignCircledCheckOutline, homefieldIconStarFilled0Percent, homefieldIconStarFilled100Percent, homefieldIconStarFilled25Percent, homefieldIconStarFilled50Percent, homefieldIconStarFilled75Percent, homefieldIconAlertErrorFilled, homefieldIconPenNoedit, homefieldIconSearch, homefieldIconCalendarDefault, homefieldIconMoneyDollarsign, homefieldIconTimeClockOutlined, homefieldIconDeleteOutlined, homefieldIconSignSubtract, homefieldIconSignAdd, homefieldIconMediaPlay, homefieldIconMediaPause, homefieldIconOrderCartStandard, homefieldIconAvailabilityDotFilled } from '@dsg-tech/homefield-angular-icons';
import * as i1$1 from '@angular/common';
import { CommonModule, DOCUMENT, isPlatformBrowser, NgOptimizedImage } from '@angular/common';
import * as i1$2 from '@angular/platform-browser';
import { Subject, combineLatest, takeUntil, BehaviorSubject, zip, fromEvent, interval } from 'rxjs';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule, NG_VALIDATORS, Validators, FormControl } from '@angular/forms';
import { trigger, transition, style, animate } from '@angular/animations';
import { toObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';

/** @format */
const _c0 = [[["hmfAccordionAction"]], "*"];
const _c1 = ["hmfAccordionAction", "*"];
const _c2 = a0 => ({
  "hmf-accordion-push-content": a0
});
const _c3 = (a0, a1) => ({
  "hmf-accordion-label-and-control-open": a0,
  "hmf-accordion-label-and-control-without-divider": a1
});
const _c4 = (a0, a1) => ({
  "hmf-accordion-content-visible hmf-px-s hmf-pb-s hmf-pt-xxs": a0,
  "hmf-accordion-content-without-divider": a1
});
const _c5 = (a0, a1) => [a0, a1];
function HmfAccordionComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate2("hmf-accordion loading hmf-accordion-", ctx_r0.size, " ", ctx_r0.classList, "");
  }
}
function HmfAccordionComponent_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.icon);
  }
}
function HmfAccordionComponent_Conditional_1_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r0.subLabelClasses);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.subLabel);
  }
}
function HmfAccordionComponent_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, HmfAccordionComponent_Conditional_1_Conditional_4_Conditional_2_Template, 2, 2, "span", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.containerClasses);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.subLabel && (ctx_r0.size === "large" || ctx_r0.size === "xlarge") ? 2 : -1);
  }
}
function HmfAccordionComponent_Conditional_1_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c5, ctx_r0.countClass || "", ctx_r0.countStyle || ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.count);
  }
}
function HmfAccordionComponent_Conditional_1_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("width", ctx_r0.iconSize);
    i0.ɵɵpropertyInterpolate("height", ctx_r0.iconSize);
  }
}
function HmfAccordionComponent_Conditional_1_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("width", ctx_r0.iconSize);
    i0.ɵɵpropertyInterpolate("height", ctx_r0.iconSize);
  }
}
function HmfAccordionComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "button", 3);
    i0.ɵɵlistener("click", function HmfAccordionComponent_Conditional_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.toggleOpen());
    });
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵtemplate(3, HmfAccordionComponent_Conditional_1_Conditional_3_Template, 1, 1, "homefield-icon", 5)(4, HmfAccordionComponent_Conditional_1_Conditional_4_Template, 3, 3, "div", 6);
    i0.ɵɵprojection(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵtemplate(7, HmfAccordionComponent_Conditional_1_Conditional_7_Template, 2, 5, "span", 8)(8, HmfAccordionComponent_Conditional_1_Conditional_8_Template, 1, 2, "homefield-icon", 9)(9, HmfAccordionComponent_Conditional_1_Conditional_9_Template, 1, 2, "homefield-icon", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 11);
    i0.ɵɵprojection(11, 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate2("hmf-accordion hmf-accordion-", ctx_r0.size, " ", ctx_r0.classList, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c2, !ctx_r0.expandOverContent));
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate2("hmf-accordion-label-and-control hmf-display-flex hmf-justify-content-between hmf-align-items-center ", ctx_r0.buttonLabelSizeClass, " ", ctx_r0.variant, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(22, _c3, ctx_r0.open, ctx_r0.variant === "no-outlined"));
    i0.ɵɵattribute("aria-expanded", ctx_r0.open)("aria-controls", ctx_r0.id + "-accordion-panel")("id", ctx_r0.id + "accordion-control");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.icon ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.label ? 4 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.count ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.open ? 8 : 9);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(25, _c4, ctx_r0.open, ctx_r0.variant === "no-outlined"));
    i0.ɵɵattribute("id", ctx_r0.id + "-accordion-panel")("aria-labelledby", ctx_r0.id + "accordion-control");
  }
}
const _c6 = ["*"];
function HmfActionTextComponent_homefield_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.startIconName)("width", "1em")("height", "1em");
  }
}
function HmfActionTextComponent_homefield_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.endIconName)("width", "1em")("height", "1em");
  }
}
function HmfTextLinkComponent_homefield_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.startIconName)("width", "1em")("height", "1em");
  }
}
function HmfTextLinkComponent_homefield_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.endIconName)("width", "1em")("height", "1em");
  }
}
const _c7 = ".homefield-textlink[_ngcontent-%COMP%], [_nghost-%COMP%]{align-content:center;align-items:center;color:var(--hmf-label-secondary-static);display:inline-flex;outline:1px dashed transparent;text-decoration:underline;text-decoration-thickness:var(--hmf-ease-in-out-fast);text-underline-offset:6px}.homefield-textlink[_ngcontent-%COMP%]   .homefield-textlink-transition[_ngcontent-%COMP%], [_nghost-%COMP%]   .homefield-textlink-transition[_ngcontent-%COMP%]{transition:color var(--hmf-ease-in-out-fast),outline var(--hmf-ease-in-out-fast),outline-offset var(--hmf-ease-in-out-fast)}.homefield-textlink[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], [_nghost-%COMP%]   svg[_ngcontent-%COMP%]{margin-right:var(--hmf-xxxs)}.homefield-textlink[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]:last-child, [_nghost-%COMP%]   svg[_ngcontent-%COMP%]:last-child{margin-left:var(--hmf-xxxs);margin-right:0}.homefield-textlink[_ngcontent-%COMP%]     homefield-icon svg path, [_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-label-secondary-static)}.homefield-textlink[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-static)}.homefield-textlink[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]:focus{outline:1px dashed var(--hmf-label-secondary-active);outline-offset:3px}.homefield-textlink[_ngcontent-%COMP%]:hover, [_nghost-%COMP%]:hover{color:var(--hmf-label-secondary-hover);cursor:pointer;text-decoration-color:var(--hmf-border-tertiary-hover);text-decoration-thickness:1.5px}.homefield-textlink[_ngcontent-%COMP%]:hover     homefield-icon svg path, [_nghost-%COMP%]:hover     homefield-icon svg path{fill:var(--hmf-label-secondary-hover)}.homefield-textlink[_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-hover)}.homefield-textlink[_ngcontent-%COMP%]:visited, [_nghost-%COMP%]:visited{color:var(--hmf-label-secondary-active)}.homefield-textlink[_ngcontent-%COMP%]:visited     homefield-icon svg path, [_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-secondary-active)}.homefield-textlink[_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-active)}.homefield-textlink[_ngcontent-%COMP%]:active, [_nghost-%COMP%]:active{color:var(--hmf-label-secondary-active);text-decoration-color:var(--hmf-border-tertiary-hover);text-decoration-thickness:1.5px}.homefield-textlink[_ngcontent-%COMP%]:active     homefield-icon svg path, [_nghost-%COMP%]:active     homefield-icon svg path{fill:var(--hmf-label-secondary-active)}.homefield-textlink[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-active)}.homefield-textlink[_ngcontent-%COMP%]:active:visited, [_nghost-%COMP%]:active:visited{color:var(--hmf-label-secondary-active)}.homefield-textlink[_ngcontent-%COMP%]:active:visited     homefield-icon svg path, [_nghost-%COMP%]:active:visited     homefield-icon svg path{fill:var(--hmf-label-secondary-active)}.homefield-textlink[_ngcontent-%COMP%]:active:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [_nghost-%COMP%]:active:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-active)}.homefield-textlink[aria-disabled=true][_ngcontent-%COMP%], .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:hover, .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:focus, .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:active, .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:visited, [aria-disabled=true][_nghost-%COMP%], [aria-disabled=true][_nghost-%COMP%]:hover, [aria-disabled=true][_nghost-%COMP%]:focus, [aria-disabled=true][_nghost-%COMP%]:active, [aria-disabled=true][_nghost-%COMP%]:visited{color:var(--hmf-label-disabled);cursor:default;pointer-events:none;text-decoration-color:var(--hmf-border-disabled);text-decoration-thickness:1px}.homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:focus     homefield-icon svg path, .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:visited     homefield-icon svg path, [aria-disabled=true][_nghost-%COMP%]     homefield-icon svg path, [aria-disabled=true][_nghost-%COMP%]:hover     homefield-icon svg path, [aria-disabled=true][_nghost-%COMP%]:focus     homefield-icon svg path, [aria-disabled=true][_nghost-%COMP%]:active     homefield-icon svg path, [aria-disabled=true][_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-disabled)}.homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [aria-disabled=true][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [aria-disabled=true][_nghost-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [aria-disabled=true][_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [aria-disabled=true][_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-disabled)}.homefield-textlink.homefield-textlink-secondary[_ngcontent-%COMP%], .homefield-textlink-secondary[_nghost-%COMP%]{color:var(--hmf-label-secondary-static);text-decoration-color:var(--hmf-label-secondary-static);text-decoration-thickness:1px;text-underline-offset:3px}.homefield-textlink.homefield-textlink-secondary[_ngcontent-%COMP%]:hover, .homefield-textlink-secondary[_nghost-%COMP%]:hover{color:var(--hmf-label-secondary-hover);text-decoration-color:var(--hmf-label-secondary-hover);text-decoration-thickness:1px}.homefield-textlink.homefield-textlink-secondary[_ngcontent-%COMP%]:active, .homefield-textlink-secondary[_nghost-%COMP%]:active{color:var(--hmf-label-secondary-active);text-decoration-color:var(--hmf-label-secondary-active);text-decoration-thickness:1px}.homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:hover, .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:focus, .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:active, .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:visited, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%], .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:hover, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:focus, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:active, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:visited{color:var(--hmf-label-disabled);cursor:default;pointer-events:none;text-decoration-color:var(--hmf-label-disabled);text-decoration-thickness:1px}.homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:focus     homefield-icon svg path, .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:visited     homefield-icon svg path, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]     homefield-icon svg path, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:focus     homefield-icon svg path, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:active     homefield-icon svg path, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-disabled)}.homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-disabled)}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%], .homefield-textlink-tertiary[_nghost-%COMP%]{color:var(--hmf-label-secondary-subtle-static);text-decoration-color:var(--hmf-label-secondary-subtle-static);text-underline-offset:3px}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink-tertiary[_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-label-secondary-subtle-static)}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-subtle-static)}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]:hover, .homefield-textlink-tertiary[_nghost-%COMP%]:hover{color:var(--hmf-label-secondary-subtle-hover);text-decoration-color:var(--hmf-label-secondary-subtle-hover);text-decoration-thickness:1px}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-tertiary[_nghost-%COMP%]:hover     homefield-icon svg path{fill:var(--hmf-label-secondary-subtle-hover)}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-subtle-hover)}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]:active, .homefield-textlink-tertiary[_nghost-%COMP%]:active{color:var(--hmf-label-secondary-subtle-active);text-decoration-color:var(--hmf-label-secondary-subtle-active);text-decoration-thickness:1px}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink-tertiary[_nghost-%COMP%]:active     homefield-icon svg path{fill:var(--hmf-label-secondary-subtle-active)}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-subtle-active)}.homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:hover, .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:focus, .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:active, .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:visited, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%], .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:hover, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:focus, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:active, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:visited{color:var(--hmf-label-disabled);cursor:default;pointer-events:none;text-decoration-color:var(--hmf-label-disabled);text-decoration-thickness:1px}.homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:focus     homefield-icon svg path, .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:visited     homefield-icon svg path, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]     homefield-icon svg path, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:focus     homefield-icon svg path, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:active     homefield-icon svg path, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-disabled)}.homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-disabled)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%], .homefield-textlink-group[_nghost-%COMP%]{color:var(--hmf-label-secondary-static);text-decoration:none}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink-group[_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-label-secondary-static)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-static)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]:hover, .homefield-textlink-group[_nghost-%COMP%]:hover{color:var(--hmf-label-secondary-hover);text-decoration:underline;text-decoration-color:var(--hmf-label-secondary-hover)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-group[_nghost-%COMP%]:hover     homefield-icon svg path{fill:var(--hmf-label-secondary-hover)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-hover)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]:active, .homefield-textlink-group[_nghost-%COMP%]:active{color:var(--hmf-label-secondary-active);text-decoration:underline;text-decoration-color:var(--hmf-label-secondary-active)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink-group[_nghost-%COMP%]:active     homefield-icon svg path{fill:var(--hmf-label-secondary-active)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-active)}.homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:hover, .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:focus, .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:active, .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:visited, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%], .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:hover, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:focus, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:active, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:visited{color:var(--hmf-label-disabled);cursor:default;pointer-events:none;text-decoration:none}.homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:focus     homefield-icon svg path, .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:visited     homefield-icon svg path, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]     homefield-icon svg path, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:focus     homefield-icon svg path, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:active     homefield-icon svg path, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-disabled)}.homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-disabled)}.homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%], .homefield-textlink-inverse[_nghost-%COMP%]{color:var(--hmf-label-inverse);text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:3px}.homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink-inverse[_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]:focus, .homefield-textlink-inverse[_nghost-%COMP%]:focus{outline-color:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]:hover, .homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]:active, .homefield-textlink-inverse[_nghost-%COMP%]:hover, .homefield-textlink-inverse[_nghost-%COMP%]:active{color:var(--hmf-label-inverse);text-decoration-thickness:1.5px}.homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink-inverse[_nghost-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-inverse[_nghost-%COMP%]:active     homefield-icon svg path{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:hover, .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:focus, .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:active, .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:visited, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%], .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:hover, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:focus, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:active, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:visited{color:var(--hmf-label-disabled-subtle);cursor:default;pointer-events:none;text-decoration-color:var(--hmf-label-disabled-subtle);text-decoration-thickness:1px}.homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:focus     homefield-icon svg path, .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:visited     homefield-icon svg path, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]     homefield-icon svg path, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:focus     homefield-icon svg path, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:active     homefield-icon svg path, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-disabled-subtle)}.homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-disabled-subtle)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%], .homefield-textlink-group-inverse[_nghost-%COMP%]{color:var(--hmf-label-inverse);text-decoration:none}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink-group-inverse[_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]:focus, .homefield-textlink-group-inverse[_nghost-%COMP%]:focus{outline-color:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]:hover, .homefield-textlink-group-inverse[_nghost-%COMP%]:hover{color:var(--hmf-label-inverse);text-decoration:underline;text-decoration-color:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-group-inverse[_nghost-%COMP%]:hover     homefield-icon svg path{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]:active, .homefield-textlink-group-inverse[_nghost-%COMP%]:active{color:var(--hmf-label-inverse);text-decoration:underline;text-decoration-color:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink-group-inverse[_nghost-%COMP%]:active     homefield-icon svg path{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:hover, .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:focus, .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:active, .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:visited, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%], .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:hover, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:focus, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:active, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:visited{color:var(--hmf-label-disabled-subtle);cursor:default;pointer-events:none;text-decoration:none}.homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:focus     homefield-icon svg path, .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:visited     homefield-icon svg path, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]     homefield-icon svg path, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:focus     homefield-icon svg path, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:active     homefield-icon svg path, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-disabled-subtle)}.homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-disabled-subtle)}.homefield-textlink.homefield-textlink-sponsored[_ngcontent-%COMP%], .homefield-textlink-sponsored[_nghost-%COMP%]{color:var(--hmf-label-secondary-static);text-decoration:none}.homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:focus     homefield-icon svg path, .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:visited     homefield-icon svg path, .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]     homefield-icon svg path, .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:focus     homefield-icon svg path, .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:active     homefield-icon svg path, .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-secondary-static)}.homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-static)}.homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:hover, .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:hover{color:var(--hmf-label-secondary-hover)}.homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:hover     homefield-icon svg path{fill:var(--hmf-label-secondary-hover);transition:fill var(--hmf-ease-in-out-fast)}.homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-hover);transition:fill var(--hmf-ease-in-out-fast)}button.homefield-actiontext[_ngcontent-%COMP%], [_nghost-%COMP%]{background:none;border:none;color:inherit;cursor:pointer;font:inherit;outline:inherit;padding:0;text-align:start}";
const _c8 = a0 => ({
  "hmf-mt-xxxs": a0
});
function HmfAlertBannerComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "span", 4);
    i0.ɵɵpipe(2, "hfSanitizeHtml");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 1, ctx_r0.title()), i0.ɵɵsanitizeHtml);
  }
}
function HmfAlertBannerComponent_Conditional_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "span", 7);
    i0.ɵɵpipe(2, "hfSanitizeHtml");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 1, ctx_r0.message()), i0.ɵɵsanitizeHtml);
  }
}
function HmfAlertBannerComponent_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("linkURL", ctx_r0.link())("variant", "secondary");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.linkTitle());
  }
}
function HmfAlertBannerComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HmfAlertBannerComponent_Conditional_6_Conditional_0_Template, 3, 3, "div", 5)(1, HmfAlertBannerComponent_Conditional_6_Conditional_1_Template, 2, 3, "a", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.message() ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.link() ? 1 : -1);
  }
}
const _c9 = a0 => ({
  "no-interaction": a0
});
const _c10 = a0 => ({
  "hmf-display-none": a0
});
function HmfBreadcrumbsComponent_nav_0_li_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 6);
    i0.ɵɵlistener("click", function HmfBreadcrumbsComponent_nav_0_li_2_Template_li_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.ellipsis = !ctx_r1.ellipsis);
    })("keypress", function HmfBreadcrumbsComponent_nav_0_li_2_Template_li_keypress_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.ellipsis = !ctx_r1.ellipsis);
    });
    i0.ɵɵtext(1, " ... ");
    i0.ɵɵelementEnd();
  }
}
function HmfBreadcrumbsComponent_nav_0_li_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "hmf-divider", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("vertical", true);
  }
}
function HmfBreadcrumbsComponent_nav_0_li_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 7)(1, "span", 8);
    i0.ɵɵtemplate(2, HmfBreadcrumbsComponent_nav_0_li_3_div_2_Template, 2, 1, "div", 9);
    i0.ɵɵelementStart(3, "a", 10);
    i0.ɵɵlistener("click", function HmfBreadcrumbsComponent_nav_0_li_3_Template_a_click_3_listener($event) {
      const breadcrumb_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.navigateToRoute($event, breadcrumb_r4));
    });
    i0.ɵɵelementStart(4, "span", 11);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(6, "meta", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const breadcrumb_r4 = ctx.$implicit;
    const index_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.ellipsis && ctx_r1.breadcrumbs.length - index_r5 - 1 < ctx_r1.numOfShownBreadcrumbs || !ctx_r1.ellipsis && index_r5 !== 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c9, index_r5 === ctx_r1.breadcrumbs.length - 1 && ctx_r1.currentPageIncluded))("href", ctx_r1.routerPresent ? undefined : breadcrumb_r4.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("data-em", ctx_r1.getDataEM(breadcrumb_r4));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c10, ctx_r1.ellipsis && ctx_r1.breadcrumbs.length - index_r5 > ctx_r1.numOfShownBreadcrumbs));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(breadcrumb_r4.name);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("content", index_r5 + 1);
  }
}
function HmfBreadcrumbsComponent_nav_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "nav", 2)(1, "ul", 3);
    i0.ɵɵtemplate(2, HmfBreadcrumbsComponent_nav_0_li_2_Template, 2, 0, "li", 4)(3, HmfBreadcrumbsComponent_nav_0_li_3_Template, 7, 11, "li", 5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.alignment === "center" ? "hmf-justify-content-center" : "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.ellipsis);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.breadcrumbs);
  }
}
function HmfBreadcrumbsComponent_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15)(1, "span", 16)(2, "a", 17)(3, "span", 18);
    i0.ɵɵtext(4, "Home");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "meta", 19);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("data-em", "breadcrumb_home");
  }
}
const _c11 = [[["rectangularSelectorBody"]]];
const _c12 = ["rectangularSelectorBody"];
const _c13 = (a0, a1, a2, a3, a4, a5, a6) => ({
  disabled: a0,
  "is-selected": a1,
  "is-contained": a2,
  "is-dblborder": a3,
  unavailable: a4,
  "rectangular-selector-button": a5,
  "circular-selector-button": a6
});
const _c14 = (a0, a1) => ({
  height: a0,
  width: a1
});
const _c15 = () => ({});
const _c16 = (a0, a1, a2) => ({
  "is-loading": a0,
  "rectangular-selector-button": a1,
  stroked: a2
});
const _c17 = (a0, a1, a2) => ({
  "background-color": a0,
  height: a1,
  width: a2
});
function HmfSelectorComponent_ng_container_2_ng_template_1_Template(rf, ctx) {}
function HmfSelectorComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HmfSelectorComponent_ng_container_2_ng_template_1_Template, 0, 0, "ng-template", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const circularSelectorImage_r1 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", circularSelectorImage_r1);
  }
}
function HmfSelectorComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function HmfSelectorComponent_ng_template_4_img_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 8);
    i0.ɵɵlistener("load", function HmfSelectorComponent_ng_template_4_img_0_Template_img_load_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onLoad());
    })("error", function HmfSelectorComponent_ng_template_4_img_0_Template_img_error_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onImageError());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r2.imageSrc, i0.ɵɵsanitizeUrl)("alt", ctx_r2.altText)("ngStyle", i0.ɵɵpureFunction2(3, _c14, ctx_r2.height, ctx_r2.width));
  }
}
function HmfSelectorComponent_ng_template_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction3(1, _c17, ctx_r2.color, ctx_r2.height, ctx_r2.width));
  }
}
function HmfSelectorComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HmfSelectorComponent_ng_template_4_img_0_Template, 1, 6, "img", 6)(1, HmfSelectorComponent_ng_template_4_div_1_Template, 1, 5, "div", 7);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.imageSrc);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.color && !ctx_r2.imageSrc);
  }
}
const _c18 = ["contentRef"];
function HmfButtonComponent_Conditional_0_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("name", ctx_r0.icon());
  }
}
function HmfButtonComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HmfButtonComponent_Conditional_0_Conditional_0_Conditional_0_Template, 1, 1, "homefield-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.icon() ? 0 : -1);
  }
}
function HmfButtonComponent_Conditional_0_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("name", ctx_r0.icon());
  }
}
function HmfButtonComponent_Conditional_0_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text());
  }
}
function HmfButtonComponent_Conditional_0_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3, 0);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
  }
}
function HmfButtonComponent_Conditional_0_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("name", ctx_r0.icon());
  }
}
function HmfButtonComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtemplate(1, HmfButtonComponent_Conditional_0_Conditional_1_Conditional_1_Template, 1, 1, "homefield-icon", 2)(2, HmfButtonComponent_Conditional_0_Conditional_1_Conditional_2_Template, 2, 1, "span")(3, HmfButtonComponent_Conditional_0_Conditional_1_Conditional_3_Template, 3, 0, "span", 3)(4, HmfButtonComponent_Conditional_0_Conditional_1_Conditional_4_Template, 1, 1, "homefield-icon", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.hasMultipleElements);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.positionIcon() === "left" && ctx_r0.icon() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.text() ? 2 : 3);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.positionIcon() === "right" && ctx_r0.icon() ? 4 : -1);
  }
}
function HmfButtonComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HmfButtonComponent_Conditional_0_Conditional_0_Template, 1, 1)(1, HmfButtonComponent_Conditional_0_Conditional_1_Template, 5, 4, "span", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.shape() === "circular" ? 0 : 1);
  }
}
const _c19 = a0 => ({
  disabled: a0
});
function HmfCheckboxComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 0);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.errorClasses);
    i0.ɵɵattribute("id", "homefield-checkbox-errorMessage-" + ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, " ");
  }
}
const _c20 = ["closeRef"];
const _c21 = ["drawerBackground"];
const _c22 = ["drawerContainer"];
const _c23 = a0 => ({
  overflowY: "auto",
  maxHeight: a0
});
function HmfDrawerComponent_Conditional_0_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.headerText, " ");
  }
}
function HmfDrawerComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵtemplate(2, HmfDrawerComponent_Conditional_0_Conditional_3_Conditional_2_Template, 2, 1, "div", 10);
    i0.ɵɵelementStart(3, "hmf-button", 11, 3);
    i0.ɵɵlistener("click", function HmfDrawerComponent_Conditional_0_Conditional_3_Template_hmf_button_click_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.closeDrawer());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r2.wrapperClasses);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.headerText && ctx_r2.isCloseButtonSticky ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r2.drawerContainerCloseClasses);
  }
}
function HmfDrawerComponent_Conditional_0_Conditional_4_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HmfDrawerComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HmfDrawerComponent_Conditional_0_Conditional_4_ng_container_0_Template, 1, 0, "ng-container", 12);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const contentTemplate_r4 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", contentTemplate_r4);
  }
}
function HmfDrawerComponent_Conditional_0_Conditional_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HmfDrawerComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, HmfDrawerComponent_Conditional_0_Conditional_5_ng_container_1_Template, 1, 0, "ng-container", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    const contentTemplate_r4 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngClass", ctx_r2.drawerContainerContentClasses)("ngStyle", i0.ɵɵpureFunction1(3, _c23, ctx_r2.isCloseButtonSticky ? "95vh" : "100vh"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", contentTemplate_r4);
  }
}
function HmfDrawerComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6, 1);
    i0.ɵɵtemplate(3, HmfDrawerComponent_Conditional_0_Conditional_3_Template, 5, 3, "ng-container")(4, HmfDrawerComponent_Conditional_0_Conditional_4_Template, 1, 1, "ng-container")(5, HmfDrawerComponent_Conditional_0_Conditional_5_Template, 2, 5, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 8, 2);
    i0.ɵɵlistener("click", function HmfDrawerComponent_Conditional_0_Template_div_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.closeDrawer());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("hmf-drawer hmf-display-flex hmf-position-fixed ", ctx_r2.className, "");
    i0.ɵɵproperty("ngClass", ctx_r2.drawerClasses);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r2.drawerContainerClasses);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.closable ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.noPadding ? 4 : 5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r2.drawerBackgroundClasses);
  }
}
function HmfDrawerComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function HmfGlobalChipsComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.iconStatusName());
  }
}
function HmfGlobalChipsComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 4);
  }
}
const _c24 = (a0, a1, a2, a3) => ({
  "hmf-align-items-m-center": a0,
  "hmf-justify-content-center hmf-hmf-text-align-center hmf-ml-0": a1,
  "hmf-justify-content-flex-end hmf-text-align-right": a2,
  "hmf-justify-content-m-flex-start": a3
});
function HmfHeroBannerComponent_picture_2_source_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "source", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("srcset", ctx_r0.mobileImage);
  }
}
function HmfHeroBannerComponent_picture_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "picture");
    i0.ɵɵtemplate(1, HmfHeroBannerComponent_picture_2_source_1_Template, 1, 1, "source", 10);
    i0.ɵɵelement(2, "img", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.mobileImage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.image, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("alt", ctx_r0.altText);
  }
}
function HmfHeroBannerComponent_h1_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.headline, " ");
  }
}
function HmfHeroBannerComponent_h2_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.headline, " ");
  }
}
function HmfHeroBannerComponent_p_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.subhead, " ");
  }
}
function HmfHeroBannerComponent_p_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "a", 17);
    i0.ɵɵtext(3, " More details ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.legalText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r0.legalTextLink, i0.ɵɵsanitizeUrl);
  }
}
function HmfHeroBannerComponent_a_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("variant", ctx_r0.buttonStyle)("href", ctx_r0.link, i0.ɵɵsanitizeUrl)("dataEm", ctx_r0.dataEm);
    i0.ɵɵattribute("altText", ctx_r0.buttonLabel)("aria-label", ctx_r0.buttonLabel);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.buttonLabel, " ");
  }
}
const _c25 = ["modalBackground"];
const _c26 = ["modalContainer"];
function HmfModalComponent_Conditional_0_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.headerText, " ");
  }
}
function HmfModalComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵtemplate(2, HmfModalComponent_Conditional_0_Conditional_3_Conditional_2_Template, 2, 1, "div", 10);
    i0.ɵɵelementStart(3, "hmf-button", 11, 3);
    i0.ɵɵlistener("click", function HmfModalComponent_Conditional_0_Conditional_3_Template_hmf_button_click_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.closeModal());
    })("keydown.enter", function HmfModalComponent_Conditional_0_Conditional_3_Template_hmf_button_keydown_enter_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.closeModal());
    });
    i0.ɵɵelement(5, "homefield-icon", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r2.modalContainerWrapperClasses);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.headerText && ctx_r2.isCloseButtonSticky ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("variant", "tertiary")("size", "small")("iconSize", "large")("label", "close")("ngClass", ctx_r2.closeButtonClasses);
  }
}
function HmfModalComponent_Conditional_0_Conditional_4_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HmfModalComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "h3", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p", 13);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 14);
    i0.ɵɵtemplate(6, HmfModalComponent_Conditional_0_Conditional_4_ng_container_6_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    const contentTemplate_r4 = i0.ɵɵreference(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.headerText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.dialogSubHeaderText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", contentTemplate_r4);
  }
}
function HmfModalComponent_Conditional_0_Conditional_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HmfModalComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HmfModalComponent_Conditional_0_Conditional_5_ng_container_0_Template, 1, 0, "ng-container", 15);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const contentTemplate_r4 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", contentTemplate_r4);
  }
}
function HmfModalComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6, 1);
    i0.ɵɵtemplate(3, HmfModalComponent_Conditional_0_Conditional_3_Template, 6, 7, "ng-container")(4, HmfModalComponent_Conditional_0_Conditional_4_Template, 7, 3, "div", 7)(5, HmfModalComponent_Conditional_0_Conditional_5_Template, 1, 1, "ng-container");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 8, 2);
    i0.ɵɵlistener("click", function HmfModalComponent_Conditional_0_Template_div_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.closeModal());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate2("hmf-modal hmf-display-flex hmf-position-fixed hmf-modal-type-", ctx_r2.type, " ", ctx_r2.className, "");
    i0.ɵɵproperty("ngClass", ctx_r2.modalClasses);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r2.modalContainerClasses);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.closable ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.type === "dialog" ? 4 : 5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r2.modalBackgroundClasses);
  }
}
function HmfModalComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c27 = ["popoverElement"];
function HmfPopoverComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx);
  }
}
function HmfPopoverComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function HmfPopoverComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2, 0);
    i0.ɵɵtemplate(2, HmfPopoverComponent_Conditional_0_Conditional_2_Template, 2, 1, "span")(3, HmfPopoverComponent_Conditional_0_Conditional_3_Template, 1, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.popoverClasses());
    i0.ɵɵproperty("ngStyle", ctx_r0.popoverStyles());
    i0.ɵɵattribute("aria-hidden", !ctx_r0.open())("data-testid", ctx_r0.testId());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_6_0 = ctx_r0.text()) ? 2 : 3, tmp_6_0);
  }
}
function HmfPaginationComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function HmfPaginationComponent_Conditional_0_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.goToPage(ctx_r1.currentPage() - 1));
    });
    i0.ɵɵelement(1, "homefield-icon", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r1.disabled());
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "chevron-left");
  }
}
function HmfPaginationComponent_Conditional_0_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function HmfPaginationComponent_Conditional_0_For_3_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const page_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.goToPage(+page_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const page_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("selected", page_r4 === ctx_r1.currentPage());
    i0.ɵɵproperty("disabled", ctx_r1.disabled());
    i0.ɵɵattribute("aria-current", page_r4 === ctx_r1.currentPage() ? "page" : null)("aria-label", page_r4 === ctx_r1.currentPage() ? "Current page, page " + page_r4 : "Go to page " + page_r4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", page_r4, " ");
  }
}
function HmfPaginationComponent_Conditional_0_For_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1, "...");
    i0.ɵɵelementEnd();
  }
}
function HmfPaginationComponent_Conditional_0_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HmfPaginationComponent_Conditional_0_For_3_Conditional_0_Template, 2, 6, "button", 6)(1, HmfPaginationComponent_Conditional_0_For_3_Conditional_1_Template, 2, 0, "span", 7);
  }
  if (rf & 2) {
    const page_r4 = ctx.$implicit;
    i0.ɵɵconditional(page_r4 !== "..." ? 0 : 1);
  }
}
function HmfPaginationComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function HmfPaginationComponent_Conditional_0_Conditional_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.goToPage(ctx_r1.currentPage() + 1));
    });
    i0.ɵɵelement(1, "homefield-icon", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r1.disabled());
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "chevron-right");
  }
}
function HmfPaginationComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "nav", 1);
    i0.ɵɵtemplate(1, HmfPaginationComponent_Conditional_0_Conditional_1_Template, 2, 2, "button", 2);
    i0.ɵɵrepeaterCreate(2, HmfPaginationComponent_Conditional_0_For_3_Template, 2, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(4, HmfPaginationComponent_Conditional_0_Conditional_4_Template, 2, 2, "button", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("pagination hmf-body-l hmf-display-flex hmf-align-items-center " + (ctx_r1.className || ""));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.canGoPrev() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.pages());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.canGoNext() ? 4 : -1);
  }
}
const _c28 = a0 => ({
  "hmf-display-flex hmf-flex-row hmf-flex-wrap": a0
});
const _c29 = a0 => ({
  "hmf-mr-xxxs": a0
});
const _c30 = (a0, a1) => ({
  clearance: a0,
  "hmf-mr-xxxs": a1
});
function HmfPriceComponent_ng_template_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1, " See Price In Cart ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c29, ctx_r0.variant === "wrapped"));
  }
}
function HmfPriceComponent_ng_template_1_Conditional_2_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" - ", i0.ɵɵpipeBind3(2, 1, ctx_r0.prices.maxOfferPrice, ctx_r0.currencyCode, "symbol"), " ");
  }
}
function HmfPriceComponent_ng_template_1_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "currency");
    i0.ɵɵtemplate(2, HmfPriceComponent_ng_template_1_Conditional_2_Conditional_1_Conditional_2_Template, 3, 5, "span");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(1, 2, ctx_r0.prices.minOfferPrice, ctx_r0.currencyCode, "symbol"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.prices.maxOfferPrice && ctx_r0.prices.maxOfferPrice !== ctx_r0.prices.minOfferPrice ? 2 : -1);
  }
}
function HmfPriceComponent_ng_template_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, HmfPriceComponent_ng_template_1_Conditional_2_Conditional_1_Template, 3, 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c30, ctx_r0.isClearance, ctx_r0.variant === "wrapped"));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.prices.minOfferPrice ? 1 : -1);
  }
}
function HmfPriceComponent_ng_template_1_Conditional_3_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" - ", i0.ɵɵpipeBind3(2, 1, ctx_r0.prices.maxListPrice, ctx_r0.currencyCode, "symbol"), " ");
  }
}
function HmfPriceComponent_ng_template_1_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "currency");
    i0.ɵɵtemplate(2, HmfPriceComponent_ng_template_1_Conditional_3_Conditional_1_Conditional_2_Template, 3, 5, "span");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(1, 2, ctx_r0.prices.minListPrice, ctx_r0.currencyCode, "symbol"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.prices.maxListPrice && ctx_r0.prices.maxListPrice !== ctx_r0.prices.minListPrice ? 2 : -1);
  }
}
function HmfPriceComponent_ng_template_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, HmfPriceComponent_ng_template_1_Conditional_3_Conditional_1_Template, 3, 6);
    i0.ɵɵtext(2, " * ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.prices.minListPrice ? 1 : -1);
  }
}
function HmfPriceComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, HmfPriceComponent_ng_template_1_Conditional_1_Template, 2, 3, "div", 5)(2, HmfPriceComponent_ng_template_1_Conditional_2_Template, 2, 5, "div", 5)(3, HmfPriceComponent_ng_template_1_Conditional_3_Template, 3, 1, "div", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c28, ctx_r0.variant === "wrapped"));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.isSeePriceInCart && ctx_r0.prices ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.isSeePriceInCart && ctx_r0.prices ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.isClearance && ctx_r0.prices ? 3 : -1);
  }
}
function HmfPriceComponent_ng_template_3_Conditional_0_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" - ", i0.ɵɵpipeBind3(2, 1, ctx_r0.strikethroughConfig.maxPrice, ctx_r0.currencyCode, "symbol"), "");
  }
}
function HmfPriceComponent_ng_template_3_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵtemplate(3, HmfPriceComponent_ng_template_3_Conditional_0_Conditional_2_Conditional_3_Template, 3, 5, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, "* ");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 2, ctx_r0.strikethroughConfig.minPrice, ctx_r0.currencyCode, "symbol"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.strikethroughConfig.hasMaxPrice ? 3 : -1);
  }
}
function HmfPriceComponent_ng_template_3_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, "* ");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(2, 1, ctx_r0.strikethroughConfig.listPrice, ctx_r0.currencyCode, "symbol"));
  }
}
function HmfPriceComponent_ng_template_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "s", 7);
    i0.ɵɵpipe(1, "currency");
    i0.ɵɵtemplate(2, HmfPriceComponent_ng_template_3_Conditional_0_Conditional_2_Template, 5, 6)(3, HmfPriceComponent_ng_template_3_Conditional_0_Conditional_3_Template, 4, 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind4(1, 3, ctx_r0.ariaLabel, ctx_r0.currencyCode, "symbol", "1.2-2"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.strikethroughConfig.showMinMaxRange ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.strikethroughConfig.showSinglePrice ? 3 : -1);
  }
}
function HmfPriceComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HmfPriceComponent_ng_template_3_Conditional_0_Template, 4, 8, "s", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.strikethroughConfig.shouldShow ? 0 : -1);
  }
}
function HmfPriceComponent_ng_template_5_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1, "See Price In Cart");
    i0.ɵɵelementEnd();
  }
}
function HmfPriceComponent_ng_template_5_Conditional_0_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" - ", i0.ɵɵpipeBind3(2, 1, ctx_r0.prices.maxOfferPrice, ctx_r0.currencyCode, "symbol"), "");
  }
}
function HmfPriceComponent_ng_template_5_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵtemplate(3, HmfPriceComponent_ng_template_5_Conditional_0_Conditional_2_Conditional_3_Template, 3, 5, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 2, ctx_r0.prices.minOfferPrice, ctx_r0.currencyCode, "symbol"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.carouselConfig.hasPriceRange ? 3 : -1);
  }
}
function HmfPriceComponent_ng_template_5_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(2, 1, ctx_r0.prices.offerPrice, ctx_r0.currencyCode, "symbol"));
  }
}
function HmfPriceComponent_ng_template_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HmfPriceComponent_ng_template_5_Conditional_0_Conditional_1_Template, 2, 0, "span", 8)(2, HmfPriceComponent_ng_template_5_Conditional_0_Conditional_2_Template, 4, 6, "div", 8)(3, HmfPriceComponent_ng_template_5_Conditional_0_Conditional_3_Template, 3, 5, "div", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.carouselConfig.showSeePriceInCart ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.carouselConfig.showOfferPrice ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.carouselConfig.showSkuRecommendationPrice ? 3 : -1);
  }
}
function HmfPriceComponent_ng_template_5_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "See Price In Cart");
    i0.ɵɵelementEnd();
  }
}
function HmfPriceComponent_ng_template_5_Conditional_1_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" - ", i0.ɵɵpipeBind3(2, 1, ctx_r0.prices.maxOfferPrice, ctx_r0.currencyCode, "symbol"), "");
  }
}
function HmfPriceComponent_ng_template_5_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "currency");
    i0.ɵɵtemplate(2, HmfPriceComponent_ng_template_5_Conditional_1_Conditional_2_Conditional_2_Template, 3, 5, "span");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(1, 2, ctx_r0.prices.minOfferPrice, ctx_r0.currencyCode, "symbol"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.carouselConfig.hasPriceRange ? 2 : -1);
  }
}
function HmfPriceComponent_ng_template_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, HmfPriceComponent_ng_template_5_Conditional_1_Conditional_1_Template, 2, 0, "span")(2, HmfPriceComponent_ng_template_5_Conditional_1_Conditional_2_Template, 3, 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.carouselConfig.showSeePriceForNoOffers ? 1 : ctx_r0.prices.minOfferPrice ? 2 : -1);
  }
}
function HmfPriceComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HmfPriceComponent_ng_template_5_Conditional_0_Template, 4, 3, "ng-container")(1, HmfPriceComponent_ng_template_5_Conditional_1_Template, 3, 1, "div", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.prices && ctx_r0.carouselConfig.hasMapRestriction ? 0 : ctx_r0.prices ? 1 : -1);
  }
}
function HmfProductImageComponent_ng_container_0_img_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 5, 2);
    i0.ɵɵlistener("error", function HmfProductImageComponent_ng_container_0_img_1_Template_img_error_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const img_r2 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleImageError(img_r2.src));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r2.imageData.imgClasses);
    i0.ɵɵproperty("alt", ctx_r2.productName)("height", ctx_r2.imageData.height)("ngSrc", ctx_r2.imageSrc)("priority", ctx_r2.imageData.isLCPImage)("title", ctx_r2.productName)("width", ctx_r2.imageData.width);
  }
}
function HmfProductImageComponent_ng_container_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 6, 2);
    i0.ɵɵlistener("error", function HmfProductImageComponent_ng_container_0_ng_template_2_Template_img_error_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const img_r5 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleImageError(img_r5.src));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r2.imageData.imgClasses);
    i0.ɵɵproperty("alt", ctx_r2.productName)("height", ctx_r2.imageData.height)("src", ctx_r2.imageSrc, i0.ɵɵsanitizeUrl)("title", ctx_r2.productName)("width", ctx_r2.imageData.width);
  }
}
function HmfProductImageComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HmfProductImageComponent_ng_container_0_img_1_Template, 2, 8, "img", 4)(2, HmfProductImageComponent_ng_container_0_ng_template_2_Template, 2, 7, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const fallbackImage_r6 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.imageData.isNgOptimizedImageSupported)("ngIfElse", fallbackImage_r6);
  }
}
function HmfProductImageComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 7);
  }
}
const _c31 = (a0, a1) => ["progress-stepper", a0, a1];
const _c32 = (a0, a1) => ["step", a0, a1];
const _c33 = a0 => ["step-name", a0];
function HmfProgressStepperComponent_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function HmfProgressStepperComponent_div_1_div_2_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    })("keydown.enter", function HmfProgressStepperComponent_div_1_div_2_Template_div_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    })("keydown.space", function HmfProgressStepperComponent_div_1_div_2_Template_div_keydown_space_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    });
    i0.ɵɵelement(1, "homefield-icon", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tabindex", ctx_r2.stepClickEvent ? 0 : -1);
  }
}
function HmfProgressStepperComponent_div_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵlistener("click", function HmfProgressStepperComponent_div_1_div_3_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    })("keydown.enter", function HmfProgressStepperComponent_div_1_div_3_Template_div_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    })("keydown.space", function HmfProgressStepperComponent_div_1_div_3_Template_div_keydown_space_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    });
    i0.ɵɵelement(1, "homefield-icon", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tabindex", ctx_r2.stepClickEvent ? 0 : -1);
  }
}
function HmfProgressStepperComponent_div_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("click", function HmfProgressStepperComponent_div_1_div_4_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    })("keydown.enter", function HmfProgressStepperComponent_div_1_div_4_Template_div_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    })("keydown.space", function HmfProgressStepperComponent_div_1_div_4_Template_div_keydown_space_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    });
    i0.ɵɵelement(1, "homefield-icon", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tabindex", ctx_r2.stepClickEvent ? 0 : -1);
  }
}
function HmfProgressStepperComponent_div_1_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("click", function HmfProgressStepperComponent_div_1_div_5_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    })("keydown.enter", function HmfProgressStepperComponent_div_1_div_5_Template_div_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    })("keydown.space", function HmfProgressStepperComponent_div_1_div_5_Template_div_keydown_space_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tabindex", ctx_r2.stepClickEvent ? 0 : -1);
  }
}
function HmfProgressStepperComponent_div_1_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function HmfProgressStepperComponent_div_1_div_6_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    })("keydown.enter", function HmfProgressStepperComponent_div_1_div_6_Template_div_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    })("keydown.space", function HmfProgressStepperComponent_div_1_div_6_Template_div_keydown_space_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepClickEvent.emit(i_r2));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tabindex", ctx_r2.stepClickEvent ? 0 : -1);
  }
}
function HmfProgressStepperComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 2);
    i0.ɵɵtemplate(2, HmfProgressStepperComponent_div_1_div_2_Template, 2, 1, "div", 3)(3, HmfProgressStepperComponent_div_1_div_3_Template, 2, 1, "div", 4)(4, HmfProgressStepperComponent_div_1_div_4_Template, 2, 1, "div", 5)(5, HmfProgressStepperComponent_div_1_div_5_Template, 1, 1, "div", 6)(6, HmfProgressStepperComponent_div_1_div_6_Template, 1, 1, "div", 7);
    i0.ɵɵelementStart(7, "span", 0);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const step_r8 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c32, step_r8.status, step_r8.nextStatus + "-next"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", step_r8.status === "completed");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", step_r8.status === "current");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", step_r8.status === "error");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", step_r8.status === "inprogress");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", step_r8.status === "incomplete");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c33, step_r8.status === "current" || step_r8.status === "error" ? "hmf-body-bold-m" : "hmf-body-m"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(step_r8.name);
  }
}
function HmfRadioGroupComponent_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate2("homefield-radiogroup-label ", ctx_r0.error ? "hmf-mb-xxs" : "hmf-mb-xxxs", " ", ctx_r0.name ? "homefield-radiogroup-label-" + ctx_r0.name : "", "");
    i0.ɵɵproperty("for", "homefield-radiogroup-label-" + ctx_r0.name)("id", "homefield-radiogroup-label-" + ctx_r0.name);
    i0.ɵɵattribute("data-test-id", ctx_r0.testId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.groupLabel, " ");
  }
}
function HmfRadioGroupComponent_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", "homefield-radiogroup-errorMessage-" + ctx_r0.name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, " ");
  }
}
const _c34 = ["input"];
const _c35 = (a0, a1, a2) => ({
  "focused": a0,
  "error": a1,
  "disabled": a2
});
const _c36 = a0 => ({
  "hmf-body-bold-l": a0
});
function HmfRadioComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
  }
}
function HmfRadioComponent_p_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", "homefield-radio-error-message-" + ctx_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.errorMessage, " ");
  }
}
function HmfRadioComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c37 = a0 => ["hmf-progress-text", a0];
function HmfProgressRingComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "circle", 2);
  }
}
function HmfProgressRingComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "animate", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("values", ctx_r0.currentSvgValues.circleStrokeLength + ";" + ctx_r0.progressStrokeOffset);
  }
}
function HmfProgressRingComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "text", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "text", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c37, ctx_r0.size() === ctx_r0.ringSize.large ? "hmf-display-m" : "hmf-display-xs"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.currentBalancePrefix + ctx_r0.formatBalance(ctx_r0.remainingBalance), " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c37, ctx_r0.size() === ctx_r0.ringSize.large ? "hmf-body-bold-m" : "hmf-body-bold-s"));
    i0.ɵɵattribute("y", ctx_r0.currentSvgValues.pointsTextY);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" of ", ctx_r0.currentBalancePrefix + ctx_r0.formatBalance(ctx_r0.targetBalance()) + " " + ctx_r0.currentBalanceDescriptor, " ");
  }
}
function HmfProgressRingComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "p", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p", 10);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.currentBalancePrefix + ctx_r0.formatBalance(ctx_r0.remainingBalance), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" of ", ctx_r0.currentBalancePrefix + ctx_r0.formatBalance(ctx_r0.targetBalance()) + " " + ctx_r0.currentBalanceDescriptor, " ");
  }
}
const _c38 = (a0, a1, a2, a3, a4, a5, a6, a7, a8) => ({
  error: a0,
  disabled: a1,
  "is-selected": a2,
  "is-contained": a3,
  "cs-large-circle": a4,
  "cs-medium-circle": a5,
  "cs-small-circle": a6,
  "cs-xsmall-circle": a7,
  "cs-xxsmall-circle": a8
});
const _c39 = (a0, a1, a2, a3, a4, a5, a6) => ({
  "is-mobile": a0,
  selected: a1,
  "cs-large-circle": a2,
  "cs-medium-circle": a3,
  "cs-small-circle": a4,
  "cs-xsmall-circle": a5,
  "cs-xxsmall-circle": a6
});
const _c40 = (a0, a1, a2, a3) => ({
  "hmf-body-bold-m content-selected": a0,
  "hmf-body-m": a1,
  "hmf-body-bold-m": a2,
  "overflow-elipsis": a3
});
function HmfDropdownSelectorComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (ctx_r0.currentSelected == null ? null : ctx_r0.currentSelected.label) || "", " ");
  }
}
function HmfDropdownSelectorComponent_ng_container_6_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const checkedLabel_r2 = ctx.$implicit;
    const isLast_r3 = ctx.last;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", checkedLabel_r2, "", ctx_r0.checkedLabelList.length > 1 && !isLast_r3 ? "," : "", " ");
  }
}
function HmfDropdownSelectorComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HmfDropdownSelectorComponent_ng_container_6_span_1_Template, 2, 2, "span", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.checkedLabelList);
  }
}
const _c41 = (a0, a1, a2) => ({
  "hmf-display-none": a0,
  error: a1,
  disabled: a2
});
const _c42 = (a0, a1, a2) => ({
  "hmf-body-s shrink hmf-px-xxs hmf-mt-xxxs": a0,
  "as-placeholder hmf-body-l": a1,
  disabled: a2
});
const _c43 = a0 => ({
  selected: a0
});
const _c44 = (a0, a1) => ({
  "hmf-elevated-shadow dropdown-container hmf-p-y-xxxs hmf-p-x-0": a0,
  "dropdown-container--bottom": a1
});
const _c45 = (a0, a1) => ({
  "hmf-display-none": a0,
  "hmf-display-flex hmf-flex-column hmf-align-items-start hmf-justify-content-between": a1
});
const _c46 = (a0, a1, a2) => ({
  "selected": a0,
  "hmf-py-xs": a1,
  "hmf-py-xxs": a2
});
const _c47 = (a0, a1, a2, a3, a4, a5, a6, a7) => ({
  "hmf-label-bold-m": a0,
  "hmf-body-bold-l": a1,
  "hmf-body-bold-m": a2,
  "hmf-label-bold-s": a3,
  "hmf-label-m": a4,
  "hmf-body-l": a5,
  "hmf-body-m": a6,
  "hmf-body-bold-s": a7
});
function HmfSelectComponent_For_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hmf-checkbox", 9);
  }
  if (rf & 2) {
    const option_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("checked", option_r2.selected)("ngClass", ctx_r2.multipleChoiceCheckboxClasses(option_r2.selected))("tabIndex", "-1");
  }
}
function HmfSelectComponent_For_7_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 10);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r2.iconName);
  }
}
function HmfSelectComponent_For_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function HmfSelectComponent_For_7_Template_button_click_0_listener($event) {
      const option_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.getSelectedValue($event, !option_r2.selected, option_r2));
    })("keydown", function HmfSelectComponent_For_7_Template_button_keydown_0_listener($event) {
      const $index_r4 = i0.ɵɵrestoreView(_r1).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.lostFocus($event, $index_r4));
    });
    i0.ɵɵtemplate(1, HmfSelectComponent_For_7_Conditional_1_Template, 1, 3, "hmf-checkbox", 9)(2, HmfSelectComponent_For_7_Conditional_2_Template, 1, 1, "homefield-icon", 10);
    i0.ɵɵelementStart(3, "span", 11);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(5, _c46, option_r2.selected, ctx_r2.size === ctx_r2.sizeVariant.LARGE, ctx_r2.size === ctx_r2.sizeVariant.SMALL));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.isMultipleChoice || ctx_r2.optionDesign === ctx_r2.optionDesignVariant.LABELCHECKBOX ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.optionDesign === ctx_r2.optionDesignVariant.LABELICON ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction8(9, _c47, ctx_r2.size === ctx_r2.sizeVariant.LARGE && ctx_r2.variant === ctx_r2.themeVariant.SECONDARY && option_r2.selected, ctx_r2.size === ctx_r2.sizeVariant.LARGE && ctx_r2.variant === ctx_r2.themeVariant.PRIMARY && option_r2.selected, ctx_r2.size === ctx_r2.sizeVariant.SMALL && ctx_r2.variant === ctx_r2.themeVariant.PRIMARY && option_r2.selected, ctx_r2.size === ctx_r2.sizeVariant.SMALL && ctx_r2.variant === ctx_r2.themeVariant.SECONDARY && option_r2.selected, ctx_r2.size === ctx_r2.sizeVariant.LARGE && ctx_r2.variant === ctx_r2.themeVariant.SECONDARY, ctx_r2.size === ctx_r2.sizeVariant.LARGE && ctx_r2.variant === ctx_r2.themeVariant.PRIMARY, ctx_r2.size === ctx_r2.sizeVariant.SMALL && ctx_r2.variant === ctx_r2.themeVariant.PRIMARY, ctx_r2.size === ctx_r2.sizeVariant.SMALL && ctx_r2.variant === ctx_r2.themeVariant.SECONDARY));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r2.label, " ");
  }
}
function HmfSelectComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "span", 12);
    i0.ɵɵtext(2, "This field is required.");
    i0.ɵɵelementEnd()();
  }
}
function HmfSelectComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "span", 12);
    i0.ɵɵtext(2, "Please select at least one option.");
    i0.ɵɵelementEnd()();
  }
}
const _c48 = a0 => ({
  "margin-right": a0
});
const _c49 = a0 => [a0, "hmf-option-container hmf-flex-column hmf-align-items-center"];
const _c50 = (a0, a1) => ({
  "padding-right": a0,
  "padding-bottom": a1
});
const _c51 = a0 => ({
  "max-width": a0
});
const _forTrack0 = ($index, $item) => $item.id;
function HmfSelectableComponent_For_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 3);
  }
}
function HmfSelectableComponent_For_2_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵclassMap(option_r4.secondLineClassList);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r4.secondLineValue, " ");
  }
}
function HmfSelectableComponent_For_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, HmfSelectableComponent_For_2_Conditional_3_Conditional_2_Template, 2, 3, "span", 8);
  }
  if (rf & 2) {
    const option_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap(option_r4.classList);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r4.value, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(option_r4.secondLineValue ? 2 : -1);
  }
}
function HmfSelectableComponent_For_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
  }
  if (rf & 2) {
    const option_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(option_r4.classList);
    i0.ɵɵproperty("ngStyle", ctx_r2.colorOptionStyle(option_r4));
  }
}
function HmfSelectableComponent_For_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 10);
    i0.ɵɵlistener("error", function HmfSelectableComponent_For_2_Conditional_5_Template_img_error_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onImageError($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(option_r4.classList);
    i0.ɵɵproperty("src", option_r4.value ? option_r4.value : ctx_r2.defaultSelectableImage, i0.ɵɵsanitizeUrl)("alt", option_r4.imgAltText);
    i0.ɵɵattribute("loading", option_r4.lazyLoadImage ? "lazy" : "eager");
  }
}
function HmfSelectableComponent_For_2_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c51, ctx_r2.width()));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r4.label, " ");
  }
}
function HmfSelectableComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "button", 2);
    i0.ɵɵlistener("click", function HmfSelectableComponent_For_2_Template_button_click_1_listener() {
      const ɵ$index_3_r2 = i0.ɵɵrestoreView(_r1).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changeSelection(ɵ$index_3_r2));
    });
    i0.ɵɵtemplate(2, HmfSelectableComponent_For_2_Conditional_2_Template, 1, 0, "div", 3)(3, HmfSelectableComponent_For_2_Conditional_3_Template, 3, 4)(4, HmfSelectableComponent_For_2_Conditional_4_Template, 1, 3, "div", 4)(5, HmfSelectableComponent_For_2_Conditional_5_Template, 1, 5, "img", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, HmfSelectableComponent_For_2_Conditional_6_Template, 2, 4, "p", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c49, ctx_r2.optionsClassList()))("ngStyle", i0.ɵɵpureFunction2(14, _c50, ctx_r2.currentSpaceBetween, ctx_r2.currentSpaceBetween));
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.optionClassList(option_r4));
    i0.ɵɵproperty("ngStyle", ctx_r2.optionStyle(option_r4))("disabled", option_r4.disabled);
    i0.ɵɵattribute("aria-label", ctx_r2.variant() === "text" ? option_r4.value : undefined);
    i0.ɵɵadvance();
    i0.ɵɵconditional(option_r4.disabled || option_r4.unavailable ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(option_r4.variant === "text" ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(option_r4.variant === "color" ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(option_r4.variant === "image" ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(option_r4.label && (option_r4.variant === "image" || option_r4.variant === "color") ? 6 : -1);
  }
}
const _c52 = ["panelContentDiv"];
const _c53 = [[["customPanelTitle"]], [["customPanelBody"]]];
const _c54 = ["customPanelTitle", "customPanelBody"];
const _c55 = a0 => ({
  "side-panel-collapsed": a0
});
const _c56 = (a0, a1, a2) => ({
  "content-closed-left": a0,
  "content-closed-right": a1,
  "bottom": a2
});
const _c57 = (a0, a1) => ({
  panelBodyClass: a0,
  "overflow-auto": a1
});
const _c58 = a0 => ({
  "hmf-display-flex hmf-justify-content-center": a0
});
function HmfSingleFeatureSpotComponent_picture_3_source_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "source", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("srcset", ctx_r0.mobileImage);
  }
}
function HmfSingleFeatureSpotComponent_picture_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "picture");
    i0.ɵɵtemplate(1, HmfSingleFeatureSpotComponent_picture_3_source_1_Template, 1, 1, "source", 8);
    i0.ɵɵelement(2, "img", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.mobileImage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.image, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("alt", ctx_r0.altText);
  }
}
function HmfSingleFeatureSpotComponent_p_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.upperText, " ");
  }
}
function HmfSingleFeatureSpotComponent_h2_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("hmf-display-s hmf-display-m-m hmf-pb-xxs \n\t\t  ", ctx_r0.headlineFont[ctx_r0.fontFamily], "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.headline, " ");
  }
}
function HmfSingleFeatureSpotComponent_p_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("hmf-header-bold-s hmf-header-bold-m-m hmf-pb-m-s hmf-pb-m-m \n\t\t  ", ctx_r0.subHeadlineFont[ctx_r0.fontFamily], "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.subhead, " ");
  }
}
function HmfSingleFeatureSpotComponent_p_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "a", 13);
    i0.ɵɵtext(3, " Details ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.detailsText, "\xA0 ");
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("hmf-feature-single-spot-details-link\n\t\t\t\t", ctx_r0.textColorVariants[ctx_r0.textColor], "");
    i0.ɵɵproperty("href", ctx_r0.detailsLink, i0.ɵɵsanitizeUrl);
  }
}
const _c59 = a0 => ({
  "hmf-flex-row": a0
});
const _c60 = (a0, a1, a2) => ({
  height: a0,
  width: a1,
  display: a2
});
const _c61 = (a0, a1) => ({
  "background-color": a0,
  "border-radius": a1,
  height: "100%",
  width: "100%",
  display: "block"
});
function HmfSkeletonComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMapInterpolate4("\n\t\t\t\t\t--base-ng-color: ", ctx_r0.baseColor, ";\n\t\t\t\t\t--highlight-ng-color: ", ctx_r0.highlightColor, ";\n\t\t\t\t\t--ng-animation-duration: ", ctx_r0.duration + "s", ";\n\t\t\t\t\t--ng-animation-direction: ", ctx_r0.reverseDirection ? "reverse" : "normal", ";");
    i0.ɵɵclassMapInterpolate1("homefield-skeleton hmf-angular-skeleton hmf-skeleton-", ctx_r0.shape || "text", "");
    i0.ɵɵpropertyInterpolate2("id", "hmf-skeleton-", ctx_r0.shape || "text", "", ctx_r0.id ? "-" + ctx_r0.id : "", "");
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(13, _c61, ctx_r0.baseColor, ctx_r0.shape === "circle" ? "50%" : ctx_r0.shape === "chip" ? "25px" : ctx_r0.borderRadius));
  }
}
function HmfSkeletonComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function HmfSnackbarComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵelement(1, "homefield-icon", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r0.messageIcon);
  }
}
function HmfSnackbarComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function HmfSnackbarComponent_Conditional_0_Conditional_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.closeSnackbar());
    });
    i0.ɵɵelement(1, "homefield-icon", 8);
    i0.ɵɵelementEnd();
  }
}
function HmfSnackbarComponent_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r0.linkUrl(), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.linkText(), " ");
  }
}
function HmfSnackbarComponent_Conditional_0_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function HmfSnackbarComponent_Conditional_0_Conditional_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onLinkClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.linkText(), " ");
  }
}
function HmfSnackbarComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
    i0.ɵɵtemplate(2, HmfSnackbarComponent_Conditional_0_Conditional_2_Template, 2, 1, "span", 2);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵprojection(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, HmfSnackbarComponent_Conditional_0_Conditional_5_Template, 2, 0, "button", 3)(6, HmfSnackbarComponent_Conditional_0_Conditional_6_Template, 2, 2, "a", 4)(7, HmfSnackbarComponent_Conditional_0_Conditional_7_Template, 2, 1, "button", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@enterLeave", ctx_r0.animationParams())("ngStyle", ctx_r0.positionStyle())("ngClass", ctx_r0.type());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.messageIcon !== undefined ? 2 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.action() === "close" ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.action() === "link" && ctx_r0.linkType() === "url" ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.action() === "link" && ctx_r0.linkType() === "event" ? 7 : -1);
  }
}
function HmfStarRatingsComponent_Conditional_0_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 2);
  }
  if (rf & 2) {
    const star_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("width", ctx_r1.size() === "large" ? "24px" : "16px")("height", ctx_r1.size() === "large" ? "24px" : "16px")("name", star_r1);
  }
}
function HmfStarRatingsComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("", ctx_r1.sizeClasses[ctx_r1.size()].text, " hmf-rating-average");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.ratingValue(), " ");
  }
}
function HmfStarRatingsComponent_Conditional_0_Conditional_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hmf-text-link", 5);
    i0.ɵɵlistener("click", function HmfStarRatingsComponent_Conditional_0_Conditional_5_Conditional_0_Template_hmf_text_link_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onClickCount($event));
    })("keydown", function HmfStarRatingsComponent_Conditional_0_Conditional_5_Conditional_0_Template_hmf_text_link_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onCountKeyDown($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r1.sizeClasses[ctx_r1.size()].quantity, " hmf-quantity");
    i0.ɵɵproperty("variant", "primary")("size", ctx_r1.size())("disabled", false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" (", ctx_r1.ratingCount(), ") ");
  }
}
function HmfStarRatingsComponent_Conditional_0_Conditional_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r1.sizeClasses[ctx_r1.size()].quantity, " hmf-quantity");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" (", ctx_r1.ratingCount(), ") ");
  }
}
function HmfStarRatingsComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HmfStarRatingsComponent_Conditional_0_Conditional_5_Conditional_0_Template, 2, 7, "hmf-text-link", 4)(1, HmfStarRatingsComponent_Conditional_0_Conditional_5_Conditional_1_Template, 2, 4, "span", 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.isVariantLink ? 0 : 1);
  }
}
function HmfStarRatingsComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
    i0.ɵɵrepeaterCreate(2, HmfStarRatingsComponent_Conditional_0_For_3_Template, 1, 3, "homefield-icon", 2, i0.ɵɵcomponentInstance().trackByFn, true);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, HmfStarRatingsComponent_Conditional_0_Conditional_4_Template, 2, 4, "span", 3)(5, HmfStarRatingsComponent_Conditional_0_Conditional_5_Template, 2, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.getAlignmentClass());
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.stars);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.shouldShowRating ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.shouldShowReviewCount ? 5 : -1);
  }
}
const _c62 = (a0, a1, a2) => ({
  "no-content": a0,
  "notification-badge-dark": a1,
  "notification-badge-light": a2
});
function HmfNotificationBadgeComponent_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.inputNumber);
  }
}
const _c63 = ["tab"];
function HmfTabbedContainerComponent_div_2_hmf_notification_badge_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hmf-notification-badge", 7);
  }
  if (rf & 2) {
    let tmp_5_0;
    let tmp_6_0;
    const tab_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("inputNumber", (tmp_5_0 = tab_r3 == null ? null : tab_r3.badgeCount == null ? null : tab_r3.badgeCount.toString()) !== null && tmp_5_0 !== undefined ? tmp_5_0 : "")("variant", (tmp_6_0 = tab_r3 == null ? null : tab_r3.variant) !== null && tmp_6_0 !== undefined ? tmp_6_0 : "dark");
  }
}
function HmfTabbedContainerComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5, 0);
    i0.ɵɵlistener("click", function HmfTabbedContainerComponent_div_2_Template_div_click_0_listener() {
      const ctx_r1 = i0.ɵɵrestoreView(_r1);
      const tab_r3 = ctx_r1.$implicit;
      const i_r4 = ctx_r1.index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.selectTab(i_r4, tab_r3));
    })("keydown", function HmfTabbedContainerComponent_div_2_Template_div_keydown_0_listener($event) {
      const ctx_r5 = i0.ɵɵrestoreView(_r1);
      const tab_r3 = ctx_r5.$implicit;
      const i_r4 = ctx_r5.index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onKeyDown($event, i_r4, tab_r3));
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, HmfTabbedContainerComponent_div_2_hmf_notification_badge_4_Template, 1, 2, "hmf-notification-badge", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "tab-", i_r4, "");
    i0.ɵɵproperty("ngClass", ctx_r4.getTabClasses(i_r4, tab_r3));
    i0.ɵɵattribute("tabindex", ctx_r4.selectedTab.tabIndex === i_r4 ? 0 : -1)("aria-selected", ctx_r4.selectedTab.tabIndex === i_r4)("aria-controls", "tab-content-" + i_r4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", tab_r3.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r3.showBadge);
  }
}
function HmfTabbedContainerComponent_div_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HmfTabbedContainerComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, HmfTabbedContainerComponent_div_3_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r7 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", ctx_r4.selectedTab.tabIndex !== i_r7);
    i0.ɵɵattribute("id", "tab-content-" + i_r7)("aria-labelledby", "tab-" + i_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r4.templateRefByIndex);
  }
}
const _c64 = ["textInput"];
const _c65 = (a0, a1) => ({
  "focused-border-color": a0,
  "unfocused-border-color": a1
});
const _c66 = (a0, a1) => ({
  "focused-border": a0,
  "error-focused-border": a1
});
function HmfTextInputComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.getLabelClasses());
    i0.ɵɵattribute("id", "homefield-textinput-label-" + ctx_r0.id)("for", "homefield-textinput-" + ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
  }
}
function HmfTextInputComponent_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "homefield-icon", 9);
    i0.ɵɵlistener("click", function HmfTextInputComponent_Conditional_3_Conditional_0_Template_homefield_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.inputStartIconClickedFunction());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.inputStartIconName);
  }
}
function HmfTextInputComponent_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "homefield-icon", 10);
    i0.ɵɵlistener("click", function HmfTextInputComponent_Conditional_3_Conditional_3_Template_homefield_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.inputEndIconClickedFunction());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.inputEndIconName);
  }
}
function HmfTextInputComponent_Conditional_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "homefield-icon", 11);
    i0.ɵɵlistener("click", function HmfTextInputComponent_Conditional_3_Conditional_4_Template_homefield_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onErrorIconClicked());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.iconName)("ngClass", ctx_r0.getDisabledErrorIconClasses());
  }
}
function HmfTextInputComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, HmfTextInputComponent_Conditional_3_Conditional_0_Template, 1, 1, "homefield-icon", 5);
    i0.ɵɵelementStart(1, "input", 6, 0);
    i0.ɵɵlistener("input", function HmfTextInputComponent_Conditional_3_Template_input_input_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onChanged($event));
    })("focus", function HmfTextInputComponent_Conditional_3_Template_input_focus_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onFocus($event));
    })("blur", function HmfTextInputComponent_Conditional_3_Template_input_blur_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onBlur($event));
    })("formattedValue", function HmfTextInputComponent_Conditional_3_Template_input_formattedValue_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onFormattedValue($event));
    });
    i0.ɵɵtwoWayListener("ngModelChange", function HmfTextInputComponent_Conditional_3_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.value, $event) || (ctx_r0.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, HmfTextInputComponent_Conditional_3_Conditional_3_Template, 1, 1, "homefield-icon", 7)(4, HmfTextInputComponent_Conditional_3_Conditional_4_Template, 1, 2, "homefield-icon", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.inputStartIconName ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("error", ctx_r0.error);
    i0.ɵɵproperty("hmfInputValidator", ctx_r0.type())("required", ctx_r0.required())("disabled", ctx_r0.disabled())("type", ctx_r0.type() === "number" ? "text" : ctx_r0.type())("decimalCount", ctx_r0.decimalCount)("placeholder", ctx_r0.placeholder)("minlength", ctx_r0.minLength)("maxlength", ctx_r0.maxLength)("min", ctx_r0.min)("max", ctx_r0.max)("autocomplete", ctx_r0.autocomplete)("readonly", ctx_r0.isReadOnly);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.value);
    i0.ɵɵproperty("ngClass", ctx_r0.getInputClasses());
    i0.ɵɵattribute("name", ctx_r0.name)("id", "homefield-textinput-" + ctx_r0.id)("aria-label", "homefield-textinput")("aria-labelledby", "homefield-textinput-label-" + ctx_r0.id);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.inputEndIconName ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.disabledIconEnabled || ctx_r0.errorIconEnabled ? 4 : -1);
  }
}
function HmfTextInputComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "textarea", 12, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function HmfTextInputComponent_Conditional_4_Template_textarea_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.value, $event) || (ctx_r0.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("input", function HmfTextInputComponent_Conditional_4_Template_textarea_input_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onChanged($event));
    })("focus", function HmfTextInputComponent_Conditional_4_Template_textarea_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onFocus($event));
    })("blur", function HmfTextInputComponent_Conditional_4_Template_textarea_blur_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onBlur($event));
    });
    i0.ɵɵtext(2, "\t\t");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const textInput_r7 = i0.ɵɵreference(1);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.value);
    i0.ɵɵproperty("disabled", ctx_r0.disabled())("required", ctx_r0.required())("rows", ctx_r0.rows)("placeholder", ctx_r0.placeholder)("title", ctx_r0.helperText ? ctx_r0.helperText : "homefield-textinput-helperText-" + ctx_r0.id)("readonly", ctx_r0.isReadOnly)("ngClass", i0.ɵɵpureFunction2(12, _c66, textInput_r7.focus, ctx_r0.error && textInput_r7.focus));
    i0.ɵɵattribute("name", ctx_r0.name)("id", "homefield-textinput-" + ctx_r0.id)("aria-label", "homefield-textinput")("aria-labelledby", "homefield-textinput-label-" + ctx_r0.id);
  }
}
function HmfTextInputComponent_p_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", "homefield-textinput-helperText-" + ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.helperText, " ");
  }
}
function HmfMonthMenuComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function HmfMonthMenuComponent_For_2_Template_button_click_0_listener() {
      const month_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.selectMonth(month_r2.key));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const month_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", month_r2.value, " ");
  }
}
function HmfYearMenuComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("mouseenter", function HmfYearMenuComponent_For_2_Template_button_mouseenter_0_listener() {
      const ɵ$index_3_r2 = i0.ɵɵrestoreView(_r1).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.preSelectedYearIndex.set(ɵ$index_3_r2));
    })("mouseleave", function HmfYearMenuComponent_For_2_Template_button_mouseleave_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.preSelectedYearIndex.set(-1));
    })("click", function HmfYearMenuComponent_For_2_Template_button_click_0_listener() {
      const yearItem_r4 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.yearSelected.emit(yearItem_r4.year));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const yearItem_r4 = ctx.$implicit;
    const ɵ$index_3_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("focused", ɵ$index_3_r2 === ctx_r2.preSelectedYearIndex())("selected", ctx_r2.currentSelectedYear() === yearItem_r4.year);
    i0.ɵɵproperty("disabled", yearItem_r4.disabled);
    i0.ɵɵattribute("tabindex", ɵ$index_3_r2 === ctx_r2.preSelectedYearIndex() ? 0 : -1)("aria-label", yearItem_r4.year);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", yearItem_r4.year, " ");
  }
}
const _c67 = ".calendar[_ngcontent-%COMP%]{background:var(--hmf-fill-base);border:1px solid var(--hmf-border-secondary-subtle-hover);box-sizing:border-box;width:fit-content}.calendar-grid[_ngcontent-%COMP%]{display:grid;gap:4px}.calendar.medium[_ngcontent-%COMP%]{--day-size: 44px;--year-width: 80px;--year-height: 44px;--month-width: 80px;--month-height: 44px;--font-size-var: large;--time-width-selector: 360px}.calendar.small[_ngcontent-%COMP%]{--day-size: 32px;--year-width: 62px;--year-height: 32px;--month-width: 80px;--month-height: 32px;--font-size-var: medium;--time-width-selector: 100%}.calendar-controls[_ngcontent-%COMP%]   .arrows[_ngcontent-%COMP%]{padding:var(--hmf-0)}.calendar[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:unset;border:unset;border-radius:4px;cursor:pointer}.calendar[_ngcontent-%COMP%]   button.left-arrow[_ngcontent-%COMP%]:disabled{cursor:not-allowed}.btn-date[_ngcontent-%COMP%]:hover:not(:disabled,.selected), .btn-date.focused[_ngcontent-%COMP%]:not(:disabled,.selected){background-color:var(--hmf-fill-secondary-hover)!important;color:var(--hmf-label-secondary-active)!important;font-weight:var(--typography-body-links-weights-bold)}.btn-date.selected[_ngcontent-%COMP%]{background-color:var(--hmf-fill-inverse)!important;color:var(--hmf-label-inverse)!important}.btn-date[_ngcontent-%COMP%]:disabled{background-color:var(--hmf-fill-base)!important;color:var(--hmf-label-disabled)!important;cursor:not-allowed;text-decoration:line-through}.btn-date[_ngcontent-%COMP%]   .timezone[_ngcontent-%COMP%]{color:inherit;font-weight:inherit}.weekdays[_ngcontent-%COMP%]{display:grid;gap:4px;grid-template-columns:repeat(7,1fr);text-align:center}.week[_ngcontent-%COMP%]{display:grid;gap:4px;grid-template-columns:repeat(7,1fr)}.week[_ngcontent-%COMP%]:not(:last-child){margin-bottom:var(--hmf-xxxs)}.day[_ngcontent-%COMP%]{border-radius:4px;height:var(--day-size);width:var(--day-size)}.day.other-month[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-active)}.btn-date-month[_ngcontent-%COMP%]:disabled{background-color:var(--hmf-fill-base);color:var(--hmf-label-disabled);cursor:not-allowed;text-decoration:line-through}.btn-date-month[_ngcontent-%COMP%]:hover:not(:disabled,.selected){background-color:var(--hmf-fill-secondary-hover);color:var(--hmf-label-secondary-active);font-weight:var(--typography-body-links-weights-bold)}.btn-date-month.selected[_ngcontent-%COMP%]{background-color:var(--hmf-fill-inverse);color:var(--hmf-label-inverse)}.months[_ngcontent-%COMP%]{border:none;display:grid;grid-template-columns:repeat(3,1fr)}.months[_ngcontent-%COMP%]   .month-btn[_ngcontent-%COMP%]{font-size:var(--font-size-var);height:var(--month-height);text-transform:capitalize!important;width:var(--month-width)}.year-grid[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(4,1fr)}.year-grid[_ngcontent-%COMP%]   .year-btn[_ngcontent-%COMP%]{height:var(--year-height);width:var(--year-width)}.time-menu-container[_ngcontent-%COMP%]{max-height:280px;overflow:hidden;position:relative;width:100%}.time-menu-container[_ngcontent-%COMP%]:after{background:linear-gradient(to bottom,#fff0,#fff);bottom:0;content:\"\";height:40px;left:0;pointer-events:none;position:absolute;right:0;z-index:1}.time-menu[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:4px;max-height:240px;min-width:var(--time-width-selector);overflow-y:auto;padding-right:8px;position:relative}.btn-time[_ngcontent-%COMP%]{align-items:baseline;display:flex;gap:4px;padding:8px;text-align:left;text-transform:uppercase!important;width:auto}.timezone[_ngcontent-%COMP%]{color:var(--hmf-label-base-subtle);font-size:11px;line-height:1}";
function HmfDateMenuComponent_Case_12_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(day_r1);
  }
}
function HmfDateMenuComponent_Case_12_For_6_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function HmfDateMenuComponent_Case_12_For_6_For_2_Template_button_click_0_listener() {
      const day_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onDateSelect(day_r3.date));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("other-month", !day_r3.isCurrentMonth)("selected", day_r3.isDaySelected);
    i0.ɵɵproperty("disabled", ctx_r3.isDisabled(day_r3.date));
    i0.ɵɵattribute("aria-selected", day_r3.isDaySelected || null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", day_r3.date.getDate(), " ");
  }
}
function HmfDateMenuComponent_Case_12_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵrepeaterCreate(1, HmfDateMenuComponent_Case_12_For_6_For_2_Template, 2, 7, "button", 14, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const week_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(week_r5);
  }
}
function HmfDateMenuComponent_Case_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 11);
    i0.ɵɵrepeaterCreate(2, HmfDateMenuComponent_Case_12_For_3_Template, 2, 1, "div", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵrepeaterCreate(5, HmfDateMenuComponent_Case_12_For_6_Template, 3, 0, "div", 13, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r3.weekDays);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r3.calendarDays());
  }
}
function HmfDateMenuComponent_Case_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hmf-month-menu", 16);
    i0.ɵɵlistener("monthSelected", function HmfDateMenuComponent_Case_13_Template_hmf_month_menu_monthSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onMonthSelected($event));
    });
    i0.ɵɵelementEnd();
  }
}
function HmfDateMenuComponent_Case_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hmf-year-component", 17);
    i0.ɵɵlistener("yearSelected", function HmfDateMenuComponent_Case_14_Template_hmf_year_component_yearSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.yearSelected($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("allowFutureYears", ctx_r3.allowFutureYears())("baseYear", ctx_r3.baseYearForYearMenu());
  }
}
const _forTrack1 = ($index, $item) => $item.display;
function HmfTimeMenuComponent_For_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.timezoneLabel());
  }
}
function HmfTimeMenuComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function HmfTimeMenuComponent_For_3_Template_button_click_0_listener() {
      const timeOption_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onTimeSelect(timeOption_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, HmfTimeMenuComponent_For_3_Conditional_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const timeOption_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("selected", ctx_r2.isSelected(timeOption_r2))("disabled", timeOption_r2.disabled)("hmf-body-m", ctx_r2.size() === "small");
    i0.ɵɵproperty("disabled", timeOption_r2.disabled);
    i0.ɵɵattribute("aria-selected", ctx_r2.isSelected(timeOption_r2));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", timeOption_r2.display, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.showTimezone() && ctx_r2.timezoneLabel() ? 2 : -1);
  }
}
const _c68 = a0 => ({
  "fixed-label": a0
});
const _c69 = a0 => ({
  error: a0
});
const _c70 = (a0, a1, a2) => ({
  "shrink hmf-pr-xxs hmf-pl-xxs hmf-body-s": a0,
  "error-background": a1,
  "default-background": a2
});
const _c71 = a0 => ({
  "time-picker": a0
});
function HmfDatePickerComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c69, ctx_r1.hasErrors));
    i0.ɵɵattribute("id", "datepicker-input-label-" + ctx_r1.id())("for", "datepicker-input-" + ctx_r1.id());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label(), " ");
  }
}
function HmfDatePickerComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(4, _c70, ctx_r1.isInputFocused() || ctx_r1.dateControl.value, ctx_r1.hasErrors, !ctx_r1.hasErrors));
    i0.ɵɵattribute("id", "datepicker-input-label-" + ctx_r1.id())("for", "datepicker-input-" + ctx_r1.id());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label(), " ");
  }
}
function HmfDatePickerComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", "datepicker-input-helperText-" + ctx_r1.id());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.helperText(), " ");
  }
}
function HmfDatePickerComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.errorMessage());
  }
}
function HmfDatePickerComponent_Conditional_13_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hmf-date-menu", 16);
    i0.ɵɵlistener("dateSelected", function HmfDatePickerComponent_Conditional_13_Conditional_1_Template_hmf_date_menu_dateSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDateMenuSelection($event));
    })("isFocused", function HmfDatePickerComponent_Conditional_13_Conditional_1_Template_hmf_date_menu_isFocused_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.dateMenuFocus($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("size", ctx_r1.size())("pastDatesExcluded", ctx_r1.pastDatesExcluded())("invalidDateRange", ctx_r1.invalidDateRange())("invalidDateList", ctx_r1.invalidDateList())("recurringDisabledDates", ctx_r1.recurringDisabledDates())("allowFutureYears", ctx_r1.allowFutureYears())("currentlySelectedDate", ctx_r1.getSafeSelectedDate());
  }
}
function HmfDatePickerComponent_Conditional_13_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hmf-time-menu", 17);
    i0.ɵɵlistener("timeSelected", function HmfDatePickerComponent_Conditional_13_Conditional_2_Template_hmf_time_menu_timeSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onTimeMenuSelection($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selectedTime", ctx_r1.currentlySelectedDate())("size", ctx_r1.size())("showTimezone", ctx_r1.showTimezone())("timezoneLabel", ctx_r1.computedTimezoneLabel())("intervalMinutes", ctx_r1.intervalMinutes())("use24HourFormat", ctx_r1.use24HourFormat())("disabledTimeRanges", ctx_r1.disabledTimeRanges());
  }
}
function HmfDatePickerComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, HmfDatePickerComponent_Conditional_13_Conditional_1_Template, 1, 7, "hmf-date-menu", 14)(2, HmfDatePickerComponent_Conditional_13_Conditional_2_Template, 1, 7, "hmf-time-menu", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c71, !ctx_r1.isDateType()));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isDateType() ? 1 : 2);
  }
}
const _c72 = ["quantityInput"];
const _c73 = (a0, a1) => ({
  "quantity-stepper__container--medium": a0,
  "quantity-stepper__container--small": a1
});
const _c74 = ["scrollbarTrack"];
const _c75 = ["scrollbarThumb"];
const _c76 = a0 => ({
  "hmf-carousel-progress-indicator-bar-dragging": a0
});
const _c77 = a0 => ({
  left: a0
});
const _c78 = ["carouselContent"];
const _c79 = ["endOfListing"];
const _c80 = a0 => ({
  "hmf-mb-xxxs": a0
});
const _c81 = a0 => ({
  "hmf-notitle": a0
});
const _c82 = a0 => ({
  "hmf-display-none hmf-display-md-block": a0
});
function HmfCarouselComponent_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c80, ctx_r1.subtitle && ctx_r1.showSubtitle));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.title, " ");
  }
}
function HmfCarouselComponent_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c81, !ctx_r1.title || !ctx_r1.showTitle));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.subtitle, " ");
  }
}
function HmfCarouselComponent_div_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function HmfCarouselComponent_div_1_div_3_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.actionButtonClicked.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.actionButtonTitle, " ");
  }
}
function HmfCarouselComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, HmfCarouselComponent_div_1_div_1_Template, 2, 4, "div", 12)(2, HmfCarouselComponent_div_1_div_2_Template, 2, 4, "div", 13)(3, HmfCarouselComponent_div_1_div_3_Template, 2, 1, "div", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showSubtitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showActionButton);
  }
}
function HmfCarouselComponent_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function HmfCarouselComponent_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.scrollLeft());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", "Previous Items Button")("ngClass", i0.ɵɵpureFunction1(3, _c82, !ctx_r1.showScrollButtonsOnMobile));
    i0.ɵɵattribute("inert", ctx_r1.skipListing ? "" : null);
  }
}
function HmfCarouselComponent_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function HmfCarouselComponent_button_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.scrollRight());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", "Next Items Button")("ngClass", i0.ɵɵpureFunction1(3, _c82, !ctx_r1.showScrollButtonsOnMobile));
    i0.ɵɵattribute("inert", ctx_r1.skipListing ? "" : null);
  }
}
function HmfCarouselComponent_hmf_scrollbar_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hmf-scrollbar", 20);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const carouselContent_r6 = i0.ɵɵreference(6);
    i0.ɵɵproperty("scrollContent", carouselContent_r6);
  }
}
const _c83 = ["paginationCarouselContent"];
const _c84 = a0 => ({
  "hmf-position-relative": a0
});
const _c85 = (a0, a1, a2) => ({
  "scroll-in": a0,
  "scroll-out": a1,
  scrollable: a2
});
const _c86 = (a0, a1) => ({
  "hmf-justify-content-center": a0,
  "hmf-justify-content-between": a1
});
const _c87 = a0 => ({
  "hmf-mb-xxs": a0
});
const _c88 = a0 => ({
  "hmf-position-absolute hmf-pagination-buttons": a0
});
const _c89 = () => [];
const _c90 = a0 => ({
  active: a0
});
function HmfPaginationCarouselComponent_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c87, ctx_r1.subtitle && ctx_r1.showSubtitle));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.title, " ");
  }
}
function HmfPaginationCarouselComponent_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c81, !ctx_r1.title || !ctx_r1.showTitle));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.subtitle, " ");
  }
}
function HmfPaginationCarouselComponent_div_1_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function HmfPaginationCarouselComponent_div_1_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.actionButtonClicked.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.actionButtonTitle, " ");
  }
}
function HmfPaginationCarouselComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, HmfPaginationCarouselComponent_div_1_div_1_Template, 2, 4, "div", 10)(2, HmfPaginationCarouselComponent_div_1_div_2_Template, 2, 4, "div", 11)(3, HmfPaginationCarouselComponent_div_1_button_3_Template, 2, 1, "button", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showSubtitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showActionButton);
  }
}
function HmfPaginationCarouselComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 16)(2, "button", 17);
    i0.ɵɵlistener("click", function HmfPaginationCarouselComponent_Conditional_6_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.previous());
    });
    i0.ɵɵelement(3, "homefield-icon", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 19);
    i0.ɵɵlistener("click", function HmfPaginationCarouselComponent_Conditional_6_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.next());
    });
    i0.ɵɵelement(5, "homefield-icon", 20);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c88, ctx_r1.arrowCentered));
  }
}
function HmfPaginationCarouselComponent_Conditional_8_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function HmfPaginationCarouselComponent_Conditional_8_button_1_Template_button_click_0_listener() {
      const index_r6 = i0.ɵɵrestoreView(_r5).index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectPage(index_r6));
    })("keydown.enter", function HmfPaginationCarouselComponent_Conditional_8_button_1_Template_button_keydown_enter_0_listener() {
      const index_r6 = i0.ɵɵrestoreView(_r5).index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectPage(index_r6));
    })("keydown.space", function HmfPaginationCarouselComponent_Conditional_8_button_1_Template_button_keydown_space_0_listener() {
      const index_r6 = i0.ɵɵrestoreView(_r5).index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectPage(index_r6));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const index_r6 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c90, index_r6 === ctx_r1.currentPage));
  }
}
function HmfPaginationCarouselComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, HmfPaginationCarouselComponent_Conditional_8_button_1_Template, 1, 3, "button", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c89).constructor(ctx_r1.totalPages));
  }
}
function HmfPaginationCarouselComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "button", 17);
    i0.ɵɵlistener("click", function HmfPaginationCarouselComponent_Conditional_9_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.previous());
    });
    i0.ɵɵelement(2, "homefield-icon", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 19);
    i0.ɵɵlistener("click", function HmfPaginationCarouselComponent_Conditional_9_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.next());
    });
    i0.ɵɵelement(4, "homefield-icon", 20);
    i0.ɵɵelementEnd()();
  }
}
const _c91 = a0 => ({
  centered: a0
});
const _c92 = a0 => ({
  "out-of-stock": a0
});
function HmfProductAvailabilityComponent_div_0_homefield_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r0.shippingMessage == null ? null : ctx_r0.shippingMessage.class);
    i0.ɵɵproperty("name", ctx_r0.shippingMessage ? ctx_r0.shippingMessage.icon : "");
  }
}
function HmfProductAvailabilityComponent_div_0_div_4_homefield_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "homefield-icon", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r0.pickupMessage == null ? null : ctx_r0.pickupMessage.class);
    i0.ɵɵproperty("name", ctx_r0.pickupMessage ? ctx_r0.pickupMessage.icon : "");
  }
}
function HmfProductAvailabilityComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, HmfProductAvailabilityComponent_div_0_div_4_homefield_icon_1_Template, 1, 3, "homefield-icon", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c92, ctx_r0.isOOS));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.pickupMessage == null ? null : ctx_r0.pickupMessage.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.pickupMessage == null ? null : ctx_r0.pickupMessage.text, " ");
  }
}
function HmfProductAvailabilityComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtemplate(2, HmfProductAvailabilityComponent_div_0_homefield_icon_2_Template, 1, 3, "homefield-icon", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, HmfProductAvailabilityComponent_div_0_div_4_Template, 3, 5, "div", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c91, !ctx_r0.selectedStoreId));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c92, ctx_r0.isOOS));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.shippingMessage == null ? null : ctx_r0.shippingMessage.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.shippingMessage == null ? null : ctx_r0.shippingMessage.text, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.selectedStoreId);
  }
}
function HmfProductAvailabilityComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "p", 9)(2, "p", 10);
    i0.ɵɵelementEnd();
  }
}
const _c93 = a0 => ({
  clickable: a0
});
const _c94 = a0 => ({
  "hmf-mr-xxs": a0
});
const _c95 = a0 => ({
  "hmf-display-flex hmf-flex-column hmf-justify-content-between": a0
});
const _c96 = (a0, a1, a2) => ({
  "hmf-mb-s": a0,
  "hmf-pt-xxs": a1,
  "hmf-mb-xxs": a2
});
const _c97 = (a0, a1) => ({
  id: a0,
  value: a1
});
const _c98 = a0 => [a0];
const _c99 = () => [1, 2, 3];
const _c100 = (a0, a1, a2) => ({
  "hmf-mt-0 hmf-mb-s": a0,
  "hmf-pt-xxs": a1,
  "hmf-mt-0 hmf-mb-xxs": a2
});
const _forTrack2 = ($index, $item) => $item.color;
function HmfProductCardComponent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "hmf-badge", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pd_r3 = i0.ɵɵnextContext();
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.isCarouselVariant ? "badge-carousel" : "badge");
    i0.ɵɵadvance();
    i0.ɵɵproperty("badgeName", pd_r3.badge);
  }
}
function HmfProductCardComponent_Conditional_1_Conditional_5_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hmf-selectable", 17);
    i0.ɵɵlistener("mouseover", function HmfProductCardComponent_Conditional_1_Conditional_5_For_2_Template_hmf_selectable_mouseover_0_listener() {
      const swatch_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setSelectedSwatchColor(swatch_r5.color));
    })("selectionChange", function HmfProductCardComponent_Conditional_1_Conditional_5_For_2_Template_hmf_selectable_selectionChange_0_listener() {
      const swatch_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setSelectedSwatchColor(swatch_r5.color));
    })("focus", function HmfProductCardComponent_Conditional_1_Conditional_5_For_2_Template_hmf_selectable_focus_0_listener() {
      const swatch_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setSelectedSwatchColor(swatch_r5.color));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const swatch_r5 = ctx.$implicit;
    const ɵ$index_19_r6 = ctx.$index;
    i0.ɵɵproperty("options", i0.ɵɵpureFunction1(8, _c98, i0.ɵɵpureFunction2(5, _c97, ɵ$index_19_r6, swatch_r5.imageSrc)))("multipleSelection", false)("contained", true)("shape", "circle")("variant", "image");
  }
}
function HmfProductCardComponent_Conditional_1_Conditional_5_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const swatchData_r7 = i0.ɵɵnextContext();
    const pd_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("linkURL", pd_r3.assetSeoUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" +", swatchData_r7.swatches.length - swatchData_r7.numberOfColorSwatchesToShow, " ");
  }
}
function HmfProductCardComponent_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵrepeaterCreate(1, HmfProductCardComponent_Conditional_1_Conditional_5_For_2_Template, 1, 10, "hmf-selectable", 15, _forTrack2);
    i0.ɵɵpipe(3, "slice");
    i0.ɵɵtemplate(4, HmfProductCardComponent_Conditional_1_Conditional_5_Conditional_4_Template, 2, 2, "a", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const swatchData_r7 = ctx;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(i0.ɵɵpipeBind3(3, 1, swatchData_r7.swatches, 0, swatchData_r7.numberOfColorSwatchesToShow));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(swatchData_r7.swatches && swatchData_r7.swatches.length > swatchData_r7.numberOfColorSwatchesToShow ? 4 : -1);
  }
}
function HmfProductCardComponent_Conditional_1_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hmf-price", 6);
  }
  if (rf & 2) {
    const pd_r3 = i0.ɵɵnextContext();
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isClearance", pd_r3.pricing.isClearance)("isSeePriceInCart", pd_r3.pricing.isSeePriceInCart)("prices", pd_r3.pricing.prices)("variant", ctx_r1.priceVariant)("isSkuRecommendation", pd_r3.pricing.isSkuRecommendation);
  }
}
function HmfProductCardComponent_Conditional_1_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hmf-star-ratings", 7);
  }
  if (rf & 2) {
    const pd_r3 = i0.ɵɵnextContext();
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.variant === "fbt" ? "hmf-mb-xxs" : "hmf-pb-xs")("ratingCount", pd_r3.starRatings.ratingCount)("ratingValue", pd_r3.starRatings.ratingValue)("showRating", pd_r3.starRatings.showCustomerRating)("showReviewCount", pd_r3.starRatings.showCustomerRating);
  }
}
function HmfProductCardComponent_Conditional_1_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 18);
    i0.ɵɵlistener("click", function HmfProductCardComponent_Conditional_1_Conditional_12_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAttributesClick());
    })("keyup.space", function HmfProductCardComponent_Conditional_1_Conditional_12_Template_div_keyup_space_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAttributesClick());
    })("keyup.enter", function HmfProductCardComponent_Conditional_1_Conditional_12_Template_div_keyup_enter_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAttributesClick());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", ctx_r1.attributesClickable ? "button" : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.displayAttributesText, " ");
  }
}
function HmfProductCardComponent_Conditional_1_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr", 10);
  }
}
function HmfProductCardComponent_Conditional_1_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hmf-product-availability", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("productAvailabilityData", ctx_r1.availability == null ? null : ctx_r1.availability.availabilityMessaging)("selectedStoreId", ctx_r1.availability == null ? null : ctx_r1.availability.selectedStoreId)("isOOS", ctx_r1.availability == null ? null : ctx_r1.availability.isOOS);
  }
}
function HmfProductCardComponent_Conditional_1_Conditional_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "hmf-add-to-cart", 19);
    i0.ɵɵlistener("addToCartClicked", function HmfProductCardComponent_Conditional_1_Conditional_17_Template_hmf_add_to_cart_addToCartClicked_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.addToCart($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("text", ctx_r1.displayButtonText)("buttonStyle", ctx_r1.buttonStyle)("showATCIcon", ctx_r1.showATCIcon);
  }
}
function HmfProductCardComponent_Conditional_1_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "button", 20);
    i0.ɵɵlistener("click", function HmfProductCardComponent_Conditional_1_Conditional_18_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onViewProductClick());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("variant", ctx_r1.buttonStyle)("text", ctx_r1.linkToProductText())("size", "medium");
  }
}
function HmfProductCardComponent_Conditional_1_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵtext(1, " Sponsored ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("variant", "sponsored")("disabled", true);
  }
}
function HmfProductCardComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hmf-card", 1);
    i0.ɵɵlistener("click", function HmfProductCardComponent_Conditional_1_Template_hmf_card_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCardClick());
    })("keydown", function HmfProductCardComponent_Conditional_1_Template_hmf_card_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCardKeyPress($event));
    });
    i0.ɵɵtemplate(1, HmfProductCardComponent_Conditional_1_Conditional_1_Template, 2, 2, "div", 2);
    i0.ɵɵelementStart(2, "div", 2)(3, "div", 2)(4, "hmf-product-image", 3);
    i0.ɵɵlistener("click", function HmfProductCardComponent_Conditional_1_Template_hmf_product_image_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onImageClick());
    })("keyup.space", function HmfProductCardComponent_Conditional_1_Template_hmf_product_image_keyup_space_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onImageClick());
    })("keyup.enter", function HmfProductCardComponent_Conditional_1_Template_hmf_product_image_keyup_enter_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onImageClick());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, HmfProductCardComponent_Conditional_1_Conditional_5_Template, 5, 5, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 2)(7, "div")(8, "p", 5);
    i0.ɵɵlistener("click", function HmfProductCardComponent_Conditional_1_Template_p_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNameClick());
    })("keyup.space", function HmfProductCardComponent_Conditional_1_Template_p_keyup_space_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNameClick());
    })("keyup.enter", function HmfProductCardComponent_Conditional_1_Template_p_keyup_enter_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNameClick());
    });
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, HmfProductCardComponent_Conditional_1_Conditional_10_Template, 1, 5, "hmf-price", 6)(11, HmfProductCardComponent_Conditional_1_Conditional_11_Template, 1, 5, "hmf-star-ratings", 7)(12, HmfProductCardComponent_Conditional_1_Conditional_12_Template, 3, 2, "div", 8);
    i0.ɵɵelementStart(13, "p", 9);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, HmfProductCardComponent_Conditional_1_Conditional_15_Template, 1, 0, "hr", 10)(16, HmfProductCardComponent_Conditional_1_Conditional_16_Template, 1, 3, "hmf-product-availability", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, HmfProductCardComponent_Conditional_1_Conditional_17_Template, 2, 3, "div", 12)(18, HmfProductCardComponent_Conditional_1_Conditional_18_Template, 2, 3, "div", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(19, HmfProductCardComponent_Conditional_1_Conditional_19_Template, 2, 2, "button", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_14_0;
    const pd_r3 = ctx;
    const ctx_r1 = i0.ɵɵnextContext();
    const isHorizontal_r11 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(28, _c93, !ctx_r1.showATC))("ngClass", ctx_r1.isCarouselVariant ? "hmf-display-block hmf-position-relative" : "");
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r1.variant === "vertical" || ctx_r1.variant === "fbt" || isHorizontal_r11) && pd_r3.badge ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate2("hmf-product-card hmf-py-xs hmf-sharp-radius hmf-display-flex hmf-product-card-container-", ctx_r1.size, " hmf-product-card-", ctx_r1.variant, "");
    i0.ɵɵproperty("ngClass", ctx_r1.containerPaddings);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(30, _c94, isHorizontal_r11));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ecode", pd_r3.ecode)("imageData", pd_r3.imageData)("productName", pd_r3.productName)("selectedSwatchColor", ctx_r1.selectedSwatchColor);
    i0.ɵɵattribute("role", ctx_r1.imageClickable ? "button" : null);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_14_0 = pd_r3.colorSwatches) ? 5 : -1, tmp_14_0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(32, _c95, isHorizontal_r11));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(34, _c96, ctx_r1.isCarouselVariant, !ctx_r1.isCarouselVariant && !isHorizontal_r11, isHorizontal_r11));
    i0.ɵɵattribute("role", ctx_r1.nameClickable ? "button" : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", pd_r3.productName, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!pd_r3.pricing.isHidden ? 10 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(pd_r3.starRatings && pd_r3.starRatings.showCustomerRating && ctx_r1.showReviewsStars ? 11 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.variant === "fbt" && ctx_r1.displayAttributesText ? 12 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", pd_r3.promoMessage, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.variant !== "horizontal" ? 15 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.variant === "vertical" ? 16 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showATC && !ctx_r1.showLinkToProduct() ? 17 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showLinkToProduct() ? 18 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isSponsored || (pd_r3.isSponsored || pd_r3.isNikeExclusive) && pd_r3.showNewSponsoredLabel ? 19 : -1);
  }
}
function HmfProductCardComponent_Conditional_2_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 23);
  }
}
function HmfProductCardComponent_Conditional_2_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr", 28);
  }
}
function HmfProductCardComponent_Conditional_2_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 32);
  }
}
function HmfProductCardComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "hmf-card")(1, "div", 2)(2, "div", 2)(3, "div", 2);
    i0.ɵɵelement(4, "div", 21);
    i0.ɵɵelementStart(5, "div", 22);
    i0.ɵɵrepeaterCreate(6, HmfProductCardComponent_Conditional_2_For_7_Template, 1, 0, "div", 23, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 2)(9, "div")(10, "div");
    i0.ɵɵelement(11, "p", 24)(12, "p", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "div", 26)(14, "div", 27);
    i0.ɵɵtemplate(15, HmfProductCardComponent_Conditional_2_Conditional_15_Template, 1, 0, "hr", 28);
    i0.ɵɵelementStart(16, "div", 29);
    i0.ɵɵelement(17, "p", 30)(18, "p", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, HmfProductCardComponent_Conditional_2_Conditional_19_Template, 1, 0, "div", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div");
    i0.ɵɵelement(21, "hmf-add-to-cart", 33);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const isHorizontal_r11 = i0.ɵɵreadContextLet(0);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate2("hmf-product-card hmf-py-xs hmf-product-card-skeleton hmf-sharp-radius hmf-product-card-container-", ctx_r1.size, " hmf-product-card-", ctx_r1.variant, "");
    i0.ɵɵproperty("ngClass", ctx_r1.containerPaddings);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c59, isHorizontal_r11));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c94, isHorizontal_r11));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.variant === "vertical" ? "hmf-mb-xs hmf-my-0 hmf-mx-auto" : "hmf-mb-xxs");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(i0.ɵɵpureFunction0(18, _c99));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c95, isHorizontal_r11));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(21, _c100, ctx_r1.isCarouselVariant, !ctx_r1.isCarouselVariant && !isHorizontal_r11, isHorizontal_r11));
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r1.variant !== "horizontal" ? 15 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c10, ctx_r1.variant !== "vertical"));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.variant === "fbt" ? 19 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("text", ctx_r1.displayButtonText);
  }
}
let HmfAccordionComponent = /*#__PURE__*/(() => {
  class HmfAccordionComponent {
    /**
     * If true, the accordion will be opened
     * @default false
     * @type {boolean}
     */
    set active(value) {
      this._active = value;
      this.open = this._active;
      this.activeChange.emit(this._active);
    }
    get active() {
      return this._active;
    }
    constructor(homefieldIconsLibraryService) {
      this.buttonLabelSize = {
        small: 'hmf-body-m',
        medium: 'hmf-body-bold-s',
        large: 'hmf-body-bold-l',
        xlarge: 'hmf-body-bold-l'
      };
      this.countClassName = {
        small: 'hmf-body-s',
        medium: 'hmf-body-m',
        large: 'hmf-body-m',
        xlarge: 'hmf-body-m'
      };
      this.label = '';
      this.classList = '';
      this.testId = '';
      this.icon = '';
      this.subLabel = '';
      this.layout = 'vertical';
      this.countStyle = '';
      this.labelStyle = '';
      /**
       * If true, the skeleton loader will be shown
       * @default false
       * @type {boolean}
       **/
      this.loading = false;
      /**
       * The size of the accordion
       * @default 'medium'
       * @type {'small' | 'medium' | 'large' | 'xlarge'}
       **/
      this.size = 'medium';
      /**
       * Display a count label on the right side of the accordion
       * @default ''
       * @type {number | string}
       */
      this.count = '';
      /**
       * Determine if accordion should expan over content
       * @default true
       * @type {boolean}
       */
      this.expandOverContent = true;
      /**
       * The variant of the top border of the accordion
       * @default 'outlined'
       * @type {'outlined' | 'outlined-top', 'no-outlined'}
       **/
      this.variant = 'outlined';
      this._active = false;
      this.activeChange = new EventEmitter();
      this.id = generateId('accordion');
      this.open = false;
      homefieldIconsLibraryService.registerIcons([homefieldIconChevronUp, homefieldIconChevronDown]);
    }
    ngOnInit() {
      this.open = this.active;
      this.updateButtonLabelSizeClass();
      this.updateIconSize();
    }
    ngOnChanges(changes) {
      if (changes['size']) {
        this.updateButtonLabelSizeClass();
        this.updateIconSize();
        this.updateCountClass();
      }
    }
    updateButtonLabelSizeClass() {
      this.buttonLabelSizeClass = this.buttonLabelSize[this.size] ?? this.buttonLabelSize['medium'];
    }
    updateCountClass() {
      this.countClass = this.countClassName[this.size] ?? this.countClassName['medium'];
    }
    updateIconSize() {
      const SIZE_MAP = {
        small: '16px',
        medium: '16px',
        large: '24px',
        xlarge: '24px'
      };
      this.iconSize = SIZE_MAP[this.size];
    }
    toggleOpen() {
      this.open = !this.open;
      this.active = this.open;
    }
    get containerClasses() {
      return {
        'hmf-flex-column': this.layout === 'vertical' && (this.size === 'large' || this.size === 'xlarge'),
        'hmf-flex-row hmf-align-items-center': this.layout === 'trailing' || this.size === 'small' || this.size === 'medium',
        [this.labelStyle]: !!this.labelStyle
      };
    }
    get subLabelClasses() {
      return {
        'hmf-ml-xxs': this.layout === 'trailing',
        'hmf-body-s': this.size !== 'xlarge',
        'hmf-body-m': this.size === 'xlarge'
      };
    }
    static {
      this.ɵfac = function HmfAccordionComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfAccordionComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfAccordionComponent,
        selectors: [["hmf-accordion"]],
        inputs: {
          label: "label",
          classList: "classList",
          testId: "testId",
          icon: "icon",
          subLabel: "subLabel",
          layout: "layout",
          countStyle: "countStyle",
          labelStyle: "labelStyle",
          loading: "loading",
          size: "size",
          count: "count",
          expandOverContent: "expandOverContent",
          variant: "variant",
          active: "active"
        },
        outputs: {
          activeChange: "activeChange"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c1,
        decls: 2,
        vars: 1,
        consts: [[3, "class"], ["ref", "{ref}", "data-testid", "{testId}", 3, "class", "ngClass"], ["ref", "{ref}", "data-testid", "{testId}", 3, "ngClass"], [3, "click", "ngClass"], [1, "hmf-display-flex", "hmf-align-items-flex-start"], ["width", "16px", "height", "16px", 1, "hmf-mr-xxs", "hmf-display-flex", 3, "name"], [1, "hmf-display-flex", "hmf-flex-column", "hmf-align-items-flex-start", 3, "ngClass"], [1, "hmf-accordion-end-adornment", "hmf-display-flex", "hmf-align-items-center"], [1, "hmf-accordion-count", 3, "ngClass"], ["name", "chevron-up", 3, "width", "height"], ["name", "chevron-down", 3, "width", "height"], [1, "hmf-accordion-content", "hmf-py-0", "hmf-px-s", "hmf-display-flex", "hmf-flex-column", 3, "ngClass"], [1, "hmf-body-s", "hmf-text-align-left", 3, "ngClass"]],
        template: function HmfAccordionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵtemplate(0, HmfAccordionComponent_Conditional_0_Template, 1, 4, "div", 0)(1, HmfAccordionComponent_Conditional_1_Template, 12, 28, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.loading ? 0 : 1);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: [".hmf-accordion[_ngcontent-%COMP%]{min-width:300px;position:relative;width:100%}.hmf-accordion[_ngcontent-%COMP%], .hmf-accordion[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{box-sizing:border-box}.hmf-accordion.loading[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_gradient 2s ease infinite;background:var(--hmf-gray500) linear-gradient(90deg,var(--hmf-gray500),var(--hmf-gray500),var(--hmf-gray500),var(--hmf-gray50),var(--hmf-gray500),var(--hmf-gray500),var(--hmf-gray500))}@keyframes _ngcontent-%COMP%_gradient{0%{background-position:100% 50%}to{background-position:0 50%}}.hmf-accordion-button-container[_ngcontent-%COMP%]{flex:1}.hmf-accordion-xlarge[_ngcontent-%COMP%]{min-height:96px}.hmf-accordion-xlarge.loading[_ngcontent-%COMP%]{background-size:800% 96px}.hmf-accordion-xlarge[_ngcontent-%COMP%]   .hmf-accordion-label-and-control[_ngcontent-%COMP%]{min-height:95px;width:100%}.hmf-accordion-large[_ngcontent-%COMP%]{min-height:56px}.hmf-accordion-large.loading[_ngcontent-%COMP%]{background-size:800% 56px}.hmf-accordion-large[_ngcontent-%COMP%]   .hmf-accordion-label-and-control[_ngcontent-%COMP%]{min-height:55px;padding:var(--hmf-xxs) 0;width:100%}.hmf-accordion-medium[_ngcontent-%COMP%], .hmf-accordion-small[_ngcontent-%COMP%]{min-height:44px}.hmf-accordion-medium.loading[_ngcontent-%COMP%], .hmf-accordion-small.loading[_ngcontent-%COMP%]{background-size:800% 44px}.hmf-accordion-medium[_ngcontent-%COMP%]   .hmf-accordion-label-and-control[_ngcontent-%COMP%], .hmf-accordion-small[_ngcontent-%COMP%]   .hmf-accordion-label-and-control[_ngcontent-%COMP%]{min-height:43px}.hmf-accordion-label-and-control[_ngcontent-%COMP%]{background-color:var(--hmf-fill-secondary-static);border:none;border-top:1px solid var(--hmf-border-base);color:var(--hmf-label-base);cursor:pointer;outline:1px dashed transparent;transition:border-color var(--hmf-ease-in-out-fast),color var(--hmf-ease-in-out-fast),outline var(--hmf-ease-in-out-fast),outline-offset var(--hmf-ease-in-out-fast);width:100%}.hmf-accordion-label-and-control-without-divider[_ngcontent-%COMP%]{border-top:none}.hmf-accordion-label-and-control[_ngcontent-%COMP%]:focus{outline:1px dashed var(--hmf-gray600);outline-offset:3px}.hmf-accordion-label-and-control[_ngcontent-%COMP%]   .hmf-accordion-end-adornment[_ngcontent-%COMP%]{color:var(--hmf-gray500)}.hmf-accordion-label-and-control-open[_ngcontent-%COMP%]{border-bottom:none}.hmf-accordion-label-and-control[_ngcontent-%COMP%]:hover{background-color:var(--hmf-fill-secondary-hover)}.hmf-accordion-label-and-control[_ngcontent-%COMP%]:active{background-color:var(--hmf-fill-secondary-active)}.hmf-accordion-content[_ngcontent-%COMP%]{background-color:var(--hmf-gray50);border:none;border-bottom:1px solid var(--hmf-border-base);color:var(--hmf-label-base);max-height:0;overflow:hidden;position:absolute;top:calc(100% - 1px);transition:max-height var(--hmf-ease-out-fast),padding var(--hmf-ease-out-fast);width:100%}.hmf-accordion-content-without-divider[_ngcontent-%COMP%]{border-bottom:none}.hmf-accordion-content.hmf-accordion-content-visible[_ngcontent-%COMP%]{max-height:none}.hmf-accordion.hmf-accordion-push-content[_ngcontent-%COMP%]{padding-bottom:0}.hmf-accordion.hmf-accordion-push-content[_ngcontent-%COMP%]   .hmf-accordion-content[_ngcontent-%COMP%]{position:static;top:unset}.hmf-accordion[_ngcontent-%COMP%]   .outlined-top[_ngcontent-%COMP%]{border-top:2px solid var(--hmf-border-inverse)}.hmf-accordion[_ngcontent-%COMP%]   .hmf-accordion-label-and-control[_ngcontent-%COMP%]{padding:0 var(--hmf-s)}.hmf-accordion[_ngcontent-%COMP%]   .hmf-accordion-count[_ngcontent-%COMP%]{color:var(--hmf-label-base-subtle);padding-right:var(--hmf-s)}"]
      });
    }
  }
  return HmfAccordionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfActionTextComponent = /*#__PURE__*/(() => {
  class HmfActionTextComponent {
    get getTabIndex() {
      return this.disabled ? '-1' : this.tabIndex;
    }
    get getVariantApplication() {
      const getFontClass = () => {
        switch (this.variant) {
          case 'primary':
          case 'secondary':
            {
              switch (this.size) {
                case 'large':
                  return 'hmf-body-bold-l';
                case 'small':
                  return 'hmf-body-bold-s';
                default:
                  return 'hmf-body-bold-m';
              }
            }
          default:
            {
              switch (this.size) {
                case 'large':
                  return 'hmf-body-l';
                case 'small':
                  return 'hmf-body-s';
                default:
                  return 'hmf-body-m';
              }
            }
        }
      };
      return ['homefield-textlink', 'homefield-actiontext', `homefield-textlink-${this.variant}`, getFontClass(), this.classList].join(' ');
    }
    get isAriaDisabled() {
      return !!this.disabled;
    }
    get isDisabled() {
      return this.disabled || null;
    }
    constructor(homefieldIconsLibraryService, elementRef) {
      this.homefieldIconsLibraryService = homefieldIconsLibraryService;
      this.elementRef = elementRef;
      this.variant = 'primary';
      this.size = 'medium';
      this.disabled = false;
      this.classList = '';
      this.tabIndex = '0';
      this.role = 'button';
      this.preventButtonClick = e => {
        if (this.disabled) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      };
      this.handleKeyboardClick = e => {
        if (e.key === ' ' || e.key === 'Enter') {
          this.elementRef.nativeElement.click();
        }
      };
      /**
       * Fulfill the requirements of ARIA's role="button" if the element isn't a native <button>
       * element. This involves:
       *
       * 1. Ensuring that the button can be disabled, and
       * 2. Ensuring that "click" events can be triggered by the "space" and "enter" keys
       *
       * See: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role#required_javascript_features
       */
      if (this.elementRef.nativeElement.tagName !== 'BUTTON') {
        this.elementRef.nativeElement.addEventListener('click', this.preventButtonClick);
        this.elementRef.nativeElement.addEventListener('keydown', this.handleKeyboardClick);
      }
      this.homefieldIconsLibraryService.registerIcons([homefieldIconLocationPinFilled, homefieldIconArrowRight, homefieldIconAlertInfoFilled]);
    }
    onDestroy() {
      this.elementRef.nativeElement.removeEventListener('click', this.preventButtonClick);
      this.elementRef.nativeElement.removeEventListener('keydown', this.handleKeyboardClick);
    }
    static {
      this.ɵfac = function HmfActionTextComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfActionTextComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfActionTextComponent,
        selectors: [["hmf-action-text"], ["span", "hmf-action-text", ""], ["button", "hmf-action-text", ""]],
        hostVars: 6,
        hostBindings: function HmfActionTextComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵhostProperty("tabIndex", ctx.getTabIndex);
            i0.ɵɵattribute("role", ctx.role)("aria-disabled", ctx.isAriaDisabled)("disabled", ctx.isDisabled);
            i0.ɵɵclassMap(ctx.getVariantApplication);
          }
        },
        inputs: {
          variant: "variant",
          size: "size",
          disabled: "disabled",
          startIconName: "startIconName",
          endIconName: "endIconName",
          classList: "classList",
          tabIndex: "tabIndex"
        },
        ngContentSelectors: _c6,
        decls: 3,
        vars: 2,
        consts: [["class", "hmf-mr-xxxs hmf-display-flex hmf-align-items-center", 3, "name", "width", "height", 4, "ngIf"], ["class", "hmf-mr-0 hmf-ml-xxxs hmf-display-flex hmf-align-items-center", 3, "name", "width", "height", 4, "ngIf"], [1, "hmf-mr-xxxs", "hmf-display-flex", "hmf-align-items-center", 3, "name", "width", "height"], [1, "hmf-mr-0", "hmf-ml-xxxs", "hmf-display-flex", "hmf-align-items-center", 3, "name", "width", "height"]],
        template: function HmfActionTextComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, HmfActionTextComponent_homefield_icon_0_Template, 1, 3, "homefield-icon", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵtemplate(2, HmfActionTextComponent_homefield_icon_2_Template, 1, 3, "homefield-icon", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.startIconName);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.endIconName);
          }
        },
        dependencies: [CommonModule, i1$1.NgIf, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: [".homefield-textlink[_ngcontent-%COMP%], [_nghost-%COMP%]{align-content:center;align-items:center;color:var(--hmf-label-secondary-static);display:inline-flex;outline:1px dashed transparent;text-decoration:underline;text-decoration-thickness:var(--hmf-ease-in-out-fast);text-underline-offset:6px}.homefield-textlink[_ngcontent-%COMP%]   .homefield-textlink-transition[_ngcontent-%COMP%], [_nghost-%COMP%]   .homefield-textlink-transition[_ngcontent-%COMP%]{transition:color var(--hmf-ease-in-out-fast),outline var(--hmf-ease-in-out-fast),outline-offset var(--hmf-ease-in-out-fast)}.homefield-textlink[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], [_nghost-%COMP%]   svg[_ngcontent-%COMP%]{margin-right:var(--hmf-xxxs)}.homefield-textlink[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]:last-child, [_nghost-%COMP%]   svg[_ngcontent-%COMP%]:last-child{margin-left:var(--hmf-xxxs);margin-right:0}.homefield-textlink[_ngcontent-%COMP%]     homefield-icon svg path, [_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-label-secondary-static)}.homefield-textlink[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-static)}.homefield-textlink[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]:focus{outline:1px dashed var(--hmf-label-secondary-active);outline-offset:3px}.homefield-textlink[_ngcontent-%COMP%]:hover, [_nghost-%COMP%]:hover{color:var(--hmf-label-secondary-hover);cursor:pointer;text-decoration-color:var(--hmf-border-tertiary-hover);text-decoration-thickness:1.5px}.homefield-textlink[_ngcontent-%COMP%]:hover     homefield-icon svg path, [_nghost-%COMP%]:hover     homefield-icon svg path{fill:var(--hmf-label-secondary-hover)}.homefield-textlink[_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-hover)}.homefield-textlink[_ngcontent-%COMP%]:visited, [_nghost-%COMP%]:visited{color:var(--hmf-label-secondary-active)}.homefield-textlink[_ngcontent-%COMP%]:visited     homefield-icon svg path, [_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-secondary-active)}.homefield-textlink[_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-active)}.homefield-textlink[_ngcontent-%COMP%]:active, [_nghost-%COMP%]:active{color:var(--hmf-label-secondary-active);text-decoration-color:var(--hmf-border-tertiary-hover);text-decoration-thickness:1.5px}.homefield-textlink[_ngcontent-%COMP%]:active     homefield-icon svg path, [_nghost-%COMP%]:active     homefield-icon svg path{fill:var(--hmf-label-secondary-active)}.homefield-textlink[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-active)}.homefield-textlink[_ngcontent-%COMP%]:active:visited, [_nghost-%COMP%]:active:visited{color:var(--hmf-label-secondary-active)}.homefield-textlink[_ngcontent-%COMP%]:active:visited     homefield-icon svg path, [_nghost-%COMP%]:active:visited     homefield-icon svg path{fill:var(--hmf-label-secondary-active)}.homefield-textlink[_ngcontent-%COMP%]:active:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [_nghost-%COMP%]:active:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-active)}.homefield-textlink[aria-disabled=true][_ngcontent-%COMP%], .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:hover, .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:focus, .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:active, .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:visited, [aria-disabled=true][_nghost-%COMP%], [aria-disabled=true][_nghost-%COMP%]:hover, [aria-disabled=true][_nghost-%COMP%]:focus, [aria-disabled=true][_nghost-%COMP%]:active, [aria-disabled=true][_nghost-%COMP%]:visited{color:var(--hmf-label-disabled);cursor:default;pointer-events:none;text-decoration-color:var(--hmf-border-disabled);text-decoration-thickness:1px}.homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:focus     homefield-icon svg path, .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:visited     homefield-icon svg path, [aria-disabled=true][_nghost-%COMP%]     homefield-icon svg path, [aria-disabled=true][_nghost-%COMP%]:hover     homefield-icon svg path, [aria-disabled=true][_nghost-%COMP%]:focus     homefield-icon svg path, [aria-disabled=true][_nghost-%COMP%]:active     homefield-icon svg path, [aria-disabled=true][_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-disabled)}.homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink[aria-disabled=true][_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [aria-disabled=true][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [aria-disabled=true][_nghost-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [aria-disabled=true][_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [aria-disabled=true][_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-disabled)}.homefield-textlink.homefield-textlink-secondary[_ngcontent-%COMP%], .homefield-textlink-secondary[_nghost-%COMP%]{color:var(--hmf-label-secondary-static);text-decoration-color:var(--hmf-label-secondary-static);text-decoration-thickness:1px;text-underline-offset:3px}.homefield-textlink.homefield-textlink-secondary[_ngcontent-%COMP%]:hover, .homefield-textlink-secondary[_nghost-%COMP%]:hover{color:var(--hmf-label-secondary-hover);text-decoration-color:var(--hmf-label-secondary-hover);text-decoration-thickness:1px}.homefield-textlink.homefield-textlink-secondary[_ngcontent-%COMP%]:active, .homefield-textlink-secondary[_nghost-%COMP%]:active{color:var(--hmf-label-secondary-active);text-decoration-color:var(--hmf-label-secondary-active);text-decoration-thickness:1px}.homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:hover, .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:focus, .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:active, .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:visited, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%], .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:hover, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:focus, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:active, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:visited{color:var(--hmf-label-disabled);cursor:default;pointer-events:none;text-decoration-color:var(--hmf-label-disabled);text-decoration-thickness:1px}.homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:focus     homefield-icon svg path, .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:visited     homefield-icon svg path, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]     homefield-icon svg path, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:focus     homefield-icon svg path, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:active     homefield-icon svg path, .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-disabled)}.homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-secondary[aria-disabled=true][_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-secondary[aria-disabled=true][_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-disabled)}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%], .homefield-textlink-tertiary[_nghost-%COMP%]{color:var(--hmf-label-secondary-subtle-static);text-decoration-color:var(--hmf-label-secondary-subtle-static);text-underline-offset:3px}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink-tertiary[_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-label-secondary-subtle-static)}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-subtle-static)}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]:hover, .homefield-textlink-tertiary[_nghost-%COMP%]:hover{color:var(--hmf-label-secondary-subtle-hover);text-decoration-color:var(--hmf-label-secondary-subtle-hover);text-decoration-thickness:1px}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-tertiary[_nghost-%COMP%]:hover     homefield-icon svg path{fill:var(--hmf-label-secondary-subtle-hover)}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-subtle-hover)}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]:active, .homefield-textlink-tertiary[_nghost-%COMP%]:active{color:var(--hmf-label-secondary-subtle-active);text-decoration-color:var(--hmf-label-secondary-subtle-active);text-decoration-thickness:1px}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink-tertiary[_nghost-%COMP%]:active     homefield-icon svg path{fill:var(--hmf-label-secondary-subtle-active)}.homefield-textlink.homefield-textlink-tertiary[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-subtle-active)}.homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:hover, .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:focus, .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:active, .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:visited, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%], .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:hover, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:focus, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:active, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:visited{color:var(--hmf-label-disabled);cursor:default;pointer-events:none;text-decoration-color:var(--hmf-label-disabled);text-decoration-thickness:1px}.homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:focus     homefield-icon svg path, .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:visited     homefield-icon svg path, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]     homefield-icon svg path, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:focus     homefield-icon svg path, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:active     homefield-icon svg path, .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-disabled)}.homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-tertiary[aria-disabled=true][_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-tertiary[aria-disabled=true][_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-disabled)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%], .homefield-textlink-group[_nghost-%COMP%]{color:var(--hmf-label-secondary-static);text-decoration:none}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink-group[_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-label-secondary-static)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-static)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]:hover, .homefield-textlink-group[_nghost-%COMP%]:hover{color:var(--hmf-label-secondary-hover);text-decoration:underline;text-decoration-color:var(--hmf-label-secondary-hover)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-group[_nghost-%COMP%]:hover     homefield-icon svg path{fill:var(--hmf-label-secondary-hover)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-hover)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]:active, .homefield-textlink-group[_nghost-%COMP%]:active{color:var(--hmf-label-secondary-active);text-decoration:underline;text-decoration-color:var(--hmf-label-secondary-active)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink-group[_nghost-%COMP%]:active     homefield-icon svg path{fill:var(--hmf-label-secondary-active)}.homefield-textlink.homefield-textlink-group[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-active)}.homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:hover, .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:focus, .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:active, .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:visited, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%], .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:hover, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:focus, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:active, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:visited{color:var(--hmf-label-disabled);cursor:default;pointer-events:none;text-decoration:none}.homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:focus     homefield-icon svg path, .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:visited     homefield-icon svg path, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]     homefield-icon svg path, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:focus     homefield-icon svg path, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:active     homefield-icon svg path, .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-disabled)}.homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group[aria-disabled=true][_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group[aria-disabled=true][_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-disabled)}.homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%], .homefield-textlink-inverse[_nghost-%COMP%]{color:var(--hmf-label-inverse);text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:3px}.homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink-inverse[_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]:focus, .homefield-textlink-inverse[_nghost-%COMP%]:focus{outline-color:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]:hover, .homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]:active, .homefield-textlink-inverse[_nghost-%COMP%]:hover, .homefield-textlink-inverse[_nghost-%COMP%]:active{color:var(--hmf-label-inverse);text-decoration-thickness:1.5px}.homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink-inverse[_nghost-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-inverse[_nghost-%COMP%]:active     homefield-icon svg path{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-inverse[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:hover, .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:focus, .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:active, .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:visited, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%], .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:hover, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:focus, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:active, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:visited{color:var(--hmf-label-disabled-subtle);cursor:default;pointer-events:none;text-decoration-color:var(--hmf-label-disabled-subtle);text-decoration-thickness:1px}.homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:focus     homefield-icon svg path, .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:visited     homefield-icon svg path, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]     homefield-icon svg path, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:focus     homefield-icon svg path, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:active     homefield-icon svg path, .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-disabled-subtle)}.homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-inverse[aria-disabled=true][_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-inverse[aria-disabled=true][_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-disabled-subtle)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%], .homefield-textlink-group-inverse[_nghost-%COMP%]{color:var(--hmf-label-inverse);text-decoration:none}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink-group-inverse[_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]:focus, .homefield-textlink-group-inverse[_nghost-%COMP%]:focus{outline-color:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]:hover, .homefield-textlink-group-inverse[_nghost-%COMP%]:hover{color:var(--hmf-label-inverse);text-decoration:underline;text-decoration-color:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-group-inverse[_nghost-%COMP%]:hover     homefield-icon svg path{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]:active, .homefield-textlink-group-inverse[_nghost-%COMP%]:active{color:var(--hmf-label-inverse);text-decoration:underline;text-decoration-color:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink-group-inverse[_nghost-%COMP%]:active     homefield-icon svg path{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-inverse)}.homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:hover, .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:focus, .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:active, .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:visited, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%], .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:hover, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:focus, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:active, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:visited{color:var(--hmf-label-disabled-subtle);cursor:default;pointer-events:none;text-decoration:none}.homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:focus     homefield-icon svg path, .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:visited     homefield-icon svg path, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]     homefield-icon svg path, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:focus     homefield-icon svg path, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:active     homefield-icon svg path, .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-disabled-subtle)}.homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-group-inverse[aria-disabled=true][_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-group-inverse[aria-disabled=true][_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-disabled-subtle)}.homefield-textlink.homefield-textlink-sponsored[_ngcontent-%COMP%], .homefield-textlink-sponsored[_nghost-%COMP%]{color:var(--hmf-label-secondary-static);text-decoration:none}.homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]     homefield-icon svg path, .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:focus     homefield-icon svg path, .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:active     homefield-icon svg path, .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:visited     homefield-icon svg path, .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]     homefield-icon svg path, .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:focus     homefield-icon svg path, .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:active     homefield-icon svg path, .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:visited     homefield-icon svg path{fill:var(--hmf-label-secondary-static)}.homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:focus   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:visited   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-static)}.homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:hover, .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:hover{color:var(--hmf-label-secondary-hover)}.homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:hover     homefield-icon svg path, .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:hover     homefield-icon svg path{fill:var(--hmf-label-secondary-hover);transition:fill var(--hmf-ease-in-out-fast)}.homefield-textlink.homefield-textlink-sponsored[aria-disabled=false][_ngcontent-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textlink-sponsored[aria-disabled=false][_nghost-%COMP%]:hover   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-hover);transition:fill var(--hmf-ease-in-out-fast)}button.homefield-actiontext[_ngcontent-%COMP%], [_nghost-%COMP%]{background:none;border:none;color:inherit;cursor:pointer;font:inherit;outline:inherit;padding:0;text-align:start}"]
      });
    }
  }
  return HmfActionTextComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfTextLinkComponent = /*#__PURE__*/(() => {
  class HmfTextLinkComponent {
    get getLinkUrl() {
      return this.disabled ? null : this.linkURL;
    }
    get getVariantApplication() {
      const getFontClass = () => {
        switch (this.variant) {
          case 'primary':
          case 'secondary':
            {
              switch (this.size) {
                case 'large':
                  return 'hmf-body-bold-l';
                case 'small':
                  return 'hmf-body-bold-s';
                default:
                  return 'hmf-body-bold-m';
              }
            }
          default:
            {
              switch (this.size) {
                case 'large':
                  return 'hmf-body-l';
                case 'small':
                  return 'hmf-body-s';
                default:
                  return 'hmf-body-m';
              }
            }
        }
      };
      return ['homefield-textlink', `homefield-textlink-${this.variant}`, getFontClass(), this.isTransitionEnabled ? 'homefield-textlink-transition' : '', this.classList].join(' ');
    }
    get getTarget() {
      return this.LinkTargets[this.target];
    }
    get isDisabled() {
      return this.disabled;
    }
    constructor(homefieldIconsLibraryService) {
      this.homefieldIconsLibraryService = homefieldIconsLibraryService;
      this.LinkTargets = {
        blank: '_blank',
        self: '_self',
        parent: '_parent',
        top: '_top'
      };
      this.variant = 'primary';
      this.size = 'medium';
      this.disabled = false;
      this.target = 'self';
      this.linkURL = '';
      this.classList = '';
      this.isTransitionEnabled = false;
      this.ariaLabel = '';
      this.altText = '';
      this.dataEm = '';
      this.tabindex = '0';
      this.homefieldIconsLibraryService.registerIcons([homefieldIconLocationPinFilled, homefieldIconArrowRight]);
    }
    static {
      this.ɵfac = function HmfTextLinkComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfTextLinkComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfTextLinkComponent,
        selectors: [["hmf-text-link"], ["a", "hmf-text-link", ""]],
        hostVars: 9,
        hostBindings: function HmfTextLinkComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-label", ctx.ariaLabel)("alt", ctx.altText)("data-em", ctx.dataEm)("href", ctx.getLinkUrl, i0.ɵɵsanitizeUrl)("target", ctx.getTarget)("aria-disabled", ctx.isDisabled)("tabindex", ctx.tabindex);
            i0.ɵɵclassMap(ctx.getVariantApplication);
          }
        },
        inputs: {
          variant: "variant",
          size: "size",
          disabled: "disabled",
          startIconName: "startIconName",
          endIconName: "endIconName",
          target: "target",
          linkURL: "linkURL",
          classList: "classList",
          isTransitionEnabled: "isTransitionEnabled",
          ariaLabel: "ariaLabel",
          altText: "altText",
          dataEm: "dataEm"
        },
        ngContentSelectors: _c6,
        decls: 3,
        vars: 2,
        consts: [["class", "hmf-mr-xxxs hmf-display-flex hmf-align-items-center", 3, "name", "width", "height", 4, "ngIf"], ["class", "hmf-mr-0 hmf-ml-xxxs hmf-display-flex hmf-align-items-center", 3, "name", "width", "height", 4, "ngIf"], [1, "hmf-mr-xxxs", "hmf-display-flex", "hmf-align-items-center", 3, "name", "width", "height"], [1, "hmf-mr-0", "hmf-ml-xxxs", "hmf-display-flex", "hmf-align-items-center", 3, "name", "width", "height"]],
        template: function HmfTextLinkComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, HmfTextLinkComponent_homefield_icon_0_Template, 1, 3, "homefield-icon", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵtemplate(2, HmfTextLinkComponent_homefield_icon_2_Template, 1, 3, "homefield-icon", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.startIconName);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.endIconName);
          }
        },
        dependencies: [CommonModule, i1$1.NgIf, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: [_c7]
      });
    }
  }
  return HmfTextLinkComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
/** Pipe to sanitize entered text that might be parsed or displayed as HTML for any reason. */
let HtmlSanitizerPipe = /*#__PURE__*/(() => {
  class HtmlSanitizerPipe {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
    }
    transform(value) {
      return this.sanitizer.sanitize(SecurityContext.HTML, value ?? '');
    }
    static {
      this.ɵfac = function HtmlSanitizerPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HtmlSanitizerPipe)(i0.ɵɵdirectiveInject(i1$2.DomSanitizer, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "hfSanitizeHtml",
        type: HtmlSanitizerPipe,
        pure: true
      });
    }
  }
  return HtmlSanitizerPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfAlertBannerComponent = /*#__PURE__*/(() => {
  class HmfAlertBannerComponent {
    constructor(homefieldIconsLibraryService, elementRef) {
      this.homefieldIconsLibraryService = homefieldIconsLibraryService;
      this.elementRef = elementRef;
      this.element = '';
      this.type = input('info');
      this.title = input('');
      this.message = input('');
      this.variant = input('banner');
      this.link = input('');
      this.linkTitle = input('');
      this.customClass = input('');
      this.DEFAULT_ICON_SIZE = {
        width: '14px',
        height: '14px'
      };
      this.ICON_CONFIG_MAP = {
        alert: {
          ...this.DEFAULT_ICON_SIZE,
          name: IconName.CANCEL,
          class: IconClass.CANCEL,
          fill: 'var(--hmf-label-negative)'
        },
        warn: {
          ...this.DEFAULT_ICON_SIZE,
          name: IconName.WARNING,
          class: IconClass.WARNING,
          fill: 'var(--hmf-label-warning)'
        },
        success: {
          ...this.DEFAULT_ICON_SIZE,
          name: IconName.CHECK,
          class: IconClass.SUCCESS,
          fill: 'var(--hmf-label-positive)'
        },
        info: {
          ...this.DEFAULT_ICON_SIZE,
          name: IconName.INFO,
          class: IconClass.INFO,
          fill: 'var(--hmf-label-base)'
        }
      };
      this.messageIconConfig = computed(() => {
        return this.ICON_CONFIG_MAP[this.type()];
      });
      this.generalClasses = computed(() => {
        let classes = this.customClass() || '';
        classes += this.type();
        if (this.variant() === 'banner') {
          classes += ' alert-message hmf-px-s hmf-py-xs';
        } else {
          classes += ' hmf-p-xxs';
        }
        return classes;
      });
      this.homefieldIconsLibraryService.registerIcons([homefieldIconAlertReportFilled, homefieldIconAlertWarningFilled, homefieldIconSignCircledCheck, homefieldIconAlertInfoFilled]);
      this.element = this.elementRef.nativeElement?.tagName?.toLowerCase();
    }
    static {
      this.ɵfac = function HmfAlertBannerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfAlertBannerComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfAlertBannerComponent,
        selectors: [["hmf-alert-banner"]],
        inputs: {
          type: [1, "type"],
          title: [1, "title"],
          message: [1, "message"],
          variant: [1, "variant"],
          link: [1, "link"],
          linkTitle: [1, "linkTitle"],
          customClass: [1, "customClass"]
        },
        decls: 7,
        vars: 12,
        consts: [[1, "hmf-display-flex", "hmf-flex-row", "hmf-flex-grow-none", 3, "ngClass"], [1, "hms-py-0", "hmf-pl-xxxs", 3, "ngClass"], [3, "width", "height", "name", "fill"], [1, "hmf-ml-xxs", "hmf-flex-column"], [1, "hmf-body-bold-l", 3, "innerHTML"], [1, "hmf-pr-m", "hmf-pt-xxxxs"], ["hmf-text-link", "", 1, "hmf-text-decoration-underline", "hmf-body-s", "hmf-mt-xxxs", 3, "linkURL", "variant"], [1, "hmf-body-s", 3, "innerHTML"]],
        template: function HmfAlertBannerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵdeclareLet(2);
            i0.ɵɵelement(3, "homefield-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 3);
            i0.ɵɵtemplate(5, HmfAlertBannerComponent_Conditional_5_Template, 3, 3, "div")(6, HmfAlertBannerComponent_Conditional_6_Template, 2, 2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.generalClasses());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c8, !!ctx.title() && !!ctx.message()));
            const icon_r2 = ctx.messageIconConfig();
            i0.ɵɵadvance(2);
            i0.ɵɵclassMap(icon_r2.class);
            i0.ɵɵproperty("width", icon_r2.width)("height", icon_r2.height)("name", icon_r2.name)("fill", icon_r2.fill);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.title() ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.variant() === "banner" ? 6 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent, HtmlSanitizerPipe, HmfTextLinkComponent],
        styles: [".alert-message[_ngcontent-%COMP%]{color:var(--hmf-label-base);padding-right:20px}.alert-message.alert[_ngcontent-%COMP%]{background-color:var(--hmf-fill-negative-subtle-static)}.alert-message.warn[_ngcontent-%COMP%]{background-color:var(--hmf-fill-warning-subtle-static)}.alert-message.success[_ngcontent-%COMP%]{background-color:var(--hmf-fill-positive-subtle-static)}.alert-message.info[_ngcontent-%COMP%]{background-color:var(--hmf-fill-base-subtle)}"]
      });
    }
  }
  return HmfAlertBannerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfBadgeComponent = /*#__PURE__*/(() => {
  class HmfBadgeComponent {
    constructor() {
      this.badgeName = '';
      this.badgeStyles = {};
    }
    ngOnChanges() {
      this.badgeName = this.cleanUpBadgeName();
      this.setBadgeValue();
    }
    cleanUpBadgeName() {
      return this.badgeName.trim();
    }
    setBadgeValue() {
      const trimmedName = this.badgeName.trim();
      const cleanedName = removeWhiteSpaces(trimmedName);
      const foundBadgeByValue = Object.values(badgeData).find(badge => badge.value === trimmedName);
      const foundBadgeByCleanedValue = Object.values(badgeData).find(badge => badge.value === cleanedName);
      const foundBadgeByKey = badgeData[trimmedName] || badgeData[cleanedName];
      const selectedBadge = foundBadgeByValue || foundBadgeByCleanedValue || foundBadgeByKey;
      if (selectedBadge) {
        this.badgeValue = selectedBadge.value;
        this.badgeStyles = {
          background: selectedBadge.backgroundColor,
          color: selectedBadge.textColor
        };
      } else {
        this.badgeValue = trimmedName;
        this.badgeStyles = {};
      }
    }
    get getVariantApplication() {
      if (this.badgeName == '') {
        return `hmf-badge hmf-display-none`;
      }
      return `hmf-badge hmf-body-bold-s hmf-sharp-radius hmf-px-xs hmf-display-inline-flex hmf-align-items-center`;
    }
    get getVariantApplication1() {
      return this.badgeStyles;
    }
    static {
      this.ɵfac = function HmfBadgeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfBadgeComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfBadgeComponent,
        selectors: [["hmf-badge"]],
        hostVars: 4,
        hostBindings: function HmfBadgeComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.getVariantApplication1);
            i0.ɵɵclassMap(ctx.getVariantApplication);
          }
        },
        inputs: {
          badgeName: "badgeName"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 2,
        vars: 1,
        template: function HmfBadgeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "span");
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.badgeValue, "\n");
          }
        },
        dependencies: [CommonModule],
        styles: [".hmf-badge[_ngcontent-%COMP%], [_nghost-%COMP%]{background-color:var(--hmf-badge-default-background-color);color:var(--hmf-badge-default-text-color);height:var(--hmf-badge-height);width:auto}"]
      });
    }
  }
  return HmfBadgeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfDividerComponent = /*#__PURE__*/(() => {
  class HmfDividerComponent {
    constructor() {
      this.vertical = false;
      // public variant = input<TVariant>('default');
      this.variant = 'default';
    }
    get getClassesByVariant() {
      const defaultClasses = `hmf-display-block`;
      let variantClasses = this.vertical ? `${defaultClasses} hmf-divider-vertical` : `${defaultClasses} hmf-divider-horizontal`;
      switch (this.variant) {
        case 'subtle':
          variantClasses += ` hmf-divider-${this.variant} hmf-border-subtle`;
          break;
        case 'prominent':
          variantClasses += ` hmf-divider-${this.variant} hmf-border-base-prominent`;
          break;
        default:
          break;
      }
      return variantClasses;
    }
    static {
      this.ɵfac = function HmfDividerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfDividerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfDividerComponent,
        selectors: [["hmf-divider"]],
        hostVars: 2,
        hostBindings: function HmfDividerComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.getClassesByVariant);
          }
        },
        inputs: {
          vertical: "vertical",
          variant: "variant"
        },
        decls: 0,
        vars: 0,
        template: function HmfDividerComponent_Template(rf, ctx) {},
        dependencies: [CommonModule],
        styles: [".hmf-divider-horizontal[_ngcontent-%COMP%], .hmf-divider-horizontal[_nghost-%COMP%]{background-color:var(--hmf-border-base);border:none;height:1px;width:auto}.hmf-divider-vertical[_ngcontent-%COMP%], .hmf-divider-vertical[_nghost-%COMP%]{background-color:var(--hmf-border-base);min-height:100%;width:1px}.hmf-divider-subtle[_ngcontent-%COMP%], .hmf-divider-subtle[_nghost-%COMP%]{background-color:var(--hmf-border-subtle)}.hmf-divider-prominent[_ngcontent-%COMP%], .hmf-divider-prominent[_nghost-%COMP%]{background-color:var(--hmf-border-base-prominent)}"]
      });
    }
  }
  return HmfDividerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var ThemeVariant = /*#__PURE__*/function (ThemeVariant) {
  ThemeVariant["PRIMARY"] = "primary";
  ThemeVariant["SECONDARY"] = "secondary";
  return ThemeVariant;
}(ThemeVariant || {});
var SizeVariant = /*#__PURE__*/function (SizeVariant) {
  SizeVariant["LARGE"] = "large";
  SizeVariant["SMALL"] = "small";
  return SizeVariant;
}(SizeVariant || {});
var OptionDesignVariant = /*#__PURE__*/function (OptionDesignVariant) {
  OptionDesignVariant["LABEL"] = "label";
  OptionDesignVariant["LABELICON"] = "label+icon";
  OptionDesignVariant["LABELCHECKBOX"] = "label+checkbox";
  return OptionDesignVariant;
}(OptionDesignVariant || {});
var CircleVariantEnum = /*#__PURE__*/function (CircleVariantEnum) {
  CircleVariantEnum["LARGE"] = "large";
  CircleVariantEnum["MEDIUM"] = "medium";
  CircleVariantEnum["SMALL"] = "small";
  CircleVariantEnum["XSMALL"] = "xsmall";
  CircleVariantEnum["XXSMALL"] = "xxsmall";
  return CircleVariantEnum;
}(CircleVariantEnum || {});
var SelectorVariant = /*#__PURE__*/function (SelectorVariant) {
  SelectorVariant["CIRCULAR"] = "circular";
  SelectorVariant["RECTANGULAR"] = "rectangular";
  return SelectorVariant;
}(SelectorVariant || {});
var Spacing = /*#__PURE__*/function (Spacing) {
  Spacing["DEFAULT"] = "0";
  Spacing["XXXSMALL"] = "xxxs";
  Spacing["XXSMALL"] = "xxs";
  Spacing["XSMALL"] = "xs";
  Spacing["SMALL"] = "s";
  Spacing["MEDIUM"] = "m";
  Spacing["LARGE"] = "l";
  Spacing["XLARGE"] = "xl";
  Spacing["XXLARGE"] = "xxl";
  Spacing["XXXLARGE"] = "xxxl";
  Spacing["XXXXLARGE"] = "xxxxl";
  return Spacing;
}(Spacing || {});
/** @format */
let HmfBreadcrumbsComponent = /*#__PURE__*/(() => {
  class HmfBreadcrumbsComponent {
    constructor() {
      this.breadcrumbs = [];
      this.numOfShownBreadcrumbs = 3;
      this.truncate = true;
      this.currentPageIncluded = true;
      this.alignment = 'left';
      this.routerPresent = false;
      this.notifyRouter = new EventEmitter();
      this.ellipsis = true;
      this.Spacing = Spacing;
    }
    ngOnChanges() {
      this.ellipsis = this.truncate && this.breadcrumbs.length > this.numOfShownBreadcrumbs;
    }
    getDataEM(breadcrumb) {
      const regexSpaceSelector = / /g;
      return breadcrumb.seoToken ? `breadcrumb_${breadcrumb.seoToken.replace(regexSpaceSelector, '')}` : `breadcrumb_${breadcrumb.name.replace(regexSpaceSelector, '')}`;
    }
    navigateToRoute(event, breadcrumb) {
      if (this.routerPresent) {
        this.notifyRouter.emit(breadcrumb.url);
        event.preventDefault();
      }
    }
    static {
      this.ɵfac = function HmfBreadcrumbsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfBreadcrumbsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfBreadcrumbsComponent,
        selectors: [["hmf-breadcrumbs"]],
        inputs: {
          breadcrumbs: "breadcrumbs",
          numOfShownBreadcrumbs: "numOfShownBreadcrumbs",
          truncate: "truncate",
          currentPageIncluded: "currentPageIncluded",
          alignment: "alignment",
          routerPresent: "routerPresent"
        },
        outputs: {
          notifyRouter: "notifyRouter"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 2,
        vars: 2,
        consts: [["aria-label", "Breadcrumbs", "class", "hmf-display-m-block hmf-body-s breadcrumbs label-secondary-subtle-static", 4, "ngIf"], ["itemscope", "", "itemtype", "https://schema.org/BreadcrumbList", 4, "ngIf"], ["aria-label", "Breadcrumbs", 1, "hmf-display-m-block", "hmf-body-s", "breadcrumbs", "label-secondary-subtle-static"], ["itemscope", "", "itemtype", "https://schema.org/BreadcrumbList", 1, "breadcrumb-list", "hmf-pl-0", "hmf-mb-0", "hmf-display-flex", "hmf-flex-wrap", 3, "ngClass"], ["aria-label", "Show more breadcrumbs", "class", "breadcrumb-ellipsis", 3, "click", "keypress", 4, "ngIf"], ["class", "hmf-subheader-m", "itemprop", "itemListElement", "itemscope", "", "itemtype", "https://schema.org/ListItem", 4, "ngFor", "ngForOf"], ["aria-label", "Show more breadcrumbs", 1, "breadcrumb-ellipsis", 3, "click", "keypress"], ["itemprop", "itemListElement", "itemscope", "", "itemtype", "https://schema.org/ListItem", 1, "hmf-subheader-m"], [1, "hmf-display-flex"], ["aria-hidden", "true", "class", "breadcrumb-pipe", 4, "ngIf"], ["itemprop", "item", 1, "breadcrumb-link", "hmf-m-0", 3, "click", "ngClass", "href"], ["itemprop", "name", 1, "hmf-body-s", 3, "ngClass"], ["itemprop", "position", 3, "content"], ["aria-hidden", "true", 1, "breadcrumb-pipe"], [1, "hmf-mx-xxs", 3, "vertical"], ["itemscope", "", "itemtype", "https://schema.org/BreadcrumbList"], ["itemprop", "itemListElement", "itemscope", "", "itemtype", "https://schema.org/ListItem"], ["href", "/", "itemprop", "item", 1, "breadcrumbs"], ["itemprop", "name", 1, "breadcrumb-link", "hmf-body-s"], ["itemprop", "position", "content", "1"]],
        template: function HmfBreadcrumbsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HmfBreadcrumbsComponent_nav_0_Template, 4, 3, "nav", 0)(1, HmfBreadcrumbsComponent_span_1_Template, 6, 1, "span", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.breadcrumbs.length > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.breadcrumbs.length === 0 || ctx.breadcrumbs === null);
          }
        },
        dependencies: [HmfDividerComponent, CommonModule, i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf],
        styles: [".breadcrumbs[_ngcontent-%COMP%]{overflow:hidden;text-decoration:none}.breadcrumbs[_ngcontent-%COMP%]   .breadcrumb-list[_ngcontent-%COMP%]{list-style-type:none;row-gap:var(--hmf-xxxs)}.breadcrumbs[_ngcontent-%COMP%]   .breadcrumb-link[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-subtle-static);cursor:pointer;text-decoration:none}@media screen{.breadcrumbs[_ngcontent-%COMP%]   .breadcrumb-link[_ngcontent-%COMP%]:hover{color:var(--hmf-label-secondary-subtle-hover);text-decoration:underline var(--hmf-label-secondary-subtle-hover)}.breadcrumbs[_ngcontent-%COMP%]   .breadcrumb-link[_ngcontent-%COMP%]:focus{border:none;color:var(--hmf-label-secondary-subtle-active);text-decoration:underline var(--hmf-label-secondary-subtle-active)}}.breadcrumbs[_ngcontent-%COMP%]   .breadcrumb-link.no-interaction[_ngcontent-%COMP%]{cursor:default;pointer-events:none}.breadcrumbs[_ngcontent-%COMP%]   .breadcrumb-current[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-subtle-static)}.breadcrumbs[_ngcontent-%COMP%]   .breadcrumb-pipe[_ngcontent-%COMP%]{color:var(--hmf-border-base);height:20px}.breadcrumbs[_ngcontent-%COMP%]   .breadcrumb-ellipsis[_ngcontent-%COMP%]{cursor:pointer;text-decoration:none}"]
      });
    }
  }
  return HmfBreadcrumbsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfSelectorComponent = /*#__PURE__*/(() => {
  class HmfSelectorComponent {
    constructor() {
      this.altText = '';
      this.ariaLabel = '';
      this.circleVariant = 'medium';
      this.color = '';
      this.contained = false;
      this.dblBorder = false;
      this.disabled = false;
      this.height = '';
      this.imageSrc = '';
      this.selected = false;
      this.selector = 'circular';
      this.stroked = false;
      this.unavailable = false;
      this.width = '';
      this.imageError = output();
      this.loading = true;
      this.circularSelectorVariants = {
        large: 'cs-large-circle',
        medium: 'cs-medium-circle',
        small: 'cs-small-circle',
        xsmall: 'cs-xsmall-circle',
        xxsmall: 'cs-xxsmall-circle'
      };
    }
    ngOnInit() {
      this.onLoad();
    }
    onLoad() {
      this.loading = false;
    }
    onImageError() {
      this.loading = false;
      this.imageError.emit();
    }
    static {
      this.ɵfac = function HmfSelectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfSelectorComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfSelectorComponent,
        selectors: [["hmf-selector"]],
        inputs: {
          altText: "altText",
          ariaLabel: "ariaLabel",
          circleVariant: "circleVariant",
          color: "color",
          contained: "contained",
          dblBorder: "dblBorder",
          disabled: "disabled",
          height: "height",
          imageSrc: "imageSrc",
          selected: "selected",
          selector: "selector",
          stroked: "stroked",
          unavailable: "unavailable",
          width: "width"
        },
        outputs: {
          imageError: "imageError"
        },
        ngContentSelectors: _c12,
        decls: 6,
        vars: 33,
        consts: [["circularSelectorImage", ""], ["id", "hmf-circular-selector", 3, "ngClass", "ngStyle"], [3, "ngClass", "ngStyle"], [4, "ngIf"], [3, "ngTemplateOutlet"], [1, "rectangular-content"], ["loading", "lazy", 3, "src", "alt", "ngStyle", "load", "error", 4, "ngIf"], ["class", "color-swatch", 3, "ngStyle", 4, "ngIf"], ["loading", "lazy", 3, "load", "error", "src", "alt", "ngStyle"], [1, "color-swatch", 3, "ngStyle"]],
        template: function HmfSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c11);
            i0.ɵɵelementStart(0, "button", 1)(1, "div", 2);
            i0.ɵɵtemplate(2, HmfSelectorComponent_ng_container_2_Template, 2, 1, "ng-container", 3)(3, HmfSelectorComponent_ng_container_3_Template, 3, 0, "ng-container", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(4, HmfSelectorComponent_ng_template_4_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.circularSelectorVariants[ctx.circleVariant]);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction7(13, _c13, ctx.disabled, ctx.selected, ctx.contained, ctx.dblBorder, ctx.unavailable, ctx.selector === "rectangular", ctx.selector === "circular"))("ngStyle", ctx.selector === "rectangular" ? i0.ɵɵpureFunction2(21, _c14, ctx.height, ctx.width) : i0.ɵɵpureFunction0(24, _c15));
            i0.ɵɵattribute("aria-label", ctx.ariaLabel);
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate1("", ctx.circularSelectorVariants[ctx.circleVariant], " inner-circle-container");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(25, _c16, ctx.loading, ctx.selector === "rectangular", ctx.stroked))("ngStyle", ctx.selector === "rectangular" ? i0.ɵɵpureFunction2(29, _c14, ctx.height, ctx.width) : i0.ɵɵpureFunction0(32, _c15));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.selector === "circular");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.selector === "rectangular");
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgIf, i1$1.NgTemplateOutlet, i1$1.NgStyle],
        styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]   .cs-large-circle[_ngcontent-%COMP%]{height:180px;width:180px}[_nghost-%COMP%]   .cs-medium-circle[_ngcontent-%COMP%]{height:100px;width:100px}[_nghost-%COMP%]   .cs-small-circle[_ngcontent-%COMP%]{height:80px;width:80px}[_nghost-%COMP%]   .cs-xsmall-circle[_ngcontent-%COMP%]{height:36px;width:36px}[_nghost-%COMP%]   button[_ngcontent-%COMP%]{background:transparent;border:1px solid transparent;border-radius:50%;box-shadow:0 0 0 1px transparent;box-sizing:content-box;color:var(--hmf-gray900);padding:0;position:relative;width:100%}[_nghost-%COMP%]   button[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{background-color:transparent;border:1px solid transparent;border-radius:50%;box-sizing:border-box}[_nghost-%COMP%]   button[_ngcontent-%COMP%]   .inner-circle-container.rectangular-selector-button[_ngcontent-%COMP%]{border-radius:var(--hmf-sharp-radius)}[_nghost-%COMP%]   button[_ngcontent-%COMP%]   .rectangular-content[_ngcontent-%COMP%]{height:100%;position:relative;z-index:-10}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:2px solid transparent}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]:not(.unavailable)   .inner-circle-container[_ngcontent-%COMP%]{border:2px solid var(--hmf-border-secondary-static)}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]:not(.unavailable).is-dblborder{border:1px solid var(--hmf-border-secondary-static)}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]:not(.unavailable).is-dblborder   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-static)}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]:not(.unavailable).is-dblborder:hover   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-hover)}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]:not(.unavailable).is-dblborder:active   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-active)}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]:not(.unavailable).is-dblborder.disabled{border:1px dashed var(--hmf-border-disabled-subtle)}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]:not(.unavailable).is-dblborder.disabled   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-disabled)}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]{box-shadow:none}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]:hover{box-shadow:none}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]:hover   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-hover)}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:2px solid var(--hmf-border-secondary-static)}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-disabled);position:relative}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], [_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]   .color-swatch[_ngcontent-%COMP%]{opacity:.3}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:after{background-color:var(--hmf-border-disabled);content:\"\";height:2px;left:0;position:absolute;top:calc(50% - 1px);transform:rotate(135deg);width:100%}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]:active   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-active)}[_nghost-%COMP%]   button.is-selected.unavailable.is-dblborder[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-static)}[_nghost-%COMP%]   button.is-selected.unavailable.is-dblborder[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-static)}[_nghost-%COMP%]   button.is-selected.unavailable.is-dblborder[_ngcontent-%COMP%]:hover   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-hover)}[_nghost-%COMP%]   button.is-selected.unavailable.is-dblborder[_ngcontent-%COMP%]:active   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-active)}[_nghost-%COMP%]   button.is-selected.unavailable.is-dblborder.disabled[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-disabled-subtle)}[_nghost-%COMP%]   button.is-selected.unavailable.is-dblborder.disabled[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-disabled)}[_nghost-%COMP%]   button.is-selected.unavailable.rectangular-selector-button[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:before{border-color:var(--hmf-gray600);border-top:1px solid;content:\"\";left:50%;margin:0;position:absolute;top:50%;transform:translate(-50%,-50%) rotate(-45deg);width:40px}[_nghost-%COMP%]   button.is-selected.unavailable.rectangular-selector-button[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:after{content:\"\";display:none}[_nghost-%COMP%]   button.is-contained[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-subtle-static)}[_nghost-%COMP%]   button.rectangular-selector-button[_ngcontent-%COMP%]{border-radius:4px;height:auto;width:max-content}[_nghost-%COMP%]   button.rectangular-selector-button[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{height:auto;width:fit-content}[_nghost-%COMP%]   button.rectangular-selector-button.disabled[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-disabled);opacity:.5;position:relative}[_nghost-%COMP%]   button.rectangular-selector-button.disabled[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:before{border-color:var(--hmf-gray600);border-top:1px solid;content:\"\";left:50%;margin:0;position:absolute;top:50%;transform:translate(-50%,-50%) rotate(-45deg);width:40px}[_nghost-%COMP%]   button.rectangular-selector-button.disabled[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:after{content:\"\";display:none}[_nghost-%COMP%]   button[_ngcontent-%COMP%]   .is-loading[_ngcontent-%COMP%]{background-color:var(--hmf-gray200);padding:0}[_nghost-%COMP%]   button[_ngcontent-%COMP%]:hover   .inner-circle-container[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-subtle-hover)}[_nghost-%COMP%]   button[_ngcontent-%COMP%]:active   .inner-circle-container[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-subtle-active)}[_nghost-%COMP%]   button.disabled[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-disabled)}[_nghost-%COMP%]   button.disabled[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], [_nghost-%COMP%]   button.disabled[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]   .color-swatch[_ngcontent-%COMP%]{opacity:.3}[_nghost-%COMP%]   button.disabled[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]{position:relative}[_nghost-%COMP%]   button.disabled[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], [_nghost-%COMP%]   button.disabled[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]   .color-swatch[_ngcontent-%COMP%]{opacity:.3}[_nghost-%COMP%]   button.disabled[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:after{background-color:var(--hmf-border-disabled);content:\"\";height:2px;left:0;position:absolute;top:calc(50% - 1px);transform:rotate(135deg);width:100%}[_nghost-%COMP%]   button.is-dblborder[_ngcontent-%COMP%]{padding:var(--hmf-xxxs)}[_nghost-%COMP%]   button.is-dblborder[_ngcontent-%COMP%]:hover{border:1px solid var(--hmf-border-secondary-subtle-static)}[_nghost-%COMP%]   button.is-dblborder[_ngcontent-%COMP%]:hover   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-subtle-hover)}[_nghost-%COMP%]   button.is-dblborder[_ngcontent-%COMP%]:active{border:1px solid var(--hmf-border-secondary-subtle-static)}[_nghost-%COMP%]   button.is-dblborder[_ngcontent-%COMP%]:active   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-subtle-active)}[_nghost-%COMP%]   button.is-dblborder.disabled[_ngcontent-%COMP%]{border:none}[_nghost-%COMP%]   button.is-dblborder.disabled[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-disabled)}[_nghost-%COMP%]   button.unavailable[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-secondary-subtle-static);opacity:.5}[_nghost-%COMP%]   button.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]{position:relative}[_nghost-%COMP%]   button.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], [_nghost-%COMP%]   button.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]   .color-swatch[_ngcontent-%COMP%]{opacity:.3}[_nghost-%COMP%]   button.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:after{background-color:var(--hmf-border-disabled);content:\"\";height:2px;left:0;position:absolute;top:calc(50% - 1px);transform:rotate(135deg);width:100%}[_nghost-%COMP%]   button.unavailable.is-dblborder[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px dashed var(--hmf-border-secondary-subtle-static)}[_nghost-%COMP%]   button.unavailable.is-dblborder[_ngcontent-%COMP%]:hover{border:1px solid var(--hmf-border-secondary-subtle-hover)}[_nghost-%COMP%]   button.unavailable.is-dblborder[_ngcontent-%COMP%]:hover   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px dashed var(--hmf-border-secondary-hover)}[_nghost-%COMP%]   button.unavailable.is-dblborder[_ngcontent-%COMP%]:active{border:1px solid var(--hmf-border-secondary-subtle-hover)}[_nghost-%COMP%]   button.unavailable.is-dblborder[_ngcontent-%COMP%]:active   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px dashed var(--hmf-border-secondary-active)}[_nghost-%COMP%]   button.unavailable.is-dblborder.disabled[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-disabled-subtle)}[_nghost-%COMP%]   button.unavailable.is-dblborder.disabled[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-disabled)}[_nghost-%COMP%]   button.unavailable.rectangular-selector-button[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:before{border-color:var(--hmf-gray600);border-top:1px solid;content:\"\";left:50%;margin:0;position:absolute;top:50%;transform:translate(-50%,-50%) rotate(-45deg);width:40px}[_nghost-%COMP%]   button.unavailable.rectangular-selector-button[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:after{content:\"\";display:none}[_nghost-%COMP%]   img[_ngcontent-%COMP%], [_nghost-%COMP%]   .color-swatch[_ngcontent-%COMP%]{border-radius:50%;width:100%}[_nghost-%COMP%]   .color-swatch[_ngcontent-%COMP%]{height:100%}"]
      });
    }
  }
  return HmfSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfBubblesComponent = /*#__PURE__*/(() => {
  class HmfBubblesComponent {
    constructor() {
      this.sizeVariants = {
        adaptable: 'adaptable',
        small: 'small',
        medium: 'medium',
        large: 'large'
      };
      this.label = '';
      this.image = '';
      this.altText = '';
      this.classList = '';
      this.sizeVariant = this.sizeVariants.small;
    }
    ngOnInit() {
      if (this.altText === '') {
        this.altText = this.label;
      }
    }
    static {
      this.ɵfac = function HmfBubblesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfBubblesComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfBubblesComponent,
        selectors: [["hmf-bubbles"]],
        inputs: {
          label: "label",
          image: "image",
          altText: "altText",
          classList: "classList",
          sizeVariant: "sizeVariant"
        },
        decls: 5,
        vars: 7,
        consts: [[3, "selector"], ["ngProjectAs", "rectangularSelectorBody", 5, ["rectangularSelectorBody"]], ["loading", "lazy", 1, "hmf-bubble-image", 3, "alt", "src"], [1, "hmf-bubble-label", "hmf-pt-xxs", "hmf-pb-xxxs"]],
        template: function HmfBubblesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "hmf-selector", 0)(1, "div", 1);
            i0.ɵɵelement(2, "img", 2);
            i0.ɵɵelementStart(3, "span", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("selector", "rectangular");
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate1("hmf-bubble-container ", ctx.sizeVariant, " hmf-display-flex hmf-body-m hmf-align-items-center hmf-text-align-center hmf-flex-column hmf-p-xxs");
            i0.ɵɵadvance();
            i0.ɵɵproperty("alt", ctx.altText)("src", ctx.image, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
          }
        },
        dependencies: [CommonModule, HomefieldIconLibraryModule, HmfSelectorComponent],
        styles: ["[_nghost-%COMP%]     #hmf-circular-selector{cursor:pointer}[_nghost-%COMP%]     #hmf-circular-selector .inner-circle-container{border:none}[_nghost-%COMP%]     #hmf-circular-selector:hover .hmf-bubble-label{text-decoration:underline}[_nghost-%COMP%]     #hmf-circular-selector:focus-visible{border-radius:0;outline:var(--hmf-gray600) dashed 1px}[_nghost-%COMP%]     .hmf-bubble-container.adaptable .hmf-bubble-image{height:100px;width:100px}[_nghost-%COMP%]     .hmf-bubble-container.adaptable .hmf-bubble-label{max-width:100px}@media (min-width: 768px){[_nghost-%COMP%]     .hmf-bubble-container.adaptable .hmf-bubble-image{height:140px;width:140px}[_nghost-%COMP%]     .hmf-bubble-container.adaptable .hmf-bubble-label{max-width:140px}}@media (min-width: 1280px){[_nghost-%COMP%]     .hmf-bubble-container.adaptable .hmf-bubble-image{height:160px;width:160px}[_nghost-%COMP%]     .hmf-bubble-container.adaptable .hmf-bubble-label{max-width:160px}}[_nghost-%COMP%]     .hmf-bubble-container.small .hmf-bubble-image{height:100px;width:100px}[_nghost-%COMP%]     .hmf-bubble-container.small .hmf-bubble-label{max-width:100px}[_nghost-%COMP%]     .hmf-bubble-container.medium .hmf-bubble-image{height:140px;width:140px}[_nghost-%COMP%]     .hmf-bubble-container.medium .hmf-bubble-label{max-width:140px}[_nghost-%COMP%]     .hmf-bubble-container.large .hmf-bubble-image{height:160px;width:160px}[_nghost-%COMP%]     .hmf-bubble-container.large .hmf-bubble-label{max-width:160px}"]
      });
    }
  }
  return HmfBubblesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfButtonComponent = /*#__PURE__*/(() => {
  class HmfButtonComponent {
    constructor(el) {
      this.el = el;
      this.buttonVariants = {
        primary: 'primary',
        secondary: 'secondary',
        tertiary: 'tertiary',
        marketing: 'marketing',
        destructive: 'destructive'
      };
      this.buttonSize = {
        small: 'small',
        medium: 'medium',
        large: 'large',
        auto: 'auto'
      };
      // Size of the label text
      this.labelSizeMap = {
        small: 'hmf-body-bold-s',
        medium: 'hmf-body-bold-l',
        large: 'hmf-body-bold-l',
        auto: 'hmf-body-bold-s'
      };
      this.variant = input(this.buttonVariants.primary);
      this.size = input(this.buttonSize.medium);
      this.iconSize = input();
      this.shape = input('square');
      this.loading = input(false);
      this.disabled = input(false);
      // Normalize text to lowercase if it's a string
      this.text = input('', {
        transform: val => typeof val === 'string' ? val.toLowerCase() : val
      });
      this.label = input('');
      this.icon = input('');
      this.classList = input('');
      this.testId = input('');
      this.dataEm = input('');
      this.positionIcon = input('left');
      this.effectiveIconSize = computed(() => {
        return this.iconSize() || this.size();
      });
      this.isCircular = computed(() => this.shape() === 'circular');
      this.role = 'button';
      this.contentRef = viewChild('contentRef');
      this.hasProjectedContent = computed(() => !!this.contentRef()?.nativeElement?.childNodes?.length);
      this.textExists = computed(() => Boolean(this.text() || this.contentRef()?.nativeElement?.childNodes?.length > 0));
    }
    get hasMultipleElements() {
      return !!this.icon() && (!!this.text() || this.hasProjectedContent()) ? 'has-multiple-elements' : '';
    }
    get dataTestId() {
      return this.testId();
    }
    get dataAttributes() {
      return this.dataEm();
    }
    get isDisabled() {
      if (this.disabled()) {
        return true;
      }
      if (this.isCircular()) {
        return !this.icon();
      }
      return !this.textExists() && (!this.label() || !this.icon());
    }
    get isButtonDisabled() {
      return this.isDisabled || null;
    }
    get ariaLabel() {
      return this.label() || this.text() || this.contentRef()?.nativeElement?.textContent;
    }
    get getVariantApplication() {
      if (this.isCircular() && !this.icon()) {
        return 'hmf-button hidden';
      }
      if (!this.isCircular() && (!this.textExists() && !this.label() || !this.textExists() && !this.icon())) {
        return 'hmf-button hidden';
      }
      const shapeClass = this.isCircular() ? 'circular-btn ' : '';
      const iconClass = this.icon() && (this.label() || this.isCircular()) ? 'icon-btn ' : '';
      const textTransformClass = !this.isCircular() ? ' hmf-text-transform-capitalize' : '';
      const _size = this.size().toString();
      const _iconSize = this.effectiveIconSize().toString();
      const defaultClasses = this.loading() ? `hmf-button loading ${_size}-btn ${_iconSize}-icon ${this.labelSizeMap[_size]} ${this.classList()}` : `hmf-button ${iconClass}${this.labelSizeMap[_size]} ${_size}-btn ${_iconSize}-icon ${this.variant()}-btn ${shapeClass}${this.classList()}${textTransformClass}`;
      if (!this.textExists() && !this.label() || !this.textExists() && !this.icon()) {
        return 'hmf-button hidden';
      }
      return defaultClasses;
    }
    ignoreMouse(buttonRef) {
      buttonRef.blur();
    }
    hostClick() {
      this.el.nativeElement.click();
    }
    static {
      this.ɵfac = function HmfButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfButtonComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfButtonComponent,
        selectors: [["hmf-button"], ["a", "hmf-button", ""], ["button", "hmf-button", ""]],
        viewQuery: function HmfButtonComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.contentRef, _c18, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        hostVars: 8,
        hostBindings: function HmfButtonComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function HmfButtonComponent_click_HostBindingHandler($event) {
              return ctx.ignoreMouse($event.target);
            })("contextmenu", function HmfButtonComponent_contextmenu_HostBindingHandler($event) {
              return ctx.ignoreMouse($event.target);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role)("data-test-id", ctx.dataTestId)("data-em", ctx.dataAttributes)("aria-disabled", ctx.isDisabled)("disabled", ctx.isButtonDisabled)("aria-label", ctx.ariaLabel);
            i0.ɵɵclassMap(ctx.getVariantApplication);
          }
        },
        inputs: {
          variant: [1, "variant"],
          size: [1, "size"],
          iconSize: [1, "iconSize"],
          shape: [1, "shape"],
          loading: [1, "loading"],
          disabled: [1, "disabled"],
          text: [1, "text"],
          label: [1, "label"],
          icon: [1, "icon"],
          classList: [1, "classList"],
          testId: [1, "testId"],
          dataEm: [1, "dataEm"],
          positionIcon: [1, "positionIcon"]
        },
        ngContentSelectors: _c6,
        decls: 1,
        vars: 1,
        consts: [["contentRef", ""], [1, "hmf-button-container", 3, "ngClass"], [3, "name"], [1, "projected"]],
        template: function HmfButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, HmfButtonComponent_Conditional_0_Template, 2, 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.loading() ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: ["[_nghost-%COMP%]{--button-elements-gap: 10px}[_nghost-%COMP%]     .hmf-button-container{align-items:center;display:inline-flex}[_nghost-%COMP%]     .hmf-button-container.has-multiple-elements{gap:var(--button-elements-gap)}[_nghost-%COMP%]     homefield-icon{display:flex}.primary-btn[_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-button-primary-text-color)}.primary-btn[aria-disabled=true][_nghost-%COMP%]     svg path{fill:var(--hmf-button-primary-inactive-text-color)}.secondary-btn[_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-button-secondary-text-color)}.secondary-btn[aria-disabled=true][_nghost-%COMP%]     svg path{fill:var(--hmf-button-secondary-inactive-text-color)}.tertiary-btn[_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-button-tertiary-text-color)}.tertiary-btn[aria-disabled=true][_nghost-%COMP%]     svg path{fill:var(--hmf-button-tertiary-inactive-text-color)}.marketing-btn[_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-button-marketing-text-color)}.marketing-btn[aria-disabled=true][_nghost-%COMP%]     svg path{fill:var(--hmf-button-marketing-inactive-text-color)}.destructive-btn[_nghost-%COMP%]     homefield-icon svg path{fill:var(--hmf-button-destructive-text-color)}.destructive-btn[aria-disabled=true][_nghost-%COMP%]     svg path{fill:var(--hmf-button-destructive-inactive-text-color)}.small-icon[_nghost-%COMP%]     homefield-icon svg{height:12px;width:12px}.medium-icon[_nghost-%COMP%]     homefield-icon svg{height:16px;width:16px}.auto-icon[_nghost-%COMP%]     homefield-icon svg{height:12px;width:12px}@media (min-width: 768px){.auto-icon[_nghost-%COMP%]{font-size:var(--body-font-size-l)!important;line-height:var(--body-line-height-l)!important}.auto-icon[_nghost-%COMP%]     homefield-icon svg{height:16px;width:16px}}.large-icon[_nghost-%COMP%]     homefield-icon svg{height:24px;width:24px}.hmf-button[_ngcontent-%COMP%], [_nghost-%COMP%]{align-items:center;border:2px solid var(--hmf-gray50);border-radius:var(--hmf-button-border-radius);box-shadow:0 0 0 transparent;box-sizing:border-box;cursor:pointer;display:inline-flex;height:auto;justify-content:center;letter-spacing:var(--hmf-button-primary-letter-spacing);line-height:var(--hmf-button-primary-line-height);outline:1px dashed transparent;padding:var(--hmf-s);text-align:center;transition:background-color var(--hmf-ease-in-out-fast),border-color var(--hmf-ease-in-out-fast),color var(--hmf-ease-in-out-fast),outline var(--hmf-ease-in-out-fast),outline-offset var(--hmf-ease-in-out-fast)}.hmf-button[_ngcontent-%COMP%]   .hmf-button-container[_ngcontent-%COMP%], [_nghost-%COMP%]   .hmf-button-container[_ngcontent-%COMP%]{align-items:center;display:flex}.hmf-button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], [_nghost-%COMP%]   span[_ngcontent-%COMP%]{pointer-events:none}.hmf-button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] + svg[_ngcontent-%COMP%], [_nghost-%COMP%]   span[_ngcontent-%COMP%] + svg[_ngcontent-%COMP%]{margin-left:10px}.hmf-button.loading[_ngcontent-%COMP%], .loading[_nghost-%COMP%]{background:linear-gradient(108deg,#f5f5f500 11.84%,#f5f5f5cc 51.76%,#f5f5f500 88.53%),var(--hmf-fill-disabled-subtle);border-radius:var(--hmf-base-radius);color:var(--hmf-label-disabled)}.hmf-button.hidden[_ngcontent-%COMP%], .hidden[_nghost-%COMP%]{display:none}.hmf-button[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], [_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{transition:fill var(--hmf-ease-in-out-fast)}.hmf-button[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%] + span[_ngcontent-%COMP%], [_nghost-%COMP%]   svg[_ngcontent-%COMP%] + span[_ngcontent-%COMP%]{margin-left:10px}.hmf-button[aria-disabled=false][_ngcontent-%COMP%], [aria-disabled=false][_nghost-%COMP%]{cursor:pointer}.hmf-button[aria-disabled=true][_ngcontent-%COMP%], [aria-disabled=true][_nghost-%COMP%]{pointer-events:none}.hmf-button.circular-btn[_ngcontent-%COMP%], .circular-btn[_nghost-%COMP%]{align-items:center;border-radius:50%;display:flex;justify-content:center;padding:0}.hmf-button.large-btn[_ngcontent-%COMP%], .large-btn[_nghost-%COMP%]{padding-bottom:var(--hmf-m);padding-top:var(--hmf-m)}.hmf-button.large-btn.icon-btn.circular-btn[_ngcontent-%COMP%], .large-btn.icon-btn.circular-btn[_nghost-%COMP%]{height:56px;min-width:56px;width:56px}.hmf-button.medium-btn[_ngcontent-%COMP%], .medium-btn[_nghost-%COMP%]{padding-bottom:var(--hmf-xs);padding-top:var(--hmf-xs)}.hmf-button.medium-btn.icon-btn.circular-btn[_ngcontent-%COMP%], .medium-btn.icon-btn.circular-btn[_nghost-%COMP%]{height:44px;min-width:44px;width:44px}.hmf-button.small-btn[_ngcontent-%COMP%], .small-btn[_nghost-%COMP%]{padding-bottom:var(--hmf-xxs);padding-top:var(--hmf-xxs)}.hmf-button.small-btn.icon-btn.circular-btn[_ngcontent-%COMP%], .small-btn.icon-btn.circular-btn[_nghost-%COMP%]{height:32px;min-width:32px;width:32px}.hmf-button.auto-btn[_ngcontent-%COMP%], .auto-btn[_nghost-%COMP%]{padding-bottom:var(--hmf-xxs);padding-top:var(--hmf-xxs)}@media (min-width: 768px){.hmf-button.auto-btn[_ngcontent-%COMP%], .auto-btn[_nghost-%COMP%]{padding-bottom:var(--hmf-xs);padding-top:var(--hmf-xs)}}.hmf-button.small-icon[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .small-icon[_nghost-%COMP%]   svg[_ngcontent-%COMP%]{height:12px;width:12px}.hmf-button.medium-icon[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .medium-icon[_nghost-%COMP%]   svg[_ngcontent-%COMP%]{height:16px;width:16px}.hmf-button.auto-icon.icon-btn.circular-btn[_ngcontent-%COMP%], .auto-icon.icon-btn.circular-btn[_nghost-%COMP%]{height:32px;min-width:32px;width:32px}.hmf-button.auto-icon[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .auto-icon[_nghost-%COMP%]   svg[_ngcontent-%COMP%]{height:12px;width:12px}@media (min-width: 768px){.hmf-button.auto-icon.icon-btn.circular-btn[_ngcontent-%COMP%], .auto-icon.icon-btn.circular-btn[_nghost-%COMP%]{height:44px;min-width:44px;width:44px}.hmf-button.auto-icon[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .auto-icon[_nghost-%COMP%]   svg[_ngcontent-%COMP%]{height:16px;width:16px}}.hmf-button.large-icon[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .large-icon[_nghost-%COMP%]   svg[_ngcontent-%COMP%]{height:24px;width:24px}.hmf-button[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]:focus{outline:1px dashed var(--hmf-gray600);outline-offset:4px}.hmf-button.primary-btn[_ngcontent-%COMP%], .primary-btn[_nghost-%COMP%]{background-color:var(--hmf-button-primary-background-color);border:2px solid var(--hmf-button-primary-border-color);color:var(--hmf-button-primary-text-color)}.hmf-button.primary-btn.loading[_ngcontent-%COMP%], .primary-btn.loading[_nghost-%COMP%]{background-color:initial;border:none;color:var(--hmf-button-primary-text-color);padding:0 16px}.hmf-button.primary-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .primary-btn[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-primary-text-color)}.hmf-button.primary-btn[_ngcontent-%COMP%]:hover:not([aria-disabled=true]), .primary-btn[_nghost-%COMP%]:hover:not([aria-disabled=true]){background-color:var(--hmf-button-primary-hover-background-color);border:2px solid var(--hmf-button-primary-hover-border-color)}.hmf-button.primary-btn[_ngcontent-%COMP%]:active, .primary-btn[_nghost-%COMP%]:active{background-color:var(--hmf-button-primary-active-background-color);border:2px solid var(--hmf-button-primary-active-border-color)}.hmf-button.primary-btn[aria-disabled=true][_ngcontent-%COMP%], .primary-btn[aria-disabled=true][_nghost-%COMP%]{background-color:var(--hmf-button-primary-inactive-background-color);border:2px solid var(--hmf-button-primary-inactive-border-color);color:var(--hmf-button-primary-inactive-text-color)}.hmf-button.primary-btn[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .primary-btn[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-primary-inactive-text-color)}.hmf-button.secondary-btn[_ngcontent-%COMP%], .secondary-btn[_nghost-%COMP%]{background-color:var(--hmf-button-secondary-background-color);border:2px solid var(--hmf-button-secondary-border-color);color:var(--hmf-button-secondary-text-color)}.hmf-button.secondary-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .secondary-btn[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-secondary-text-color)}.hmf-button.secondary-btn[_ngcontent-%COMP%]:hover:not([aria-disabled=true]), .secondary-btn[_nghost-%COMP%]:hover:not([aria-disabled=true]){background-color:var(--hmf-button-secondary-hover-background-color);border:2px solid var(--hmf-button-secondary-hover-border-color);color:var(--hmf-button-secondary-hover-text-color)}.hmf-button.secondary-btn[_ngcontent-%COMP%]:hover:not([aria-disabled=true])   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .secondary-btn[_nghost-%COMP%]:hover:not([aria-disabled=true])   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-secondary-hover-text-color)}.hmf-button.secondary-btn[_ngcontent-%COMP%]:active, .secondary-btn[_nghost-%COMP%]:active{background-color:var(--hmf-button-secondary-active-background-color);border:2px solid var(--hmf-button-secondary-active-border-color);color:var(--hmf-button-secondary-active-text-color)}.hmf-button.secondary-btn[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .secondary-btn[_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-secondary-active-text-color)}.hmf-button.secondary-btn[aria-disabled=true][_ngcontent-%COMP%], .secondary-btn[aria-disabled=true][_nghost-%COMP%]{background-color:var(--hmf-button-secondary-inactive-background-color);border:2px solid var(--hmf-button-secondary-inactive-border-color);color:var(--hmf-button-secondary-inactive-text-color)}.hmf-button.secondary-btn[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .secondary-btn[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-secondary-inactive-text-color)}.hmf-button.tertiary-btn[_ngcontent-%COMP%], .tertiary-btn[_nghost-%COMP%]{background-color:var(--hmf-button-tertiary-background-color);border:2px solid var(--hmf-button-tertiary-border-color);color:var(--hmf-button-tertiary-text-color)}.hmf-button.tertiary-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .tertiary-btn[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-tertiary-text-color)}.hmf-button.tertiary-btn[_ngcontent-%COMP%]:hover:not([aria-disabled=true]), .tertiary-btn[_nghost-%COMP%]:hover:not([aria-disabled=true]){background-color:var(--hmf-button-tertiary-hover-background-color);border:2px solid var(--hmf-button-tertiary-hover-border-color);color:var(--hmf-button-tertiary-hover-text-color)}.hmf-button.tertiary-btn[_ngcontent-%COMP%]:hover:not([aria-disabled=true])   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .tertiary-btn[_nghost-%COMP%]:hover:not([aria-disabled=true])   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-tertiary-hover-text-color)}.hmf-button.tertiary-btn[_ngcontent-%COMP%]:active, .tertiary-btn[_nghost-%COMP%]:active{background-color:var(--hmf-button-tertiary-active-background-color);border:2px solid var(--hmf-button-tertiary-active-border-color);color:var(--hmf-button-tertiary-active-text-color)}.hmf-button.tertiary-btn[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .tertiary-btn[_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-tertiary-active-text-color)}.hmf-button.tertiary-btn[aria-disabled=true][_ngcontent-%COMP%], .tertiary-btn[aria-disabled=true][_nghost-%COMP%]{background-color:var(--hmf-button-tertiary-inactive-background-color);border:2px solid var(--hmf-button-tertiary-inactive-border-color);color:var(--hmf-button-tertiary-inactive-text-color)}.hmf-button.tertiary-btn[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .tertiary-btn[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-tertiary-inactive-text-color)}.hmf-button.marketing-btn[_ngcontent-%COMP%], .marketing-btn[_nghost-%COMP%]{background-color:var(--hmf-button-marketing-background-color);border:2px var(--hmf-button-marketing-border-color);color:var(--hmf-button-marketing-text-color)}.hmf-button.marketing-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .marketing-btn[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-marketing-text-color)}.hmf-button.marketing-btn[_ngcontent-%COMP%]:hover:not([aria-disabled=true]), .marketing-btn[_nghost-%COMP%]:hover:not([aria-disabled=true]){background-color:var(--hmf-button-marketing-hover-background-color);border:2px var(--hmf-button-marketing-hover-border-color);color:var(--hmf-button-marketing-hover-text-color)}.hmf-button.marketing-btn[_ngcontent-%COMP%]:hover:not([aria-disabled=true])   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .marketing-btn[_nghost-%COMP%]:hover:not([aria-disabled=true])   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-marketing-hover-text-color)}.hmf-button.marketing-btn[_ngcontent-%COMP%]:active, .marketing-btn[_nghost-%COMP%]:active{background-color:var(--hmf-button-marketing-active-background-color);border:2px var(--hmf-button-marketing-active-border-color);color:var(--hmf-button-marketing-active-text-color)}.hmf-button.marketing-btn[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .marketing-btn[_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-marketing-active-text-color)}.hmf-button.marketing-btn[aria-disabled=true][_ngcontent-%COMP%], .marketing-btn[aria-disabled=true][_nghost-%COMP%]{background-color:var(--hmf-button-marketing-inactive-background-color);border:2px var(--hmf-button-marketing-inactive-border-color);color:var(--hmf-button-marketing-inactive-text-color)}.hmf-button.marketing-btn[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .marketing-btn[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-marketing-inactive-text-color)}.hmf-button.destructive-btn[_ngcontent-%COMP%], .destructive-btn[_nghost-%COMP%]{background-color:var(--hmf-button-destructive-background-color);border:2px var(--hmf-button-destructive-border-color);color:var(--hmf-button-destructive-text-color)}.hmf-button.destructive-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .destructive-btn[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-destructive-text-color)}.hmf-button.destructive-btn[_ngcontent-%COMP%]:hover:not([aria-disabled=true]), .destructive-btn[_nghost-%COMP%]:hover:not([aria-disabled=true]){background-color:var(--hmf-button-destructive-hover-background-color);border:2px var(--hmf-button-destructive-hover-border-color);color:var(--hmf-button-destructive-hover-text-color)}.hmf-button.destructive-btn[_ngcontent-%COMP%]:hover:not([aria-disabled=true])   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .destructive-btn[_nghost-%COMP%]:hover:not([aria-disabled=true])   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-destructive-hover-text-color)}.hmf-button.destructive-btn[_ngcontent-%COMP%]:active, .destructive-btn[_nghost-%COMP%]:active{background-color:var(--hmf-button-destructive-active-background-color);border:2px var(--hmf-button-destructive-active-border-color);color:var(--hmf-button-destructive-active-text-color)}.hmf-button.destructive-btn[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .destructive-btn[_nghost-%COMP%]:active   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-destructive-active-text-color)}.hmf-button.destructive-btn[aria-disabled=true][_ngcontent-%COMP%], .destructive-btn[aria-disabled=true][_nghost-%COMP%]{background-color:var(--hmf-button-destructive-inactive-background-color);border:2px var(--hmf-button-destructive-inactive-border-color);color:var(--hmf-button-destructive-inactive-text-color)}.hmf-button.destructive-btn[aria-disabled=true][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .destructive-btn[aria-disabled=true][_nghost-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-button-destructive-inactive-text-color)}.projected[_ngcontent-%COMP%]:empty{display:none}"]
      });
    }
  }
  return HmfButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfCardComponent = /*#__PURE__*/(() => {
  class HmfCardComponent {
    constructor() {
      this.padding = '0';
    }
    get getVariantApplication() {
      return `hmf-p-${this.padding}`;
    }
    static {
      this.ɵfac = function HmfCardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfCardComponent,
        selectors: [["hmf-card"], ["a", "hmf-card", ""]],
        hostVars: 2,
        hostBindings: function HmfCardComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.getVariantApplication);
          }
        },
        inputs: {
          padding: "padding"
        },
        ngContentSelectors: _c6,
        decls: 1,
        vars: 0,
        template: function HmfCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        dependencies: [CommonModule],
        styles: ["[_nghost-%COMP%]{background:var(--hmf-background-base);border-radius:var(--hmf-sharp-radius)}[_nghost-%COMP%]:hover{box-shadow:var(--hmf-elevated-shadow)}[_nghost-%COMP%]:focus{border:1px dashed var(--hmf-border-focused)}[_nghost-%COMP%]:active{border:1px solid var(--hmf-gray300);box-shadow:var(--hmf-soft-shadow)}"]
      });
    }
  }
  return HmfCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfCheckboxComponent = /*#__PURE__*/(() => {
  class HmfCheckboxComponent {
    constructor(homefieldIconsLibraryService) {
      this.label = '';
      this.checked = false;
      this.disabled = false;
      this.error = false;
      this.classList = '';
      this.tabIndex = '0';
      this.testId = '';
      this.ariaLabel = '';
      /**
       * The size of the checkbox
       * @default 'medium'
       * @type {'small' | 'medium' | 'large'}
       **/
      this.size = 'medium';
      this.eventChange = new EventEmitter();
      this.isFocused = false;
      homefieldIconsLibraryService.registerIcons([homefieldIconSignCheck]);
    }
    ngOnInit() {
      this.id = this.id ? this.id : generateId('checkbox');
      this.updateFontValue();
      this.updateIconSize();
      this.updateMarginSpace();
    }
    ngOnChanges(changes) {
      if (changes['size']) {
        this.updateFontValue();
        this.updateIconSize();
        this.updateMarginSpace();
      }
    }
    updateIconSize() {
      this.iconSize = this.size === 'large' ? '16px' : '10px';
    }
    updateFontValue() {
      this.fontValue = this.size === 'small' ? 'm' : 'l';
    }
    updateMarginSpace() {
      this.marginSpace = this.size === 'large' ? 'hmf-mr-xs' : 'hmf-mr-xxs';
    }
    get labelClasses() {
      return {
        checked: this.checked,
        error: this.error && !this.disabled,
        disabled: this.disabled,
        focused: this.isFocused,
        [`hmf-body-bold-${this.fontValue}`]: this.checked,
        [`hmf-body-${this.fontValue}`]: !this.checked
      };
    }
    get checkboxSpanClasses() {
      return {
        'homefield-checkbox-span': true,
        [`homefield-checkbox-span-${this.size}`]: true,
        [this.marginSpace]: true,
        'checkbox--active': this.checked
      };
    }
    get errorClasses() {
      return {
        'hmf-my-0': true,
        'hmf-mt-xxxs': true,
        'hmf-ml-m': true,
        'hmf-legal-s': true,
        focused: this.isFocused
      };
    }
    isCheckboxSelectedState() {
      this.checked = !this.checked;
      this.eventChange.emit(this.checked);
    }
    setInputHasFocus(focusState) {
      this.isFocused = focusState;
    }
    static {
      this.ɵfac = function HmfCheckboxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfCheckboxComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfCheckboxComponent,
        selectors: [["hmf-checkbox"]],
        inputs: {
          label: "label",
          checked: "checked",
          disabled: "disabled",
          error: "error",
          errorMessage: "errorMessage",
          classList: "classList",
          tabIndex: "tabIndex",
          testId: "testId",
          ariaLabel: "ariaLabel",
          id: "id",
          name: "name",
          size: "size"
        },
        outputs: {
          eventChange: "eventChange"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 7,
        vars: 26,
        consts: [[3, "ngClass"], ["type", "checkbox", 1, "homefield-checkbox-input", 3, "change", "focus", "blur", "tabindex", "checked"], ["aria-hidden", "true", 1, "homefield-checkbox-svg", 3, "name", "ngClass", "height", "width"]],
        template: function HmfCheckboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "label", 0)(2, "input", 1);
            i0.ɵɵlistener("change", function HmfCheckboxComponent_Template_input_change_2_listener() {
              return ctx.isCheckboxSelectedState();
            })("focus", function HmfCheckboxComponent_Template_input_focus_2_listener() {
              return ctx.setInputHasFocus(true);
            })("blur", function HmfCheckboxComponent_Template_input_blur_2_listener() {
              return ctx.setInputHasFocus(false);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "span", 0);
            i0.ɵɵelement(4, "homefield-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, HmfCheckboxComponent_Conditional_6_Template, 2, 3, "p", 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("homefield-checkbox ", ctx.classList, "");
            i0.ɵɵattribute("data-test-id", ctx.testId);
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate1("homefield-checkbox-label hmf-mb-0 hmf-body-", ctx.fontValue, "");
            i0.ɵɵproperty("ngClass", ctx.labelClasses);
            i0.ɵɵattribute("for", "homefield-checkbox-" + ctx.id)("aria-describedby", ctx.error ? "homefield-checkbox-errorMessage-" + ctx.id : "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("tabindex", ctx.tabIndex)("checked", ctx.checked);
            i0.ɵɵattribute("aria-describedby", ctx.error ? "homefield-checkbox-errorMessage-" + ctx.id : "")("aria-label", ctx.ariaLabel || null)("disabled", ctx.disabled || null)("id", "homefield-checkbox-" + ctx.id)("name", ctx.name);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.checkboxSpanClasses);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("height", ctx.iconSize);
            i0.ɵɵpropertyInterpolate("width", ctx.iconSize);
            i0.ɵɵproperty("name", "sign-check")("ngClass", i0.ɵɵpureFunction1(24, _c19, ctx.disabled));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.errorMessage && ctx.error && !ctx.disabled ? 6 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: [".homefield-checkbox{display:flex;flex-direction:column;margin-bottom:var(--hmf-xs);margin-right:var(--hmf-xs)}.homefield-checkbox .homefield-checkbox-label{align-content:center;align-items:center;color:var(--hmf-label-secondary-subtle-static);cursor:pointer;display:flex;outline:1px dashed transparent}.homefield-checkbox .homefield-checkbox-label.checked{color:var(--hmf-label-secondary-static)}.homefield-checkbox .homefield-checkbox-label.checked:hover{color:var(--hmf-label-secondary-hover)}.homefield-checkbox .homefield-checkbox-label.checked:active{color:var(--hmf-label-secondary-active)}.homefield-checkbox .homefield-checkbox-label .homefield-checkbox-input[type=checkbox]{appearance:none;height:0;overflow:hidden;position:absolute;white-space:nowrap;width:0}.homefield-checkbox .homefield-checkbox-label .homefield-checkbox-span{background-color:var(--hmf-fill-secondary-static);border:1px solid var(--hmf-border-secondary-subtle-static);border-radius:var(--hmf-sharp-radius);box-sizing:border-box;display:inline-block;z-index:2}.homefield-checkbox .homefield-checkbox-label .homefield-checkbox-span-small,.homefield-checkbox .homefield-checkbox-label .homefield-checkbox-span-medium{height:var(--hmf-s);width:var(--hmf-s)}.homefield-checkbox .homefield-checkbox-label .homefield-checkbox-span-large{height:var(--hmf-m);width:var(--hmf-m)}.homefield-checkbox .homefield-checkbox-label .homefield-checkbox-span .homefield-checkbox-svg{display:none}.homefield-checkbox .homefield-checkbox-label .homefield-checkbox-span.checkbox--active{background:var(--hmf-fill-tertiary-static);border:none;line-height:9px;padding:3px}.homefield-checkbox .homefield-checkbox-label .homefield-checkbox-span.checkbox--active .homefield-checkbox-svg{display:block}.homefield-checkbox .homefield-checkbox-label .homefield-checkbox-span .homefield-checkbox-svg svg path,.homefield-checkbox .homefield-checkbox-label .homefield-checkbox-span svg.homefield-checkbox-svg path{fill:var(--hmf-label-inverse)}.homefield-checkbox .homefield-checkbox-label .homefield-checkbox-span .homefield-checkbox-svg svg.disabled path,.homefield-checkbox .homefield-checkbox-label .homefield-checkbox-span svg.homefield-checkbox-svg.disabled path{fill:var(--hmf-label-disabled)}.homefield-checkbox .homefield-checkbox-label:hover{color:var(--hmf-label-secondary-subtle-hover)}.homefield-checkbox .homefield-checkbox-label:hover .homefield-checkbox-span{background:var(--hmf-fill-secondary-hover);border:2px solid var(--hmf-border-secondary-subtle-hover);border-radius:var(--hmf-base-radius)}.homefield-checkbox .homefield-checkbox-label:hover .homefield-checkbox-span.checkbox--active{background:var(--hmf-fill-tertiary-static);border:none}.homefield-checkbox .homefield-checkbox-label:active{color:var(--hmf-label-secondary-subtle-active)}.homefield-checkbox .homefield-checkbox-label:active .homefield-checkbox-span{background:var(--hmf-fill-secondary-active);border:2px solid var(--hmf-border-secondary-subtle-active);box-sizing:border-box}.homefield-checkbox .homefield-checkbox-label:active .homefield-checkbox-span.checkbox--active{background:var(--hmf-fill-tertiary-static);border:none;padding:3px}.homefield-checkbox .homefield-checkbox-label:focus,.homefield-checkbox .homefield-checkbox-label.focused{outline:var(--hmf-checkbox-focus-outline);outline-offset:3px}.homefield-checkbox .homefield-checkbox-label.disabled{color:var(--hmf-label-disabled);cursor:not-allowed}.homefield-checkbox .homefield-checkbox-label.disabled .homefield-checkbox-span{background:var(--hmf-fill-disabled-subtle);border:1px solid var(--hmf-border-disabled)}.homefield-checkbox .homefield-checkbox-label.disabled .homefield-checkbox-span.checkbox--active{background:var(--hmf-fill-disabled-subtle);border:none;padding:3px}.homefield-checkbox .homefield-checkbox-label.disabled .homefield-checkbox-span.checkbox--active .homefield-checkbox-svg svg path{fill:var(--hmf-label-disabled)}.homefield-checkbox .homefield-checkbox-label.error{color:var(--hmf-label-negative)}.homefield-checkbox .homefield-checkbox-label.error .homefield-checkbox-span{background:var(--hmf-fill-negative-subtle);border-color:var(--hmf-fill-negative)}.homefield-checkbox .homefield-checkbox-label.error .homefield-checkbox-span.checkbox--active{background:var(--hmf-fill-negative);border-color:var(--hmf-fill-negative)}.homefield-checkbox>p{color:var(--hmf-label-negative)}.homefield-checkbox>p.focused{text-decoration:underline}\n"],
        encapsulation: 2
      });
    }
  }
  return HmfCheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfDrawerComponent = /*#__PURE__*/(() => {
  class HmfDrawerComponent {
    set setDrawerBackground(ref) {
      if (ref) {
        this.drawerBackground = ref;
        this.drawerBackgroundReady$.next(true);
      }
    }
    set setDrawerContainer(ref) {
      if (ref) {
        this.drawerContainer = ref;
        this.drawerContainerReady$.next(true);
      }
    }
    constructor(renderer, homefieldIconsLibraryService, document) {
      this.renderer = renderer;
      this.homefieldIconsLibraryService = homefieldIconsLibraryService;
      this.document = document;
      this.open = false;
      this.closing = false;
      this.previousFocus = null;
      this.drawerBackgroundReady$ = new Subject();
      this.drawerContainerReady$ = new Subject();
      this.viewChildrenReady$ = combineLatest([this.drawerBackgroundReady$, this.drawerContainerReady$]);
      this.className = '';
      this.headerText = '';
      this.isCloseButtonSticky = false;
      this.closable = true;
      this.anchorElement = null;
      this.interactability = false;
      this.attachedBackground = false;
      this.direction = 'right';
      this.focus = true;
      this.mobilePeek = false;
      this.size = 'medium';
      this.clickableBackground = false;
      this.transparentBackground = false;
      this.noPadding = false;
      this.opened = new EventEmitter();
      this.closed = new EventEmitter();
      this.closeRef = {};
      // This is a workaround because *ngIf clears the view and renders AfterViewInit
      // useless as a hook to work with ViewChild elements after they've been setup
      this.drawerBackground = {};
      this.drawerContainer = {};
      homefieldIconsLibraryService.registerIcons([homefieldIconSignCancel]);
    }
    ngOnInit() {
      if (this.focus) {
        this.handleFocusFirstElement();
      }
      if (this.parentDestroyRef) {
        this.parentDestroyRef.onDestroy(() => {
          if (this.open) {
            this.closeDrawer();
          }
        });
      }
    }
    ngOnDestroy() {
      this.document.removeEventListener('keydown', this.handleFocusTrap.bind(this));
    }
    openDrawer() {
      this.open = true;
      this.renderer.addClass(this.document.body, 'side-panel-open');
      this.previousFocus = this.document.activeElement;
      if (!this.interactability) {
        this.document.body.style.overflow = 'hidden';
        this.document.addEventListener('keydown', this.handleFocusTrap.bind(this));
      } else {
        window.addEventListener('scroll', this.setPositioningStyle.bind(this));
        this.document.addEventListener('keydown', this.handleInteractableEscape.bind(this));
      }
      this.viewChildrenReady$.pipe(takeUntil(this.closed)).subscribe(([drawerBackgroundReady, drawerContainerReady]) => {
        if (drawerBackgroundReady && drawerContainerReady) {
          this.setPositioningStyle();
          this.opened.emit();
        }
      });
    }
    closeDrawer() {
      this.closing = true;
      if (!this.interactability) {
        this.document.body.style.overflow = 'auto';
        this.document.removeEventListener('keydown', this.handleFocusTrap.bind(this));
      } else {
        window.removeEventListener('scroll', this.setPositioningStyle.bind(this));
        this.document.removeEventListener('keydown', this.handleInteractableEscape.bind(this));
      }
      setTimeout(() => {
        this.closing = false;
        this.renderer.removeClass(this.document.body, 'side-panel-open');
        this.closed.emit();
        this.open = false;
      }, 400);
    }
    setPositioningStyle() {
      const element = this.drawerContainer?.nativeElement;
      const background = this.drawerBackground?.nativeElement;
      if (!element || !background) {
        return;
      }
      if (this.anchorElement) {
        if (this.direction !== 'bottom') {
          element.style.top = this.calculateTop(element);
        } else {
          element.style.bottom = this.calculateBottom(element);
        }
        if (this.direction === 'left' || this.direction === 'right') {
          element.style.maxHeight = `calc(100% - ${this.anchorElement.getBoundingClientRect().bottom}px)`;
        } else {
          element.style.maxHeight = `100%`;
        }
        if (this.attachedBackground) {
          if (this.direction !== 'bottom') {
            if (this.anchorElement.getBoundingClientRect().bottom < 0) {
              background.style.top = `0px`;
            } else {
              background.style.top = `${this.anchorElement.getBoundingClientRect().bottom}px`;
            }
          } else if (this.anchorElement.getBoundingClientRect().top > window.innerHeight) {
            background.style.bottom = '0';
          } else {
            background.style.bottom = `${window.innerHeight - this.anchorElement.getBoundingClientRect().top}px`;
          }
        }
      }
    }
    handleFocusTrap(event) {
      if (this.open) {
        const drawer = this.document.querySelector('.hmf-drawer-container');
        if (drawer) {
          const focusable = drawer.querySelectorAll('button, [href], input, select, textarea, li, a,[tabindex]:not([tabindex="-1"])');
          // Check if focusable elements exist before accessing them
          if (focusable.length === 0) {
            return;
          }
          const firstFocusable = focusable[0];
          const lastFocusable = focusable[focusable.length - 1];
          const isTabPressed = event.key === 'Tab';
          if (event.key === 'Escape') {
            this.handleEscapePressed();
          }
          if (!isTabPressed) {
            return;
          }
          if (event.shiftKey) {
            if (this.document.activeElement === firstFocusable) {
              lastFocusable.focus();
              event.preventDefault();
            }
          } else if (this.document.activeElement === lastFocusable) {
            firstFocusable.focus();
            event.preventDefault();
          }
        }
      }
    }
    handleInteractableEscape(event) {
      const isEscPressed = event.key === 'Escape';
      if (isEscPressed) {
        this.handleEscapePressed();
      }
    }
    calculateTop(element) {
      let top = '';
      if (this.anchorElement.getBoundingClientRect().bottom < 0) {
        top = '0px';
      } else if (this.anchorElement.getBoundingClientRect().bottom + element.scrollHeight > window.innerHeight && !this.interactability && this.direction !== 'right' && this.direction !== 'left') {
        top = `${window.innerHeight - element.scrollHeight}px`;
      } else {
        top = `${this.anchorElement.getBoundingClientRect().bottom}px`;
      }
      return top;
    }
    calculateBottom(element) {
      let bottom = '';
      if (this.anchorElement.getBoundingClientRect().top - element.scrollHeight < 0) {
        bottom = `${window.innerHeight - element.scrollHeight}px`;
      } else {
        bottom = `${window.innerHeight - (this.anchorElement.getBoundingClientRect().bottom - this.anchorElement.scrollHeight)}px`;
      }
      return bottom;
    }
    handleFocusFirstElement() {
      if (this.open) {
        if (this.closeRef?.nativeElement) {
          this.closeRef.nativeElement.focus();
        } else if (this.drawerContainer?.nativeElement) {
          const focusableElements = this.drawerContainer.nativeElement.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
          const focusElement = focusableElements.length > 0 ? focusableElements[0] : null;
          if (focusElement) {
            const x = window.scrollX;
            const y = window.scrollY;
            focusElement.focus();
            window.scrollTo(x, y);
          }
        }
      } else if (this.previousFocus) {
        this.previousFocus.focus();
      }
    }
    handleEscapePressed() {
      if (this.closable) {
        this.closeDrawer();
      }
    }
    get drawerClasses() {
      return {
        [`direction-${this.direction}`]: !!this.direction,
        interactable: !!this.interactability,
        'non-interactable': !this.interactability,
        [`drawer--${this.size}`]: !!this.size
      };
    }
    get drawerContainerClasses() {
      return {
        closing: this.closing,
        'mobile-peek': !!this.mobilePeek
      };
    }
    get drawerContainerWrapperClasses() {
      const titleFlexClasses = `hmf-display-flex hmf-align-items-flex-end`;
      const marginClasses = 'hmf-pt-m-m hmf-px-m-m hmf-px-s hmf-pt-s hmf-pb-xs';
      return {
        'hmf-position-sticky hmf-close-wrapper': !!this.isCloseButtonSticky,
        [`${titleFlexClasses}`]: !!this.isCloseButtonSticky,
        [`${marginClasses}`]: !this.noPadding
      };
    }
    get wrapperClasses() {
      return {
        ...this.drawerContainerWrapperClasses,
        'hmf-justify-content-between': !!this.headerText,
        'hmf-justify-content-end': !this.headerText
      };
    }
    get drawerContainerContentClasses() {
      return {
        'hmf-px-m-m hmf-px-s hmf-flex-grow': !this.noPadding
      };
    }
    get drawerContainerCloseClasses() {
      return {
        'hmf-m-m': !this.isCloseButtonSticky,
        'hmf-position-absolute': !this.isCloseButtonSticky,
        'hmf-drawer-container-close': !this.isCloseButtonSticky
      };
    }
    get drawerBackgroundClasses() {
      return {
        'hmf-drawer-no-overlay-background': !!this.transparentBackground,
        'hmf-drawer-background-interactable': !!this.interactability,
        'hmf-drawer-background-non-interactable': !this.interactability && !this.clickableBackground,
        'hmf-drawer-background-clickable': !this.interactability && !!this.clickableBackground,
        'hmf-drawer-background-close': this.closing
      };
    }
    handleWindowResize() {
      if (this.open) {
        this.setPositioningStyle();
      }
    }
    handleWindowScroll() {
      if (!(this.open && this.interactability)) {
        return;
      }
      this.setPositioningStyle();
    }
    static {
      this.ɵfac = function HmfDrawerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfDrawerComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService), i0.ɵɵdirectiveInject(DOCUMENT));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfDrawerComponent,
        selectors: [["hmf-drawer"]],
        viewQuery: function HmfDrawerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c20, 5);
            i0.ɵɵviewQuery(_c21, 5);
            i0.ɵɵviewQuery(_c22, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.setDrawerBackground = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.setDrawerContainer = _t.first);
          }
        },
        hostBindings: function HmfDrawerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("resize", function HmfDrawerComponent_resize_HostBindingHandler() {
              return ctx.handleWindowResize();
            }, false, i0.ɵɵresolveWindow)("scroll", function HmfDrawerComponent_scroll_HostBindingHandler() {
              return ctx.handleWindowScroll();
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          className: "className",
          headerText: "headerText",
          isCloseButtonSticky: "isCloseButtonSticky",
          closable: "closable",
          anchorElement: "anchorElement",
          interactability: "interactability",
          attachedBackground: "attachedBackground",
          direction: "direction",
          focus: "focus",
          mobilePeek: "mobilePeek",
          size: "size",
          clickableBackground: "clickableBackground",
          transparentBackground: "transparentBackground",
          noPadding: "noPadding",
          parentDestroyRef: "parentDestroyRef"
        },
        outputs: {
          opened: "opened",
          closed: "closed"
        },
        ngContentSelectors: _c6,
        decls: 3,
        vars: 1,
        consts: [["contentTemplate", ""], ["drawerContainer", ""], ["drawerBackground", ""], ["closeRef", ""], [3, "class", "ngClass"], [3, "ngClass"], ["id", "hmf-drawer-container-id", 1, "hmf-drawer-container", "hmf-display-flex", "hmf-position-fixed", "hmf-flex-column", 3, "ngClass"], [1, "hmf-drawer-container-content", 3, "ngClass", "ngStyle"], ["id", "hmf-drawer-background-id", "onkeypress", "", 1, "hmf-drawer-background", "hmf-position-fixed", 3, "click", "ngClass"], ["id", "hmf-drawer-container-wrapper", 1, "hmf-drawer-container-wrapper", 3, "ngClass"], [1, "hmf-align-self-center", "hmf-header-bold-s"], ["variant", "tertiary", "iconSize", "large", "positionIcon", "left", "icon", "sign-cancel", "label", "Close Drawer", "onkeypress", "", "tabindex", "0", 3, "click", "ngClass"], [4, "ngTemplateOutlet"]],
        template: function HmfDrawerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, HmfDrawerComponent_Conditional_0_Template, 8, 8, "div", 4)(1, HmfDrawerComponent_ng_template_1_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.open ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgTemplateOutlet, i1$1.NgStyle, HmfButtonComponent, HomefieldIconLibraryModule],
        styles: [".hmf-drawer[_ngcontent-%COMP%]{height:100%;inset:0;position:fixed;width:100%;z-index:var(--hmf-z-index-overlay)}.hmf-drawer.interactable[_ngcontent-%COMP%]{pointer-events:none}.hmf-drawer.interactable[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]{pointer-events:all}.hmf-drawer.drawer--small[_ngcontent-%COMP%]{--hmf-drawer-size: 40%}.hmf-drawer.drawer--medium[_ngcontent-%COMP%]{--hmf-drawer-size: 75%}.hmf-drawer.drawer--large[_ngcontent-%COMP%]{--hmf-drawer-size: 94%}.hmf-drawer[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]{background:var(--hmf-background-base);box-shadow:var(--hmf-elevated-shadow);box-sizing:border-box;height:auto;padding:var(--hmf-0);transition:width var(--hmf-ease-out-fast),var(--hmf-ease-out-fast);width:100%;z-index:calc(var(--hmf-z-index-overlay) + 1)}.hmf-drawer[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]   .hmf-drawer-container-wrapper[_ngcontent-%COMP%]{background-color:var(--hmf-background-base);box-sizing:border-box}.hmf-drawer[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]   .hmf-drawer-container-wrapper.cursor-pointer[_ngcontent-%COMP%]{cursor:pointer}.hmf-drawer[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]   .hmf-drawer-container-wrapper[_ngcontent-%COMP%]   .hmf-drawer-title[_ngcontent-%COMP%]{word-break:break-word}.hmf-drawer[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]   .hmf-drawer-container-wrapper[_ngcontent-%COMP%]   .back-button[_ngcontent-%COMP%]{min-width:0}.hmf-drawer[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]   .hmf-drawer-container-wrapper[_ngcontent-%COMP%]   .hmf-drawer-container-close[_ngcontent-%COMP%]{background:var(--hmf-background-base);border:none;cursor:pointer;min-width:0;right:0;top:0;z-index:calc(var(--hmf-z-index-overlay) + 2)}.hmf-drawer[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]   .hmf-drawer-container-wrapper[_ngcontent-%COMP%]   .hmf-drawer-container-close[_ngcontent-%COMP%]:focus{outline:1px dashed var(--hmf-border-focused);outline-offset:3px}.hmf-drawer[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]   .hmf-drawer-container-wrapper.hmf-close-wrapper[_ngcontent-%COMP%]{background-color:var(--hmf-background-base);box-sizing:initial;min-height:var(--hmf-xl);top:0}.hmf-drawer[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]   .hmf-drawer-container-wrapper[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{height:var(--hmf-m);margin:var(--hmf-none);width:var(--hmf-m)}.hmf-drawer[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]   .hmf-drawer-container-content[_ngcontent-%COMP%]{max-height:100%;overflow-y:auto;padding-bottom:var(--hmf-m)}.hmf-drawer[_ngcontent-%COMP%]   .hmf-drawer-background[_ngcontent-%COMP%]{height:100%;width:100%;z-index:var(--hmf-z-index-overlay)}.hmf-drawer[_ngcontent-%COMP%]   .hmf-drawer-background[_ngcontent-%COMP%]:not(.hmf-drawer .hmf-drawer-background.hmf-drawer-no-overlay-background){animation:_ngcontent-%COMP%_overlay-fade .3s forwards}.hmf-drawer[_ngcontent-%COMP%]   .hmf-drawer-background.hmf-drawer-background-non-interactable[_ngcontent-%COMP%]{pointer-events:none}.hmf-drawer[_ngcontent-%COMP%]   .hmf-drawer-background.hmf-drawer-background-clickable[_ngcontent-%COMP%]{pointer-events:auto}.hmf-drawer[_ngcontent-%COMP%]   #hmf-drawer-background-id[_ngcontent-%COMP%]{pointer-events:initial}.hmf-drawer.direction-top[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]{height:var(--hmf-drawer-size, 94%);width:100%;overflow:hidden;top:0;transform:translateY(0);transition:transform var(--hmf-ease-out-fast),var(--hmf-ease-out-fast)}@starting-style{.hmf-drawer.direction-top[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]{transform:translateY(-100%)}}.hmf-drawer.direction-top[_ngcontent-%COMP%]   .hmf-drawer-container.closing[_ngcontent-%COMP%]{overflow:hidden;transform:translateY(-100%)}@media (max-width: 768px){.hmf-drawer.direction-top[_ngcontent-%COMP%]   .hmf-drawer-container.mobile-peek[_ngcontent-%COMP%]{overflow:hidden;bottom:0;transform:translateY(0);transition:transform var(--hmf-ease-out-fast),var(--hmf-ease-out-fast)}@starting-style{.hmf-drawer.direction-top[_ngcontent-%COMP%]   .hmf-drawer-container.mobile-peek[_ngcontent-%COMP%]{transform:translateY(100%)}}.hmf-drawer.direction-top[_ngcontent-%COMP%]   .hmf-drawer-container.mobile-peek.closing[_ngcontent-%COMP%]{overflow:hidden;transform:translateY(100%)}}.hmf-drawer.direction-right[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]{height:100%;width:var(--hmf-drawer-size, 40%);overflow:hidden;right:0;transform:translate(0);transition:transform var(--hmf-ease-out-fast),var(--hmf-ease-out-fast)}@starting-style{.hmf-drawer.direction-right[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]{transform:translate(100%)}}.hmf-drawer.direction-right[_ngcontent-%COMP%]   .hmf-drawer-container.closing[_ngcontent-%COMP%]{overflow:hidden;transform:translate(100%)}@media (max-width: 768px){.hmf-drawer.direction-right[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]{width:94%}.hmf-drawer.direction-right[_ngcontent-%COMP%]   .hmf-drawer-container.mobile-peek[_ngcontent-%COMP%]{height:var(--hmf-drawer-size, 94%);width:100%;overflow:hidden;bottom:0;transform:translateY(0);transition:transform var(--hmf-ease-out-fast),var(--hmf-ease-out-fast)}@starting-style{.hmf-drawer.direction-right[_ngcontent-%COMP%]   .hmf-drawer-container.mobile-peek[_ngcontent-%COMP%]{transform:translateY(100%)}}.hmf-drawer.direction-right[_ngcontent-%COMP%]   .hmf-drawer-container.mobile-peek.closing[_ngcontent-%COMP%]{overflow:hidden;transform:translateY(100%)}}.hmf-drawer.direction-right[_ngcontent-%COMP%]   .hmf-drawer-background-close[_ngcontent-%COMP%]:not(.hmf-drawer.direction-right .hmf-drawer-background-close.hmf-drawer-no-overlay-background){animation:_ngcontent-%COMP%_reverse-overlay-fade .3s forwards}.hmf-drawer.direction-bottom[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]{height:var(--hmf-drawer-size, 94%);width:100%;overflow:hidden;bottom:0;transform:translateY(0);transition:transform var(--hmf-ease-out-fast),var(--hmf-ease-out-fast)}@starting-style{.hmf-drawer.direction-bottom[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]{transform:translateY(100%)}}.hmf-drawer.direction-bottom[_ngcontent-%COMP%]   .hmf-drawer-container.closing[_ngcontent-%COMP%]{overflow:hidden;transform:translateY(100%)}.hmf-drawer.direction-left[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]{height:100%;width:var(--hmf-drawer-size, 40%);overflow:hidden;left:0;transform:translate(0);transition:transform var(--hmf-ease-out-fast),var(--hmf-ease-out-fast)}@starting-style{.hmf-drawer.direction-left[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]{transform:translate(-100%)}}.hmf-drawer.direction-left[_ngcontent-%COMP%]   .hmf-drawer-container.closing[_ngcontent-%COMP%]{overflow:hidden;transform:translate(-100%)}@media (max-width: 768px){.hmf-drawer.direction-left[_ngcontent-%COMP%]   .hmf-drawer-container[_ngcontent-%COMP%]{width:94%}.hmf-drawer.direction-left[_ngcontent-%COMP%]   .hmf-drawer-container.mobile-peek[_ngcontent-%COMP%]{height:var(--hmf-drawer-size, 94%);width:100%;overflow:hidden;bottom:0;transform:translateY(0);transition:transform var(--hmf-ease-out-fast),var(--hmf-ease-out-fast)}@starting-style{.hmf-drawer.direction-left[_ngcontent-%COMP%]   .hmf-drawer-container.mobile-peek[_ngcontent-%COMP%]{transform:translateY(100%)}}.hmf-drawer.direction-left[_ngcontent-%COMP%]   .hmf-drawer-container.mobile-peek.closing[_ngcontent-%COMP%]{overflow:hidden;transform:translateY(100%)}}.hmf-drawer.direction-left[_ngcontent-%COMP%]   .hmf-drawer-background-close[_ngcontent-%COMP%]:not(.hmf-drawer.direction-left .hmf-drawer-background-close.hmf-drawer-no-overlay-background){animation:_ngcontent-%COMP%_reverse-overlay-fade .3s forwards}@keyframes _ngcontent-%COMP%_overlay-fade{0%{background-color:transparent}to{background-color:rgb(var(--hmf-gray900-rgb),.4)}}@keyframes _ngcontent-%COMP%_reverse-overlay-fade{0%{background-color:rgb(var(--hmf-gray900-rgb),.4)}to{background-color:transparent}}"]
      });
    }
  }
  return HmfDrawerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfGlobalChipsComponent = /*#__PURE__*/(() => {
  class HmfGlobalChipsComponent {
    toggleFilter() {
      this.visibleFilter = !this.visibleFilter;
      if (this.visibleFilter) {
        this.removeFilter.emit(null);
      }
    }
    constructor(homefieldIconsLibraryService, elementRef) {
      this.homefieldIconsLibraryService = homefieldIconsLibraryService;
      this.elementRef = elementRef;
      this.element = '';
      this.label = input('');
      this.showCancelSign = input(false);
      this.isSelected = input(false);
      this.iconStatusName = input('');
      this.removeFilter = output();
      this.visibleFilter = false;
      this.homefieldIconsLibraryService.registerIcons([homefieldIconSignCancel, homefieldIconAlertNewreleases, homefieldIconSignCircledSubtractOutlined, homefieldIconSignCircledAddFilled, homefieldIconAlertWarningOutlined]);
      this.element = this.elementRef.nativeElement?.tagName?.toLowerCase();
    }
    static {
      this.ɵfac = function HmfGlobalChipsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfGlobalChipsComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfGlobalChipsComponent,
        selectors: [["hmf-global-chips"]],
        inputs: {
          label: [1, "label"],
          showCancelSign: [1, "showCancelSign"],
          isSelected: [1, "isSelected"],
          iconStatusName: [1, "iconStatusName"]
        },
        outputs: {
          removeFilter: "removeFilter"
        },
        decls: 6,
        vars: 7,
        consts: [[1, "hmf-global-chips-container", 3, "click", "ngClass"], [1, "global-chip", "hmf-align-items-center", "hmf-display-inline-flex", "hmf-body-m", "hmf-px-xs", "hmf-py-xxxs", 3, "ngClass"], ["width", "20px", "height", "20px", 1, "hmf-global-chip-svg", "hmf-display-flex", "hmf-pr-xxs", 3, "name"], [1, "hmf-body-l"], ["width", "20px", "height", "20px", "name", "sign-cancel", 1, "hmf-global-chip-svg", "hmf-display-flex", "hmf-pl-xs"]],
        template: function HmfGlobalChipsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function HmfGlobalChipsComponent_Template_div_click_0_listener() {
              return ctx.toggleFilter();
            });
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵtemplate(2, HmfGlobalChipsComponent_Conditional_2_Template, 1, 1, "homefield-icon", 2);
            i0.ɵɵelementStart(3, "span", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, HmfGlobalChipsComponent_Conditional_5_Template, 1, 0, "homefield-icon", 4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c10, ctx.visibleFilter));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.isSelected() ? "global-chips--active" : "");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.iconStatusName() ? 2 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.label());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showCancelSign() ? 5 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: [".hmf-global-chips-container[_ngcontent-%COMP%]   .global-chip[_ngcontent-%COMP%]{background-color:transparent;border-radius:50px;box-shadow:var(--hmf-subtle-shadow);cursor:pointer;height:100%;min-width:0;width:max-content}.hmf-global-chips-container[_ngcontent-%COMP%]   .global-chip[_ngcontent-%COMP%]:hover{box-shadow:var(--hmf-elevated-shadow)}.hmf-global-chips-container[_ngcontent-%COMP%]   .global-chip[_ngcontent-%COMP%]:focus-visible{outline:1px dashed var(--hmf-gray600);outline-offset:2px}.hmf-global-chips-container[_ngcontent-%COMP%]   .global-chip--active[_ngcontent-%COMP%]{border:1px solid var(--border-base)}"]
      });
    }
  }
  return HmfGlobalChipsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfHeroBannerComponent = /*#__PURE__*/(() => {
  class HmfHeroBannerComponent {
    constructor() {
      this.textColorVariants = {
        dark: 'dark-text',
        light: 'light-text'
      };
      this.textBoxPositionVariants = {
        left: 'float-left',
        center: 'float-center',
        right: 'float-right',
        none: 'none'
      };
      this.textColor = 'light';
      this.textBoxPosition = 'left';
      this.textBoxBackground = true;
      this.headlineIsH1 = true;
      this.headline = '';
      this.subhead = '';
      this.link = '';
      this.buttonLabel = '';
      this.altText = '';
      this.buttonStyle = 'marketing';
      this.imageTitle = '';
      this.dataEm = '';
      this.legalText = '';
      this.legalTextLink = '';
    }
    static {
      this.ɵfac = function HmfHeroBannerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfHeroBannerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfHeroBannerComponent,
        selectors: [["hmf-hero-banner"]],
        inputs: {
          textColor: "textColor",
          textBoxPosition: "textBoxPosition",
          textBoxBackground: "textBoxBackground",
          headlineIsH1: "headlineIsH1",
          headline: "headline",
          subhead: "subhead",
          link: "link",
          buttonLabel: "buttonLabel",
          altText: "altText",
          mobileImage: "mobileImage",
          image: "image",
          buttonStyle: "buttonStyle",
          imageTitle: "imageTitle",
          dataEm: "dataEm",
          legalText: "legalText",
          legalTextLink: "legalTextLink"
        },
        decls: 10,
        vars: 19,
        consts: [["id", "hmf-hero-banner"], [1, "hmf-hero-banner-image-container", "hmf-display-m-flex", "hmf-justify-content-center", 3, "ngClass"], [4, "ngIf"], [1, "hmf-hero-banner-copybox-container", "hmf-align-items-center", "hmf-display-flex", "hmf-position-absolute"], [3, "ngClass"], ["class", "hmf-display-m hmf-display-m-l hmf-display-l-xl hmf-pb-xxs", 4, "ngIf"], ["class", "hmf-display-m hmf-display-m-l hmf-display-l-xl  hmf-my-m-s hmf-my-s-s hmf-pb-xxs", 4, "ngIf"], ["class", "hmf-header-bold-xs hmf-subheader-bold-s hmf-header-bold-l hmf-mb-xxs", 4, "ngIf"], ["class", "hmf-hero-banner-details-text hmf-legal-s hmf-mb-m-s hmf-position-m-absolute", 4, "ngIf"], ["hmf-button", "", "class", "hmf-mb-s hmf-text-decoration-under cta-button", "height", "base", 3, "variant", "href", "dataEm", 4, "ngIf"], ["media", "(max-width: 768px)", 3, "srcset", 4, "ngIf"], ["role", "img", "loading", "lazy", "width", "320", "height", "240", 1, "loaded", 3, "src"], ["media", "(max-width: 768px)", 3, "srcset"], [1, "hmf-display-m", "hmf-display-m-l", "hmf-display-l-xl", "hmf-pb-xxs"], [1, "hmf-display-m", "hmf-display-m-l", "hmf-display-l-xl", "hmf-my-m-s", "hmf-my-s-s", "hmf-pb-xxs"], [1, "hmf-header-bold-xs", "hmf-subheader-bold-s", "hmf-header-bold-l", "hmf-mb-xxs"], [1, "hmf-hero-banner-details-text", "hmf-legal-s", "hmf-mb-m-s", "hmf-position-m-absolute"], [3, "href"], ["hmf-button", "", "height", "base", 1, "hmf-mb-s", "hmf-text-decoration-under", "cta-button", 3, "variant", "href", "dataEm"]],
        template: function HmfHeroBannerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, HmfHeroBannerComponent_picture_2_Template, 3, 3, "picture", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3)(4, "div", 4);
            i0.ɵɵtemplate(5, HmfHeroBannerComponent_h1_5_Template, 2, 1, "h1", 5)(6, HmfHeroBannerComponent_h2_6_Template, 2, 1, "h2", 6)(7, HmfHeroBannerComponent_p_7_Template, 2, 1, "p", 7)(8, HmfHeroBannerComponent_p_8_Template, 4, 2, "p", 8)(9, HmfHeroBannerComponent_a_9_Template, 2, 6, "a", 9);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("", ctx.textBoxPositionVariants[ctx.textBoxPosition], " hmf-hero-banner-container hmf-position-relative hmf-display-flex hmf-flex-row hmf-flex-wrap hmf-justify-content-center hmf-align-items-m-center hmf-mb-s hmf-mx-xs-0 hmf-mx-m-xs hmf-mx-l-s");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(14, _c24, ctx.textBoxPosition === "center" || ctx.textBoxPosition === "left" || ctx.textBoxPosition === "right", ctx.textBoxPosition === "center", ctx.textBoxPosition === "right", ctx.textBoxPosition === "left"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.image);
            i0.ɵɵadvance(2);
            i0.ɵɵclassMapInterpolate1("hmf-hero-banner-copybox hmf-display-flex hmf-justify-content-s-center hmf-flex-s-column hmf-mx-m-0 hmf-p-s hmf-px-m-l hmf-position-s-absoulute mobile-float-center ", ctx.textColorVariants[ctx.textColor], "");
            i0.ɵɵproperty("ngClass", ctx.textBoxBackground ? "background" : "no-background");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.headline && ctx.headlineIsH1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.headline && !ctx.headlineIsH1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.subhead);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.legalText && ctx.legalTextLink);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.buttonLabel && ctx.link);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgIf, HmfButtonComponent],
        styles: ["[_nghost-%COMP%]   .hmf-hero-banner-container[_ngcontent-%COMP%]{height:100%;max-width:100vw;overflow:hidden;width:100%}[_nghost-%COMP%]   .hmf-hero-banner-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:auto;width:100%}[_nghost-%COMP%]   .hmf-hero-banner-container[_ngcontent-%COMP%]   .hmf-hero-banner-image-container[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   .hmf-hero-banner-container[_ngcontent-%COMP%]   .hmf-hero-banner-copybox-container[_ngcontent-%COMP%]{inset:0;width:100%}[_nghost-%COMP%]   .hmf-hero-banner-container[_ngcontent-%COMP%]   .hmf-hero-banner-details-text[_ngcontent-%COMP%]{color:inherit}[_nghost-%COMP%]   .hmf-hero-banner-container[_ngcontent-%COMP%]   .hmf-hero-banner-details-text[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:underline}@media (min-width: 480px){[_nghost-%COMP%]   .hmf-hero-banner-container[_ngcontent-%COMP%]   .hmf-hero-banner-details-text[_ngcontent-%COMP%]{bottom:0}}[_nghost-%COMP%]   .hmf-hero-banner-container[_ngcontent-%COMP%]   .hmf-hero-banner-copybox[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   .hmf-hero-banner-container[_ngcontent-%COMP%]   .hmf-hero-banner-copybox.light-text[_ngcontent-%COMP%]{color:var(--hmf-gray50)}[_nghost-%COMP%]   .hmf-hero-banner-container[_ngcontent-%COMP%]   .hmf-hero-banner-copybox.dark-text[_ngcontent-%COMP%]{color:var(--hmf-label-base)}[_nghost-%COMP%]   .hmf-hero-banner-container[_ngcontent-%COMP%]   .hmf-hero-banner-copybox[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{color:inherit}@media (min-width: 480px){[_nghost-%COMP%]   .hmf-hero-banner-container.mobile-float-center[_ngcontent-%COMP%]{height:inherit}}[_nghost-%COMP%]   .hmf-hero-banner-container.float-left[_ngcontent-%COMP%]   .hmf-hero-banner-copybox-container[_ngcontent-%COMP%], [_nghost-%COMP%]   .hmf-hero-banner-container.float-center[_ngcontent-%COMP%]   .hmf-hero-banner-copybox-container[_ngcontent-%COMP%], [_nghost-%COMP%]   .hmf-hero-banner-container.float-right[_ngcontent-%COMP%]   .hmf-hero-banner-copybox-container[_ngcontent-%COMP%]{height:inherit}[_nghost-%COMP%]   .hmf-hero-banner-container.float-left[_ngcontent-%COMP%]   .hmf-hero-banner-copybox[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   .hmf-hero-banner-container.float-right[_ngcontent-%COMP%]{width:100%}@media (min-width: 768px){[_nghost-%COMP%]   .hmf-hero-banner-container.float-right[_ngcontent-%COMP%]   .hmf-hero-banner-copybox[_ngcontent-%COMP%]{max-width:80%}}[_nghost-%COMP%]   .hmf-hero-banner-container.float-center[_ngcontent-%COMP%]{width:100%}@media (min-width: 768px){[_nghost-%COMP%]   .hmf-hero-banner-container.float-center[_ngcontent-%COMP%]   .hmf-hero-banner-copybox[_ngcontent-%COMP%]{max-width:1036px}}"]
      });
    }
  }
  return HmfHeroBannerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfModalComponent = /*#__PURE__*/(() => {
  class HmfModalComponent {
    set setModalBackground(ref) {
      if (ref) {
        this.modalBackground = ref;
        this.modalBackgroundReady$.next(true);
      }
    }
    set setModalContainer(ref) {
      if (ref) {
        this.modalContainer = ref;
        this.modalContainerReady$.next(true);
      }
    }
    //TODO: inject window token and replace direct usage
    constructor(homefieldIconsLibraryService, document) {
      this.homefieldIconsLibraryService = homefieldIconsLibraryService;
      this.document = document;
      this.open = false;
      this.closeableModalVariants = ['modal', 'dropdown', 'popover'];
      this.previousFocus = null;
      this.modalBackgroundReady$ = new Subject();
      this.modalContainerReady$ = new Subject();
      this.viewChildrenReady$ = combineLatest([this.modalBackgroundReady$, this.modalContainerReady$]);
      this.anchorElement = null;
      this.attachedBackground = false;
      this.className = '';
      this.closable = true;
      this.direction = 'right';
      this.focus = false;
      this.headerText = '';
      this.dialogSubHeaderText = '';
      this.mobilePeek = false;
      this.interactability = false;
      this.clickableBackground = false;
      this.isCloseButtonSticky = false;
      this.showHeaderBottomBorder = true;
      this.transparentBackground = false;
      this.type = 'modal';
      this.opened = new EventEmitter();
      this.closed = new EventEmitter();
      this.closeRef = {};
      this.closing = false;
      //This is a workaround because *ngIf clears the view and renders AfterViewInit
      //useless as a hook to work with ViewChild elements after they've been setup
      this.modalBackground = {};
      this.modalContainer = {};
      homefieldIconsLibraryService.registerIcons([homefieldIconSignCancel]);
    }
    ngOnInit() {
      if (!this.type) {
        this.type = 'modal';
      }
      if (this.focus) {
        this.handleFocusFirstElement();
      }
      if (this.parentDestroyRef) {
        this.parentDestroyRef.onDestroy(() => {
          if (this.open) {
            this.closeModal();
          }
        });
      }
    }
    ngOnDestroy() {
      this.document.removeEventListener('keydown', this.handleFocusTrap.bind(this));
    }
    openModal() {
      this.open = true;
      this.previousFocus = this.document.activeElement;
      if (!this.interactability) {
        this.document.body.style.overflow = 'hidden';
        this.document.addEventListener('keydown', this.handleFocusTrap.bind(this));
      } else {
        window.addEventListener('scroll', this.setPositioningStyle.bind(this));
        this.document.addEventListener('keydown', this.handleInteractableEscape.bind(this));
      }
      this.viewChildrenReady$.pipe(takeUntil(this.closed)).subscribe(([modalBackgroundReady, modalContainerReady]) => {
        if (modalBackgroundReady && modalContainerReady) {
          this.setPositioningStyle();
          this.opened.emit();
        }
      });
    }
    closeModal() {
      this.closing = true;
      if (!this.interactability) {
        this.document.body.style.overflow = 'auto';
        this.document.removeEventListener('keydown', this.handleFocusTrap.bind(this));
      } else {
        window.removeEventListener('scroll', this.setPositioningStyle.bind(this));
        this.document.removeEventListener('keydown', this.handleInteractableEscape.bind(this));
      }
      setTimeout(() => {
        this.closing = false;
        this.closed.emit();
        this.open = false;
      }, 400);
    }
    setPositioningStyle() {
      const element = this.modalContainer?.nativeElement;
      const background = this.modalBackground?.nativeElement;
      if (!element || !background) {
        return;
      }
      if (this.anchorElement) {
        if (this.direction !== 'bottom') {
          element.style.top = this.calculateTop(element);
        } else {
          element.style.bottom = this.calculateBottom(element);
        }
        if (this.anchorElement.offsetWidth) {
          if (this.type === 'dropdown') {
            element.style.width = `auto`;
            element.style.minWidth = `${this.anchorElement.offsetWidth}px`;
          }
          if (this.type === 'popover' || this.type === 'dropdown') {
            element.style.left = this.calculateLeft(element);
          }
        }
      }
    }
    handleFocusTrap(event) {
      if (this.open) {
        const modal = this.document.querySelector('.hmf-modal-container');
        if (modal) {
          const focusable = modal.querySelectorAll('button, [href], input, select, textarea, li, a,[tabindex]:not([tabindex="-1"])');
          const firstFocusable = focusable[0];
          const lastFocusable = focusable[focusable.length - 1];
          const isTabPressed = event.key === 'Tab';
          if (event.key === 'Escape') {
            this.handleEscapePressed();
          }
          if (!isTabPressed) {
            return;
          }
          if (event.shiftKey) {
            if (this.document.activeElement === firstFocusable) {
              lastFocusable.focus();
              event.preventDefault();
            }
          } else {
            if (this.document.activeElement === lastFocusable) {
              firstFocusable.focus();
              event.preventDefault();
            }
          }
        }
      }
    }
    handleInteractableEscape(event) {
      const isEscPressed = event.key === 'Escape';
      if (isEscPressed) {
        this.handleEscapePressed();
        return;
      }
    }
    calculateLeft(element) {
      let left = '';
      if (this.anchorElement.getBoundingClientRect().left + element.clientWidth > window.innerWidth) {
        left = `${this.anchorElement.getBoundingClientRect().left - (element.clientWidth - (window.innerWidth + window.scrollX - this.anchorElement.getBoundingClientRect().left)) - 20}px`;
      } else {
        left = `${this.anchorElement.getBoundingClientRect().left + window.scrollX}px`;
      }
      return left;
    }
    calculateTop(element) {
      let top = '';
      if (this.anchorElement.getBoundingClientRect().bottom + element.clientHeight > window.innerHeight) {
        if (element.clientHeight > window.innerHeight) {
          top = `${this.anchorElement.getBoundingClientRect().bottom + window.scrollY}px`;
          element.style.overflowY = 'scroll';
          element.style.maxHeight = this.calculateMaxHeight(element);
        } else {
          top = `${this.anchorElement.getBoundingClientRect().bottom - (element.scrollHeight - (window.innerHeight + window.scrollY - this.anchorElement.getBoundingClientRect().bottom)) - 20}px`;
        }
      } else {
        top = `${this.anchorElement.getBoundingClientRect().bottom + window.scrollY}px`;
      }
      return top;
    }
    calculateBottom(element) {
      let bottom = '';
      if (this.anchorElement.getBoundingClientRect().top - element.scrollHeight < 0) {
        bottom = `${window.innerHeight - element.scrollHeight}px`;
      } else {
        bottom = `${window.innerHeight - (this.anchorElement.getBoundingClientRect().bottom - this.anchorElement.scrollHeight)}px`;
      }
      return bottom;
    }
    calculateMaxHeight(element) {
      let maxHeight = '';
      if (this.anchorElement.getBoundingClientRect().bottom + element.clientHeight > window.innerHeight) {
        maxHeight = `${window.innerHeight - this.anchorElement.getBoundingClientRect().bottom - 20}px`;
      } else {
        maxHeight = 'none';
      }
      return maxHeight;
    }
    handleFocusFirstElement() {
      if (this.open) {
        if (this.closeRef && this.closeRef.nativeElement) {
          this.closeRef.nativeElement.focus();
        } else if (this.modalContainer && this.modalContainer.nativeElement) {
          const focusElement = this.modalContainer.nativeElement.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])')[0];
          if (focusElement) {
            const x = window.scrollX;
            const y = window.scrollY;
            focusElement.focus();
            window.scrollTo(x, y);
          }
        }
      } else {
        if (this.previousFocus) {
          this.previousFocus.focus();
        }
      }
    }
    handleEscapePressed() {
      if (this.type && this.closeableModalVariants.includes(this.type)) {
        this.closeModal();
      }
    }
    get modalClasses() {
      return {
        [`direction-${this.direction}`]: !!this.direction,
        interactable: !!this.interactability,
        'non-interactable': !this.interactability,
        'hmf-align-items-center hmf-justify-content-center': this.type === 'dialog' || this.type === 'modal'
      };
    }
    get modalContainerClasses() {
      return {
        closing: this.closing,
        'mobile-peek': !!this.mobilePeek
      };
    }
    get closeButtonClasses() {
      return {
        // When sticky, it aligns with the title using flex
        'hmf-position-absolute': !this.isCloseButtonSticky,
        'hmf-m-0': !!this.isCloseButtonSticky,
        'close-button-padding': !this.isCloseButtonSticky,
        'hmf-ml-auto': !!this.isCloseButtonSticky // Keeps the button to the right when sticky
      };
    }
    get modalContainerWrapperClasses() {
      const titleFlexClasses = `hmf-display-flex hmf-justify-content-between hmf-align-items-flex-start`;
      const marginClasses = 'hmf-pt-m-m hmf-pb-m-xs hmf-px-m-m hmf-pt-s-xs hmf-pb-s-xs hmf-px-s hmf-py-s';
      return {
        'hmf-position-sticky hmf-close-wrapper ': !!this.isCloseButtonSticky,
        'hmf-border-bottom-header': !!this.isCloseButtonSticky && this.type === 'modal' && !!this.showHeaderBottomBorder,
        [`${titleFlexClasses}`]: !!this.isCloseButtonSticky,
        [`${marginClasses}`]: !!this.isCloseButtonSticky
      };
    }
    get modalContainerCloseClasses() {
      return {
        'hmf-m-m': !this.isCloseButtonSticky,
        'hmf-position-absolute': !this.isCloseButtonSticky,
        'hmf-ml-auto': !!this.isCloseButtonSticky
      };
    }
    get modalBackgroundClasses() {
      return {
        'hmf-modal-no-overlay-background': !!this.transparentBackground,
        'hmf-modal-background-interactable': !!this.interactability,
        'hmf-modal-background-non-interactable': !this.interactability && !this.clickableBackground,
        'hmf-modal-background-clickable': !this.interactability && !!this.clickableBackground,
        'hmf-modal-background-close': this.closing
      };
    }
    handleWindowResize() {
      if (this.open) {
        this.setPositioningStyle();
      }
    }
    handleWindowScroll() {
      if (!(this.open && this.interactability)) {
        return;
      }
      this.setPositioningStyle();
    }
    static {
      this.ɵfac = function HmfModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfModalComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService), i0.ɵɵdirectiveInject(DOCUMENT));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfModalComponent,
        selectors: [["hmf-modal"]],
        viewQuery: function HmfModalComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c20, 5);
            i0.ɵɵviewQuery(_c25, 5);
            i0.ɵɵviewQuery(_c26, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.setModalBackground = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.setModalContainer = _t.first);
          }
        },
        hostBindings: function HmfModalComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("resize", function HmfModalComponent_resize_HostBindingHandler() {
              return ctx.handleWindowResize();
            }, false, i0.ɵɵresolveWindow)("scroll", function HmfModalComponent_scroll_HostBindingHandler() {
              return ctx.handleWindowScroll();
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          anchorElement: "anchorElement",
          attachedBackground: "attachedBackground",
          className: "className",
          closable: "closable",
          direction: "direction",
          focus: "focus",
          headerText: "headerText",
          dialogSubHeaderText: "dialogSubHeaderText",
          mobilePeek: "mobilePeek",
          interactability: "interactability",
          clickableBackground: "clickableBackground",
          isCloseButtonSticky: "isCloseButtonSticky",
          showHeaderBottomBorder: "showHeaderBottomBorder",
          transparentBackground: "transparentBackground",
          type: "type",
          parentDestroyRef: "parentDestroyRef"
        },
        outputs: {
          opened: "opened",
          closed: "closed"
        },
        ngContentSelectors: _c6,
        decls: 3,
        vars: 1,
        consts: [["contentTemplate", ""], ["modalContainer", ""], ["modalBackground", ""], ["closeRef", ""], [3, "class", "ngClass"], [3, "ngClass"], ["id", "hmf-modal-container-id", 1, "hmf-modal-container", "hmf-display-flex", "hmf-position-fixed", "hmf-flex-column", 3, "ngClass"], [1, "hmf-dialog-container", "hmf-flex-column", "hmf-flex-grow", "hmf-p-s"], ["id", "hmf-modal-background-id", "onkeypress", "", 1, "hmf-modal-background", "hmf-position-fixed", 3, "click", "ngClass"], ["id", "hmf-modal-container-wrapper", 1, "hmf-modal-container-wrapper", 3, "ngClass"], [1, "hmf-header-bold-s"], [1, "hmf-modal-container-close", "hmf-display-flex", "hmf-flex-column", "hmf-align-items-center", "hmf-legal-s", "hmf-p-0", "hmf-m-0", 3, "click", "keydown.enter", "variant", "size", "iconSize", "label", "ngClass"], ["width", "24px", "height", "24px", "name", "sign-cancel"], [1, "hmf-body-m"], [1, "hmf-dialog-controls", "hmf-flex-column", "hmf-flex-m-row", "hmf-flex-wrap", "hmf-justify-content-between"], [4, "ngTemplateOutlet"]],
        template: function HmfModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, HmfModalComponent_Conditional_0_Template, 8, 9, "div", 4)(1, HmfModalComponent_ng_template_1_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.open ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgTemplateOutlet, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent, HmfButtonComponent],
        styles: [".hmf-modal[_ngcontent-%COMP%]{height:100%;inset:0;width:100%;z-index:var(--hmf-z-index-overlay)}.hmf-modal.interactable[_ngcontent-%COMP%]{pointer-events:none}.hmf-modal.interactable[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]{pointer-events:all}.hmf-modal[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]{background-color:var(--hmf-gray50);box-shadow:var(--hmf-elevated-shadow);height:auto;width:auto;z-index:calc(var(--hmf-z-index-overlay) + 1)}.hmf-modal[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]   .hmf-modal-container-wrapper.hmf-border-bottom-header[_ngcontent-%COMP%]{border-bottom:1px solid var(--hmf-border-base)}.hmf-modal[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]   .hmf-modal-container-wrapper[_ngcontent-%COMP%]   .hmf-modal-title[_ngcontent-%COMP%]{word-break:break-word}.hmf-modal[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]   .hmf-modal-container-wrapper[_ngcontent-%COMP%]   .hmf-modal-container-close[_ngcontent-%COMP%]{background:transparent;border:none;cursor:pointer;right:0;top:0;z-index:calc(var(--hmf-z-index-overlay) + 2)}.hmf-modal[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]   .hmf-modal-container-wrapper[_ngcontent-%COMP%]   .hmf-modal-container-close[_ngcontent-%COMP%]:focus{outline:1px dashed var(--hmf-gray600);outline-offset:3px}.hmf-modal[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]   .hmf-modal-container-wrapper[_ngcontent-%COMP%]   .hmf-modal-container-close[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-gray900)}.hmf-modal[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]   .hmf-modal-container-wrapper[_ngcontent-%COMP%]   .hmf-modal-container-close.close-button-padding[_ngcontent-%COMP%]{margin:var(--hmf-s)}@media (min-width: 768px){.hmf-modal[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]   .hmf-modal-container-wrapper[_ngcontent-%COMP%]   .hmf-modal-container-close.close-button-padding[_ngcontent-%COMP%]{margin:var(--hmf-m)}}.hmf-modal[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]   .hmf-modal-container-wrapper.hmf-close-wrapper[_ngcontent-%COMP%]{background-color:var(--hmf-background-base);box-sizing:border-box;min-height:var(--hmf-xl);top:0;width:100%}.hmf-modal[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]   .hmf-modal-container-wrapper[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{height:var(--hmf-m);margin:var(--hmf-0);width:var(--hmf-m)}.hmf-modal[_ngcontent-%COMP%]   .hmf-modal-background[_ngcontent-%COMP%]{height:100%;width:100%;z-index:var(--hmf-z-index-overlay)}.hmf-modal[_ngcontent-%COMP%]   .hmf-modal-background[_ngcontent-%COMP%]:not(.hmf-modal .hmf-modal-background.hmf-modal-no-overlay-background){animation:_ngcontent-%COMP%_overlay-fade .3s ease-out forwards}.hmf-modal[_ngcontent-%COMP%]   .hmf-modal-background.hmf-modal-background-non-interactable[_ngcontent-%COMP%]{pointer-events:none}.hmf-modal[_ngcontent-%COMP%]   .hmf-modal-background.hmf-modal-background-clickable[_ngcontent-%COMP%]{pointer-events:auto}.hmf-modal.hmf-modal-type-modal[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_opacity-in .3s ease-out forwards;min-height:300px;padding:var(--hmf-s);width:calc(100% - var(--hmf-s) * 2)}@media (min-width: 768px){.hmf-modal.hmf-modal-type-modal[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]{min-width:300px;padding:var(--hmf-m);width:auto}}.hmf-modal.hmf-modal-type-dialog[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_opacity-in .3s ease-out forwards;width:100%}@media (min-width: 768px){.hmf-modal.hmf-modal-type-dialog[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]{width:35%!important}}@keyframes _ngcontent-%COMP%_overlay-fade{0%{background-color:transparent}to{background-color:rgb(var(--hmf-gray900-rgb),.4)}}@keyframes _ngcontent-%COMP%_opacity-in{0%{opacity:0}to{opacity:1}}[_nghost-%COMP%]     .hmf-modal-container-close.hmf-close-secondary homefield-icon svg>path{fill:var(--hmf-gray50)}"]
      });
    }
  }
  return HmfModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfPopoverComponent = /*#__PURE__*/(() => {
  class HmfPopoverComponent {
    // Apply styles to the host element
    get position_style() {
      return 'absolute';
    }
    get zIndex() {
      return '1000';
    }
    constructor() {
      this.platformId = inject(PLATFORM_ID);
      this.elementRef = inject(ElementRef);
      this.open = input(false);
      this.variant = input('configurable');
      this.styleColor = input('light');
      this.position = input('bottom');
      this.alignment = input('center');
      this.padding = input('default');
      this.displayCaret = input(false);
      this.text = input('');
      this.className = input('');
      this.testId = input('popover');
      this.anchorElement = input(null);
      this.handleCloseModule = output();
      this.popoverRef = viewChild('popoverElement');
      this.topPosition = '0px';
      this.leftPosition = '0px';
      this.popoverClasses = computed(() => {
        const positionClassString = PopoverUtils.getPositionClass(this.position(), this.alignment());
        const positionClasses = positionClassString.split(' ');
        return ['hmf-popover', this.displayCaret() ? 'has-caret' : '', ...positionClasses, PopoverUtils.getBackgroundClass(this.styleColor()), PopoverUtils.getPaddingClass(this.padding()), 'hmf-body-m', this.className()].filter(Boolean).join(' ');
      });
      this.popoverStyles = computed(() => ({}));
      effect(() => {
        const isShown = this.open();
        const anchor = this.anchorElement();
        if (isShown && anchor && isPlatformBrowser(this.platformId)) {
          requestAnimationFrame(() => {
            this.updatePosition();
          });
        }
      });
      effect(() => {
        if (isPlatformBrowser(this.platformId)) {
          if (this.open()) {
            this.addOutsideClickListener();
          } else {
            this.removeOutsideClickListener();
          }
        }
      });
    }
    ngAfterViewInit() {
      if (this.open() && this.anchorElement()) {
        this.updatePosition();
      }
    }
    ngOnDestroy() {
      this.removeOutsideClickListener();
    }
    updatePosition() {
      const anchor = this.anchorElement();
      if (!anchor) return;
      const hostElement = this.elementRef.nativeElement;
      const anchorRect = anchor.getBoundingClientRect();
      const popoverRect = hostElement.getBoundingClientRect();
      const {
        top,
        left
      } = calculatePosition(anchorRect, popoverRect, this.position(), this.alignment());
      const {
        adjustedLeft,
        adjustedTop
      } = adjustToViewport(left, top, popoverRect, anchorRect);
      this.topPosition = `${adjustedTop}px`;
      this.leftPosition = `${adjustedLeft}px`;
    }
    addOutsideClickListener() {
      if (!isPlatformBrowser(this.platformId) || this.outsideClickListener) return;
      this.outsideClickListener = event => {
        const hostElement = this.elementRef.nativeElement;
        const target = event.target;
        const anchor = this.anchorElement();
        if (!hostElement.contains(target) && anchor && !anchor.contains(target)) {
          this.handleCloseModule.emit(false);
        }
      };
      document.addEventListener('click', this.outsideClickListener, true);
    }
    removeOutsideClickListener() {
      if (isPlatformBrowser(this.platformId) && this.outsideClickListener) {
        document.removeEventListener('click', this.outsideClickListener, true);
        this.outsideClickListener = undefined;
      }
    }
    static {
      this.ɵfac = function HmfPopoverComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfPopoverComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfPopoverComponent,
        selectors: [["hmf-popover"]],
        viewQuery: function HmfPopoverComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.popoverRef, _c27, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        hostVars: 8,
        hostBindings: function HmfPopoverComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("position", ctx.position_style)("z-index", ctx.zIndex)("top", ctx.topPosition)("left", ctx.leftPosition);
          }
        },
        inputs: {
          open: [1, "open"],
          variant: [1, "variant"],
          styleColor: [1, "styleColor"],
          position: [1, "position"],
          alignment: [1, "alignment"],
          padding: [1, "padding"],
          displayCaret: [1, "displayCaret"],
          text: [1, "text"],
          className: [1, "className"],
          testId: [1, "testId"],
          anchorElement: [1, "anchorElement"]
        },
        outputs: {
          handleCloseModule: "handleCloseModule"
        },
        ngContentSelectors: _c6,
        decls: 1,
        vars: 1,
        consts: [["popoverElement", ""], ["role", "tooltip", 3, "class", "ngStyle"], ["role", "tooltip", 3, "ngStyle"]],
        template: function HmfPopoverComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, HmfPopoverComponent_Conditional_0_Template, 4, 6, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.open() ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgStyle],
        styles: [".hmf-popover[_ngcontent-%COMP%]{border:none;box-shadow:var(--hmf-elevated-shadow);max-width:320px;min-width:120px;width:max-content}.has-caret[_ngcontent-%COMP%]:before, .has-caret[_ngcontent-%COMP%]:after{border:solid transparent;content:\"\";height:0;pointer-events:none;position:absolute;width:0}.popover-dark[_ngcontent-%COMP%]{background:var(--hmf-fill-inverse);border:1px solid var(--hmf-border-base);color:var(--hmf-fill-base);--popover-bg: var(--hmf-fill-inverse)}.popover-light[_ngcontent-%COMP%]{background:var(--hmf-fill-base);border:1px solid var(--hmf-border-base);color:var(--hmf-fill-inverse);--popover-bg: var(--hmf-fill-base)}.position-bottom[_ngcontent-%COMP%]:before{border-color:transparent transparent var(--hmf-border-base) transparent;border-width:0 var(--hmf-xs) var(--hmf-xs) var(--hmf-xs);bottom:100%;left:50%;margin-left:calc(var(--hmf-xs) * -1)}.position-bottom[_ngcontent-%COMP%]:after{border-color:transparent transparent var(--popover-bg, var(--hmf-gray50)) transparent;border-width:0 calc(var(--hmf-xs) - 1px) calc(var(--hmf-xs) - 1px) calc(var(--hmf-xs) - 1px);bottom:calc(100% - 1px);left:50%;margin-left:calc((var(--hmf-xs) - 1px) * -1)}.position-top[_ngcontent-%COMP%]:before{border-color:var(--hmf-border-base) transparent transparent transparent;border-width:var(--hmf-xs) var(--hmf-xs) 0 var(--hmf-xs);left:50%;margin-left:calc(var(--hmf-xs) * -1);top:100%}.position-top[_ngcontent-%COMP%]:after{border-color:var(--popover-bg, var(--hmf-gray50)) transparent transparent transparent;border-width:calc(var(--hmf-xs) - 1px) calc(var(--hmf-xs) - 1px) 0 calc(var(--hmf-xs) - 1px);left:50%;margin-left:calc((var(--hmf-xs) - 1px) * -1);top:calc(100% - 1px)}.position-right[_ngcontent-%COMP%]:before{border-color:transparent var(--hmf-border-base) transparent transparent;border-width:var(--hmf-xs) var(--hmf-xs) var(--hmf-xs) 0;margin-top:calc(var(--hmf-xs) * -1);right:100%;top:50%}.position-right[_ngcontent-%COMP%]:after{border-color:transparent var(--popover-bg, var(--hmf-gray50)) transparent transparent;border-width:calc(var(--hmf-xs) - 1px) calc(var(--hmf-xs) - 1px) calc(var(--hmf-xs) - 1px) 0;margin-top:calc((var(--hmf-xs) - 1px) * -1);right:calc(100% - 1px);top:50%}.position-left[_ngcontent-%COMP%]:before{border-color:transparent transparent transparent var(--hmf-border-base);border-width:var(--hmf-xs) 0 var(--hmf-xs) var(--hmf-xs);left:100%;margin-top:calc(var(--hmf-xs) * -1);top:50%}.position-left[_ngcontent-%COMP%]:after{border-color:transparent transparent transparent var(--popover-bg, var(--hmf-gray50));border-width:calc(var(--hmf-xs) - 1px) 0 calc(var(--hmf-xs) - 1px) calc(var(--hmf-xs) - 1px);left:calc(100% - 1px);margin-top:calc((var(--hmf-xs) - 1px) * -1);top:50%}.position-top.alignment-left[_ngcontent-%COMP%]:before, .position-bottom.alignment-left[_ngcontent-%COMP%]:before, .position-top.alignment-left[_ngcontent-%COMP%]:after, .position-bottom.alignment-left[_ngcontent-%COMP%]:after{left:8px;margin-left:0}.position-top.alignment-center[_ngcontent-%COMP%]:before, .position-bottom.alignment-center[_ngcontent-%COMP%]:before, .position-top.alignment-center[_ngcontent-%COMP%]:after, .position-bottom.alignment-center[_ngcontent-%COMP%]:after{left:50%;margin-left:calc(var(--hmf-xs) * -1)}.position-top.alignment-right[_ngcontent-%COMP%]:before, .position-bottom.alignment-right[_ngcontent-%COMP%]:before, .position-top.alignment-right[_ngcontent-%COMP%]:after, .position-bottom.alignment-right[_ngcontent-%COMP%]:after{left:auto;margin-left:0;right:8px}.position-left.alignment-left[_ngcontent-%COMP%]:before, .position-right.alignment-left[_ngcontent-%COMP%]:before, .position-left.alignment-left[_ngcontent-%COMP%]:after, .position-right.alignment-left[_ngcontent-%COMP%]:after{margin-top:0;top:8px}.position-left.alignment-center[_ngcontent-%COMP%]:before, .position-right.alignment-center[_ngcontent-%COMP%]:before, .position-left.alignment-center[_ngcontent-%COMP%]:after, .position-right.alignment-center[_ngcontent-%COMP%]:after{margin-top:calc(var(--hmf-xs) * -1);top:50%}.position-left.alignment-right[_ngcontent-%COMP%]:before, .position-right.alignment-right[_ngcontent-%COMP%]:before, .position-left.alignment-right[_ngcontent-%COMP%]:after, .position-right.alignment-right[_ngcontent-%COMP%]:after{bottom:8px;margin-top:0;top:auto}.container[_ngcontent-%COMP%]{position:relative}"]
      });
    }
  }
  return HmfPopoverComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfPaginationComponent = /*#__PURE__*/(() => {
  class HmfPaginationComponent {
    constructor(homefieldIconsLibraryService) {
      this.homefieldIconsLibraryService = homefieldIconsLibraryService;
      this.totalPages = input(1);
      this.currentPage = input(1);
      this.disabled = input(false);
      this.pageChange = output();
      this.className = input('');
      this.pages = computed(() => {
        return getPages(this.totalPages(), this.currentPage());
      });
      this.canGoPrev = computed(() => this.currentPage() > 1);
      this.canGoNext = computed(() => this.currentPage() < this.totalPages());
      this.homefieldIconsLibraryService.registerIcons([homefieldIconChevronLeft, homefieldIconChevronRight]);
    }
    goToPage(page) {
      if (!this.disabled() && page !== this.currentPage()) {
        this.pageChange.emit(page);
      }
    }
    static {
      this.ɵfac = function HmfPaginationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfPaginationComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfPaginationComponent,
        selectors: [["hmf-pagination"]],
        inputs: {
          totalPages: [1, "totalPages"],
          currentPage: [1, "currentPage"],
          disabled: [1, "disabled"],
          className: [1, "className"]
        },
        outputs: {
          pageChange: "pageChange"
        },
        decls: 1,
        vars: 1,
        consts: [["aria-label", "Pagination", "role", "navigation", 3, "class"], ["aria-label", "Pagination", "role", "navigation"], ["aria-label", "Previous page", 1, "arrow", "hmf-display-flex", "hmf-align-items-center", "hmf-justify-content-center", 3, "disabled"], ["aria-label", "Next page", 1, "arrow", "hmf-display-flex", "hmf-align-items-center", "hmf-justify-content-center", 3, "disabled"], ["aria-label", "Previous page", 1, "arrow", "hmf-display-flex", "hmf-align-items-center", "hmf-justify-content-center", 3, "click", "disabled"], ["width", "24px", "height", "24px", 1, "hmf-display-flex", 3, "name"], ["type", "button", 1, "page", 3, "selected", "disabled"], [1, "ellipsis", "hmf-display-flex", "hmf-justify-content-center"], ["type", "button", 1, "page", 3, "click", "disabled"], ["aria-label", "Next page", 1, "arrow", "hmf-display-flex", "hmf-align-items-center", "hmf-justify-content-center", 3, "click", "disabled"]],
        template: function HmfPaginationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HmfPaginationComponent_Conditional_0_Template, 5, 4, "nav", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.totalPages() > 0 ? 0 : -1);
          }
        },
        dependencies: [CommonModule, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: [".ellipsis[_ngcontent-%COMP%]{width:5px}.pagination[_ngcontent-%COMP%]{font-style:normal;gap:var(--hmf-xs)}.page[_ngcontent-%COMP%]{background:var(--hmf-fill-secondary-static);border:none;color:var(--hmf-label-base);cursor:pointer;height:var(--sizing-interactive-component-medium, 44px);padding:var(--hmf-xxxs);width:var(--sizing-interactive-component-medium, 44px)}.page[_ngcontent-%COMP%]:disabled{cursor:not-allowed}.page[_ngcontent-%COMP%]:active:not(:disabled){background:var(--hmf-fill-secondary-active)}.page[_ngcontent-%COMP%]:hover:not(:disabled){background:var(--hmf-fill-secondary-hover)}.selected[_ngcontent-%COMP%]{background:var(--hmf-fill-base-subtle);border-radius:var(--hmf-sharp-radius)}.arrow[_ngcontent-%COMP%]{background:var(--hmf-fill-secondary-static);border:1px solid var(--hmf-border-secondary-static);border-radius:var(--hmf-round-radius);cursor:pointer;height:var(--sizing-interactive-component-medium, 44px);padding:var(--hmf-xxxs);width:var(--sizing-interactive-component-medium, 44px)}.arrow[_ngcontent-%COMP%]:disabled{background:var(--hmf-fill-base);border:1px solid var(--hmf-border-disabled-subtle);cursor:not-allowed}.arrow[_ngcontent-%COMP%]:active:not(:disabled){background:var(--hmf-fill-secondary-active);border:1px solid var(--hmf-border-secondary-active)}.arrow[_ngcontent-%COMP%]:hover:not(:disabled){background:var(--hmf-fill-secondary-hover);border:1px solid var(--hmf-border-secondary-hover)}"],
        changeDetection: 0
      });
    }
  }
  return HmfPaginationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfPriceComponent = /*#__PURE__*/(() => {
  class HmfPriceComponent {
    constructor() {
      this.isClearance = false;
      this.isSeePriceInCart = false;
      this.isSkuRecommendation = false;
      this.prices = {
        maxListPrice: '',
        maxOfferPrice: '',
        minListPrice: '',
        minOfferPrice: '',
        listPrice: '',
        maxMapPrice: '',
        minMapPrice: '',
        offerPrice: '',
        mapPriceIndicator: undefined
      };
      this.variant = 'vertical';
      this.currencyCode = 'USD';
    }
    static {
      this.MAP_PRICE_INDICATOR_THRESHOLD = 1;
    }
    get ariaLabel() {
      return `Was ${this.prices.minListPrice || this.prices.listPrice || ''}`;
    }
    get strikethroughConfig() {
      // Show strikethrough only if (clearance OR see price in cart) AND prices exist
      const shouldShow = (this.isSeePriceInCart || this.isClearance) && !!this.prices;
      // Early return if strikethrough should not be displayed
      if (!shouldShow) {
        return {
          shouldShow: false,
          showMinMaxRange: false,
          showSinglePrice: false,
          minPrice: '',
          maxPrice: '',
          listPrice: ''
        };
      }
      // Show min-max range if "see price in cart" OR has min list price
      const showMinMaxRange = (this.isSeePriceInCart || this.prices.minListPrice) && !!this.prices.minListPrice;
      // Show single price if NOT "see price in cart" AND NO min list price
      const showSinglePrice = !this.isSeePriceInCart && !this.prices.minListPrice;
      return {
        shouldShow,
        showMinMaxRange,
        showSinglePrice,
        minPrice: this.prices.minListPrice || '',
        maxPrice: this.prices.maxListPrice || '',
        listPrice: this.prices.listPrice || '',
        hasMaxPrice: this.prices.maxListPrice && this.prices.maxListPrice !== this.prices.minListPrice
      };
    }
    /**
     * Safely parses a price string to a number, handling potential currency symbols
     * @param priceString - The price string to parse
     * @returns Parsed number or 0 if invalid
     */
    parsePriceString(priceString) {
      if (!priceString) return 0;
      // Remove any non-numeric characters except decimal point and minus sign
      const cleanPrice = priceString.toString().replace(/[^0-9.-]/g, '');
      const parsed = parseFloat(cleanPrice);
      return isNaN(parsed) ? 0 : parsed;
    }
    /**
     * Determines which price elements to show in carousel variant based on MAP restrictions,
     * offer prices, and component flags.
     *
     * @returns Configuration object with boolean flags for template rendering decisions
     */
    get carouselConfig() {
      if (!this.prices) {
        return {
          showSeePriceInCart: false,
          showOfferPrice: false,
          showSkuRecommendationPrice: false,
          hasMapRestriction: false,
          hasPriceRange: false,
          showSeePriceForNoOffers: false
        };
      }
      const minOffer = this.parsePriceString(this.prices.minOfferPrice);
      const maxMap = this.parsePriceString(this.prices.maxMapPrice);
      const hasMapPrice = !!this.prices.maxMapPrice;
      const hasMinOfferPrice = !!this.prices.minOfferPrice;
      const isOfferBelowMAP = hasMapPrice && hasMinOfferPrice && minOffer < maxMap;
      const isOfferAboveMAP = hasMapPrice && hasMinOfferPrice && minOffer >= maxMap;
      const hasMapPriceIndicator = this.prices.mapPriceIndicator === HmfPriceComponent.MAP_PRICE_INDICATOR_THRESHOLD;
      const hasNoPrices = !this.prices.minOfferPrice && !this.prices.maxOfferPrice;
      return {
        hasMapRestriction: hasMapPrice,
        showSeePriceInCart: isOfferBelowMAP || this.isSeePriceInCart,
        showOfferPrice: isOfferAboveMAP && !this.isSkuRecommendation && !this.isSeePriceInCart,
        showSkuRecommendationPrice: isOfferAboveMAP && this.isSkuRecommendation && !this.isSeePriceInCart && !!this.prices.offerPrice,
        showSeePriceForNoOffers: hasNoPrices || hasMapPriceIndicator,
        hasPriceRange: this.prices.maxOfferPrice && this.prices.minOfferPrice !== this.prices.maxOfferPrice
      };
    }
    static {
      this.ɵfac = function HmfPriceComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfPriceComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfPriceComponent,
        selectors: [["hmf-price"]],
        inputs: {
          isClearance: "isClearance",
          isSeePriceInCart: "isSeePriceInCart",
          isSkuRecommendation: "isSkuRecommendation",
          prices: "prices",
          variant: "variant",
          currencyCode: "currencyCode"
        },
        decls: 7,
        vars: 1,
        consts: [["default", ""], ["strikethroughOnly", ""], ["carousel", ""], [3, "ngTemplateOutlet"], [3, "ngClass"], [1, "hmf-body-bold-l", 3, "ngClass"], [1, "hmf-text-decoration-linethrough", "hmf-body-s"], [1, "strikethrough-price", "hmf-body-s"], [1, "hmf-body-bold-l"]],
        template: function HmfPriceComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainer(0, 3);
            i0.ɵɵtemplate(1, HmfPriceComponent_ng_template_1_Template, 4, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, HmfPriceComponent_ng_template_3_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, HmfPriceComponent_ng_template_5_Template, 2, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const default_r2 = i0.ɵɵreference(2);
            const strikethroughOnly_r3 = i0.ɵɵreference(4);
            const carousel_r4 = i0.ɵɵreference(6);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.variant === "vertical" || ctx.variant === "wrapped" ? default_r2 : ctx.variant === "strikethrough" ? strikethroughOnly_r3 : carousel_r4);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgTemplateOutlet, i1$1.CurrencyPipe],
        styles: [".clearance[_ngcontent-%COMP%]{color:var(--hmf-red900)}.strikethrough-price[_ngcontent-%COMP%]{color:var(--hmf-label-base);font-size:var(--hmf-body-s-font-size, 14px);letter-spacing:var(--hmf-body-letter-spacing, .5px);text-decoration:line-through;text-decoration-skip-ink:none;text-underline-offset:-5px}[_nghost-%COMP%]{display:block}"],
        changeDetection: 0
      });
    }
  }
  return HmfPriceComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfProductImageService = /*#__PURE__*/(() => {
  class HmfProductImageService {
    constructor(platformId) {
      this.platformId = platformId;
    }
    buildImageSrc(imageData, ecode, selectedSwatchColor) {
      const isBrowser = isPlatformBrowser(this.platformId);
      if (typeof imageData.sourceImg === 'string' && !!imageData.sourceImg.length || imageData.sourceImg && !!Object.keys(imageData.sourceImg).length) {
        return buildImageSrcUsingSourceImg(imageData.sourceImg, imageData.width, imageData.imgFormat);
      } else {
        return buildImageSrcUsingProductImageData(imageData, ecode, isBrowser, window, selectedSwatchColor);
      }
    }
    static {
      this.ɵfac = function HmfProductImageService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfProductImageService)(i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: HmfProductImageService,
        factory: HmfProductImageService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return HmfProductImageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfProductImageComponent = /*#__PURE__*/(() => {
  class HmfProductImageComponent {
    constructor(platformId, hmfProductImgService) {
      this.platformId = platformId;
      this.hmfProductImgService = hmfProductImgService;
      this.ecode = '';
      this.imageData = undefined;
      this.productName = '';
      this.selectedSwatchColor = '';
      this.imageErrorDetected = new EventEmitter();
      // Added the # placeholder because the NgOptimizeImage trigger the test error of the
      // ngSrc initialized with "falsy" value
      this.imageSrc = '#';
      this.imageUnavailable = false;
    }
    ngOnChanges() {
      if (!this.imageData) {
        return;
      }
      this.updateImageSrc(this.imageData);
    }
    updateImageSrc(imgData) {
      this.imageSrc = this.hmfProductImgService.buildImageSrc(imgData, this.ecode, this.selectedSwatchColor);
    }
    /**
     * Emit the faulty image src to the parent when an error is detected
     */
    handleImageError(imageSrc) {
      this.imageUnavailable = true;
      this.imageErrorDetected.emit(imageSrc);
    }
    static {
      this.ɵfac = function HmfProductImageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfProductImageComponent)(i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(HmfProductImageService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfProductImageComponent,
        selectors: [["hmf-product-image"]],
        inputs: {
          ecode: "ecode",
          imageData: "imageData",
          productName: "productName",
          selectedSwatchColor: "selectedSwatchColor"
        },
        outputs: {
          imageErrorDetected: "imageErrorDetected"
        },
        features: [i0.ɵɵProvidersFeature([HmfProductImageService]), i0.ɵɵNgOnChangesFeature],
        decls: 3,
        vars: 2,
        consts: [["productImageUnavailable", ""], ["fallbackImage", ""], ["img", ""], [4, "ngIf", "ngIfElse"], ["itemprop", "image", 3, "alt", "class", "height", "ngSrc", "priority", "title", "width", "error", 4, "ngIf", "ngIfElse"], ["itemprop", "image", 3, "error", "alt", "height", "ngSrc", "priority", "title", "width"], ["loading", "lazy", "itemprop", "image", 3, "error", "alt", "height", "src", "title", "width"], ["title", "Product Image Unavailable", "src", "https://images.dickssportinggoods.com/assets/icons/dsg/ImageUnavailablePDPSwatch.svg?qlt=70&wid=600&fmt=pjpeg"]],
        template: function HmfProductImageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HmfProductImageComponent_ng_container_0_Template, 4, 2, "ng-container", 3)(1, HmfProductImageComponent_ng_template_1_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const productImageUnavailable_r7 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.imageUnavailable && ctx.imageData)("ngIfElse", productImageUnavailable_r7);
          }
        },
        dependencies: [CommonModule, i1$1.NgIf, NgOptimizedImage],
        styles: ["[_nghost-%COMP%]{display:block;margin:0 auto}img[_ngcontent-%COMP%]{height:inherit;width:inherit}"],
        changeDetection: 0
      });
    }
  }
  return HmfProductImageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfProgressStepperComponent = /*#__PURE__*/(() => {
  class HmfProgressStepperComponent {
    getSteps() {
      return this.steps.map((step, i) => {
        if (i + 1 < this.steps.length) {
          return {
            ...step,
            nextStatus: this.steps[i + 1].status
          };
        }
        return step;
      });
    }
    constructor(homefieldIconsLibraryService, elementRef) {
      this.homefieldIconsLibraryService = homefieldIconsLibraryService;
      this.elementRef = elementRef;
      this.element = '';
      this.steps = [];
      this.nameAlignment = 'middle';
      this.orientation = 'horizontal';
      this.stepClickEvent = new EventEmitter();
      this.homefieldIconsLibraryService.registerIcons([homefieldIconAlertHighpriority, homefieldIconSignCheck]);
      this.element = this.elementRef.nativeElement?.tagName?.toLowerCase();
    }
    static {
      this.ɵfac = function HmfProgressStepperComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfProgressStepperComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfProgressStepperComponent,
        selectors: [["hmf-progress-stepper"]],
        inputs: {
          steps: "steps",
          nameAlignment: "nameAlignment",
          orientation: "orientation"
        },
        outputs: {
          stepClickEvent: "stepClickEvent"
        },
        decls: 2,
        vars: 5,
        consts: [[3, "ngClass"], [3, "ngClass", 4, "ngFor", "ngForOf"], [1, "step-content"], ["class", "progress-icon completed-icon", 3, "tabindex", "click", "keydown.enter", "keydown.space", 4, "ngIf"], ["class", "progress-icon current-icon", 3, "tabindex", "click", "keydown.enter", "keydown.space", 4, "ngIf"], ["class", "progress-icon error-icon", 3, "tabindex", "click", "keydown.enter", "keydown.space", 4, "ngIf"], ["class", "progress-icon inprogress-icon", 3, "tabindex", "click", "keydown.enter", "keydown.space", 4, "ngIf"], ["class", "progress-icon incomplete-icon", 3, "tabindex", "click", "keydown.enter", "keydown.space", 4, "ngIf"], [1, "progress-icon", "completed-icon", 3, "click", "keydown.enter", "keydown.space", "tabindex"], ["width", "8px", "height", "8px", "name", "sign-check", "fill", "var(--hmf-label-base)", 1, "progress-icon"], [1, "progress-icon", "current-icon", 3, "click", "keydown.enter", "keydown.space", "tabindex"], ["width", "8px", "height", "8px", "name", "sign-check", "fill", "var(--hmf-label-marketing-static)", 1, "progress-icon"], [1, "progress-icon", "error-icon", 3, "click", "keydown.enter", "keydown.space", "tabindex"], ["width", "8px", "height", "8px", "name", "alert-highpriority", "fill", "var(--hmf-label-marketing-static)", 1, "progress-icon"], [1, "progress-icon", "inprogress-icon", 3, "click", "keydown.enter", "keydown.space", "tabindex"], [1, "progress-icon", "incomplete-icon", 3, "click", "keydown.enter", "keydown.space", "tabindex"]],
        template: function HmfProgressStepperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, HmfProgressStepperComponent_div_1_Template, 9, 13, "div", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c31, ctx.orientation, ctx.nameAlignment));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.getSteps());
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: [".progress-icon[_ngcontent-%COMP%]{align-items:center;border-radius:100%;box-sizing:border-box;cursor:pointer;display:flex;height:16px;justify-content:center;width:16px}.progress-icon.completed-icon[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-inverse)}.progress-icon.current-icon[_ngcontent-%COMP%]{background:var(--hmf-label-positive)}.progress-icon.error-icon[_ngcontent-%COMP%]{background:var(--hmf-fill-negative)}.progress-icon.incomplete-icon[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-secondary-subtle-static);height:16px;width:16px}.progress-icon.inprogress-icon[_ngcontent-%COMP%]{border:2px solid var(--hmf-label-positive);height:16px;width:16px}.progress-icon[_ngcontent-%COMP%]:where(button){background:none;border:none;color:inherit;cursor:pointer;font:inherit;margin:0;outline:none;padding:0;text-decoration:none}.progress-icon[_ngcontent-%COMP%]:where(button):focus{outline:2px solid var(--hmf-label-positive);outline-offset:2px}.progress-icon[_ngcontent-%COMP%]:where(button):focus:not(:focus-visible){outline:none}.progress-icon[_ngcontent-%COMP%]:where(button):focus-visible{outline:2px solid var(--hmf-label-positive);outline-offset:2px}.progress-icon[_ngcontent-%COMP%]:where(button):disabled{cursor:default;opacity:1}.progress-stepper[_ngcontent-%COMP%]{display:flex;width:100%}.progress-stepper[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{align-items:stretch;display:flex}.progress-stepper[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]{display:flex}.progress-stepper[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]:before, .progress-stepper[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]:after{content:\"\";position:absolute}.progress-stepper[_ngcontent-%COMP%]   .step.current[_ngcontent-%COMP%]{color:var(--hmf-label-positive)}.progress-stepper[_ngcontent-%COMP%]   .step.error[_ngcontent-%COMP%]{color:var(--hmf-label-negative)}.progress-stepper[_ngcontent-%COMP%]   .step.incomplete[_ngcontent-%COMP%]{color:var(--hmf-label-base-subtle)}.progress-stepper.horizontal[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{flex-basis:0;flex-direction:row;flex-grow:1;justify-content:center}.progress-stepper.horizontal[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]{display:flex;flex-direction:column;position:relative;width:100%}.progress-stepper.horizontal[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]:before, .progress-stepper.horizontal[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]:after{border-top:1px solid var(--hmf-border-inverse);height:0;top:8px}.progress-stepper.horizontal[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]   .step-name[_ngcontent-%COMP%]{margin-top:var(--hmf-xxxs)}.progress-stepper.horizontal[_ngcontent-%COMP%]   .step.incomplete-next[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]:after{border-top:1px dashed var(--hmf-border-secondary-subtle-static)}.progress-stepper.horizontal[_ngcontent-%COMP%]   .step.incomplete[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]:before{border-top:1px dashed var(--hmf-border-secondary-subtle-static)}.progress-stepper.horizontal[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:first-child{justify-content:flex-start}.progress-stepper.horizontal[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:first-child   .step-content[_ngcontent-%COMP%]{align-items:flex-start}.progress-stepper.horizontal[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:first-child   .step-content[_ngcontent-%COMP%]:before{display:none}.progress-stepper.horizontal[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:first-child   .step-content[_ngcontent-%COMP%]:after{left:16px;width:calc(100% - 16px)}.progress-stepper.horizontal[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:last-child{justify-content:flex-end}.progress-stepper.horizontal[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:last-child   .step-content[_ngcontent-%COMP%]{align-items:flex-end}.progress-stepper.horizontal[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:last-child   .step-content[_ngcontent-%COMP%]:before{right:16px;width:calc(100% - 16px)}.progress-stepper.horizontal[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:last-child   .step-content[_ngcontent-%COMP%]:after{display:none}.progress-stepper.horizontal.start[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:not(:first-child,:last-child)   .step-content[_ngcontent-%COMP%]{align-items:flex-start}.progress-stepper.horizontal.start[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:not(:first-child,:last-child)   .step-content[_ngcontent-%COMP%]:before{display:none}.progress-stepper.horizontal.start[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:not(:first-child,:last-child)   .step-content[_ngcontent-%COMP%]:after{left:16px;width:calc(100% - 16px)}.progress-stepper.horizontal.start[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:last-child{flex-grow:0;justify-content:flex-start}.progress-stepper.horizontal.start[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:last-child   .step-content[_ngcontent-%COMP%]{align-items:flex-start;white-space:nowrap}.progress-stepper.horizontal.start[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:last-child   .step-content[_ngcontent-%COMP%]:before{display:none}.progress-stepper.horizontal.start[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:last-child   .step-content[_ngcontent-%COMP%]:after{display:none}.progress-stepper.horizontal.middle[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{flex-grow:0}.progress-stepper.horizontal.middle[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:not(:first-child,:last-child){flex-basis:calc(33.3333333333% - 21.3333333333px + 16px);width:calc(33.3333333333% - 21.3333333333px + 16px)}.progress-stepper.horizontal.middle[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:not(:first-child,:last-child)   .step-content[_ngcontent-%COMP%]{align-items:center}.progress-stepper.horizontal.middle[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:not(:first-child,:last-child)   .step-content[_ngcontent-%COMP%]:before{right:calc(50% + 8px);width:calc(50% - 7px)}.progress-stepper.horizontal.middle[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:not(:first-child,:last-child)   .step-content[_ngcontent-%COMP%]:after{left:calc(50% + 8px);width:calc(50% - 7px)}.progress-stepper.horizontal.middle[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:first-child{flex-basis:calc((33.3333333333% - 21.3333333333px) / 2 + 16px);width:calc((33.3333333333% - 21.3333333333px) / 2 + 16px)}.progress-stepper.horizontal.middle[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:last-child{flex-basis:calc((33.3333333333% - 21.3333333333px) / 2 + 16px);width:calc((33.3333333333% - 21.3333333333px) / 2 + 16px)}.progress-stepper.horizontal.end[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:not(:first-child,:last-child)   .step-content[_ngcontent-%COMP%]{align-items:flex-end}.progress-stepper.horizontal.end[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:not(:first-child,:last-child)   .step-content[_ngcontent-%COMP%]:before{right:16px;width:calc(100% - 16px)}.progress-stepper.horizontal.end[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:not(:first-child,:last-child)   .step-content[_ngcontent-%COMP%]:after{display:none}.progress-stepper.horizontal.end[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:first-child{flex-grow:0;justify-content:flex-end}.progress-stepper.horizontal.end[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:first-child   .step-content[_ngcontent-%COMP%]{align-items:flex-end;white-space:nowrap}.progress-stepper.horizontal.end[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:first-child   .step-content[_ngcontent-%COMP%]:before{display:none}.progress-stepper.horizontal.end[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:first-child   .step-content[_ngcontent-%COMP%]:after{display:none}.progress-stepper.vertical[_ngcontent-%COMP%], .progress-stepper.vertical[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{flex-direction:column}.progress-stepper.vertical[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:not(:last-child){padding-bottom:var(--hmf-s)}.progress-stepper.vertical[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]{align-items:center;flex-direction:row;position:relative}.progress-stepper.vertical[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]   .step-name[_ngcontent-%COMP%]{line-height:1!important;margin-left:var(--hmf-xxs)}.progress-stepper.vertical[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]:after{border-right:1px solid var(--hmf-border-inverse);height:16px;left:8px;top:16px;width:0}.progress-stepper.vertical[_ngcontent-%COMP%]   .step.incomplete-next[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]:after{border-right:1px dashed var(--hmf-border-secondary-subtle-static)}.progress-stepper.vertical[_ngcontent-%COMP%]   .step.incomplete[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]:before{border-right:1px dashed var(--hmf-border-secondary-subtle-static)}.progress-stepper.vertical[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:last-child   .step-content[_ngcontent-%COMP%]:after{display:none}.progress-stepper[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{cursor:pointer}  .progress-stepper svg{display:block}"]
      });
    }
  }
  return HmfProgressStepperComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfProgressBarComponent = /*#__PURE__*/(() => {
  class HmfProgressBarComponent {
    constructor() {
      this.value = 0;
      this.size = 'medium';
      this.className = '';
      this.type = 'neutral';
    }
    get cappedValue() {
      return Math.min(Math.max(this.value, 0), 100);
    }
    static {
      this.ɵfac = function HmfProgressBarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfProgressBarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfProgressBarComponent,
        selectors: [["hmf-progress-bar"]],
        inputs: {
          value: "value",
          size: "size",
          className: "className",
          type: "type"
        },
        decls: 3,
        vars: 10,
        consts: [["data-testid", "progress-bar-semantic", "max", "100", "aria-hidden", "true", 1, "progress-bar-semantic", 3, "value"], ["data-testid", "progress-bar-wrapper"], ["data-testid", "progress-bar-fill"]],
        template: function HmfProgressBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "progress", 0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵelement(2, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("value", ctx.cappedValue);
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate2("progress-bar-wrapper hmf-round-radius progress-bar-", ctx.size, " ", ctx.className, "");
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate1("progress-bar-fill progress-bar-", ctx.type, "");
            i0.ɵɵstyleProp("width", ctx.cappedValue, "%");
          }
        },
        styles: [".progress-bar-wrapper[_ngcontent-%COMP%]{background-color:var(--hmf-fill-base-prominent);border-radius:999px;overflow:hidden}.progress-bar-semantic[_ngcontent-%COMP%]{height:0;opacity:0;position:absolute;width:0}.progress-bar-medium[_ngcontent-%COMP%]{height:16px}.progress-bar-small[_ngcontent-%COMP%]{height:8px}.progress-bar-fill[_ngcontent-%COMP%]{height:100%;transition:width .3s ease}.progress-bar-negative[_ngcontent-%COMP%]{background-color:var(--hmf-fill-negative)}.progress-bar-warning[_ngcontent-%COMP%]{background-color:var(--hmf-fill-warning)}.progress-bar-positive[_ngcontent-%COMP%]{background-color:var(--hmf-fill-positive)}.progress-bar-neutral[_ngcontent-%COMP%]{background-color:var(--hmf-fill-inverse)}"]
      });
    }
  }
  return HmfProgressBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
const RADIO_CONTROL_GROUP_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => HmfRadioGroupComponent),
  multi: true
};
let HmfRadioGroupComponent = /*#__PURE__*/(() => {
  class HmfRadioGroupComponent {
    // inputs affecting group component and children
    get name() {
      return this.groupName;
    }
    set name(value) {
      this.groupName = value;
      this.updateRadioButtonNames();
    }
    get size() {
      return this.radioButtonSize;
    }
    set size(value) {
      this.radioButtonSize = value;
      this.updateRadioButtonSizes();
      this.markRadiosForCheck();
    }
    get selected() {
      return this.radioButtonSelected;
    }
    set selected(selected) {
      this.radioButtonSelected = selected;
      this.radioValue = selected ? selected.value : null;
      this.checkSelectedRadioButton();
    }
    get disabled() {
      return this.disabledFlag;
    }
    set disabled(value) {
      this.disabledFlag = value;
      this.markRadiosForCheck();
    }
    get error() {
      return this.errorFlag;
    }
    set error(value) {
      this.errorFlag = value;
      this.updateRadioErrorStatus(value);
    }
    get required() {
      return this.requiredFlag;
    }
    set required(value) {
      this.requiredFlag = value;
      this.markRadiosForCheck();
    }
    get value() {
      return this.radioValue;
    }
    set value(newValue) {
      if (this.radioValue !== newValue) {
        this.radioValue = newValue;
        this.updateSelectedRadioFromValue();
      }
    }
    get radios() {
      return this.hmfRadios;
    }
    constructor(cd) {
      this.cd = cd;
      // inputs only affecting group component
      this.groupLabel = '';
      this.row = false;
      this.errorMessage = null;
      this.testId = '';
      this.className = '';
      this.eventChange = new EventEmitter();
      this.hmfRadios = new QueryList();
      this.radioValue = null;
      this.requiredFlag = false;
      this.groupName = null;
      this.radioButtonSize = 'small';
      this.radioButtonSelected = null;
      this.buttonChanges = null;
      this.disabledFlag = false;
      this.errorFlag = false;
      // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-explicit-any
      this.controlValueAccessorChange = () => {};
      // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-explicit-any
      this.onTouch = () => {};
    }
    ngAfterContentInit() {
      if (this.hmfRadios.length) {
        if (!this.name) {
          this.name = `homefield-radio-group-${Math.floor(Math.random() * Math.floor(Math.random() * Date.now())).toString()}`;
        }
        this.updateRadioErrorStatus(this.errorFlag);
      }
      this.buttonChanges = this.hmfRadios.changes.subscribe(() => {
        if (this.selected && !this.hmfRadios.find(radio => radio === this.selected)) {
          this.selected = null;
        }
      });
      this.updateSelectedRadioFromValue();
    }
    ngOnChanges(changes) {
      if (changes['error']) {
        this.errorFlag = changes['error'].currentValue;
        this.updateRadioErrorStatus(this.errorFlag);
      }
    }
    ngOnDestroy() {
      this.buttonChanges?.unsubscribe();
    }
    /*  control value accessor fns start  */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    writeValue(selected) {
      if (typeof selected !== 'object') {
        this.value = selected;
      } else {
        this.value = selected?.value;
      }
      this.cd.markForCheck();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnChange(fn) {
      this.controlValueAccessorChange = fn;
      this.cd.markForCheck();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnTouched(fn) {
      this.onTouch = fn;
      this.cd.markForCheck();
    }
    /* control value accessor fns end*/
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
      this.cd.markForCheck();
    }
    updateRadioButtonNames() {
      this.hmfRadios.forEach(radio => {
        radio.name = this.name;
      });
    }
    updateRadioButtonSizes() {
      this.hmfRadios.forEach(radio => {
        radio.defaultSize = this.radioButtonSize;
      });
    }
    emitChangeEvent(event) {
      this.eventChange.emit(event);
      this.writeValue(event.value);
      this.controlValueAccessorChange(event.value);
      this.onTouch(event.value);
      this.cd.markForCheck();
    }
    updateSelectedRadioFromValue() {
      const isAlreadySelected = this.selected !== null && this.selected?.value === this.value;
      if (this.hmfRadios.length && !isAlreadySelected) {
        let radioFound = false;
        this.hmfRadios.forEach(radio => {
          if (this.value === radio.value) {
            this.selected = radio;
            radioFound = true;
          }
        });
        if (!radioFound) {
          this.selected = null;
        }
        this.checkSelectedRadioButton();
      }
    }
    checkSelectedRadioButton() {
      this.hmfRadios.forEach(radio => {
        if (radio !== this.selected) {
          radio.checked = false;
        }
      });
      if (this.selected && !this.selected.checked) {
        this.selected.checked = true;
      }
    }
    markRadiosForCheck() {
      this.hmfRadios.forEach(radio => radio.markForCheck());
    }
    updateRadioErrorStatus(value) {
      if (!this.disabledFlag) {
        this.hmfRadios.forEach(radio => {
          radio.updateErrorStatus(value);
          radio.markForCheck();
        });
      }
    }
    static {
      this.ɵfac = function HmfRadioGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfRadioGroupComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfRadioGroupComponent,
        selectors: [["hmf-radio-group"], ["", "hmfRadioGroup", ""]],
        contentQueries: function HmfRadioGroupComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, HmfRadioComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hmfRadios = _t);
          }
        },
        inputs: {
          groupLabel: "groupLabel",
          row: "row",
          errorMessage: "errorMessage",
          testId: "testId",
          className: "className",
          name: "name",
          size: "size",
          selected: "selected",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          error: [2, "error", "error", booleanAttribute],
          required: [2, "required", "required", booleanAttribute],
          value: "value"
        },
        outputs: {
          eventChange: "eventChange"
        },
        exportAs: ["hmfRadioGroup"],
        features: [i0.ɵɵProvidersFeature([RADIO_CONTROL_GROUP_VALUE_ACCESSOR]), i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c6,
        decls: 5,
        vars: 10,
        consts: [[3, "for", "class", "id", 4, "ngIf"], ["class", "error hmf-my-0 hmf-mb-xxs hmf-mt-xxxs hmf-legal-s", 3, "id", 4, "ngIf"], ["role", "radiogroup"], [3, "for", "id"], [1, "error", "hmf-my-0", "hmf-mb-xxs", "hmf-mt-xxxs", "hmf-legal-s", 3, "id"]],
        template: function HmfRadioGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, HmfRadioGroupComponent_label_1_Template, 2, 8, "label", 0)(2, HmfRadioGroupComponent_p_2_Template, 2, 2, "p", 1);
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("homefield-radiogroup hmf-display-flex hmf-flex-column ", ctx.className, "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.groupLabel);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.error && ctx.errorMessage);
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate1("hmf-display-flex ", ctx.row ? "hmf-flex-row" : "hmf-flex-column", "");
            i0.ɵɵattribute("aria-labelledby", "homefield-radiogroup-label-" + ctx.name)("aria-describedby", "homefield-radiogroup-errorMessage-" + ctx.name);
          }
        },
        dependencies: () => [CommonModule, i1$1.NgIf],
        styles: [".homefield-radiogroup-label{font-family:var(--font-primary);font-size:var(--label-font-size-m);font-weight:var(--font-primary-regular-weight);letter-spacing:var(--label-letter-spacing);line-height:var(--label-line-height-m)}.error{color:var(--hmf-label-negative)}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return HmfRadioGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SelectionChangeDispatcher = /*#__PURE__*/(() => {
  class SelectionChangeDispatcher {
    constructor() {
      this.listeners = [];
    }
    notify(id, name) {
      for (const listener of this.listeners) {
        listener(id, name);
      }
    }
    listen(listener) {
      this.listeners.push(listener);
      return () => {
        this.listeners = this.listeners.filter(registered => {
          return listener !== registered;
        });
      };
    }
    ngOnDestroy() {
      this.listeners = [];
    }
    static {
      this.ɵfac = function SelectionChangeDispatcher_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SelectionChangeDispatcher)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SelectionChangeDispatcher,
        factory: SelectionChangeDispatcher.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SelectionChangeDispatcher;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const RADIO_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => HmfRadioComponent),
  multi: true
};
let HmfRadioComponent = /*#__PURE__*/(() => {
  class HmfRadioComponent {
    get checked() {
      return this.radioChecked;
    }
    set checked(value) {
      if (this.radioChecked !== value) {
        this.radioChecked = value;
        if (value && this.radioGroup && this.radioGroup.value !== this.value) {
          this.radioGroup.selected = this;
        } else if (!value && this.radioGroup && this.radioGroup.value === this.value) {
          this.radioGroup.selected = null;
        }
        if (value) {
          this.radioDispatcher.notify(this.id, this.name ? this.name : '');
        }
        this.cd.markForCheck();
      }
    }
    get required() {
      return this.requiredFlag;
    }
    set required(value) {
      this.requiredFlag = value;
      this.cd.markForCheck();
    }
    get disabled() {
      return this.disabledFlag || this.radioGroup !== null && this.radioGroup?.disabled;
    }
    set disabled(value) {
      this.setDisabledFlag(value);
      this.cd.markForCheck();
    }
    get value() {
      return this.radioValue;
    }
    set value(value) {
      if (this.radioValue !== value) {
        this.radioValue = value;
        if (this.radioGroup) {
          if (!this.checked) {
            this.checked = this.radioGroup.value === value;
          }
          if (this.checked) {
            this.radioGroup.selected = this;
          }
        }
      }
      this.cd.markForCheck();
    }
    get size() {
      return this._size || this.defaultSize;
    }
    set size(value) {
      this._size = value;
    }
    constructor(cd, radioDispatcher, radioGroupRef) {
      this.cd = cd;
      this.radioDispatcher = radioDispatcher;
      this.radioGroupRef = radioGroupRef;
      this.inputElement = null;
      this.tabIndex = 0;
      this.label = '';
      this.id = Math.floor(Math.random() * Math.floor(Math.random() * Date.now())).toString();
      this.error = false;
      this.errorMessage = null;
      this.ariaLabel = null;
      this.ariaLabelledby = null;
      this.ariaDescribedby = null;
      this.classList = '';
      this.testId = '';
      this.defaultSize = 'small';
      this.eventChange = new EventEmitter();
      this.radioValue = null;
      this.requiredFlag = false;
      this.radioChecked = false;
      this.disabledFlag = false;
      this._size = null;
      this.inputHasFocus = false;
      // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-explicit-any
      this.controlValueAccessorChange = () => {};
      // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-explicit-any
      this.onTouched = () => {};
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      this.groupSelectionChangeListener = () => {};
      this.radioGroup = this.radioGroupRef;
    }
    ngDoCheck() {
      this.setTabIndex();
    }
    ngAfterViewInit() {
      this.setTabIndex();
    }
    ngOnInit() {
      if (this.radioGroup) {
        this.checked = this.radioGroup.value === this.value;
        if (this.checked) {
          this.radioGroup.selected = this;
        }
        this.name = this.radioGroup.name;
      }
      this.groupSelectionChangeListener = this.radioDispatcher.listen((id, name) => {
        if (id !== this.id && name === this.name) {
          this.checked = false;
        }
      });
    }
    setDisabledFlag(value) {
      if (this.disabledFlag !== value) {
        this.disabledFlag = value;
        this.cd.markForCheck();
      }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    writeValue(value) {
      this.controlValueAccessorChange(value);
      this.cd.markForCheck();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnChange(fn) {
      this.controlValueAccessorChange = fn;
      this.cd.markForCheck();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnTouched(fn) {
      this.onTouched = fn;
      this.cd.markForCheck();
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
      this.cd.markForCheck();
    }
    onRadioSelect() {
      if (!this.disabled) {
        const groupValueChanged = this.radioGroup && this.value !== this.radioGroup.value;
        this.writeValue(this.value);
        this.controlValueAccessorChange(this.value);
        this.onTouched(this.value);
        this.checked = true;
        const eventChanged = {
          source: this,
          value: this.value
        };
        this.eventChange.emit(eventChanged);
        if (this.radioGroup) {
          this.radioGroup.writeValue(this.value);
          if (groupValueChanged) {
            this.radioGroup.emitChangeEvent(eventChanged);
          }
        }
      }
    }
    markForCheck() {
      this.cd.markForCheck();
    }
    updateErrorStatus(value, message) {
      this.error = value;
      if (message) {
        this.errorMessage = message;
      } else {
        this.errorMessage = null;
      }
    }
    setTabIndex() {
      const input = this.inputElement?.nativeElement;
      if (input) {
        input.setAttribute('tabindex', this.tabIndex + '');
      }
    }
    static {
      this.ɵfac = function HmfRadioComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfRadioComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(SelectionChangeDispatcher), i0.ɵɵdirectiveInject(forwardRef(() => HmfRadioGroupComponent), 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfRadioComponent,
        selectors: [["hmf-radio"]],
        viewQuery: function HmfRadioComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c34, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
          }
        },
        inputs: {
          tabIndex: [2, "tabIndex", "tabIndex", value => value === null ? 0 : numberAttribute(value)],
          label: "label",
          checked: [2, "checked", "checked", booleanAttribute],
          required: [2, "required", "required", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute],
          value: "value",
          size: "size",
          id: "id",
          name: "name",
          error: "error",
          errorMessage: "errorMessage",
          ariaLabel: [0, "aria-label", "ariaLabel"],
          ariaLabelledby: [0, "aria-labelledby", "ariaLabelledby"],
          ariaDescribedby: [0, "aria-describedby", "ariaDescribedby"],
          classList: "classList",
          testId: "testId",
          defaultSize: "defaultSize"
        },
        outputs: {
          eventChange: "eventChange"
        },
        exportAs: ["hmfRadio"],
        features: [i0.ɵɵProvidersFeature([RADIO_CONTROL_VALUE_ACCESSOR])],
        ngContentSelectors: _c6,
        decls: 10,
        vars: 30,
        consts: [["input", ""], ["innerContent", ""], [1, "homefield-radio-label", "hmf-display-flex", "hmf-align-items-center", "hmf-align-content-center", "hmf-mb-0", 3, "ngClass", "for"], ["type", "radio", 3, "change", "id", "checked", "disabled", "value", "required"], [1, "homefield-radio-span", "hmf-display-flex", "hmf-position-absolute"], [1, "homefield-radio-label-text", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["class", "hmf-my-0 hmf-mt-xxxs hmf-body-s label-negative", 3, "id", 4, "ngIf"], [1, "hmf-my-0", "hmf-mt-xxxs", "hmf-body-s", "label-negative", 3, "id"]],
        template: function HmfRadioComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div")(1, "label", 2)(2, "input", 3, 0);
            i0.ɵɵlistener("change", function HmfRadioComponent_Template_input_change_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onRadioSelect());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "span", 4);
            i0.ɵɵelementStart(5, "span", 5);
            i0.ɵɵtemplate(6, HmfRadioComponent_ng_container_6_Template, 2, 1, "ng-container", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(7, HmfRadioComponent_p_7_Template, 2, 2, "p", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, HmfRadioComponent_ng_template_8_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const innerContent_r3 = i0.ɵɵreference(9);
            i0.ɵɵclassMapInterpolate2("homefield-radio homefield-radio-", ctx.size, " ", ctx.classList, " hmf-display-flex hmf-flex-column hmf-body-l hmf-mb-xs hmf-mr-xs");
            i0.ɵɵattribute("data-test-id", ctx.testId);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(24, _c35, ctx.inputHasFocus, ctx.error, ctx.disabled))("for", "homefield-radio-" + ctx.id);
            i0.ɵɵattribute("aria-describedby", ctx.error ? "homefield-radio-error-message-" + ctx.id : "");
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate1("homefield-radio-input hmf-position-absolute ", ctx.name ? "homefield-radio-input-" + ctx.name : "", "");
            i0.ɵɵproperty("id", "homefield-radio-" + ctx.id)("checked", ctx.checked)("disabled", ctx.disabled)("value", ctx.value)("required", ctx.required);
            i0.ɵɵattribute("name", ctx.name)("aria-label", ctx.ariaLabel)("aria-labelledby", ctx.ariaLabelledby)("aria-describedby", ctx.ariaDescribedby);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(28, _c36, ctx.checked));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label)("ngIfElse", innerContent_r3);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.error && ctx.errorMessage);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgIf, ReactiveFormsModule, FormsModule],
        styles: [".homefield-radio[_ngcontent-%COMP%]{--input-size: 16px;--input-checked-fill-size: 62.5%}.homefield-radio[_ngcontent-%COMP%], .homefield-radio[_ngcontent-%COMP%]   *[_ngcontent-%COMP%], .homefield-radio[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]:before, .homefield-radio[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]:after{box-sizing:content-box}.homefield-radio.homefield-radio-small[_ngcontent-%COMP%]{--input-size: 16px;--input-checked-fill-size: 62.5%;--label-spacing: var(--hmf-xxs)}.homefield-radio.homefield-radio-medium[_ngcontent-%COMP%]{--input-size: 24px;--input-checked-fill-size: 66.6667%;--label-spacing: var(--hmf-xs)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-subtle-static);position:relative;transition:color var(--hmf-ease-in-out-fast)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label[_ngcontent-%COMP%]   .homefield-radio-input[_ngcontent-%COMP%]{height:calc(var(--input-size));left:var(--hmf-0);margin:var(--hmf-0);opacity:0;top:50%;transform:translateY(-50%);width:calc(var(--input-size));z-index:1}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label[_ngcontent-%COMP%]   .homefield-radio-span[_ngcontent-%COMP%]{background-color:var(--hmf-fill-secondary-static);border:1px solid var(--hmf-border-secondary-subtle-static);border-radius:var(--hmf-round-radius);height:var(--input-size);left:calc(var(--input-size) / 2 + 1px);top:50%;transform:translate(-50%,-50%);transition:background-color var(--hmf-ease-in-out-fast),border var(--hmf-ease-in-out-fast);width:var(--input-size)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label[_ngcontent-%COMP%]   .homefield-radio-span[_ngcontent-%COMP%]:before{background-color:transparent;border-radius:50%;content:\"\";height:100%;position:absolute;transform:scale(var(--input-checked-fill-size));transform-origin:center center;transition:background-color var(--hmf-ease-in-out-fast);width:100%}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label[_ngcontent-%COMP%]   .homefield-radio-label-text[_ngcontent-%COMP%]{margin-left:calc(var(--input-size) + var(--label-spacing));transition:color var(--hmf-ease-in-out-fast)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label[_ngcontent-%COMP%]   .homefield-radio-input[_ngcontent-%COMP%]:checked + .homefield-radio-span[_ngcontent-%COMP%]{border-color:var(--hmf-border-secondary-static)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label[_ngcontent-%COMP%]   .homefield-radio-input[_ngcontent-%COMP%]:checked + .homefield-radio-span[_ngcontent-%COMP%]:before{background-color:var(--hmf-fill-tertiary-static)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label[_ngcontent-%COMP%]   .homefield-radio-input[_ngcontent-%COMP%]:checked ~ .homefield-radio-label-text[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-static)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label[_ngcontent-%COMP%]:hover{color:var(--hmf-label-secondary-subtle-hover)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label[_ngcontent-%COMP%]:hover   .homefield-radio-span[_ngcontent-%COMP%]{background-color:var(--hmf-fill-secondary-hover);border:2px solid var(--hmf-border-secondary-subtle-hover)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label[_ngcontent-%COMP%]:active{color:var(--hmf-label-secondary-subtle-active)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label[_ngcontent-%COMP%]:active   .homefield-radio-span[_ngcontent-%COMP%]{background-color:var(--hmf-fill-secondary-active);border:2px solid var(--hmf-border-secondary-subtle-active)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label.disabled[_ngcontent-%COMP%]{color:var(--hmf-label-disabled);cursor:not-allowed}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label.disabled[_ngcontent-%COMP%]   .homefield-radio-span[_ngcontent-%COMP%]{background:var(--hmf-fill-disabled-subtle);border:1px solid var(--hmf-border-disabled)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label.disabled[_ngcontent-%COMP%]   .homefield-radio-span[_ngcontent-%COMP%]:after{background:var(--hmf-border-disabled);content:\"\";height:1px;left:var(--hmf-0);position:absolute;top:50%;transform:translateY(-50%) rotate(-45deg);transform-origin:50% 50%;transition:opacity var(--hmf-ease-in-out-fast);width:var(--input-size)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label.disabled[_ngcontent-%COMP%]   .homefield-radio-input[_ngcontent-%COMP%]:checked + .homefield-radio-span[_ngcontent-%COMP%]{background:var(--hmf-fill-base);border:1px solid var(--hmf-border-disabled-subtle)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label.disabled[_ngcontent-%COMP%]   .homefield-radio-input[_ngcontent-%COMP%]:checked + .homefield-radio-span[_ngcontent-%COMP%]:before{background-color:var(--hmf-fill-disabled)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label.disabled[_ngcontent-%COMP%]   .homefield-radio-input[_ngcontent-%COMP%]:checked + .homefield-radio-span[_ngcontent-%COMP%]:after{opacity:0}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label.disabled[_ngcontent-%COMP%]   .homefield-radio-input[_ngcontent-%COMP%]:checked ~ .homefield-radio-label-text[_ngcontent-%COMP%]{color:inherit}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label.error[_ngcontent-%COMP%]{color:var(--hmf-label-negative)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label.error[_ngcontent-%COMP%]   .homefield-radio-span[_ngcontent-%COMP%]{background:var(--hmf-fill-negative-subtle);border:1px solid var(--hmf-border-negative)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label.error[_ngcontent-%COMP%]   .homefield-radio-input[_ngcontent-%COMP%]:checked + .homefield-radio-span[_ngcontent-%COMP%]:before{background-color:var(--hmf-fill-negative)}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label.error[_ngcontent-%COMP%]   .homefield-radio-input[_ngcontent-%COMP%]:checked ~ .homefield-radio-label-text[_ngcontent-%COMP%]{color:inherit}.homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label[_ngcontent-%COMP%]:not(.disabled), .homefield-radio[_ngcontent-%COMP%]   .homefield-radio-label[_ngcontent-%COMP%]:not(.disabled)   .homefield-radio-input[_ngcontent-%COMP%]{cursor:pointer}.homefield-radio[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{margin-left:calc(var(--input-size) + var(--label-spacing))}"],
        changeDetection: 0
      });
    }
  }
  return HmfRadioComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfProgressRingComponent = /*#__PURE__*/(() => {
  class HmfProgressRingComponent {
    constructor() {
      this.currentSvgValues = svgValues.large;
      this.currentVariantColors = variantColors.default;
      this.ringSize = ringSize;
      this.currentBalance = input(0);
      this.targetBalance = input(300);
      this.size = input(this.ringSize.large);
      this.variant = input(ringVariants.default);
      this.animateLoading = input(false);
      this.balancePrefix = input('');
      this.balanceDescriptor = input('');
    }
    ngOnChanges() {
      this.setRingSvgValues();
      this.setRingVariantColors();
      this.setConfigValues();
    }
    setRingSvgValues() {
      if (this.ringSize[this.size()]) {
        this.currentSvgValues = svgValues[this.size()];
      } else {
        this.currentSvgValues = svgValues.large;
      }
    }
    setRingVariantColors() {
      if (ringVariants[this.variant()]) {
        this.currentVariantColors = variantColors[this.variant()];
      } else {
        this.currentVariantColors = variantColors.default;
      }
    }
    setConfigValues() {
      if (this.balancePrefix()) {
        this.currentBalancePrefix = this.balancePrefix();
      } else if (this.variant() === ringVariants.gold) {
        this.currentBalancePrefix = '$';
      } else {
        this.currentBalancePrefix = '';
      }
      if (this.balanceDescriptor()) {
        this.currentBalanceDescriptor = this.balanceDescriptor();
      } else if (this.variant() === ringVariants.gold) {
        this.currentBalanceDescriptor = 'Spent';
      } else {
        this.currentBalanceDescriptor = 'Points';
      }
    }
    formatBalance(balance) {
      const balanceStr = balance.toString();
      let result = '';
      for (let i = 0; i < balanceStr.length; i++) {
        result = balanceStr[balanceStr.length - 1 - i] + result;
        if ((i + 1) % 3 === 0 && i + 1 !== balanceStr.length) {
          result = ',' + result;
        }
      }
      return result;
    }
    get progressRingStyle() {
      return {
        stroke: this.getCssVarWithFallback(this.currentVariantColors.progressRingColor, 'var(--hmf-scgreen)'),
        'stroke-dashoffset': this.progressStrokeOffset,
        'stroke-width': this.currentSvgValues.strokeWidth,
        'stroke-dasharray': this.currentSvgValues.circleStrokeLength + ' ' + this.currentSvgValues.circleStrokeLength * 2
      };
    }
    get progressRingBackgroundStyle() {
      return {
        stroke: this.isTargetReached ? this.getCssVarWithFallback(this.currentVariantColors.bgRingColorAfterTarget, 'var(--hmf-primary100)') : this.getCssVarWithFallback(this.currentVariantColors.bgRingColorBeforeTarget, 'var(--hmf-border-base-subtle)'),
        'stroke-width': this.currentSvgValues.strokeWidth
      };
    }
    get roundedCurrentBalance() {
      return Math.floor(this.currentBalance());
    }
    get remainingBalance() {
      if (this.variant() === ringVariants.default && this.isTargetReached) {
        return this.targetBalance();
      }
      const balanceModulo = this.roundedCurrentBalance % this.targetBalance();
      if (balanceModulo === 0 && this.roundedCurrentBalance > 0) {
        return this.targetBalance();
      }
      return balanceModulo;
    }
    get isTargetReached() {
      return this.roundedCurrentBalance >= this.targetBalance();
    }
    get progressStrokeOffset() {
      const progressPercentage = this.remainingBalance / this.targetBalance();
      if (this.remainingBalance === this.targetBalance()) {
        // full circle
        return 0;
      } else if (progressPercentage >= 1 - this.currentSvgValues.closingMarginPercentage) {
        // almost full
        return this.currentSvgValues.circleStrokeLength * this.currentSvgValues.closingMarginPercentage;
      } else {
        const progressStrokeLength = progressPercentage * this.currentSvgValues.circleStrokeLength;
        return this.currentSvgValues.circleStrokeLength - progressStrokeLength;
      }
    }
    getCssVarWithFallback(varName, fallback) {
      if (varName && this.isCssVar(varName)) {
        return `var(${varName}, ${fallback})`;
      }
      return fallback;
    }
    isCssVar(varMaybe) {
      return varMaybe.startsWith('--');
    }
    static {
      this.ɵfac = function HmfProgressRingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfProgressRingComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfProgressRingComponent,
        selectors: [["hmf-progress-ring"]],
        inputs: {
          currentBalance: [1, "currentBalance"],
          targetBalance: [1, "targetBalance"],
          size: [1, "size"],
          variant: [1, "variant"],
          animateLoading: [1, "animateLoading"],
          balancePrefix: [1, "balancePrefix"],
          balanceDescriptor: [1, "balanceDescriptor"]
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 8,
        vars: 10,
        consts: [[1, "hmf-display-flex"], [1, "hmf-position-relative"], ["cx", "50%", "cy", "50%", "r", "110", 1, "hmf-circle-background"], ["cx", "50%", "cy", "50%", 1, "hmf-progress-ring-background", "hmf-position-absolute", 3, "ngStyle"], ["cx", "50%", "cy", "50%", 1, "hmf-progress-ring", "hmf-position-absolute", 3, "ngStyle"], ["attributeName", "stroke-dashoffset", "dur", "3s", "repeatCount", "1"], [1, "hmf-ml-xxs"], ["x", "50%", "y", "48%", 3, "ngClass"], ["x", "50%", 3, "ngClass"], [1, "hmf-progress-text", "hmf-header-bold-s", "hmf-my-0"], [1, "hmf-progress-text", "hmf-body-bold-s", "hmf-my-0"]],
        template: function HmfProgressRingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(1, "svg", 1);
            i0.ɵɵtemplate(2, HmfProgressRingComponent_Conditional_2_Template, 1, 0, ":svg:circle", 2);
            i0.ɵɵelement(3, "circle", 3);
            i0.ɵɵelementStart(4, "circle", 4);
            i0.ɵɵtemplate(5, HmfProgressRingComponent_Conditional_5_Template, 1, 1, ":svg:animate", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, HmfProgressRingComponent_Conditional_6_Template, 4, 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, HmfProgressRingComponent_Conditional_7_Template, 5, 2, "div", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵattribute("width", ctx.currentSvgValues.containerDiameter)("height", ctx.currentSvgValues.containerDiameter);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.size() === ctx.ringSize.large ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", ctx.progressRingBackgroundStyle);
            i0.ɵɵattribute("r", ctx.currentSvgValues.ringRadio);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", ctx.progressRingStyle);
            i0.ɵɵattribute("r", ctx.currentSvgValues.ringRadio);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.animateLoading() ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.size() !== ctx.ringSize.small ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.size() === ctx.ringSize.small ? 7 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgStyle],
        styles: [".hmf-circle-background[_ngcontent-%COMP%]{fill:var(--hmf-fill-base-subtle)}.hmf-progress-ring-background[_ngcontent-%COMP%]{fill:none}.hmf-progress-ring[_ngcontent-%COMP%]{fill:none;stroke-linecap:round;transform:rotate(-90deg);transform-origin:center}.hmf-progress-text[_ngcontent-%COMP%]{fill:var(--hmf-label-base);text-anchor:middle}"]
      });
    }
  }
  return HmfProgressRingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InsideViewportDirective = /*#__PURE__*/(() => {
  class InsideViewportDirective {
    constructor(el, platformId) {
      this.el = el;
      this.platformId = platformId;
      this.hmfInsideViewport = false;
      this.isElementVisible = new EventEmitter(true);
    }
    ngOnChanges() {
      if (isPlatformBrowser(this.platformId) && this.hmfInsideViewport) {
        this.isElementInView();
      }
    }
    isElementInView() {
      const elementHeight = this.el.nativeElement.offsetHeight;
      const parentElement = this.el.nativeElement.offsetParent?.getBoundingClientRect();
      if (parentElement) {
        if (parentElement.top > 0 && parentElement.top > elementHeight) {
          this.isElementVisible.emit(true);
        } else {
          this.isElementVisible.emit(false);
        }
      }
    }
    static {
      this.ɵfac = function InsideViewportDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InsideViewportDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PLATFORM_ID));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: InsideViewportDirective,
        selectors: [["", "hmfInsideViewport", ""]],
        inputs: {
          hmfInsideViewport: "hmfInsideViewport"
        },
        outputs: {
          isElementVisible: "isElementVisible"
        },
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return InsideViewportDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ClickHandlerDirective = /*#__PURE__*/(() => {
  class ClickHandlerDirective {
    constructor(element, platformId, renderer) {
      this.element = element;
      this.platformId = platformId;
      this.renderer = renderer;
      this.hmfClickDetectionHandler = false;
      this.isClickedOutside = new EventEmitter(true);
    }
    ngOnInit() {
      if (isPlatformBrowser(this.platformId)) {
        this.handleClickEvent();
      }
    }
    ngOnDestroy() {
      if (this.unListener) {
        this.unListener();
      }
    }
    handleClickEvent() {
      this.unListener = this.renderer.listen('window', 'click', ({
        target
      }) => {
        // Only run when review-dropdown-select is not clicked.
        // We need to know if there are a click outside the content to close it and avoid a lot of dropdowns reminds opened.
        const dropdownElement = this.element.nativeElement;
        const hasElement = !!dropdownElement && !dropdownElement.contains(target);
        this.isClickedOutside.emit(hasElement && this.hmfClickDetectionHandler);
      });
    }
    static {
      this.ɵfac = function ClickHandlerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ClickHandlerDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ClickHandlerDirective,
        selectors: [["", "hmfClickDetectionHandler", ""]],
        inputs: {
          hmfClickDetectionHandler: "hmfClickDetectionHandler"
        },
        outputs: {
          isClickedOutside: "isClickedOutside"
        }
      });
    }
  }
  return ClickHandlerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let InputValidatorDirective = /*#__PURE__*/(() => {
  class InputValidatorDirective {
    get control() {
      return this.ngControl;
    }
    constructor(ngControl) {
      this.ngControl = ngControl;
      this.decimalCount = 0;
      this.hmfInputValidator = 'zip';
      this.ZIPCODE_LENGTH_OF_FIVE = 5;
      this.ZIPCODE_LENGTH_OF_SIX = 6;
      this.previousValue = '';
      this.validationError = new EventEmitter();
      this.formattedValue = new EventEmitter();
    }
    ngAfterViewInit() {
      // Handle initial values for Template-driven Forms
      if (!this.control) {
        const inputElement = this.nativeElement;
        const initialValue = inputElement.value;
        if (initialValue) {
          this.processValue(initialValue, this.hmfInputValidator);
        }
      }
    }
    ngOnInit() {
      // Handle initial values for Reactive Forms
      const control = this.control?.control;
      if (control) {
        const initialValue = control.value;
        if (initialValue) {
          this.processValue(initialValue, this.hmfInputValidator);
        }
        control.valueChanges?.subscribe(value => {
          this.processValue(value, this.hmfInputValidator);
        });
      }
    }
    onInput(event) {
      const input = event.target;
      const inputType = this.hmfInputValidator;
      this.processValue(input.value, inputType);
    }
    processValue(value, type) {
      if (type === 'zip') {
        this.onZipCodeInput({
          target: {
            value
          }
        });
      } else if (type === 'tel') {
        this.onPhoneNumberInput({
          target: {
            value
          }
        });
      } else if (type === 'number') {
        this.onNumberInput({
          target: {
            value
          }
        });
      } else {
        this.formattedValue.emit(value);
      }
    }
    onZipCodeInput(event) {
      const input = event.target;
      const cursorPosition = input.selectionStart ?? 0;
      // Remove invalid characters and enforce length limits
      let zipCode = input.value ?? '';
      if (zipCode.length <= this.ZIPCODE_LENGTH_OF_FIVE) {
        zipCode = zipCode.replace(/\D/g, ''); // Remove all non-digit characters
      } else if (zipCode.length === this.ZIPCODE_LENGTH_OF_SIX) {
        zipCode = zipCode.replace(/[^\d-]/g, ''); // Allow digits and hyphen
      } else {
        zipCode = zipCode.replace(/[^\d-]/g, ''); // Remove all non-digit characters except for the hyphen
      }
      // Format the zip code
      const formattedZipCode = ZipCodeUtil.maskZipCode(zipCode);
      // Set the formatted value back to the input
      this.formattedValue.emit(formattedZipCode);
      // Adjust cursor position
      this.adjustCursorPosition(() => ZipCodeUtil.moveCursorForZipCode(input, cursorPosition, (zipCode.match(/\D/g) || []).length, formattedZipCode, event));
      // Validate the zip code
      this.validateInput(zipCode, 'zip');
    }
    onPhoneNumberInput(event) {
      const input = event.target;
      const cursorPosition = input.selectionStart ?? 0;
      const phoneNumber = input.value?.replace(/\D/g, ''); // Remove all non-digit characters
      const previousCharCount = (input.value?.match(/\D/g) || []).length;
      // Format the phone number
      const formattedPhoneNumber = PhoneNumberUtil.maskPhoneNumber(phoneNumber);
      // Set the formatted value back to the input
      this.formattedValue.emit(formattedPhoneNumber);
      // Adjust cursor position
      this.adjustCursorPosition(() => PhoneNumberUtil.moveCursorForPhoneNumber(input, cursorPosition, previousCharCount, formattedPhoneNumber, phoneNumber, event));
      // Validate the phone number
      this.validateInput(phoneNumber, 'tel');
    }
    onNumberInput(event) {
      const input = event.target;
      let value = input.value;
      const decimalCount = this.decimalCount ?? 0;
      value = normalizeNumberInput(value, decimalCount, this.previousValue);
      input.value = value;
      this.previousValue = value;
      this.formattedValue.emit(value);
    }
    /**
     * Adjusts the cursor position after formatting the input value.
     * @param adjustCursorWithUtils - The function to adjust the cursor position.
     */
    adjustCursorPosition(adjustCursorWithUtils) {
      setTimeout(() => {
        adjustCursorWithUtils();
      }, 0);
    }
    /**
     * Validates the input value and emits validation errors if necessary.
     * @param rawValue - The raw input value.
     * @param type - The type of input ('zip' or 'tel').
     */
    validateInput(rawValue, type) {
      const isZip = type === 'zip';
      const validation = isZip ? ZipCodeUtil.validateZipCode(rawValue) : PhoneNumberUtil.validatePhoneNumber(rawValue);
      const errorField = isZip ? 'zipCode' : 'phoneNumber';
      if (!validation.valid) {
        const errorMessage = validation.error;
        this.validationError.emit({
          field: errorField,
          error: errorMessage
        });
      }
    }
    static {
      this.ɵfac = function InputValidatorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputValidatorDirective)(i0.ɵɵdirectiveInject(i2.NgControl, 10));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: InputValidatorDirective,
        selectors: [["", "hmfInputValidator", ""]],
        hostBindings: function InputValidatorDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("input", function InputValidatorDirective_input_HostBindingHandler($event) {
              return ctx.onInput($event);
            });
          }
        },
        inputs: {
          decimalCount: "decimalCount",
          hmfInputValidator: "hmfInputValidator"
        },
        outputs: {
          validationError: "validationError",
          formattedValue: "formattedValue"
        }
      });
    }
  }
  return InputValidatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HmfDropdownSelectorComponent = /*#__PURE__*/(() => {
  class HmfDropdownSelectorComponent {
    constructor(homefieldIconsLibraryService) {
      this.ariaLabel = '';
      this.checkedLabelList = [];
      this.circleVariant = CircleVariantEnum.MEDIUM;
      this.currentSelected = {
        key: '',
        label: '',
        selected: false
      };
      this.isContained = false;
      this.isDisabled = false;
      this.isError = false;
      this.isLabelInside = false;
      this.isMobile = false;
      this.isMultipleChoice = false;
      this.isSelected = false;
      this.label = '';
      this.showDropdown = false;
      this.variant = ThemeVariant.PRIMARY;
      this.loading = true;
      this.themeVariant = ThemeVariant;
      this.circleVariantEnum = CircleVariantEnum;
      homefieldIconsLibraryService.registerIcons([homefieldIconChevronDown, homefieldIconChevronUp]);
    }
    static {
      this.ɵfac = function HmfDropdownSelectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfDropdownSelectorComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfDropdownSelectorComponent,
        selectors: [["hmf-dropdown-selector"]],
        inputs: {
          ariaLabel: "ariaLabel",
          checkedLabelList: "checkedLabelList",
          circleVariant: "circleVariant",
          currentSelected: "currentSelected",
          isContained: "isContained",
          isDisabled: "isDisabled",
          isError: "isError",
          isLabelInside: "isLabelInside",
          isMobile: "isMobile",
          isMultipleChoice: "isMultipleChoice",
          isSelected: "isSelected",
          label: "label",
          showDropdown: "showDropdown",
          variant: "variant"
        },
        decls: 8,
        vars: 31,
        consts: [["id", "hmf-dropdown-selector", 1, "hmf-button", "primary-btn", "rectangular-selector-button", "hmf-p-0", 3, "disabled", "ngClass"], [1, "inner-circle-container", "rectangular-selector-button", 3, "ngClass"], [1, "rectangular-content"], [1, "hmf-p-xs"], [1, "content", "hmf-mr-xs", "hmf-display-flex", "hmf-align-items-center", "hmf-justify-content-between", 3, "ngClass"], [4, "ngIf"], ["id", "chevron-icon", "width", "16px", "height", "16px", 1, "review-chip-svg", "hmf-display-flex", "hmf-ml-auto", 3, "name"], [4, "ngFor", "ngForOf"]],
        template: function HmfDropdownSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "span", 4);
            i0.ɵɵtemplate(5, HmfDropdownSelectorComponent_ng_container_5_Template, 2, 1, "ng-container", 5)(6, HmfDropdownSelectorComponent_ng_container_6_Template, 2, 1, "ng-container", 5);
            i0.ɵɵelement(7, "homefield-icon", 6);
            i0.ɵɵelementEnd()()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("disabled", ctx.isDisabled)("ngClass", i0.ɵɵpureFunctionV(8, _c38, [ctx.isError, ctx.isDisabled, ctx.isSelected, ctx.isContained, ctx.circleVariant === ctx.circleVariantEnum.LARGE, ctx.circleVariant === ctx.circleVariantEnum.MEDIUM, ctx.circleVariant === ctx.circleVariantEnum.SMALL, ctx.circleVariant === ctx.circleVariantEnum.XSMALL, ctx.circleVariant === ctx.circleVariantEnum.XXSMALL]));
            i0.ɵɵattribute("aria-label", ctx.ariaLabel);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction7(18, _c39, ctx.isMobile, ctx.checkedLabelList.length, ctx.circleVariant === ctx.circleVariantEnum.LARGE, ctx.circleVariant === ctx.circleVariantEnum.MEDIUM, ctx.circleVariant === ctx.circleVariantEnum.SMALL, ctx.circleVariant === ctx.circleVariantEnum.XSMALL, ctx.circleVariant === ctx.circleVariantEnum.XXSMALL));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(26, _c40, ctx.checkedLabelList.length, !ctx.checkedLabelList.length && ctx.variant === ctx.themeVariant.PRIMARY, ctx.variant === ctx.themeVariant.SECONDARY, !ctx.isLabelInside && ctx.isMultipleChoice));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isMultipleChoice);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isMultipleChoice);
            i0.ɵɵadvance();
            i0.ɵɵproperty("name", ctx.showDropdown ? "chevron-up" : "chevron-down");
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]   .cs-large-circle[_ngcontent-%COMP%]{height:180px;width:180px}[_nghost-%COMP%]   .cs-medium-circle[_ngcontent-%COMP%]{height:100px;width:100px}[_nghost-%COMP%]   .cs-small-circle[_ngcontent-%COMP%]{height:80px;width:80px}[_nghost-%COMP%]   .cs-xsmall-circle[_ngcontent-%COMP%]{height:36px;width:36px}[_nghost-%COMP%]   button[_ngcontent-%COMP%]{background:transparent;border:1px solid transparent;border-radius:50%;box-shadow:0 0 0 1px transparent;box-sizing:content-box;color:var(--hmf-gray900);padding:0;position:relative;width:100%}[_nghost-%COMP%]   button[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{background-color:transparent;border:1px solid transparent;border-radius:50%;box-sizing:border-box}[_nghost-%COMP%]   button[_ngcontent-%COMP%]   .inner-circle-container.rectangular-selector-button[_ngcontent-%COMP%]{border-radius:var(--hmf-sharp-radius)}[_nghost-%COMP%]   button[_ngcontent-%COMP%]   .rectangular-content[_ngcontent-%COMP%]{height:100%;position:relative;z-index:-10}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:2px solid transparent}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]:not(.unavailable)   .inner-circle-container[_ngcontent-%COMP%]{border:2px solid var(--hmf-border-secondary-static)}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]:not(.unavailable).is-dblborder{border:1px solid var(--hmf-border-secondary-static)}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]:not(.unavailable).is-dblborder   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-static)}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]:not(.unavailable).is-dblborder:hover   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-hover)}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]:not(.unavailable).is-dblborder:active   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-active)}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]:not(.unavailable).is-dblborder.disabled{border:1px dashed var(--hmf-border-disabled-subtle)}[_nghost-%COMP%]   button.is-selected[_ngcontent-%COMP%]:not(.unavailable).is-dblborder.disabled   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-disabled)}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]{box-shadow:none}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]:hover{box-shadow:none}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]:hover   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-hover)}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:2px solid var(--hmf-border-secondary-static)}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-disabled);position:relative}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], [_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]   .color-swatch[_ngcontent-%COMP%]{opacity:.3}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:after{background-color:var(--hmf-border-disabled);content:\"\";height:2px;left:0;position:absolute;top:calc(50% - 1px);transform:rotate(135deg);width:100%}[_nghost-%COMP%]   button.is-selected.unavailable[_ngcontent-%COMP%]:active   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-active)}[_nghost-%COMP%]   button.is-selected.unavailable.is-dblborder[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-static)}[_nghost-%COMP%]   button.is-selected.unavailable.is-dblborder[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-static)}[_nghost-%COMP%]   button.is-selected.unavailable.is-dblborder[_ngcontent-%COMP%]:hover   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-hover)}[_nghost-%COMP%]   button.is-selected.unavailable.is-dblborder[_ngcontent-%COMP%]:active   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-active)}[_nghost-%COMP%]   button.is-selected.unavailable.is-dblborder.disabled[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-disabled-subtle)}[_nghost-%COMP%]   button.is-selected.unavailable.is-dblborder.disabled[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-disabled)}[_nghost-%COMP%]   button.is-selected.unavailable.rectangular-selector-button[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:before{border-color:var(--hmf-gray600);border-top:1px solid;content:\"\";left:50%;margin:0;position:absolute;top:50%;transform:translate(-50%,-50%) rotate(-45deg);width:40px}[_nghost-%COMP%]   button.is-selected.unavailable.rectangular-selector-button[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:after{content:\"\";display:none}[_nghost-%COMP%]   button.is-contained[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-subtle-static)}[_nghost-%COMP%]   button.rectangular-selector-button[_ngcontent-%COMP%]{border-radius:4px;height:auto;width:max-content}[_nghost-%COMP%]   button.rectangular-selector-button[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{height:auto;width:fit-content}[_nghost-%COMP%]   button.rectangular-selector-button.disabled[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-disabled);opacity:.5;position:relative}[_nghost-%COMP%]   button.rectangular-selector-button.disabled[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:before{border-color:var(--hmf-gray600);border-top:1px solid;content:\"\";left:50%;margin:0;position:absolute;top:50%;transform:translate(-50%,-50%) rotate(-45deg);width:40px}[_nghost-%COMP%]   button.rectangular-selector-button.disabled[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:after{content:\"\";display:none}[_nghost-%COMP%]   button[_ngcontent-%COMP%]   .is-loading[_ngcontent-%COMP%]{background-color:var(--hmf-gray200);padding:0}[_nghost-%COMP%]   button[_ngcontent-%COMP%]:hover   .inner-circle-container[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-subtle-hover)}[_nghost-%COMP%]   button[_ngcontent-%COMP%]:active   .inner-circle-container[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-subtle-active)}[_nghost-%COMP%]   button.disabled[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-disabled)}[_nghost-%COMP%]   button.disabled[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], [_nghost-%COMP%]   button.disabled[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]   .color-swatch[_ngcontent-%COMP%]{opacity:.3}[_nghost-%COMP%]   button.disabled[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]{position:relative}[_nghost-%COMP%]   button.disabled[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], [_nghost-%COMP%]   button.disabled[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]   .color-swatch[_ngcontent-%COMP%]{opacity:.3}[_nghost-%COMP%]   button.disabled[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:after{background-color:var(--hmf-border-disabled);content:\"\";height:2px;left:0;position:absolute;top:calc(50% - 1px);transform:rotate(135deg);width:100%}[_nghost-%COMP%]   button.is-dblborder[_ngcontent-%COMP%]{padding:var(--hmf-xxxs)}[_nghost-%COMP%]   button.is-dblborder[_ngcontent-%COMP%]:hover{border:1px solid var(--hmf-border-secondary-subtle-static)}[_nghost-%COMP%]   button.is-dblborder[_ngcontent-%COMP%]:hover   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-subtle-hover)}[_nghost-%COMP%]   button.is-dblborder[_ngcontent-%COMP%]:active{border:1px solid var(--hmf-border-secondary-subtle-static)}[_nghost-%COMP%]   button.is-dblborder[_ngcontent-%COMP%]:active   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-secondary-subtle-active)}[_nghost-%COMP%]   button.is-dblborder.disabled[_ngcontent-%COMP%]{border:none}[_nghost-%COMP%]   button.is-dblborder.disabled[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-disabled)}[_nghost-%COMP%]   button.unavailable[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-secondary-subtle-static);opacity:.5}[_nghost-%COMP%]   button.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]{position:relative}[_nghost-%COMP%]   button.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], [_nghost-%COMP%]   button.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]   .color-swatch[_ngcontent-%COMP%]{opacity:.3}[_nghost-%COMP%]   button.unavailable[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:after{background-color:var(--hmf-border-disabled);content:\"\";height:2px;left:0;position:absolute;top:calc(50% - 1px);transform:rotate(135deg);width:100%}[_nghost-%COMP%]   button.unavailable.is-dblborder[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px dashed var(--hmf-border-secondary-subtle-static)}[_nghost-%COMP%]   button.unavailable.is-dblborder[_ngcontent-%COMP%]:hover{border:1px solid var(--hmf-border-secondary-subtle-hover)}[_nghost-%COMP%]   button.unavailable.is-dblborder[_ngcontent-%COMP%]:hover   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px dashed var(--hmf-border-secondary-hover)}[_nghost-%COMP%]   button.unavailable.is-dblborder[_ngcontent-%COMP%]:active{border:1px solid var(--hmf-border-secondary-subtle-hover)}[_nghost-%COMP%]   button.unavailable.is-dblborder[_ngcontent-%COMP%]:active   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px dashed var(--hmf-border-secondary-active)}[_nghost-%COMP%]   button.unavailable.is-dblborder.disabled[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-disabled-subtle)}[_nghost-%COMP%]   button.unavailable.is-dblborder.disabled[_ngcontent-%COMP%]   .inner-circle-container[_ngcontent-%COMP%]{border:1.5px solid var(--hmf-border-disabled)}[_nghost-%COMP%]   button.unavailable.rectangular-selector-button[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:before{border-color:var(--hmf-gray600);border-top:1px solid;content:\"\";left:50%;margin:0;position:absolute;top:50%;transform:translate(-50%,-50%) rotate(-45deg);width:40px}[_nghost-%COMP%]   button.unavailable.rectangular-selector-button[_ngcontent-%COMP%]   .inner-circle-container.stroked[_ngcontent-%COMP%]:after{content:\"\";display:none}[_nghost-%COMP%]   img[_ngcontent-%COMP%], [_nghost-%COMP%]   .color-swatch[_ngcontent-%COMP%]{border-radius:50%;width:100%}[_nghost-%COMP%]   .color-swatch[_ngcontent-%COMP%]{height:100%}#hmf-dropdown-selector[_ngcontent-%COMP%]{width:100%}#hmf-dropdown-selector[_ngcontent-%COMP%]   .rectangular-selector-button[_ngcontent-%COMP%]{background-color:var(--hmf-fill-base);border:1px solid var(--hmf-border-secondary-subtle-static);width:100%}#hmf-dropdown-selector[_ngcontent-%COMP%]   .rectangular-selector-button.selected[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-static)}#hmf-dropdown-selector[_ngcontent-%COMP%]   .rectangular-selector-button[_ngcontent-%COMP%]   .rectangular-content[_ngcontent-%COMP%]{z-index:initial}#hmf-dropdown-selector[_ngcontent-%COMP%]   .rectangular-selector-button[_ngcontent-%COMP%]   .rectangular-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-subtle-static);text-align:left;width:100%}#hmf-dropdown-selector[_ngcontent-%COMP%]   .rectangular-selector-button[_ngcontent-%COMP%]   .rectangular-content[_ngcontent-%COMP%]   .content.overflow-elipsis[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#hmf-dropdown-selector[_ngcontent-%COMP%]   .rectangular-selector-button[_ngcontent-%COMP%]   .rectangular-content[_ngcontent-%COMP%]   .content-selected[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-static)}#hmf-dropdown-selector[_ngcontent-%COMP%]   .rectangular-selector-button[_ngcontent-%COMP%]   .rectangular-content[_ngcontent-%COMP%]   .review-chip-svg[_ngcontent-%COMP%]{margin-left:var(--hmf-xs);pointer-events:none}#hmf-dropdown-selector.disabled[_ngcontent-%COMP%]{background-color:var(--hmf-fill-disabled-subtle)}#hmf-dropdown-selector.disabled[_ngcontent-%COMP%]   .rectangular-selector-button[_ngcontent-%COMP%]{border-color:1px solid var(--hmf-border-disabled)}#hmf-dropdown-selector.disabled[_ngcontent-%COMP%]   .rectangular-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:var(--hmf-label-disabled)}#hmf-dropdown-selector.disabled[_ngcontent-%COMP%]   .review-chip-svg[_ngcontent-%COMP%]  svg path{fill:var(--hmf-label-disabled)}#hmf-dropdown-selector[_ngcontent-%COMP%]:hover:not([disabled]){cursor:pointer}#hmf-dropdown-selector[_ngcontent-%COMP%]:hover:not([disabled])   .rectangular-selector-button[_ngcontent-%COMP%]{border:2px solid var(--hmf-gray900);box-shadow:var(--hmf-subtle-shadow)}#hmf-dropdown-selector[_ngcontent-%COMP%]:hover:not([disabled])   .rectangular-selector-button.selected[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-hover)}#hmf-dropdown-selector[_ngcontent-%COMP%]:hover:not([disabled])   .rectangular-selector-button.is-mobile[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-subtle-static)}#hmf-dropdown-selector[_ngcontent-%COMP%]:hover:not([disabled])   .rectangular-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-subtle-hover)}#hmf-dropdown-selector[_ngcontent-%COMP%]:hover:not([disabled])   .rectangular-content[_ngcontent-%COMP%]   .content.selected[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-hover)}#hmf-dropdown-selector[_ngcontent-%COMP%]:active:not([disabled])   .rectangular-selector-button[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-subtle-active)}#hmf-dropdown-selector[_ngcontent-%COMP%]:active:not([disabled])   .rectangular-selector-button[_ngcontent-%COMP%]   .rectangular-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-subtle-active)}#hmf-dropdown-selector.error[_ngcontent-%COMP%]{background-color:var(--hmf-fill-negative-subtle)}#hmf-dropdown-selector.error[_ngcontent-%COMP%]   .rectangular-selector-button[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-negative)}#hmf-dropdown-selector.error[_ngcontent-%COMP%]   .rectangular-selector-button.selected[_ngcontent-%COMP%]{border-width:2px}#hmf-dropdown-selector.error[_ngcontent-%COMP%]   .rectangular-selector-button[_ngcontent-%COMP%]   .rectangular-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:var(--hmf-label-negative)}#hmf-dropdown-selector.error[_ngcontent-%COMP%]   .rectangular-selector-button[_ngcontent-%COMP%]   .rectangular-content[_ngcontent-%COMP%]   .content-selected[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-static)}#hmf-dropdown-selector.error[_ngcontent-%COMP%]   .rectangular-selector-button[_ngcontent-%COMP%]   .rectangular-content[_ngcontent-%COMP%]   .review-chip-svg[_ngcontent-%COMP%]  svg path{fill:var(--hmf-red500)}"]
      });
    }
  }
  return HmfDropdownSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HmfSelectComponent = /*#__PURE__*/(() => {
  class HmfSelectComponent {
    constructor(homefieldIconsLibraryService) {
      this.ariaLabel = '';
      this.circleVariant = CircleVariantEnum.MEDIUM;
      this.dropdownList = [];
      this.iconName = '';
      this.isDefaultValueTriggered = false;
      this.isDisabled = false;
      this.isError = false;
      this.isLabelInside = false;
      this.isMobile = false;
      this.isMultipleChoice = false;
      this.isRequired = false;
      this.label = '';
      this.optionDesign = OptionDesignVariant.LABEL;
      this.size = SizeVariant.LARGE;
      this.variant = ThemeVariant.PRIMARY;
      this.selector = SelectorVariant.RECTANGULAR;
      this.selected = false;
      this.sizeVariant = SizeVariant;
      this.themeVariant = ThemeVariant;
      this.optionDesignVariant = OptionDesignVariant;
      this.contained = true;
      this.isBottom = false;
      this.showDropdown = false;
      this.checkedLabelList = [];
      this.currentSelected = {
        key: '',
        label: '',
        selected: false
      };
      this.handleCheckedLabelList = new EventEmitter();
      this.handleIndividualCheckedList = new EventEmitter();
      this.handleUpdatedList = new EventEmitter();
      this.dropdownEvent = new EventEmitter();
      this.triggerDefaultValue = new EventEmitter();
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      this.onTouched = () => {};
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      this.onChanged = () => {};
      this.value = [];
      homefieldIconsLibraryService.registerIcons(completeIconSet);
    }
    ngOnChanges() {
      if (!this.isDefaultValueTriggered || !this.dropdownList.length) {
        return;
      }
      if (this.isMultipleChoice) {
        this.checkedLabelList = [];
        this.dropdownList.forEach(option => this.storeMultipleChoice(option.selected, option.label));
      } else {
        const selectedOption = this.dropdownList.find(({
          selected
        }) => selected);
        if (selectedOption) this.storeSingleChoice(true, selectedOption.label);
      }
      this.triggerDefaultValue.emit(this.isDefaultValueTriggered);
    }
    toggleSelect(event) {
      event.stopPropagation();
      event.preventDefault();
      this.selected = !this.selected;
      this.showDropdown = this.selected;
      this.dropdownEvent.emit(this.showDropdown);
    }
    getSelectedValue(event, selected, {
      key,
      label,
      ...props
    }) {
      event.stopPropagation();
      event.preventDefault();
      if (this.isMultipleChoice) {
        this.storeMultipleChoice(selected, label);
        this.updateDropdownSelection();
      } else {
        this.storeSingleChoice(selected, label);
      }
      this.hideMenu();
      this.currentSelected = {
        ...props,
        selected,
        key,
        label
      };
      const updatedList = this.updatingDropdownList(selected, key);
      this.emitUpdatedData(updatedList);
      this.onChanged(this.checkedLabelList);
    }
    hideMenu() {
      if (!this.isMultipleChoice) {
        this.selected = false;
        this.showDropdown = false;
        this.dropdownEvent.emit(this.showDropdown);
      }
    }
    handleElementPosition(isVisble) {
      this.isBottom = isVisble;
    }
    lostFocus(e, index) {
      if (e.key === 'Tab' && index === this.dropdownList.length - 1) {
        this.hideMenu();
      }
    }
    handleClickEvent(isClickedOutside) {
      if (isClickedOutside) {
        this.showDropdown = false;
        this.selected = false;
      }
    }
    trackByKey(_, dropdownData) {
      return dropdownData.key;
    }
    multipleChoiceCheckboxClasses(optionSelected) {
      const baseClasses = {
        'multiple-choice': true,
        'hmf-sharp-radius': true,
        'hmf-display-flex': true,
        'hmf-align-items-center': true,
        'hmf-justify-content-between': true
      };
      if (optionSelected) {
        return {
          ...baseClasses,
          active: true
        };
      }
      return baseClasses;
    }
    writeValue(value) {
      this.value = value ?? [];
      this.checkedLabelList = value ?? [];
      this.updateDropdownSelection();
    }
    registerOnChange(notify) {
      this.onChanged = notify;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    validate() {
      if (this.isRequired && this.checkedLabelList.length === 0) {
        return {
          required: true
        };
      }
      return null;
    }
    storeSingleChoice(selected, label) {
      const updatedSelection = selected ? [label] : [];
      this.checkedLabelList = updatedSelection;
    }
    updateDropdownSelection() {
      this.dropdownList.forEach(option => {
        option.selected = this.checkedLabelList.includes(option.label);
        if (option.selected) {
          this.currentSelected = option;
        }
      });
    }
    storeMultipleChoice(selected, label) {
      if (selected) {
        this.checkedLabelList.push(label);
        // Note: although is not needed, I've added a comparison function inside the sort call due a sonarqube warning
        this.checkedLabelList.sort((a, b) => a.localeCompare(b));
      } else {
        const index = this.checkedLabelList.indexOf(label);
        if (index !== -1) {
          this.checkedLabelList.splice(index, 1);
        }
      }
    }
    updatingDropdownList(selected, key) {
      const updatedList = [...this.dropdownList];
      return updatedList.map(dropdownData => {
        const defaultSelectValue = this.isMultipleChoice ? dropdownData.selected : false;
        const selectionUpdated = key === dropdownData.key ? selected : defaultSelectValue;
        return {
          ...dropdownData,
          selected: selectionUpdated
        };
      });
    }
    emitUpdatedData(updatedList) {
      // share checked name list
      this.handleCheckedLabelList.emit(this.checkedLabelList);
      // share individual selected item
      this.handleIndividualCheckedList.emit(this.currentSelected);
      // share initial list updated with selected values
      this.handleUpdatedList.emit(updatedList);
    }
    static {
      this.ɵfac = function HmfSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfSelectComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfSelectComponent,
        selectors: [["hmf-select"]],
        inputs: {
          ariaLabel: "ariaLabel",
          circleVariant: "circleVariant",
          dropdownList: "dropdownList",
          iconName: "iconName",
          isDefaultValueTriggered: "isDefaultValueTriggered",
          isDisabled: "isDisabled",
          isError: "isError",
          isLabelInside: "isLabelInside",
          isMobile: "isMobile",
          isMultipleChoice: "isMultipleChoice",
          isRequired: "isRequired",
          label: "label",
          optionDesign: "optionDesign",
          size: "size",
          variant: "variant"
        },
        outputs: {
          handleCheckedLabelList: "handleCheckedLabelList",
          handleIndividualCheckedList: "handleIndividualCheckedList",
          handleUpdatedList: "handleUpdatedList",
          dropdownEvent: "dropdownEvent",
          triggerDefaultValue: "triggerDefaultValue"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => HmfSelectComponent),
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: HmfSelectComponent,
          multi: true
        }]), i0.ɵɵNgOnChangesFeature],
        decls: 10,
        vars: 40,
        consts: [["id", "selectContainer", 1, "hmf-select", "hmf-position-relative", 3, "isClickedOutside", "hmfClickDetectionHandler", "ngClass"], ["for", "hmf-dropdown-selector", 1, "hmf-select-label", "hmf-position-absolute", 3, "ngClass"], ["id", "toggleSelect", "onkeypress", "", 1, "toggle-select", 3, "click", "ariaLabel", "checkedLabelList", "circleVariant", "currentSelected", "isContained", "isDisabled", "isError", "isLabelInside", "isMultipleChoice", "isMobile", "isSelected", "label", "ngClass", "showDropdown", "variant"], ["id", "optionsWrapper", 3, "ngClass"], ["id", "optionsContainer", 1, "display-dropdown-options", 3, "isElementVisible", "hmfInsideViewport", "ngClass"], [1, "dropdown-option", "hmf-display-flex", "hmf-align-items-center", "hmf-m-0", "hmf-px-s", 3, "ngClass"], [1, "hmf-display-flex", "hmf-align-items-center", "hmf-mt-xxxs", "select-label", "is-required"], [1, "hmf-display-flex", "hmf-align-items-center", "select-label", "is-error"], [1, "dropdown-option", "hmf-display-flex", "hmf-align-items-center", "hmf-m-0", "hmf-px-s", 3, "click", "keydown", "ngClass"], [3, "checked", "ngClass", "tabIndex"], ["width", "16px", "height", "16px", 1, "hmf-mr-xxs", 3, "name"], [3, "ngClass"], [1, "hmf-body-s"]],
        template: function HmfSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("isClickedOutside", function HmfSelectComponent_Template_div_isClickedOutside_0_listener($event) {
              return ctx.handleClickEvent($event);
            });
            i0.ɵɵelementStart(1, "label", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "hmf-dropdown-selector", 2);
            i0.ɵɵlistener("click", function HmfSelectComponent_Template_hmf_dropdown_selector_click_3_listener($event) {
              return ctx.toggleSelect($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 3)(5, "div", 4);
            i0.ɵɵlistener("isElementVisible", function HmfSelectComponent_Template_div_isElementVisible_5_listener($event) {
              return ctx.handleElementPosition($event);
            });
            i0.ɵɵrepeaterCreate(6, HmfSelectComponent_For_7_Template, 5, 18, "button", 5, ctx.trackByKey, true);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(8, HmfSelectComponent_Conditional_8_Template, 3, 0, "div", 6)(9, HmfSelectComponent_Conditional_9_Template, 3, 0, "div", 7);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("hmfClickDetectionHandler", true)("ngClass", i0.ɵɵpureFunction3(24, _c41, !ctx.dropdownList.length, ctx.isError, ctx.isDisabled));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(28, _c42, ctx.currentSelected.selected || ctx.showDropdown, !(ctx.selected || ctx.showDropdown), ctx.isDisabled));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ariaLabel", ctx.ariaLabel)("checkedLabelList", ctx.checkedLabelList)("circleVariant", ctx.circleVariant)("currentSelected", ctx.currentSelected)("isContained", ctx.contained)("isDisabled", ctx.isDisabled)("isError", ctx.isError || ctx.isRequired)("isLabelInside", ctx.isLabelInside)("isMultipleChoice", ctx.isMultipleChoice)("isMobile", !ctx.checkedLabelList.length && ctx.isMobile)("isSelected", ctx.selected)("label", ctx.label)("ngClass", i0.ɵɵpureFunction1(32, _c43, ctx.checkedLabelList.length))("showDropdown", ctx.showDropdown)("variant", ctx.variant);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(34, _c44, ctx.showDropdown, ctx.isMobile && ctx.isBottom));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hmfInsideViewport", ctx.isMobile && ctx.showDropdown)("ngClass", i0.ɵɵpureFunction2(37, _c45, !ctx.showDropdown, ctx.showDropdown));
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.dropdownList);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.isRequired && ctx.checkedLabelList.length === 0 ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isError && ctx.checkedLabelList.length === 0 ? 9 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent, HmfDropdownSelectorComponent, HmfCheckboxComponent, InsideViewportDirective, ClickHandlerDirective],
        styles: [".hmf-select[_ngcontent-%COMP%]{min-width:300px;width:-webkit-fill-available}.hmf-select[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{z-index:10}.hmf-select[_ngcontent-%COMP%]   label.as-placeholder[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-subtle-static);left:1rem;top:.85em;transition:top .3s ease,font-size .3s ease,color .3s ease}.hmf-select[_ngcontent-%COMP%]   label.shrink[_ngcontent-%COMP%]{background-color:var(--hmf-fill-base);color:var(--hmf-label-base);left:.75rem;top:0!important;transform:translateY(-50%)}.hmf-select[_ngcontent-%COMP%]   label.disabled[_ngcontent-%COMP%]{background-color:var(--hmf-fill-disabled-subtle);color:var(--hmf-label-disabled)}.hmf-select[_ngcontent-%COMP%]   label.label-icon[_ngcontent-%COMP%]{padding-left:2.8rem}.hmf-select[_ngcontent-%COMP%]:hover:not(.hmf-button[aria-disabled=true])   label[_ngcontent-%COMP%]{color:var(--hmf-gray-800)}.hmf-select[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:var(--hmf-gray700)}.hmf-select[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%]{position:relative;width:100%}.hmf-select[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button.primary-btn[_ngcontent-%COMP%]{background-color:var(--hmf-fill-base);border-color:var(--hmf-gray500);border-width:1px;color:var(--hmf-label-secondary-subtle-static);height:44px;justify-content:space-between;min-width:208px;outline:none;text-align:left;width:100%}.hmf-select[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button.primary-btn[aria-disabled=true][_ngcontent-%COMP%]{background-color:var(--hmf-fill-disabled-subtle);border-color:var(--hmf-label-disabled);color:var(--hmf-label-disabled)}.hmf-select[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button.primary-btn[_ngcontent-%COMP%]:hover:not([aria-disabled=true]){background-color:var(--hmf-fill-base);border-color:var(--hmf-gray900);border-width:2px;box-shadow:none}.hmf-select[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button.primary-btn[_ngcontent-%COMP%]:focus:not([aria-disabled=true]){border-color:var(--hmf-gray800);color:var(--hmf-label-secondary-subtle-active);outline:none}.hmf-select[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button.primary-btn[_ngcontent-%COMP%]:active:not([aria-disabled=true]){border-color:var(--hmf-gray700)}.hmf-select[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%]{padding-left:var(--hmf-xs)}.hmf-select[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-gray900)}.hmf-select[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-gray900)}.hmf-select.error[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button.primary-btn[_ngcontent-%COMP%]{background-color:var(--hmf-fill-secondary-static);border-color:var(--hmf-red500);color:var(--hmf-label-negative)}.hmf-select.error[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button.primary-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-red500)}.hmf-select.error[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button.primary-btn[aria-disabled=true][_ngcontent-%COMP%]{background-color:var(--hmf-gray200);border-color:var(--hmf-gray700)}.hmf-select.error[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button.primary-btn[aria-disabled=true][_ngcontent-%COMP%]   span[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-gray900)}.hmf-select.error[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button.primary-btn[_ngcontent-%COMP%]:hover:not([aria-disabled=true]){background-color:var(--hmf-red50);border-color:var(--hmf-red500)}.hmf-select.error[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button.primary-btn[_ngcontent-%COMP%]:focus:not([aria-disabled=true]){border-color:var(--hmf-red500);outline:none}.hmf-select.error[_ngcontent-%COMP%]   .hmf-dropdown-button-container[_ngcontent-%COMP%] > .hmf-button.primary-btn[_ngcontent-%COMP%]:active:not([aria-disabled=true]){border-color:var(--hmf-red500)}.hmf-select.error[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:var(--hmf-label-negative)}.hmf-select.error[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:var(--hmf-red500)}.hmf-select[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]{box-shadow:var(--hmf-subtle-shadow);width:100%}.hmf-select[_ngcontent-%COMP%]   .hmf-modal-container[_ngcontent-%COMP%]   .hmf-dropdown-container[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]{display:block}.dropdown-container[_ngcontent-%COMP%]{position:absolute;width:100%;z-index:1}@media (min-width: 1024px){.dropdown-container[_ngcontent-%COMP%]   .dropdown-container[_ngcontent-%COMP%]{max-height:440px}}.dropdown-container--bottom[_ngcontent-%COMP%]{bottom:0;margin-bottom:var(--hmf-xl)}.dropdown-container[_ngcontent-%COMP%]   .display-dropdown-options[_ngcontent-%COMP%]{background-color:var(--hmf-gray50);max-height:343px;overflow:auto;scrollbar-color:var(--hmf-fill-inverse);scrollbar-width:var(--hmf-xxxs);width:calc(100% - 4px);z-index:1}@media (min-width: 1024px){.dropdown-container[_ngcontent-%COMP%]   .display-dropdown-options[_ngcontent-%COMP%]   .display-dropdown-options[_ngcontent-%COMP%]{max-height:440px}}.dropdown-container[_ngcontent-%COMP%]   .display-dropdown-options[_ngcontent-%COMP%]::-webkit-scrollbar{width:var(--hmf-xxxs)}.dropdown-container[_ngcontent-%COMP%]   .display-dropdown-options[_ngcontent-%COMP%]::-webkit-scrollbar-track{background:var(--hmf-fill-base-prominent)}.dropdown-container[_ngcontent-%COMP%]   .display-dropdown-options[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background:var(--hmf-fill-inverse);border:var(--hmf-xxxs) solid transparent;border-radius:var(--hmf-xxs)}.dropdown-container[_ngcontent-%COMP%]   .display-dropdown-options[_ngcontent-%COMP%]::-webkit-scrollbar-thumb:hover{background:var(--hmf-fill-base-prominent)}.dropdown-container[_ngcontent-%COMP%]   .display-dropdown-options[_ngcontent-%COMP%]   .dropdown-option[_ngcontent-%COMP%]{background-color:initial;border:none;cursor:pointer;text-align:left}.dropdown-container[_ngcontent-%COMP%]   .display-dropdown-options[_ngcontent-%COMP%]   .dropdown-option.selected[_ngcontent-%COMP%], .dropdown-container[_ngcontent-%COMP%]   .display-dropdown-options[_ngcontent-%COMP%]   .dropdown-option[_ngcontent-%COMP%]:hover{background-color:var(--hmf-gray100)}.dropdown-container[_ngcontent-%COMP%]   .display-dropdown-options[_ngcontent-%COMP%]   .dropdown-option[_ngcontent-%COMP%]   .multiple-choice[_ngcontent-%COMP%]{--hmf-xs: 0px;--hmf-mr-xs: 0px;--hmf-mr-xxs: 0px}.dropdown-container[_ngcontent-%COMP%]   .display-dropdown-options[_ngcontent-%COMP%]   .dropdown-option[_ngcontent-%COMP%]   homefield-icon[_ngcontent-%COMP%]{display:grid;place-self:center}"]
      });
    }
  }
  return HmfSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfSelectableComponent = /*#__PURE__*/(() => {
  class HmfSelectableComponent {
    constructor() {
      this.options = input([]);
      this.multipleSelection = input(true);
      this.allowDeselection = input(true);
      this.shape = input('square');
      this.variant = input('text');
      this.contained = input(false);
      this.width = input('100%');
      this.minWidth = input('initial');
      this.height = input('100%');
      this.spaceBetween = input('');
      this.fillColor = input('');
      this.flexWrap = input(true);
      this.classList = input('');
      this.optionsClassList = input('');
      this.currentOptions = [];
      this.currentSpaceBetween = 'var(--hmf-s)';
      this.currentFillColor = 'transparent';
      this.currentBorderRadius = '0';
      this.defaultSelectableImage = 'https://images.dickssportinggoods.com/marketing/productImageUnavailable.jpg';
      this.selectionChange = output();
    }
    ngOnChanges() {
      this.setDefaultValues();
      this.setOptionsDefaultValues();
    }
    optionClassList(opt) {
      return {
        'hmf-selectable-selected': opt.selected,
        'hmf-selectable-unselected': !opt.selected,
        'hmf-selectable-unavailable': opt.unavailable,
        'hmf-selectable-disabled': opt.disabled,
        'hmf-selectable-contained': this.contained(),
        'hmf-selectable-allow-deselection': this.allowDeselection(),
        'hmf-selectable-square': this.shape() === 'square',
        'hmf-selectable-circle': this.shape() === 'circle',
        'hmf-flex-wrap': opt.wrapButtonText
      };
    }
    optionStyle(opt) {
      return {
        width: this.width(),
        minWidth: this.minWidth(),
        height: this.height(),
        'background-color': opt.fillColor,
        'border-radius': this.currentBorderRadius
      };
    }
    colorOptionStyle(opt) {
      return {
        'border-radius': this.currentBorderRadius,
        'background-color': opt.value
      };
    }
    setDefaultValues() {
      this.currentBorderRadius = this.shape() === 'square' ? '0' : '50%';
      if (this.spaceBetween()) {
        if (this.isCssVar(this.spaceBetween())) {
          this.currentSpaceBetween = this.getCssVarWithFallback(this.spaceBetween(), 'var(--hmf-s)');
        } else {
          this.currentSpaceBetween = this.spaceBetween();
        }
      }
      if (this.fillColor() && this.isCssVar(this.fillColor())) {
        this.currentFillColor = this.getCssVarWithFallback(this.fillColor(), 'transparent');
      }
    }
    setOptionsDefaultValues() {
      this.currentOptions = [];
      if (!this.options()) {
        return;
      }
      for (const [index, option] of this.options().entries()) {
        const defaultAltText = 'Option ' + index + ' alt text';
        const currentOption = {
          id: option.id,
          value: option.value,
          secondLineValue: option.secondLineValue || '',
          selected: option.selected || false,
          unavailable: option.unavailable || false,
          disabled: option.disabled || false,
          variant: option.variant || this.variant(),
          fillColor: option.fillColor || this.currentFillColor,
          imgAltText: option.imgAltText || defaultAltText,
          label: option.label || '',
          lazyLoadImage: !!option?.lazyLoadImage,
          classList: option.classList || '',
          secondLineClassList: option.secondLineClassList || '',
          wrapButtonText: option.wrapButtonText || false
        };
        this.currentOptions.push(currentOption);
      }
    }
    changeSelection(index) {
      const optionClicked = this.currentOptions[index];
      if (this.cannotUpdate(optionClicked)) {
        return;
      }
      const selectedValues = [];
      if (this.multipleSelection()) {
        optionClicked.selected = !optionClicked.selected;
        for (const option of this.currentOptions) {
          if (option.selected) {
            selectedValues.push({
              id: option.id,
              value: option.value
            });
          }
        }
      } else {
        if (optionClicked.selected) {
          optionClicked.selected = false;
        } else {
          for (const option of this.currentOptions) {
            option.selected = false;
          }
          optionClicked.selected = true;
          selectedValues.push({
            id: optionClicked.id,
            value: optionClicked.value
          });
        }
      }
      this.selectionChange.emit(selectedValues);
    }
    /**
     * Handles the image error event by setting the source of the image to a default image.
     * @param event - The event object containing the target image element that encountered an error.
     */
    onImageError(event) {
      const target = event.target;
      target.src = this.defaultSelectableImage;
    }
    cannotUpdate(option) {
      return option.disabled || option.selected && !this.allowDeselection();
    }
    isCssVar(varMaybe) {
      return varMaybe.startsWith('--');
    }
    getCssVarWithFallback(varName, fallback) {
      return `var(${varName}, ${fallback})`;
    }
    negateCssValue(value) {
      return `calc(-1 * ${value})`;
    }
    static {
      this.ɵfac = function HmfSelectableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfSelectableComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfSelectableComponent,
        selectors: [["hmf-selectable"]],
        inputs: {
          options: [1, "options"],
          multipleSelection: [1, "multipleSelection"],
          allowDeselection: [1, "allowDeselection"],
          shape: [1, "shape"],
          variant: [1, "variant"],
          contained: [1, "contained"],
          width: [1, "width"],
          minWidth: [1, "minWidth"],
          height: [1, "height"],
          spaceBetween: [1, "spaceBetween"],
          fillColor: [1, "fillColor"],
          flexWrap: [1, "flexWrap"],
          classList: [1, "classList"],
          optionsClassList: [1, "optionsClassList"]
        },
        outputs: {
          selectionChange: "selectionChange"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 3,
        vars: 7,
        consts: [[1, "hmf-selectable-container", "hmf-display-flex", 3, "ngClass", "ngStyle"], [3, "ngClass", "ngStyle"], ["type", "button", 1, "hmf-selectable-base", "fill-base-subtle", "hmf-display-flex", "hmf-align-items-center", "hmf-justify-content-center", "hmf-text-align-center", "hmf-position-relative", "hmf-flex-shrink-none", 3, "click", "ngStyle", "disabled"], [1, "hmf-selectable-unavailable-slash"], [1, "hmf-color-variant", "hmf-m-xxxs", 3, "class", "ngStyle"], [3, "class", "src", "alt"], [1, "hmf-label-base", "hmf-text-align-center", "hmf-mb-0", "hmf-mt-xxs", 3, "ngStyle"], [1, "hmf-m-xxxs"], [3, "class"], [1, "hmf-color-variant", "hmf-m-xxxs", 3, "ngStyle"], [3, "error", "src", "alt"]],
        template: function HmfSelectableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵrepeaterCreate(1, HmfSelectableComponent_For_2_Template, 7, 17, "div", 1, _forTrack0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c5, ctx.classList(), ctx.flexWrap() ? "hmf-flex-wrap" : "x-scrollable hmf-p-xxxs"))("ngStyle", i0.ɵɵpureFunction1(5, _c48, ctx.negateCssValue(ctx.currentSpaceBetween)));
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.currentOptions);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgStyle],
        styles: ["button[_ngcontent-%COMP%]{color:inherit}.hmf-selectable-container[_ngcontent-%COMP%]{font-family:var(--font-primary);font-size:var(--body-font-size-s);font-weight:var(--font-primary-regular-weight);letter-spacing:var(--body-letter-spacing);line-height:var(--body-line-height-s);overflow:visible;-ms-overflow-style:none;scrollbar-width:none;transition:height 1s}.hmf-selectable-container[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.hmf-selectable-base[_ngcontent-%COMP%]{border:1px solid transparent;box-sizing:border-box;cursor:pointer;overflow:hidden;padding:1px}.hmf-selectable-base[_ngcontent-%COMP%]   .hmf-color-variant[_ngcontent-%COMP%]{height:calc(100% - var(--hmf-xxs));width:100%}.hmf-selectable-base[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:100%}.hmf-selectable-base.hmf-selectable-disabled[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-disabled);color:inherit;cursor:default;padding:1px}.hmf-selectable-selected[_ngcontent-%COMP%]{border:2px solid var(--hmf-border-secondary-static);font-weight:700;padding:0}.hmf-selectable-selected[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-style:bold!important}@media (hover: hover) and (pointer: fine){.hmf-selectable-selected[_ngcontent-%COMP%]:hover{border-color:var(--hmf-border-secondary-static);border-width:2px}.hmf-selectable-selected[_ngcontent-%COMP%]:hover.hmf-selectable-allow-deselection{border-color:var(--hmf-border-secondary-hover);border-width:1px;padding:1px}}.hmf-selectable-selected[_ngcontent-%COMP%]:active{border-color:var(--hmf-border-secondary-static);border-width:2px}.hmf-selectable-selected[_ngcontent-%COMP%]:active.hmf-selectable-allow-deselection{border-color:var(--hmf-border-secondary-active);border-width:1px;padding:1px}.hmf-selectable-unselected[_ngcontent-%COMP%]{cursor:pointer;outline:none;outline-offset:1px;overflow:hidden}.hmf-selectable-unselected.hmf-selectable-contained[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-subtle-static)}@media (hover: hover) and (pointer: fine){.hmf-selectable-unselected[_ngcontent-%COMP%]:hover{border:1px solid var(--hmf-border-secondary-subtle-hover);outline:1px solid var(--hmf-border-secondary-subtle-hover)}}.hmf-selectable-unselected[_ngcontent-%COMP%]:active{border:1px solid var(--hmf-border-secondary-subtle-active);outline:1px solid var(--hmf-border-secondary-subtle-active)}.hmf-selectable-unselected[_ngcontent-%COMP%]:disabled{border:1px dashed var(--hmf-fill-disabled);cursor:not-allowed;outline:none}.hmf-selectable-unavailable[_ngcontent-%COMP%]{border:1px dashed var(--hmf-border-secondary-subtle-static);isolation:isolate;position:relative}.hmf-selectable-unavailable[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{opacity:.5}.hmf-selectable-unavailable[_ngcontent-%COMP%]   .hmf-selectable-unavailable-slash[_ngcontent-%COMP%]{container-type:size;height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%;z-index:1}.hmf-selectable-unavailable[_ngcontent-%COMP%]   .hmf-selectable-unavailable-slash[_ngcontent-%COMP%]:after{background-color:var(--hmf-fill-disabled);box-shadow:0 0 0 1px var(--hmf-fill-base);content:\"\";height:calc(100cqmin + 2px);left:50%;position:absolute;top:50%;transform:translate(-50%,-50%) rotate(45deg);width:1px}@supports not (height: 100cqmin){.hmf-selectable-unavailable[_ngcontent-%COMP%]   .hmf-selectable-unavailable-slash[_ngcontent-%COMP%]:after{height:100%}}.hmf-selectable-unavailable.hmf-selectable-rectangle[_ngcontent-%COMP%]   .hmf-selectable-unavailable-slash[_ngcontent-%COMP%]:after{height:112cqmin}@supports not (height: 100cqmin){.hmf-selectable-unavailable.hmf-selectable-rectangle[_ngcontent-%COMP%]   .hmf-selectable-unavailable-slash[_ngcontent-%COMP%]:after{height:112%}}.hmf-selectable-outline[_ngcontent-%COMP%]{border:none;outline:none}.hmf-selectable-contained[_ngcontent-%COMP%]{border-color:1px solid var(--hmf-border-secondary-hover)}.hmf-selectable-unavailable-unselected[_ngcontent-%COMP%], .hmf-selectable-unavailable-unselected[_ngcontent-%COMP%]:hover, .hmf-selectable-unavailable-unselected[_ngcontent-%COMP%]:active{border-style:dashed}.hmf-selectable-border-normal[_ngcontent-%COMP%]{outline:none!important}.x-scrollable[_ngcontent-%COMP%]{overflow:scroll}"]
      });
    }
  }
  return HmfSelectableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfSidePanelComponent = /*#__PURE__*/(() => {
  class HmfSidePanelComponent {
    constructor(renderer, document, homefieldIconsLibraryService, elementRef, platformId) {
      this.renderer = renderer;
      this.document = document;
      this.homefieldIconsLibraryService = homefieldIconsLibraryService;
      this.elementRef = elementRef;
      this.platformId = platformId;
      this.element = '';
      /**
       * @description Boolean representing if the side panel is open or not.
       */
      this.showSidePanel = false;
      /**
       * @description Number representing the duration of the side panel transition in milliseconds.
       */
      this.duration = 500;
      /**
       * @description Number representing the width of the side panel when opened as a
       * percentage relative to the parent container.
       */
      this.width = 40;
      /**
       * @description String representing which direction the panel will be positioned at.
       */
      this.side = 'right';
      /**
       * @description String representing the css class that will be added to the side panel.
       */
      this.panelContentClass = '';
      /**
       * @description Boolean representing if the top section wil be sticky or not.
       */
      this.isHeaderSticky = false;
      /**
       * @description String representing the css class that will be added to the side panel body.
       */
      this.panelBodyClass = '';
      /**
       * @description Event Emitter that is fired when the panel is closed.
       */
      this.sidePanelIsOpen = new EventEmitter();
      this.panelContent = viewChild.required('panelContentDiv');
      this.homefieldIconsLibraryService.registerIcons([homefieldIconSignCancel]);
      this.element = this.elementRef.nativeElement?.tagName?.toLowerCase();
      // If the panel should be open when the component loads,
      // add the correct styles to prevent overlap
      if (this.showSidePanel) {
        this.toggleScrollBar(true);
      }
    }
    /**
     * @description Detects when the showSidePanel value changes and toggles the scrollbar.
     */
    ngOnChanges(changes) {
      if (changes['showSidePanel'] !== undefined && changes['showSidePanel'].currentValue !== undefined) {
        this.toggleScrollBar(changes['showSidePanel'].currentValue);
      }
    }
    ngOnDestroy() {
      this.showSidePanel = false;
      this.toggleScrollBar(this.showSidePanel);
    }
    /**
     * @description Closes the side panel and emits a sidePanelIsOpen event
     */
    closePanel() {
      this.showSidePanel = false;
      this.toggleScrollBar(this.showSidePanel);
      this.sidePanelIsOpen.emit(false);
    }
    /**
     * @description Hides or shows the scrollbar of the documents body based on if the panel is open or not.
     * Hides bar when panel is open and reshows bar when it's closed
     */
    toggleScrollBar(isPanelOpen) {
      if (isPanelOpen) {
        this.renderer.setStyle(this.document.body, 'overflow', 'hidden');
        this.renderer.addClass(this.document.body, 'side-panel-open');
      } else {
        this.renderer.setStyle(this.document.body, 'overflow', 'visible');
        this.renderer.removeClass(this.document.body, 'side-panel-open');
      }
    }
    /**
     * @description Returns an object with the width, side, and duration for this instance of the component.
     */
    getPanelStyle(showPanel) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const panelStyle = {};
      panelStyle.transition = `${this.side} ${this.duration}ms, visibility ${this.duration}ms`;
      panelStyle.width = `${this.width}%`;
      panelStyle[this.side] = `${showPanel ? 0 : this.getPanelWidth() * -1}px`;
      return panelStyle;
    }
    /**
     * @description Returns a string that represents the panel header classes,
     * depending on if the panel is on the right or left side.
     */
    getPanelHeaderClass() {
      let panelHeaderClass = '';
      if (this.side === 'left') {
        panelHeaderClass = 'flex-row-reverse left-side-panel';
      } else {
        panelHeaderClass = 'flex-row right-side-panel';
      }
      return panelHeaderClass;
    }
    getPanelWidth() {
      if (isPlatformBrowser(this.platformId)) {
        return this.panelContent().nativeElement.getBoundingClientRect().width;
      } else {
        return this.width;
      }
    }
    static {
      this.ɵfac = function HmfSidePanelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfSidePanelComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PLATFORM_ID));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfSidePanelComponent,
        selectors: [["hmf-side-panel"]],
        viewQuery: function HmfSidePanelComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.panelContent, _c52, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          showSidePanel: "showSidePanel",
          duration: "duration",
          width: "width",
          side: "side",
          panelContentClass: "panelContentClass",
          isHeaderSticky: "isHeaderSticky",
          panelBodyClass: "panelBodyClass"
        },
        outputs: {
          sidePanelIsOpen: "sidePanelIsOpen"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c54,
        decls: 12,
        vars: 15,
        consts: [["panelContentDiv", ""], [1, "panel-container", "hmf-body-s", 3, "ngClass"], [1, "panel-overlay", 3, "click"], [1, "panel-content", 3, "ngClass", "ngStyle"], [1, "panel-header", 3, "ngClass"], [1, "panel-title", "hmf-header-bold-s"], [1, "close-button"], ["type", "button", 1, "btn", "btn-close", 3, "click"], ["name", "sign-cancel"], [1, "panel-body-container", 3, "ngClass"]],
        template: function HmfSidePanelComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c53);
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵlistener("click", function HmfSidePanelComponent_Template_div_click_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.closePanel());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 3, 0)(4, "div", 4)(5, "div", 5);
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 6)(8, "button", 7);
            i0.ɵɵlistener("click", function HmfSidePanelComponent_Template_button_click_8_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.closePanel());
            });
            i0.ɵɵelement(9, "homefield-icon", 8);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(10, "div", 9);
            i0.ɵɵprojection(11, 1);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c55, !ctx.showSidePanel));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.panelContentClass)("ngStyle", ctx.getPanelStyle(ctx.showSidePanel))("ngClass", i0.ɵɵpureFunction3(8, _c56, !ctx.showSidePanel && ctx.side === "left", !ctx.showSidePanel && ctx.side === "right", ctx.side === "bottom"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.getPanelHeaderClass());
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(12, _c57, ctx.panelBodyClass, ctx.isHeaderSticky));
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgStyle, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: ["[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]{inset:0;max-width:100vw;position:fixed;z-index:1001}[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]   .panel-overlay[_ngcontent-%COMP%]{background:var(--hmf-panel-overlay-background-color);bottom:0;left:0;opacity:.6;position:fixed;top:0;width:100%}[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]   .panel-content[_ngcontent-%COMP%]{background:var(--hmf-panel-content-background-color);bottom:0;box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f;display:flex;flex-direction:column;overflow:auto;position:absolute;top:0}@media (max-width: 768px){[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]   .panel-content[_ngcontent-%COMP%]{width:100%!important}[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]   .panel-content.content-closed-left[_ngcontent-%COMP%]{left:-100%!important}[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]   .panel-content.content-closed-right[_ngcontent-%COMP%]{right:-100%!important}}[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]   .panel-content.bottom[_ngcontent-%COMP%]{border-top-left-radius:.5rem;border-top-right-radius:.5rem;height:80%!important;top:auto;width:100%!important}[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]   .panel-content[_ngcontent-%COMP%]   .panel-header[_ngcontent-%COMP%]{align-items:center;background-color:var(--hmf-panel-header-background-color);border-bottom:1px solid var(--hmf-panel-header-border-color);display:flex;padding-bottom:var(--hmf-xs);padding-top:var(--hmf-xs)}[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]   .panel-content[_ngcontent-%COMP%]   .panel-header.left-side-panel[_ngcontent-%COMP%]{padding-right:var(--hmf-m);text-align:right}[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]   .panel-content[_ngcontent-%COMP%]   .panel-header.right-side-panel[_ngcontent-%COMP%]{padding-left:var(--hmf-m);text-align:left}@media (min-width: 768px){[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]   .panel-content[_ngcontent-%COMP%]   .panel-header.left-side-panel[_ngcontent-%COMP%]{padding-left:var(--hmf-xxxs);padding-right:var(--hmf-l)}[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]   .panel-content[_ngcontent-%COMP%]   .panel-header.right-side-panel[_ngcontent-%COMP%]{padding-left:var(--hmf-l);padding-right:var(--hmf-xxxs)}}[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]   .panel-content[_ngcontent-%COMP%]   .panel-header[_ngcontent-%COMP%]   .panel-title[_ngcontent-%COMP%]{flex-grow:1;line-height:3.6rem;text-transform:uppercase}[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]   .panel-content[_ngcontent-%COMP%]   .panel-header[_ngcontent-%COMP%]   .close-button[_ngcontent-%COMP%]{height:100%;position:relative}[_nghost-%COMP%]   .panel-container[_ngcontent-%COMP%]   .panel-content[_ngcontent-%COMP%]   .panel-body-container.overflow-auto[_ngcontent-%COMP%]{overflow:auto}[_nghost-%COMP%]   .btn.btn-close[_ngcontent-%COMP%]:hover{background-color:var(--hmf-panel-close-button-hover-background-color);border:1px solid var(--hmf-panel-close-button-hover-border-color)}[_nghost-%COMP%]   .btn.btn-close[_ngcontent-%COMP%]:active{background-color:var(--hmf-panel-close-button-active-background-color);border:1px solid var(--hmf-panel-close-button-active-border-color)}[_nghost-%COMP%]   .btn.btn-close[_ngcontent-%COMP%]:focus{outline:var(--hmf-focus-outline)}[_nghost-%COMP%]   .side-panel-collapsed[_ngcontent-%COMP%]{visibility:collapse}"]
      });
    }
  }
  return HmfSidePanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfSingleFeatureSpotComponent = /*#__PURE__*/(() => {
  class HmfSingleFeatureSpotComponent {
    constructor() {
      this.textColorVariants = {
        dark: 'hmf-dark-text',
        light: 'hmf-light-text'
      };
      this.textBoxPositionVariants = {
        left: 'block-left',
        right: 'block-right'
      };
      this.textBoxBackgroundColorVariants = {
        red: 'hmf-red',
        black: 'hmf-black',
        white: 'hmf-white'
      };
      this.headlineFont = {
        multiHorizontalFont: 'hmf-display-m-m hmf-display-xs',
        horizontalFont: 'hmf-display-m-l hmf-display-xs'
      };
      this.subHeadlineFont = {
        multiHorizontalFont: 'hmf-header-bold-m hmf-subheader-bold-m',
        horizontalFont: 'hmf-header-bold-l hmf-subheader-bold-m'
      };
      this.fontFamily = '';
      this.textColor = 'light';
      this.textBoxPosition = 'left';
      this.textBoxBackgroundColor = 'black';
      this.upperText = '';
      this.headline = '';
      this.subhead = '';
      this.link = '';
      this.altText = '';
      this.mobileImage = '';
      this.image = '';
      this.detailsText = '';
      this.detailsLink = '';
      this.imageTitle = '';
      this.dataEm = '';
    }
    static {
      this.ɵfac = function HmfSingleFeatureSpotComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfSingleFeatureSpotComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfSingleFeatureSpotComponent,
        selectors: [["hmf-single-feature-spot"]],
        inputs: {
          fontFamily: "fontFamily",
          textColor: "textColor",
          textBoxPosition: "textBoxPosition",
          textBoxBackgroundColor: "textBoxBackgroundColor",
          upperText: "upperText",
          headline: "headline",
          subhead: "subhead",
          link: "link",
          altText: "altText",
          mobileImage: "mobileImage",
          image: "image",
          detailsText: "detailsText",
          detailsLink: "detailsLink",
          imageTitle: "imageTitle",
          dataEm: "dataEm"
        },
        decls: 10,
        vars: 17,
        consts: [["id", "hmf-feature-single-spot"], ["tabindex", "0", "role", "link", 3, "href"], [1, "hmf-feature-single-spot-image-container", "hmf-display-m-flex", "hmf-justify-content-m-center", 3, "ngClass"], [4, "ngIf"], [1, "hmf-feature-single-spot-copybox-container", "hmf-display-flex", "hmf-position-absolute"], ["class", "hmf-header-bold-s hmf-header-bold-m-m hmf-mb-0 hmf-pb-m-xs hmf-pb-xxs", 4, "ngIf"], [3, "class", 4, "ngIf"], ["class", "hmf-feature-single-spot-details-text hmf-legal-xs hmf-mb-m-s hmf-position-m-absolute", 4, "ngIf"], ["media", "(max-width: 766px)", 3, "srcset", 4, "ngIf"], ["role", "img", "loading", "lazy", "width", "320", "height", "240", 1, "loaded", 3, "src"], ["media", "(max-width: 766px)", 3, "srcset"], [1, "hmf-header-bold-s", "hmf-header-bold-m-m", "hmf-mb-0", "hmf-pb-m-xs", "hmf-pb-xxs"], [1, "hmf-feature-single-spot-details-text", "hmf-legal-xs", "hmf-mb-m-s", "hmf-position-m-absolute"], ["tabindex", "0", 3, "href"]],
        template: function HmfSingleFeatureSpotComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 0)(1, "a", 1)(2, "div", 2);
            i0.ɵɵtemplate(3, HmfSingleFeatureSpotComponent_picture_3_Template, 3, 3, "picture", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4)(5, "div");
            i0.ɵɵtemplate(6, HmfSingleFeatureSpotComponent_p_6_Template, 2, 1, "p", 5)(7, HmfSingleFeatureSpotComponent_h2_7_Template, 2, 4, "h2", 6)(8, HmfSingleFeatureSpotComponent_p_8_Template, 2, 4, "p", 6)(9, HmfSingleFeatureSpotComponent_p_9_Template, 4, 5, "p", 7);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate1("", ctx.textBoxPositionVariants[ctx.textBoxPosition], " hmf-feature-single-spot-container hmf-display-flex hmf-justify-content-center hmf-flex-wrap");
            i0.ɵɵproperty("href", ctx.link, i0.ɵɵsanitizeUrl);
            i0.ɵɵattribute("data-em", ctx.dataEm);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c58, ctx.textBoxPosition === "left" || ctx.textBoxPosition === "right"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.image);
            i0.ɵɵadvance(2);
            i0.ɵɵclassMapInterpolate2("hmf-feature-single-spot-copybox hmf-display-flex hmf-justify-content-center hmf-flex-column hmf-mx-m-0 hmf-p-s hmf-px-m-l \n\t\t", ctx.textColorVariants[ctx.textColor], " \n\t\t", ctx.textBoxBackgroundColorVariants[ctx.textBoxBackgroundColor], "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.upperText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.headline);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.subhead);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.detailsText);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgIf],
        styles: ["[_nghost-%COMP%]   .hmf-feature-single-spot-container[_ngcontent-%COMP%]{border-radius:var(--hmf-sharp-radius);box-shadow:var(--hmf-subtle-shadow);height:100%;max-width:100vw;overflow:hidden;position:relative;width:100%}[_nghost-%COMP%]   .hmf-feature-single-spot-container[_ngcontent-%COMP%]:focus{outline:1px dashed var(--hmf-gray600);outline-offset:var(--hmf-xxxs)}[_nghost-%COMP%]   .hmf-feature-single-spot-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:auto;width:100%}[_nghost-%COMP%]   .hmf-feature-single-spot-container[_ngcontent-%COMP%]   .hmf-feature-single-spot-image-container[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   .hmf-feature-single-spot-container[_ngcontent-%COMP%]   .hmf-feature-single-spot-copybox-container[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   .hmf-feature-single-spot-container[_ngcontent-%COMP%]   .hmf-feature-single-spot-details-text[_ngcontent-%COMP%]{color:inherit}[_nghost-%COMP%]   .hmf-feature-single-spot-container[_ngcontent-%COMP%]   .hmf-feature-single-spot-details-text[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:underline}[_nghost-%COMP%]   .hmf-feature-single-spot-container[_ngcontent-%COMP%]   .hmf-feature-single-spot-details-text[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus{outline:1px dashed var(--hmf-gray600);outline-offset:var(--hmf-xxxs)}@media (min-width: 768px){[_nghost-%COMP%]   .hmf-feature-single-spot-container[_ngcontent-%COMP%]   .hmf-feature-single-spot-details-text[_ngcontent-%COMP%]{bottom:0}}@media (max-width: 992px){[_nghost-%COMP%]   .hmf-feature-single-spot-container[_ngcontent-%COMP%]   .hmf-feature-single-spot-copybox[_ngcontent-%COMP%]{width:100%}}[_nghost-%COMP%]   .hmf-feature-single-spot-container[_ngcontent-%COMP%]   .hmf-feature-single-spot-copybox[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{color:inherit}[_nghost-%COMP%]   .hmf-feature-single-spot-container.block-left[_ngcontent-%COMP%], [_nghost-%COMP%]   .hmf-feature-single-spot-container.block-right[_ngcontent-%COMP%]{justify-content:unset}[_nghost-%COMP%]   .hmf-feature-single-spot-container.block-left[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], [_nghost-%COMP%]   .hmf-feature-single-spot-container.block-right[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:unset;width:unset}[_nghost-%COMP%]   .hmf-feature-single-spot-container.block-left[_ngcontent-%COMP%]   .hmf-feature-single-spot-image-container[_ngcontent-%COMP%], [_nghost-%COMP%]   .hmf-feature-single-spot-container.block-right[_ngcontent-%COMP%]   .hmf-feature-single-spot-image-container[_ngcontent-%COMP%]{max-width:50%;overflow:hidden}[_nghost-%COMP%]   .hmf-feature-single-spot-container.block-left[_ngcontent-%COMP%]   .hmf-feature-single-spot-copybox-container[_ngcontent-%COMP%], [_nghost-%COMP%]   .hmf-feature-single-spot-container.block-right[_ngcontent-%COMP%]   .hmf-feature-single-spot-copybox-container[_ngcontent-%COMP%]{position:relative;width:50%}[_nghost-%COMP%]   .hmf-feature-single-spot-container.block-left[_ngcontent-%COMP%]   .hmf-feature-single-spot-copybox[_ngcontent-%COMP%], [_nghost-%COMP%]   .hmf-feature-single-spot-container.block-right[_ngcontent-%COMP%]   .hmf-feature-single-spot-copybox[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   .hmf-feature-single-spot-container.block-left[_ngcontent-%COMP%]{text-align:left}[_nghost-%COMP%]   .hmf-feature-single-spot-container.block-left[_ngcontent-%COMP%]   .hmf-feature-single-spot-image-container[_ngcontent-%COMP%]{order:2}[_nghost-%COMP%]   .hmf-feature-single-spot-container.block-right[_ngcontent-%COMP%]{text-align:right}[_nghost-%COMP%]   .hmf-feature-single-spot-container.block-right[_ngcontent-%COMP%]   .hmf-feature-single-spot-copybox-container[_ngcontent-%COMP%]{right:0}[_nghost-%COMP%]   .hmf-feature-single-spot-container.block-right[_ngcontent-%COMP%]   .hmf-feature-single-spot-details-text[_ngcontent-%COMP%]{right:var(--hmf-l)}[_nghost-%COMP%]   .hmf-red[_ngcontent-%COMP%]{background-color:var(--hmf-red900);color:var(--hmf-label-inverse-base)}[_nghost-%COMP%]   .hmf-black[_ngcontent-%COMP%]{background-color:var(--hmf-background-inverse);color:var(--hmf-label-inverse-base)}[_nghost-%COMP%]   .hmf-white[_ngcontent-%COMP%]{background-color:var(--hmf-background-base-subtle);color:var(--hmf-label-base)}[_nghost-%COMP%]   .hmf-light-text[_ngcontent-%COMP%]{color:var(--hmf-label-inverse-base)}[_nghost-%COMP%]   .hmf-dark-text[_ngcontent-%COMP%]{color:var(--hmf-label-base)}"]
      });
    }
  }
  return HmfSingleFeatureSpotComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfSkeletonComponent = /*#__PURE__*/(() => {
  class HmfSkeletonComponent {
    constructor() {
      // required
      this.loading = false;
      this.shape = 'text';
      // optional
      this.borderRadius = '';
      this.baseColor = '#ebebeb';
      this.count = 1;
      this.reverseDirection = false;
      this.duration = '.5';
      this.height = '';
      this.id = '';
      this.highlightColor = '#f5f5f5';
      this.inline = false;
      this.width = '100%';
    }
    ngOnInit() {
      console.warn('[DEPRECATION WARNING] The "count" property is deprecated as of v2.0 and will be removed in v3.0. Please use multiple <hmf-skeleton> components instead');
      if (!this.height) {
        this.height = this.shape === 'circle' ? '100px' : '20px';
      }
      if (this.shape === 'circle') {
        this.width = this.height;
      }
    }
    trackByIndex(index) {
      return index.toString();
    }
    static {
      this.ɵfac = function HmfSkeletonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfSkeletonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfSkeletonComponent,
        selectors: [["hmf-skeleton"]],
        inputs: {
          loading: "loading",
          shape: "shape",
          borderRadius: "borderRadius",
          baseColor: "baseColor",
          count: "count",
          reverseDirection: "reverseDirection",
          duration: "duration",
          height: "height",
          id: "id",
          highlightColor: "highlightColor",
          inline: "inline",
          width: "width"
        },
        ngContentSelectors: _c6,
        decls: 3,
        vars: 9,
        consts: [[3, "ngClass", "ngStyle"], ["aria-live", "polite", "aria-busy", "true", 3, "id", "class", "style", "ngStyle"], ["aria-live", "polite", "aria-busy", "true", 3, "id", "ngStyle"]],
        template: function HmfSkeletonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, HmfSkeletonComponent_Conditional_1_Template, 1, 16, "div", 1)(2, HmfSkeletonComponent_Conditional_2_Template, 1, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c59, ctx.inline))("ngStyle", i0.ɵɵpureFunction3(5, _c60, ctx.loading ? ctx.height : "auto", ctx.width, typeof ctx.height === "string" && ctx.height && ctx.height.includes("%") ? "block" : "inline-block"));
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.loading ? 1 : 2);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgStyle],
        styles: ["@keyframes _ngcontent-%COMP%_homefield-skeleton{to{transform:translate(100%)}}.homefield-skeleton[_ngcontent-%COMP%]{--base-color: #ebebeb;--highlight-color: #f5f5f5;--animation-duration: .5s;--animation-direction: normal;--pseudo-element-display: block;background-color:var(--base-color);border-radius:.25rem;display:inline-flex;line-height:1;overflow:hidden;position:relative;-webkit-user-select:none;user-select:none;width:100%;z-index:1}.homefield-skeleton[_ngcontent-%COMP%]:after{animation-direction:var(--animation-direction);animation-duration:var(--animation-duration);animation-iteration-count:infinite;animation-name:_ngcontent-%COMP%_homefield-skeleton;animation-timing-function:linear;background-image:linear-gradient(90deg,var(--base-color),var(--highlight-color),var(--base-color));background-repeat:no-repeat;content:\" \";display:var(--pseudo-element-display);height:100%;inset:0;position:absolute;transform:translate(-100%);will-change:transform}@media (prefers-reduced-motion){.homefield-skeleton[_ngcontent-%COMP%]{--pseudo-element-display: none}}.homefield-skeleton[_ngcontent-%COMP%]{height:100%;width:100%}.homefield-skeleton.hmf-angular-skeleton[_ngcontent-%COMP%]:after{animation-direction:var(--ng-animation-direction);animation-duration:var(--ng-animation-duration);background-image:linear-gradient(90deg,var(--base-ng-color),var(--highlight-ng-color),var(--base-ng-color))}"]
      });
    }
  }
  return HmfSkeletonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfSnackbarComponent = /*#__PURE__*/(() => {
  class HmfSnackbarComponent {
    constructor() {
      this.type = input('light');
      this.action = input('close');
      this.linkType = input('url');
      this.linkUrl = input();
      this.linkText = input();
      this.dismissDelay = input(5);
      this.position = input('bottom');
      this.offset = input('small');
      this.homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);
      this.elementRef = inject(ElementRef);
      this.cdr = inject(ChangeDetectorRef);
      this.linkClickEvent = output();
      this.element = '';
      this.messageIcon = '';
      this.visible = false;
      this.offsetValue = computed(() => {
        const offsetToEm = {
          small: '1em',
          medium: '6em',
          large: '12em'
        };
        return offsetToEm[this.offset()];
      });
      this.animationParams = computed(() => {
        const positionToTranslation = {
          bottom: `calc(100% + ${this.offsetValue()})`,
          top: `calc(-1 * (100% + ${this.offsetValue()}))`
        };
        return {
          value: '',
          params: {
            translationY: positionToTranslation[this.position()]
          }
        };
      });
      this.positionStyle = computed(() => ({
        [this.position()]: this.offsetValue()
      }));
      this.homefieldIconsLibraryService.registerIcons([homefieldIconAlertInfoOutlined, homefieldIconAlertReportOutlined, homefieldIconAlertWarningOutlined, homefieldIconSignCancel, homefieldIconSignCircledCheckOutline]);
      this.element = this.elementRef.nativeElement?.tagName?.toLowerCase();
    }
    ngOnInit() {
      this.setIcon();
    }
    ngOnChanges() {
      this.setIcon();
    }
    setIcon() {
      // check to see which icon should be displayed.
      switch (this.type().toLowerCase()) {
        case 'error':
          this.messageIcon = 'alert-report-outlined';
          break;
        case 'warning':
          this.messageIcon = 'alert-warning-outlined';
          break;
        case 'success':
          this.messageIcon = 'sign-circled-check-outline';
          break;
        case 'light':
        case 'dark':
          this.messageIcon = 'alert-info-outlined';
          break;
      }
      this.cdr.detectChanges();
    }
    onLinkClick() {
      this.linkClickEvent.emit();
      this.closeSnackbar();
    }
    openSnackbar() {
      this.visible = true;
      this.cdr.detectChanges();
      if (this.action() === 'auto-dismiss') {
        setTimeout(() => {
          this.closeSnackbar();
        }, this.dismissDelay() * 1000);
      }
    }
    closeSnackbar() {
      this.visible = false;
      this.cdr.detectChanges();
    }
    static {
      this.ɵfac = function HmfSnackbarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfSnackbarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfSnackbarComponent,
        selectors: [["hmf-snackbar"]],
        inputs: {
          type: [1, "type"],
          action: [1, "action"],
          linkType: [1, "linkType"],
          linkUrl: [1, "linkUrl"],
          linkText: [1, "linkText"],
          dismissDelay: [1, "dismissDelay"],
          position: [1, "position"],
          offset: [1, "offset"]
        },
        outputs: {
          linkClickEvent: "linkClickEvent"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c6,
        decls: 1,
        vars: 1,
        consts: [[1, "snackbar", "hmf-elevated-shadow", "hmf-p-s", 3, "ngStyle", "ngClass"], [1, "snackbar-content"], [1, "snackbar-icon"], ["title", "close", 1, "close"], [1, "link", "hmf-body-l", 3, "href"], [1, "link", "hmf-body-l"], ["width", "16px", "height", "16px", "fill", "currentColor", 3, "name"], ["title", "close", 1, "close", 3, "click"], ["width", "16px", "height", "16px", "fill", "currentColor", "name", "sign-cancel"], [1, "link", "hmf-body-l", 3, "click"]],
        template: function HmfSnackbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, HmfSnackbarComponent_Conditional_0_Template, 8, 7, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.visible ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgStyle, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: [".snackbar svg{display:block}.snackbar[_ngcontent-%COMP%]{align-items:center;color:var(--hmf-label-base);display:flex;left:50%;min-width:343px;position:fixed;transform:translate(-50%)}.snackbar[_ngcontent-%COMP%]   .snackbar-content[_ngcontent-%COMP%]{align-items:center;display:flex;flex:1}.snackbar[_ngcontent-%COMP%]   .snackbar-icon[_ngcontent-%COMP%]{margin-right:8px}.snackbar[_ngcontent-%COMP%]   .snackbar-icon[_ngcontent-%COMP%]   homefield-icon[_ngcontent-%COMP%]{display:block}.snackbar[_ngcontent-%COMP%]   .snackbar-icon[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{display:block}.snackbar[_ngcontent-%COMP%]   button.close[_ngcontent-%COMP%], .snackbar[_ngcontent-%COMP%]   button.link[_ngcontent-%COMP%]{background:none;border:none;color:inherit;cursor:pointer;font-size:inherit;font-style:inherit;margin:0 0 0 16px;padding:0;text-decoration:none}.snackbar[_ngcontent-%COMP%]   a.link[_ngcontent-%COMP%], .snackbar[_ngcontent-%COMP%]   button.link[_ngcontent-%COMP%]{color:inherit;margin:0 0 0 16px;padding:0;text-decoration:underline}.snackbar.error[_ngcontent-%COMP%]{background-color:var(--hmf-fill-negative);color:var(--hmf-label-inverse-base)}.snackbar.warning[_ngcontent-%COMP%]{background-color:var(--hmf-fill-warning)}.snackbar.success[_ngcontent-%COMP%]{background-color:var(--hmf-fill-positive);color:var(--hmf-label-inverse-base)}.snackbar.light[_ngcontent-%COMP%]{background-color:var(--hmf-fill-base)}.snackbar.dark[_ngcontent-%COMP%]{background-color:var(--hmf-fill-inverse);color:var(--hmf-label-inverse-base)}.snackbar.light[_ngcontent-%COMP%]   a.link[_ngcontent-%COMP%], .snackbar.warning[_ngcontent-%COMP%]   a.link[_ngcontent-%COMP%]{color:var(--hmf-label-base-subtle)}"],
        data: {
          animation: [trigger('enterLeave', [transition(':enter', [style({
            opacity: 0,
            transform: 'translate(-50%, {{translationY}})'
          }), animate('200ms ease-in-out', style({
            opacity: 1,
            transform: 'translate(-50%, 0)'
          }))], {
            params: {
              translationY: ''
            }
          }), transition(':leave', [animate('200ms ease-in-out', style({
            opacity: 0,
            transform: 'translate(-50%, {{translationY}})'
          }))], {
            params: {
              translationY: ''
            }
          })])]
        },
        changeDetection: 0
      });
    }
  }
  return HmfSnackbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
const sizeClasses = sizeClassesStar;
let HmfStarRatingsComponent = /*#__PURE__*/(() => {
  class HmfStarRatingsComponent {
    constructor(homefieldIconsLibraryService) {
      this.homefieldIconsLibraryService = homefieldIconsLibraryService;
      this.ratingCount = input(0);
      this.ratingValue = input(0.0);
      this.size = input('medium');
      this.showRating = input(true);
      this.showReviewCount = input(true);
      this.alignment = input('right');
      this.sizeClasses = sizeClassesStar;
      this.variantCount = input('text');
      this._starIcons = Object.values({
        0: 'star-filled-0-percent',
        1: 'star-filled-25-percent',
        2: 'star-filled-50-percent',
        3: 'star-filled-75-percent',
        4: 'star-filled-100-percent'
      });
      this.handleClickCount = new EventEmitter();
      this.onRatingValueChange$ = toObservable(this.ratingValue);
      this.stars = [];
      this.destroyRef = inject(DestroyRef);
      this.homefieldIconsLibraryService.registerIcons([homefieldIconStarFilled0Percent, homefieldIconStarFilled100Percent, homefieldIconStarFilled25Percent, homefieldIconStarFilled50Percent, homefieldIconStarFilled75Percent]);
    }
    ngOnInit() {
      this.onRatingValueChange$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
        this.setStars(value);
      });
    }
    /**
    * @description The rating logic
    * Which star icon to show for the decimal value of rating.
    0.0 - 0.24 = unfilled
    0.25 - 0.49 = quarter filled star
    0.5 - 0.74 = half filled star
    0.75 - 0.99 = three quarters filled star
    */
    setStars(ratingValue) {
      this.stars = setStars(ratingValue, this._starIcons);
    }
    trackByFn(index, item) {
      return index.toString() + item;
    }
    onClickCount(event) {
      event.preventDefault();
      this.handleClickCount.emit();
    }
    onCountKeyDown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.handleClickCount.emit();
      }
    }
    getAlignmentClass() {
      return this.alignment();
    }
    get shouldShowRating() {
      return this.showRating() && this.ratingValue() !== 0;
    }
    get shouldShowReviewCount() {
      return this.showReviewCount() && this.ratingCount() !== 0;
    }
    get isVariantLink() {
      return this.variantCount() === 'link';
    }
    static {
      this.ɵfac = function HmfStarRatingsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfStarRatingsComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfStarRatingsComponent,
        selectors: [["hmf-star-ratings"]],
        inputs: {
          ratingCount: [1, "ratingCount"],
          ratingValue: [1, "ratingValue"],
          size: [1, "size"],
          showRating: [1, "showRating"],
          showReviewCount: [1, "showReviewCount"],
          alignment: [1, "alignment"],
          variantCount: [1, "variantCount"]
        },
        outputs: {
          handleClickCount: "handleClickCount"
        },
        decls: 1,
        vars: 1,
        consts: [[1, "hmf-display-flex", "hmf-align-items-center", "hmf-flex-wrap", "hmf-star-rating", 3, "ngClass"], [1, "hmf-stars"], [3, "width", "height", "name"], [3, "class"], [3, "variant", "size", "disabled", "class"], [3, "click", "keydown", "variant", "size", "disabled"]],
        template: function HmfStarRatingsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HmfStarRatingsComponent_Conditional_0_Template, 6, 3, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.ratingCount.toString() !== "0" && ctx.ratingValue.toString() !== "0" ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent, HmfTextLinkComponent],
        styles: [".hmf-star-rating[_ngcontent-%COMP%]{color:var(--hmf-label-base);cursor:pointer;gap:var(--hmf-xxxs)}.hmf-star-rating[_ngcontent-%COMP%]   .hmf-stars[_ngcontent-%COMP%]{gap:var(--hmf-xxxxs)}.hmf-star-rating.left[_ngcontent-%COMP%]   .hmf-stars[_ngcontent-%COMP%]{order:1}.hmf-star-rating.left[_ngcontent-%COMP%]   .hmf-rating-average[_ngcontent-%COMP%]{order:2}.hmf-star-rating.left[_ngcontent-%COMP%]   .hmf-quantity[_ngcontent-%COMP%], .hmf-star-rating.right[_ngcontent-%COMP%]   .hmf-stars[_ngcontent-%COMP%]{order:3}.hmf-star-rating.right[_ngcontent-%COMP%]   .hmf-rating-average[_ngcontent-%COMP%]{order:1}.hmf-star-rating.right[_ngcontent-%COMP%]   .hmf-quantity[_ngcontent-%COMP%], .hmf-star-rating.split[_ngcontent-%COMP%]   .hmf-stars[_ngcontent-%COMP%]{order:2}.hmf-star-rating.split[_ngcontent-%COMP%]   .hmf-rating-average[_ngcontent-%COMP%]{order:1}.hmf-star-rating.split[_ngcontent-%COMP%]   .hmf-quantity[_ngcontent-%COMP%]{order:3}"],
        changeDetection: 0
      });
    }
  }
  return HmfStarRatingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfNotificationBadgeComponent = /*#__PURE__*/(() => {
  class HmfNotificationBadgeComponent {
    constructor() {
      this.inputNumber = '';
      this.variant = 'dark';
    }
    get textLength() {
      return this.inputNumber.trim().length;
    }
    static {
      this.ɵfac = function HmfNotificationBadgeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfNotificationBadgeComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfNotificationBadgeComponent,
        selectors: [["hmf-notification-badge"]],
        inputs: {
          inputNumber: "inputNumber",
          variant: "variant"
        },
        exportAs: ["hmfNotificationBadge"],
        decls: 2,
        vars: 6,
        consts: [["aria-label", "Notification badge", 1, "notification-badge", 3, "ngClass"], [4, "ngIf"]],
        template: function HmfNotificationBadgeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, HmfNotificationBadgeComponent_span_1_Template, 2, 1, "span", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c62, ctx.inputNumber.trim().length === 0, ctx.variant === "dark", ctx.variant === "light"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.inputNumber.trim().length > 0);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgIf],
        styles: [".notification-badge[_ngcontent-%COMP%]{border-radius:var(--hmf-round-radius);box-shadow:0 1px #0000001a;display:flex;flex-direction:column;flex-shrink:0;font-family:var(--Typography-Font, Archivo);font-size:var(--typography-body-links-small-size, 12px);font-style:normal;font-weight:var(--typography-body-links-weights-regular, 400);gap:var(--hmf-xxxxl);height:auto;letter-spacing:var(--Typography-Letter-Spacing, 0px);line-height:var(--typography-body-links-small-line-height, 16.8px);min-height:6px;min-width:6px;padding:0 4.8px;text-align:center;width:fit-content}.notification-badge-dark[_ngcontent-%COMP%]{background-color:var(--hmf-fill-creative-primary);color:var(--hmf-label-inverse)}.notification-badge-light[_ngcontent-%COMP%]{background-color:var(--hmf-fill-base-prominent);color:var(--hmf-label-base)}.notification-badge.no-content[_ngcontent-%COMP%]{box-shadow:0 0 #0000001a;padding:0}"]
      });
    }
  }
  return HmfNotificationBadgeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfTabbedContainerComponent = /*#__PURE__*/(() => {
  class HmfTabbedContainerComponent {
    constructor() {
      this.tabs = [];
      this.size = 'medium';
      this.initialTab = 0;
      this.tabClicked = new EventEmitter();
      this.selectedTab = {
        tabIndex: this.initialTab,
        tabText: this.tabs[0]?.label || ''
      };
    }
    ngAfterViewInit() {
      setTimeout(() => {
        if (this.tabs.length > 0 && this.initialTab < this.tabs.length) {
          this.selectTab(this.initialTab, this.tabs[this.initialTab]);
        }
      }, 0);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get templateRefByIndex() {
      return this.templateRefs
      // Turn TemplateRefs into an array
      .toArray()[
      // Filter out the container TemplateRefs
      // (If you don't do this, you will run into problems with ngFor because ngFor creates an additional TemplateRef)
      // 'container' is the non-ngFor TemplateRef. Rework this. Doesn't exist in builds.
      // .filter(template => template.elementRef.nativeElement.data === 'container')
      this.selectedTab.tabIndex];
    }
    selectTab(i, tab) {
      this.selectedTab = {
        tabIndex: i,
        tabText: tab.label
      };
      this.tabClicked.emit(this.selectedTab);
    }
    /**
     * Handles keyboard navigation and interaction for tabs.
     *
     * @param event - The keyboard event triggered by user interaction.
     * @param index - The index of the currently focused tab.
     * @param tab - The tab object associated with the current index.
     *
     * @remarks
     * - Pressing 'ArrowRight' moves focus to the next tab.
     * - Pressing 'ArrowLeft' moves focus to the previous tab.
     * - Pressing 'Enter' or 'Space' selects the current tab and prevents the default browser behavior.
     */
    onKeyDown(event, index, tab) {
      switch (event.key) {
        case 'ArrowRight':
          this.focusNextTab(index);
          break;
        case 'ArrowLeft':
          this.focusPreviousTab(index);
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          this.selectTab(index, tab);
          break;
      }
    }
    focusNextTab(currentIndex) {
      const tabsArray = this.tabElements?.toArray() || [];
      const nextIndex = (currentIndex + 1) % tabsArray.length;
      tabsArray[nextIndex]?.nativeElement.focus();
    }
    focusPreviousTab(currentIndex) {
      const tabsArray = this.tabElements.toArray();
      const previousIndex = (currentIndex - 1 + tabsArray.length) % tabsArray.length;
      tabsArray[previousIndex]?.nativeElement.focus();
    }
    /**
     * Generates the CSS classes for a tab based on its state and properties.
     *
     * @param index - The index of the tab
     * @param tab - The tab object
     * @returns Object with CSS classes for ngClass directive
     */
    getTabClasses(index, tab) {
      return {
        'hmf-body-l hmf-px-s': this.size === 'medium',
        'hmf-subheader-l hmf-px-l': this.size === 'large',
        selected: this.selectedTab.tabIndex === index,
        'hmf-body-bold-l': this.selectedTab.tabIndex === index && this.size === 'medium',
        'hmf-subheader-bold-l': this.selectedTab.tabIndex === index && this.size === 'large',
        'hmf-display-flex hmf-align-items-center hmf-gap-2': !!tab.showBadge
      };
    }
    static {
      this.ɵfac = function HmfTabbedContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfTabbedContainerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfTabbedContainerComponent,
        selectors: [["hmf-tabbed-container"]],
        contentQueries: function HmfTabbedContainerComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TemplateRef, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRefs = _t);
          }
        },
        viewQuery: function HmfTabbedContainerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c63, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabElements = _t);
          }
        },
        inputs: {
          tabs: "tabs",
          size: "size",
          initialTab: "initialTab"
        },
        outputs: {
          tabClicked: "tabClicked"
        },
        decls: 4,
        vars: 2,
        consts: [["tab", ""], [1, "hmf-tabbed-container-container", "hmf-p-xs"], ["role", "tablist", 1, "hmf-display-flex", "hmf-flex-row"], ["class", "hmf-py-xs tab hmf-text-align-center hmf-label-base", "role", "tab", 3, "ngClass", "id", "click", "keydown", 4, "ngFor", "ngForOf"], ["class", "hmf-p-s", "role", "tabpanel", 3, "hidden", 4, "ngFor", "ngForOf"], ["role", "tab", 1, "hmf-py-xs", "tab", "hmf-text-align-center", "hmf-label-base", 3, "click", "keydown", "ngClass", "id"], [3, "inputNumber", "variant", 4, "ngIf"], [3, "inputNumber", "variant"], ["role", "tabpanel", 1, "hmf-p-s", 3, "hidden"], [4, "ngTemplateOutlet"]],
        template: function HmfTabbedContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵtemplate(2, HmfTabbedContainerComponent_div_2_Template, 5, 8, "div", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, HmfTabbedContainerComponent_div_3_Template, 2, 4, "div", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.tabs);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.tabs);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, i1$1.NgTemplateOutlet, HmfNotificationBadgeComponent],
        styles: [".hmf-tabbed-container-container[_ngcontent-%COMP%]   .tab[_ngcontent-%COMP%]{border-bottom:1px solid var(--hmf-border-secondary-subtle-static);color:var(--hmf-label-secondary-subtle-static);cursor:pointer}.hmf-tabbed-container-container[_ngcontent-%COMP%]   .tab[_ngcontent-%COMP%]:hover{background-color:var(--hmf-fill-secondary-hover);border-bottom:1px var(--hmf-border-secondary-subtle-hover) solid;color:var(--hmf-label-secondary-subtle-hover)}.hmf-tabbed-container-container[_ngcontent-%COMP%]   .tab[_ngcontent-%COMP%]:active{background-color:var(--hmf-fill-secondary-active);border-bottom:1px var(--hmf-label-secondary-subtle-hover) solid;color:var(--hmf-label-secondary-subtle-active)}.hmf-tabbed-container-container[_ngcontent-%COMP%]   .tab.selected[_ngcontent-%COMP%]{border-bottom:4px var(--hmf-border-tertiary-static) solid;color:var(--hmf-label-tertiary-static)}.hmf-tabbed-container-container[_ngcontent-%COMP%]   .hmf-gap-2[_ngcontent-%COMP%]{gap:var(--hmf-xxs)}"]
      });
    }
  }
  return HmfTabbedContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfTextInputComponent = /*#__PURE__*/(() => {
  class HmfTextInputComponent {
    constructor(homefieldIconsLibraryService) {
      this.homefieldIconsLibraryService = homefieldIconsLibraryService;
      this.type = input('text');
      this.placeholder = '';
      this.id = Math.floor(Math.random() * Math.floor(Math.random() * Date.now())).toString();
      this.name = '';
      this.label = '';
      this.helperText = '';
      this.error = false;
      // Length specific inputs
      this.minLength = null;
      this.maxLength = null;
      // Number specific inputs
      this.min = null;
      this.max = null;
      this.className = '';
      this.disabledIconEnabled = false;
      this.errorIconEnabled = true;
      this.iconClassName = '';
      // Textarea specific inputs
      this.rows = 5;
      // Accessability specific inputs
      this.autocomplete = 'on';
      this.isReadOnly = false;
      this.decimalCount = 0;
      this.disabled = input(false);
      this.required = input(false);
      this.inputEndIconClicked = new EventEmitter();
      this.inputStartIconClicked = new EventEmitter();
      this.validationError = new EventEmitter();
      this.hmfFocus = output();
      this.hmfBlur = output();
      this.value = signal('');
      this.isInputFocused = false;
      this.iconName = '';
      this.fixingError = false;
      this.homefieldIconsLibraryService.registerIcons([homefieldIconAlertErrorFilled, homefieldIconPenNoedit, homefieldIconSearch, homefieldIconArrowRight, homefieldIconCalendarDefault, homefieldIconMoneyDollarsign]);
    }
    // Validator methods
    get validator() {
      const validators = [];
      if (this.minLength) {
        validators.push(Validators.minLength(Number(this.minLength)));
      }
      if (this.maxLength) {
        validators.push(Validators.maxLength(Number(this.maxLength)));
      }
      if (this.min) {
        validators.push(Validators.min(Number(this.min)));
      }
      if (this.max) {
        validators.push(Validators.max(Number(this.max)));
      }
      return Validators.compose(validators);
    }
    validate(control) {
      return this.validator ? this.validator(control) : null;
    }
    ngOnChanges() {
      this.getIconAndClassName();
    }
    writeValue(value) {
      if (value === this.value()) {
        return;
      }
      this.value.set(value ?? '');
    }
    onFormattedValue(formattedValue) {
      const inputElement = this.inputRef.nativeElement;
      inputElement.value = formattedValue;
    }
    onChanged(event) {
      const input = event.target;
      this.value.set(input.value); // Update input value
      this.onChange?.(this.value());
    }
    onBlur(event) {
      this.onTouched?.();
      this.isInputFocused = false;
      this.fixingError = false;
      this.hmfBlur.emit(event);
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    onFocus(event) {
      this.isInputFocused = true;
      this.hmfFocus.emit(event);
    }
    getInputClasses() {
      return {
        filled: (this.value() || this.isInputFocused) && !this.placeholder,
        'hmf-pl-l': this.inputStartIconName,
        'hmf-pr-xl': this.inputEndIconName,
        'focused-border': !this.error && this.isInputFocused || this.fixingError,
        'error-focused-border': this.error && this.isInputFocused && !this.fixingError
      };
    }
    getDisabledErrorIconClasses() {
      const baseClasses = {
        'hmf-display-flex': true,
        'hmf-align-items-center': true,
        'cursor-pointer': true,
        'hmf-position-absolute': true,
        'icon-position-right': true,
        'hmf-pr-l': !!this.inputEndIconName
      };
      if (this.iconClassName && typeof this.iconClassName === 'string') {
        return {
          ...baseClasses,
          [this.iconClassName]: true
        };
      }
      return baseClasses;
    }
    /**
     * @description Retrives the name and class of the icon that will be displayed based on the state of the text input.
     */
    getIconAndClassName() {
      if (this.disabled() && this.disabledIconEnabled) {
        this.iconName = 'pen-noedit';
        this.iconClassName = 'disabled-icon-color';
      } else if (this.error) {
        this.iconName = 'alert-error-filled';
        this.iconClassName = 'alert-error-icon-color';
      } else {
        this.iconClassName = '';
        this.iconName = '';
      }
    }
    inputEndIconClickedFunction() {
      this.inputEndIconClicked.emit();
    }
    inputStartIconClickedFunction() {
      this.inputStartIconClicked.emit();
    }
    onErrorIconClicked() {
      this.fixingError = true;
      this.inputRef.nativeElement.focus();
    }
    getLabelClasses() {
      const hasValueOrFocus = !!this.value() || this.isInputFocused;
      const showPlaceholder = !!this.placeholder;
      const showError = !!this.error && !showPlaceholder;
      const showDefaultBackground = !this.error || this.fixingError;
      const showStartIconMargin = !!this.inputStartIconName && !hasValueOrFocus && !showPlaceholder;
      return {
        // Placeholder styling
        'as-placeholder': showPlaceholder || !showPlaceholder,
        'hmf-position-absolute': showPlaceholder || !showPlaceholder,
        'hmf-body-l': showPlaceholder || !showPlaceholder,
        // Shrink and padding
        shrink: showPlaceholder || hasValueOrFocus && !showPlaceholder,
        'hmf-px-xxs': showPlaceholder || hasValueOrFocus && !showPlaceholder,
        'hmf-body-s': showPlaceholder || hasValueOrFocus && !showPlaceholder,
        // Backgrounds
        'label-disabled': this.disabled(),
        'error-background': showError,
        'default-background': showDefaultBackground,
        // Margin for start icon
        'hmf-ml-l': showStartIconMargin
      };
    }
    static {
      this.ɵfac = function HmfTextInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfTextInputComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfTextInputComponent,
        selectors: [["hmf-text-input"]],
        viewQuery: function HmfTextInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c64, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputRef = _t.first);
          }
        },
        inputs: {
          type: [1, "type"],
          placeholder: "placeholder",
          id: "id",
          name: "name",
          label: "label",
          helperText: "helperText",
          error: "error",
          minLength: "minLength",
          maxLength: "maxLength",
          min: "min",
          max: "max",
          className: "className",
          inputStartIconName: "inputStartIconName",
          inputEndIconName: "inputEndIconName",
          disabledIconEnabled: "disabledIconEnabled",
          errorIconEnabled: "errorIconEnabled",
          iconClassName: "iconClassName",
          rows: "rows",
          autocomplete: "autocomplete",
          isReadOnly: "isReadOnly",
          decimalCount: "decimalCount",
          disabled: [1, "disabled"],
          required: [1, "required"]
        },
        outputs: {
          inputEndIconClicked: "inputEndIconClicked",
          inputStartIconClicked: "inputStartIconClicked",
          validationError: "validationError",
          hmfFocus: "hmfFocus",
          hmfBlur: "hmfBlur"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => HmfTextInputComponent),
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => HmfTextInputComponent),
          multi: true
        }]), i0.ɵɵNgOnChangesFeature],
        decls: 6,
        vars: 18,
        consts: [["textInput", ""], [1, "hmf-ml-xxxs", 3, "ngClass"], [1, "homefield-textinput-wrapper", 3, "ngClass"], [3, "ngModel", "disabled", "required", "rows", "placeholder", "title", "readonly", "ngClass"], ["class", "helper-text hmf-mb-0 hmf-mt-xxxs hmf-ml-xs", 4, "ngIf"], ["id", "input-start-icon", "width", "16px", "height", "16px", "onkeydown", "inputStartIconClickedFunction()", 1, "hmf-display-flex", "hmf-align-items-center", "cursor-pointer", "hmf-position-absolute", "icon-position-left", 3, "name"], [3, "input", "focus", "blur", "formattedValue", "ngModelChange", "hmfInputValidator", "required", "disabled", "type", "decimalCount", "placeholder", "minlength", "maxlength", "min", "max", "autocomplete", "readonly", "ngModel", "ngClass"], ["onkeydown", "inputEndIconClickedFunction()", "id", "input-end-icon", "width", "16px", "height", "16px", 1, "hmf-display-flex", "hmf-align-items-center", "cursor-pointer", "hmf-position-absolute", "icon-position-right", 3, "name"], ["onkeydown", "onErrorIconClicked()", "id", "disabled-error-icon", "width", "20px", "height", "20px", 3, "name", "ngClass"], ["id", "input-start-icon", "width", "16px", "height", "16px", "onkeydown", "inputStartIconClickedFunction()", 1, "hmf-display-flex", "hmf-align-items-center", "cursor-pointer", "hmf-position-absolute", "icon-position-left", 3, "click", "name"], ["onkeydown", "inputEndIconClickedFunction()", "id", "input-end-icon", "width", "16px", "height", "16px", 1, "hmf-display-flex", "hmf-align-items-center", "cursor-pointer", "hmf-position-absolute", "icon-position-right", 3, "click", "name"], ["onkeydown", "onErrorIconClicked()", "id", "disabled-error-icon", "width", "20px", "height", "20px", 3, "click", "name", "ngClass"], [3, "ngModelChange", "input", "focus", "blur", "ngModel", "disabled", "required", "rows", "placeholder", "title", "readonly", "ngClass"], [1, "helper-text", "hmf-mb-0", "hmf-mt-xxxs", "hmf-ml-xs"]],
        template: function HmfTextInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, HmfTextInputComponent_Conditional_1_Template, 2, 4, "label", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtemplate(3, HmfTextInputComponent_Conditional_3_Template, 5, 23)(4, HmfTextInputComponent_Conditional_4_Template, 3, 15, "textarea", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, HmfTextInputComponent_p_5_Template, 2, 2, "p", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("homefield-textinput ", ctx.className, " hmf-position-relative");
            i0.ɵɵclassProp("error", ctx.error && !ctx.fixingError);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.label ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.type());
            i0.ɵɵclassProp("focused", ctx.isInputFocused)("disabled", ctx.disabled());
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(15, _c65, ctx.isInputFocused && !ctx.error, !ctx.isInputFocused));
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.type() !== "textarea" ? 3 : 4);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.helperText);
          }
        },
        dependencies: [FormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.RequiredValidator, i2.MinLengthValidator, i2.MaxLengthValidator, i2.NgModel, CommonModule, i1$1.NgClass, i1$1.NgIf, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent, InputValidatorDirective],
        styles: [".homefield-textinput[_ngcontent-%COMP%]{display:flex;flex-direction:column;min-width:0;width:100%}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%]{align-content:center;align-items:center;border:var(--hmf-text-input-border);border-radius:var(--hmf-sharp-radius);box-sizing:border-box;display:flex;height:45px;min-width:0;outline:1px dashed transparent;transition:background-color var(--hmf-ease-in-out-fast),border var(--hmf-ease-in-out-fast);width:100%}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{padding-right:var(--hmf-xs)}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]:first-child{padding-left:var(--hmf-xxs)}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper.textarea[_ngcontent-%COMP%]{flex-grow:1;height:auto;min-height:75px;padding:1px;resize:vertical}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-family:var(--hmf-text-input-font-family);font-size:var(--hmf-text-input-font-size);font-weight:var(--hmf-text-input-font-weight);letter-spacing:var(--hmf-text-input-letter-spacing);line-height:var(--hmf-text-input-line-height)}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:focus{outline:1px dashed var(--hmf-gray700);outline-offset:5px}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{height:16px;width:16px}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]{background-color:transparent;border:none;box-sizing:border-box;color:var(--hmf-text-input-input-color);flex-grow:1;font-family:var(--hmf-text-input-font-family);font-size:var(--hmf-text-input-font-size);font-weight:var(--hmf-text-input-font-weight);height:100%;letter-spacing:var(--hmf-text-input-letter-spacing);line-height:var(--hmf-text-input-line-height);padding:var(--hmf-0)}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]:focus-visible{outline:none}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]:focus{outline:1px dashed var(--hmf-border-focused);outline-offset:4px}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::placeholder{color:var(--hmf-text-input-input-placeholder-color)}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%] > textarea[_ngcontent-%COMP%]{border:none;font-family:var(--hmf-text-input-text-area-font-family);font-size:var(--hmf-text-input-text-area-font-size);font-weight:var(--hmf-text-input-text-area-font-weight);height:100%;letter-spacing:var(--hmf-text-input-text-area-letter-spacing);line-height:var(--hmf-text-input-text-area-line-height);margin:0!important;min-height:75px;outline:none;padding:var(--hmf-xs)!important;width:100%}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper.disabled[_ngcontent-%COMP%]{background-color:var(--hmf-fill-disabled-subtle);cursor:not-allowed}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper.disabled[_ngcontent-%COMP%] > input[_ngcontent-%COMP%], .homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper.disabled[_ngcontent-%COMP%] > textarea[_ngcontent-%COMP%]{color:var(--hmf-label-disabled);cursor:not-allowed}.homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper.disabled[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::placeholder, .homefield-textinput[_ngcontent-%COMP%]   .homefield-textinput-wrapper.disabled[_ngcontent-%COMP%] > textarea[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::placeholder{color:var(--hmf-label-disabled)}.homefield-textinput[_ngcontent-%COMP%] > p[_ngcontent-%COMP%], .homefield-textinput[_ngcontent-%COMP%] > .helper-text[_ngcontent-%COMP%]{font-family:var(--hmf-text-input-font-family)}.homefield-textinput[_ngcontent-%COMP%] > label[_ngcontent-%COMP%]{color:var(--hmf-label-base);margin-bottom:var(--hmf-xxxs)}.homefield-textinput[_ngcontent-%COMP%]   input.filled[_ngcontent-%COMP%] + label[_ngcontent-%COMP%], .homefield-textinput[_ngcontent-%COMP%]   label.shrink[_ngcontent-%COMP%]{background-color:var(--hmf-fill-base);color:var(--hmf-label-base);left:.75rem;top:0!important;transform:translateY(-50%)}.homefield-textinput[_ngcontent-%COMP%]   label.label-disabled[_ngcontent-%COMP%]{background-color:var(--hmf-fill-disabled-subtle);color:var(--hmf-label-disabled)}.homefield-textinput[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{color:var(--hmf-label-base);font-size:11px;line-height:14px;margin-top:var(--hmf-xxxs)}.homefield-textinput.error[_ngcontent-%COMP%] > label[_ngcontent-%COMP%]{color:var(--hmf-text-input-error-label-color)}.homefield-textinput.error[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{color:var(--hmf-label-negative)}.homefield-textinput.error[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%]{background-color:var(--hmf-text-input-error-background-color);border:1px solid var(--hmf-border-negative)}.homefield-textinput.error[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::placeholder, .homefield-textinput.error[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::placeholder{color:var(--hmf-text-input-error-placeholder-color)}.homefield-textinput.error[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%]   .homefield-textinput-alerterror-icon[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .homefield-textinput.error[_ngcontent-%COMP%]   .homefield-textinput-wrapper[_ngcontent-%COMP%]   .homefield-textinput-alerterror-icon[_ngcontent-%COMP%]   g[_ngcontent-%COMP%]{fill:var(--hmf-text-input-error-svg-fill)}.as-placeholder[_ngcontent-%COMP%]{left:1rem;top:.85em;transition:top .3s ease,font-size .3s ease,color .3s ease}[_nghost-%COMP%]  .alert-error-icon-color svg path{fill:var(--hmf-text-input-error-svg-fill)}[_nghost-%COMP%]  .disabled-icon-color svg path{fill:var(--hmf-text-input-disabled-icon-color)}.icon-position-right[_ngcontent-%COMP%]{right:.5rem}.icon-position-left[_ngcontent-%COMP%]{left:.5rem}.focused-border[_ngcontent-%COMP%]{outline:1px dashed var(--hmf-border-focused)}.error-focused-border[_ngcontent-%COMP%]{outline:1px dashed var(--hmf-border-negative)!important}.unfocused-border-color[_ngcontent-%COMP%]{border-color:var(--hmf-border-secondary-subtle-static)}.disabled-border-color[_ngcontent-%COMP%]{border-color:var(--hmf-border-disabled)}.error-background[_ngcontent-%COMP%]{background-color:var(--hmf-fill-negative-subtle)}.default-background[_ngcontent-%COMP%]{background-color:var(--hmf-fill-base)}.disabled-background[_ngcontent-%COMP%]{background-color:var(--hmf-fill-disabled-subtle)}.cursor-pointer[_ngcontent-%COMP%]{cursor:pointer}input[type=number][_ngcontent-%COMP%]::-webkit-inner-spin-button, input[type=number][_ngcontent-%COMP%]::-webkit-outer-spin-button{appearance:none;margin:0}input[type=number][_ngcontent-%COMP%]{appearance:textfield}"]
      });
    }
  }
  return HmfTextInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Date validation functions
 */
const DateValidationFunctions = {
  /**
   * Validates if a date string matches the expected format
   */
  isValidDateFormat: value => {
    return DATE_FORMAT_PATTERN.test(value);
  },
  /**
   * Parses a date string into a Date object with validation
   */
  parseStringToDate: value => {
    if (!value || typeof value !== 'string') {
      return null;
    }
    if (!DateValidationFunctions.isValidDateFormat(value)) {
      return null;
    }
    const DATE_PARTS_COUNT = 3;
    const MONTH_OFFSET = 1; // Months are 0-indexed in Date constructor
    const dateParts = value.split('/').map(Number);
    if (dateParts.length !== DATE_PARTS_COUNT) {
      return null;
    }
    const [month, day, year] = dateParts;
    const date = new Date(year, month - MONTH_OFFSET, day);
    // Validate if the date is real (e.g., not February 30th)
    if (date.getFullYear() !== year || date.getMonth() !== month - MONTH_OFFSET || date.getDate() !== day) {
      return null;
    }
    return date;
  },
  /**
   * Formats a Date object to MM/DD/YYYY string format
   */
  formatDateToString: date => {
    if (date instanceof Date && !isNaN(date.getTime())) {
      const MONTH_OFFSET = 1; // Months are 0-indexed
      const PAD_LENGTH = 2; // Pad to 2 digits
      const PAD_CHAR = '0'; // Pad with zeros
      const month = String(date.getMonth() + MONTH_OFFSET).padStart(PAD_LENGTH, PAD_CHAR);
      const day = String(date.getDate()).padStart(PAD_LENGTH, PAD_CHAR);
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    }
    return '';
  },
  /**
   * Checks if a date matches a recurring disabled rule - ADAPTED TO EXISTING INTERFACE
   */
  matchesRecurringRule: (rule, date) => {
    // Restore original date range logic
    const start = rule.startDate ?? new Date(-8640000000000000);
    const end = rule.endDate ?? new Date(8640000000000000);
    if (date < start || date > end) return false;
    switch (rule.frequency // ← Use existing 'frequency' property
    ) {
      case 'weekly':
        return rule.daysOfWeek.includes(date.getDay());
      case 'monthly':
        return rule.daysOfMonth.includes(date.getDate());
      case 'yearly':
        // Keep original logic: check BOTH monthsOfYear AND daysOfMonth
        return rule.monthsOfYear.includes(date.getMonth()) && rule.daysOfMonth.includes(date.getDate());
      default:
        return false;
    }
  },
  /**
   * Comprehensive date validation function
   */
  isInvalidDate: (date, context) => {
    const {
      invalidDateList,
      invalidDateRange,
      recurringDisabledDates,
      pastDatesExcluded
    } = context;
    // Check if past dates are excluded
    if (pastDatesExcluded && date < new Date()) {
      return true;
    }
    // Check against invalid date list
    if (invalidDateList?.some(d => DateValidationFunctions.formatDateToString(d) === DateValidationFunctions.formatDateToString(date))) {
      return true;
    }
    // Check against invalid date range
    if (invalidDateRange && date >= invalidDateRange.startDate && date <= invalidDateRange.endDate) {
      return true;
    }
    // Check against recurring disabled rules
    if (recurringDisabledDates?.some(rule => DateValidationFunctions.matchesRecurringRule(rule, date))) {
      return true;
    }
    return false;
  },
  /**
   * Creates a business validator function for Angular forms
   */
  createDateBusinessValidator: component => {
    return control => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const date = DateValidationFunctions.parseStringToDate(value);
      if (!date) {
        return {
          invalidDate: true
        };
      }
      // Business rule validation
      const validationContext = {
        invalidDateList: component.invalidDateList(),
        invalidDateRange: component.invalidDateRange(),
        recurringDisabledDates: component.recurringDisabledDates(),
        pastDatesExcluded: component.pastDatesExcluded()
      };
      if (DateValidationFunctions.isInvalidDate(date, validationContext)) {
        return {
          invalidDate: true
        };
      }
      return null;
    };
  }
};
/**
 * Creates the date validation strategy
 */
const createDateStrategy = component => ({
  validators: [Validators.pattern(DATE_FORMAT_PATTERN), DateValidationFunctions.createDateBusinessValidator(component)],
  iconName: 'calendar-default',
  ariaLabel: DATE_PICKER_ARIA_LABELS.DATE,
  errorText: {
    pattern: DATE_PICKER_ERROR_MESSAGES.pattern,
    invalidDate: DATE_PICKER_ERROR_MESSAGES.invalidDate
  },
  parseValue: value => {
    return DateValidationFunctions.parseStringToDate(value);
  },
  normalizeOutput: value => value
});

/** @format */
/**
 * Time validation functions
 */
const TimeValidationFunctions = {
  /**
   * Validates hour range for 12-hour format
   */
  isValid12HourRange: hour => {
    return hour >= 1 && hour <= MAX_HOUR_12H_FORMAT;
  },
  /**
   * Validates hour range for 24-hour format
   */
  isValid24HourRange: hour => {
    return hour >= 0 && hour <= MAX_HOUR_24H_FORMAT;
  },
  /**
   * Validates minute range
   */
  isValidMinuteRange: minute => {
    return minute >= MIN_TIME_VALUE && minute <= MAX_MINUTES;
  },
  /**
   * Converts 12-hour format to 24-hour format
   * Handles special cases like noon (12 PM) and midnight (12 AM)
   * @param hour - Hour value in 12-hour format (1-12)
   * @param meridian - AM/PM indicator (case insensitive)
   * @returns Hour value converted to 24-hour format (0-23)
   */
  convertTo24Hour: (hour, meridian) => {
    // Normalize meridian to uppercase to handle both "am"/"pm" and "AM"/"PM"
    const meridianUpper = meridian.toUpperCase();
    // Handle afternoon/evening hours (1 PM - 11 PM)
    // Add 12 to convert from 12h to 24h format (1 PM → 13, 2 PM → 14, etc.)
    // Special case: 12 PM (noon) already represents 12 in 24h format
    if (meridianUpper === 'PM' && hour !== MAX_HOUR_12H_FORMAT) {
      return hour + MAX_HOUR_12H_FORMAT;
    }
    // Handle special case for midnight: 12 AM should be represented as 0 in 24h format
    if (meridianUpper === 'AM' && hour === MAX_HOUR_12H_FORMAT) {
      return MIN_TIME_VALUE; // 12 AM becomes 0 (midnight)
    }
    // For morning hours (1 AM - 11 AM) and noon (12 PM), keep the hour as is
    return hour;
  },
  /**
   * Validates time format - accepts both 12H and 24H based on component configuration
   */
  isValidTimeFormat: value => {
    if (!value || typeof value !== 'string') {
      return false;
    }
    const timeWithoutTimezone = value.replace(TIME_FORMAT_PATTERN, '').trim();
    // Accept both formats but prefer 12H with AM/PM when possible
    return TIME_12H_FORMAT_PATTERN.test(timeWithoutTimezone) || TIME_24H_FORMAT_PATTERN.test(timeWithoutTimezone);
  },
  /**
   * Parse time components for normalization
   * Extracts hour, minute, period (AM/PM) from time strings in 12-hour format
   * Note: This function does not handle timezones in the current implementation
   * @param timeString - Time string in 12-hour format (e.g., "3:45 PM")
   * @returns Object containing parsed components or null if invalid
   */
  parseTimeComponents: timeString => {
    // Attempt to match against 12-hour format pattern (e.g., "3:45 PM")
    // This pattern captures hour, minute, AM/PM indicator, and optional timezone
    const timeMatch = TIME_12H_FORMAT_PATTERN.exec(timeString);
    // If no match found for 12-hour format, return null for invalid input
    if (!timeMatch) return null;
    // Destructure the regex match array to extract all time components for 12h format
    // Format: [full match, hours, minutes, period (AM/PM), timezone (optional)]
    const [, hourStr, minuteStr, period, timezone] = timeMatch;
    // Parse time components with explicit base 10 to handle values with leading zeros correctly
    // Example: "09" minutes should be parsed as 9, not interpreted as octal
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);
    // Validate ranges for hours and minutes
    if (hour < 1 || hour > MAX_HOUR_12H_FORMAT || minute < MIN_TIME_VALUE || minute > MAX_MINUTES) {
      return null;
    }
    // If timezone is present, return null as timezone handling is not supported in this method
    if (timezone) {
      return null;
    }
    return {
      hour,
      minute,
      period: period.toUpperCase(),
      timezone: timezone?.toUpperCase()
    };
  },
  /**
   * Parses time string - handles both 12H and 24H formats
   */
  parseStringToTime: value => {
    if (!value || typeof value !== 'string') {
      return null;
    }
    // Remove any leading/trailing whitespace
    const timeWithoutTimezone = value.trim();
    // First attempt: Try to match against 12-hour format pattern (e.g., "3:45 PM EST")
    // 12-hour format is preferred for user input processing when possible
    let match = TIME_12H_FORMAT_PATTERN.exec(timeWithoutTimezone);
    let is24HourFormat = false;
    // Second attempt: If 12H format doesn't match, try 24H format pattern (e.g., "15:45 EST")
    if (!match) {
      match = TIME_24H_FORMAT_PATTERN.exec(timeWithoutTimezone);
      is24HourFormat = true;
    }
    // If neither format matches, the input isn't a valid time string
    if (!match) {
      return null;
    }
    // At this point we have a valid match in either 12h or 24h format
    // Destructure the regex match array to extract all time components
    // Format: [full match, hours, minutes, meridian (12h only), timezone (optional)]
    // Note: meridian will be undefined for 24h format matches
    const [, h, m, meridian] = match;
    if (!h || !m) {
      return null;
    }
    // Convert string values to numbers with explicit radix 10
    // This prevents potential octal interpretation of values with leading zeros (e.g., "09" → 9, not 0)
    let hour = parseInt(h, 10);
    const minute = parseInt(m, 10);
    if (isNaN(hour) || isNaN(minute)) {
      return null;
    }
    // Validate based on format
    if (is24HourFormat) {
      if (!TimeValidationFunctions.isValid24HourRange(hour)) {
        return null;
      }
    } else {
      if (!meridian) {
        // 12H format requires meridian
        return null;
      }
      if (!TimeValidationFunctions.isValid12HourRange(hour)) {
        return null;
      }
      hour = TimeValidationFunctions.convertTo24Hour(hour, meridian);
    }
    if (!TimeValidationFunctions.isValidMinuteRange(minute)) {
      return null;
    }
    const parsed = new Date();
    parsed.setHours(hour, minute, 0, 0);
    return isNaN(parsed.getTime()) ? null : parsed;
  },
  /**
   * Factory function: Creates time validator function
   */
  createTimeValidator: () => {
    return control => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const parsedTime = TimeValidationFunctions.parseStringToTime(value);
      if (!parsedTime) {
        return {
          invalidTime: true,
          message: getValidationErrorMessage.timePattern()
        };
      }
      return null;
    };
  },
  /**
   * Factory function: Creates time parser
   */
  createTimeParser: () => {
    return value => {
      return TimeValidationFunctions.parseStringToTime(value);
    };
  },
  /**
   * Formats time in 24-hour format with zero padding
   * Ensures consistent display format (HH:MM) with leading zeros
   */
  formatTime24Hour: (hours, minutes) => {
    const hoursStr = hours.toString().padStart(2, '0');
    const minutesStr = minutes.toString().padStart(2, '0');
    return `${hoursStr}:${minutesStr}`;
  },
  /**
   * Formats time in 12-hour format (H:MM AM/PM)
   * Handles special cases like noon and midnight using shared constants
   * Zero-pads minutes but displays hours without leading zero per standard 12h format
   */
  formatTime12Hour: (hours, minutes) => {
    const isPM = hours >= MAX_HOUR_12H_FORMAT;
    let displayHours = hours;
    // Convert from 24-hour values to 12-hour display format
    // Example: 13 hours (1 PM) becomes 1 hour in 12-hour format
    if (hours > MAX_HOUR_12H_FORMAT) {
      displayHours = hours - MAX_HOUR_12H_FORMAT; // Subtract 12 from hours > 12
    }
    // Special case: midnight (00:00) should display as 12:00 AM
    // In 12-hour format, hour 0 is represented as 12 AM
    if (hours === MIN_TIME_VALUE) {
      displayHours = MAX_HOUR_12H_FORMAT; // 0 hours becomes 12 AM
    }
    const minutesStr = minutes.toString().padStart(2, '0');
    const period = isPM ? 'PM' : 'AM';
    return `${displayHours}:${minutesStr} ${period}`;
  },
  /**
   * Formats time from Date object with configuration options
   */
  formatTimeFromDate: (date, use24Hour, showTimezone, timezoneLabel) => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    let timeString;
    if (use24Hour) {
      timeString = TimeValidationFunctions.formatTime24Hour(hours, minutes);
    } else {
      timeString = TimeValidationFunctions.formatTime12Hour(hours, minutes);
    }
    // Add timezone if enabled - maintain consistency with the display format
    // when the timezone will be rendered in the interface
    if (showTimezone && timezoneLabel) {
      timeString += ` ${timezoneLabel}`;
    }
    return timeString;
  },
  /**
   * Helper function to add timezone to a time string if present in the match
   * This is the final formatting step that ensures timezone information is preserved
   * @param timeString The already formatted time string (HH:MM or H:MM AM/PM format)
   * @param timezone Optional timezone string to append (e.g., ' EST', ' GMT', etc.)
   * @returns The final formatted time string with timezone if present
   */
  addTimezoneIfPresent: (timeString, timezone) => {
    if (timezone) {
      return timeString + timezone;
    }
    return timeString;
  },
  /**
   * Extract hours and minutes from regex match for 24-hour format
   * Handles 24H format array positions and returns a unified object structure
   */
  extractTimeComponents24H: match => {
    // In 24H format: [full match, hours, minutes, timezone]
    // Array destructuring for 24h format: match = ["15:30 EST", "15", "30", "EST"]
    const [, hoursStr, minutesStr, timezone] = match;
    return {
      // Always use radix 10 to avoid octal interpretation of values with leading zeros
      hours: parseInt(hoursStr, DECIMAL_RADIX),
      minutes: parseInt(minutesStr, DECIMAL_RADIX),
      timezone
    };
  },
  /**
   * Extract hours and minutes from regex match for 12-hour format
   * Handles 12H format array positions and returns a unified object structure
   */
  extractTimeComponents12H: match => {
    // In 12H format: [full match, hours, minutes, meridian, timezone]
    // Array destructuring for 12h format: match = ["3:30 PM EST", "3", "30", "PM", " EST"]
    const [, hoursStr, minutesStr, meridian, timezone] = match;
    return {
      // Always use radix 10 to avoid octal interpretation of values with leading zeros
      hours: parseInt(hoursStr, DECIMAL_RADIX),
      minutes: parseInt(minutesStr, DECIMAL_RADIX),
      meridian,
      timezone
    };
  },
  /**
   * Process time string for 24-hour format
   */
  processTimeString24H: timeString => {
    const match = TIME_24H_FORMAT_PATTERN.exec(timeString);
    // If no match is found with the expected pattern, return the original string
    if (!match) return timeString;
    // Extract time components using the specific 24H method
    const {
      hours,
      minutes,
      timezone
    } = TimeValidationFunctions.extractTimeComponents24H(match);
    // Format using 24-hour representation (HH:MM)
    const formattedTime = TimeValidationFunctions.formatTime24Hour(hours, minutes);
    // Add timezone information if present and return the complete formatted result
    return TimeValidationFunctions.addTimezoneIfPresent(formattedTime, timezone);
  },
  /**
   * Process time string for 12-hour format
   */
  processTimeString12H: timeString => {
    const match = TIME_12H_FORMAT_PATTERN.exec(timeString);
    // If no match is found with the expected pattern, return the original string
    if (!match) return timeString;
    // Extract time components using the specific 12H method
    const {
      hours,
      minutes,
      meridian,
      timezone
    } = TimeValidationFunctions.extractTimeComponents12H(match);
    // Initialize with current hour value before potential adjustments
    let adjustedHours = hours;
    // Apply PM adjustment: add 12 to hours for PM times when hour < 12
    if (meridian && meridian.toUpperCase() === 'PM' && hours < MAX_HOUR_12H_FORMAT) {
      adjustedHours += MAX_HOUR_12H_FORMAT;
    }
    // Format using 12-hour representation with meridian adjustment
    const formattedTime = TimeValidationFunctions.formatTime12Hour(adjustedHours, minutes);
    // Add timezone information if present and return the complete formatted result
    return TimeValidationFunctions.addTimezoneIfPresent(formattedTime, timezone);
  },
  /**
   * Normalize output format - standardizes time format based on detected format
   */
  normalizeOutput: value => {
    if (!value) return '';
    const cleanValue = value.trim();
    if (!TimeValidationFunctions.isValidTimeFormat(cleanValue)) {
      return cleanValue;
    }
    // Format detection: Check if input matches 24H pattern to determine appropriate method
    const cleanValueWithoutTimezone = cleanValue.replace(TIME_FORMAT_PATTERN, '').trim();
    const is24Hour = TIME_24H_FORMAT_PATTERN.test(cleanValueWithoutTimezone);
    // Use specific processing methods based on detected format
    if (is24Hour) {
      return TimeValidationFunctions.processTimeString24H(cleanValue);
    } else {
      return TimeValidationFunctions.processTimeString12H(cleanValue);
    }
  }
};
/**
 * Factory function: Creates time strategy
 */
const createTimeStrategy = () => ({
  validators: [TimeValidationFunctions.createTimeValidator()],
  iconName: 'time-clock-outlined',
  ariaLabel: DATE_PICKER_ARIA_LABELS.TIME,
  errorText: getValidationErrorMessage.timeInvalid(),
  parseValue: TimeValidationFunctions.createTimeParser(),
  normalizeOutput: TimeValidationFunctions.normalizeOutput
});

/** @format */
let HmfMonthMenuComponent = /*#__PURE__*/(() => {
  class HmfMonthMenuComponent {
    constructor() {
      this.size = input('medium');
      this.selectedDate = input(null);
      this.monthSelected = output();
      this.monthsMap = new Map([[0, 'January'], [1, 'February'], [2, 'March'], [3, 'April'], [4, 'May'], [5, 'June'], [6, 'July'], [7, 'August'], [8, 'September'], [9, 'October'], [10, 'November'], [11, 'December']]);
    }
    selectMonth(month) {
      this.monthSelected.emit(month);
    }
    static {
      this.ɵfac = function HmfMonthMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfMonthMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfMonthMenuComponent,
        selectors: [["hmf-month-menu"]],
        inputs: {
          size: [1, "size"],
          selectedDate: [1, "selectedDate"]
        },
        outputs: {
          monthSelected: "monthSelected"
        },
        decls: 4,
        vars: 3,
        consts: [[1, "months", 3, "ngClass"], ["type", "button", 1, "month-btn", "btn-date-month", "month"], ["type", "button", 1, "month-btn", "btn-date-month", "month", 3, "click"]],
        template: function HmfMonthMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵrepeaterCreate(1, HmfMonthMenuComponent_For_2_Template, 2, 1, "button", 1, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵpipe(3, "keyvalue");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.size());
            i0.ɵɵadvance();
            i0.ɵɵrepeater(i0.ɵɵpipeBind1(3, 1, ctx.monthsMap));
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.KeyValuePipe],
        styles: [".calendar[_ngcontent-%COMP%]{background:var(--hmf-fill-base);border:1px solid var(--hmf-border-secondary-subtle-hover);box-sizing:border-box;width:fit-content}.calendar-grid[_ngcontent-%COMP%]{display:grid;gap:4px}.calendar.medium[_ngcontent-%COMP%]{--day-size: 44px;--year-width: 80px;--year-height: 44px;--month-width: 80px;--month-height: 44px;--font-size-var: large;--time-width-selector: 360px}.calendar.small[_ngcontent-%COMP%]{--day-size: 32px;--year-width: 62px;--year-height: 32px;--month-width: 80px;--month-height: 32px;--font-size-var: medium;--time-width-selector: 100%}.calendar-controls[_ngcontent-%COMP%]   .arrows[_ngcontent-%COMP%]{padding:var(--hmf-0)}.calendar[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:unset;border:unset;border-radius:4px;cursor:pointer}.calendar[_ngcontent-%COMP%]   button.left-arrow[_ngcontent-%COMP%]:disabled{cursor:not-allowed}.btn-date[_ngcontent-%COMP%]:hover:not(:disabled,.selected), .btn-date.focused[_ngcontent-%COMP%]:not(:disabled,.selected){background-color:var(--hmf-fill-secondary-hover)!important;color:var(--hmf-label-secondary-active)!important;font-weight:var(--typography-body-links-weights-bold)}.btn-date.selected[_ngcontent-%COMP%]{background-color:var(--hmf-fill-inverse)!important;color:var(--hmf-label-inverse)!important}.btn-date[_ngcontent-%COMP%]:disabled{background-color:var(--hmf-fill-base)!important;color:var(--hmf-label-disabled)!important;cursor:not-allowed;text-decoration:line-through}.btn-date[_ngcontent-%COMP%]   .timezone[_ngcontent-%COMP%]{color:inherit;font-weight:inherit}.weekdays[_ngcontent-%COMP%]{display:grid;gap:4px;grid-template-columns:repeat(7,1fr);text-align:center}.week[_ngcontent-%COMP%]{display:grid;gap:4px;grid-template-columns:repeat(7,1fr)}.week[_ngcontent-%COMP%]:not(:last-child){margin-bottom:var(--hmf-xxxs)}.day[_ngcontent-%COMP%]{border-radius:4px;height:var(--day-size);width:var(--day-size)}.day.other-month[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-active)}.btn-date-month[_ngcontent-%COMP%]:disabled{background-color:var(--hmf-fill-base);color:var(--hmf-label-disabled);cursor:not-allowed;text-decoration:line-through}.btn-date-month[_ngcontent-%COMP%]:hover:not(:disabled,.selected){background-color:var(--hmf-fill-secondary-hover);color:var(--hmf-label-secondary-active);font-weight:var(--typography-body-links-weights-bold)}.btn-date-month.selected[_ngcontent-%COMP%]{background-color:var(--hmf-fill-inverse);color:var(--hmf-label-inverse)}.months[_ngcontent-%COMP%]{border:none;display:grid;grid-template-columns:repeat(3,1fr)}.months[_ngcontent-%COMP%]   .month-btn[_ngcontent-%COMP%]{font-size:var(--font-size-var);height:var(--month-height);text-transform:capitalize!important;width:var(--month-width)}.year-grid[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(4,1fr)}.year-grid[_ngcontent-%COMP%]   .year-btn[_ngcontent-%COMP%]{height:var(--year-height);width:var(--year-width)}.time-menu-container[_ngcontent-%COMP%]{max-height:280px;overflow:hidden;position:relative;width:100%}.time-menu-container[_ngcontent-%COMP%]:after{background:linear-gradient(to bottom,#fff0,#fff);bottom:0;content:\"\";height:40px;left:0;pointer-events:none;position:absolute;right:0;z-index:1}.time-menu[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:4px;max-height:240px;min-width:var(--time-width-selector);overflow-y:auto;padding-right:8px;position:relative}.btn-time[_ngcontent-%COMP%]{align-items:baseline;display:flex;gap:4px;padding:8px;text-align:left;text-transform:uppercase!important;width:auto}.timezone[_ngcontent-%COMP%]{color:var(--hmf-label-base-subtle);font-size:11px;line-height:1}"]
      });
    }
  }
  return HmfMonthMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HmfYearMenuComponent = /*#__PURE__*/(() => {
  class HmfYearMenuComponent {
    constructor() {
      // Input
      this.baseYear = input.required();
      this.allowFutureYears = input.required();
      // Output
      this.yearSelected = output();
      this.preSelectedYearIndex = signal(-1);
      this.currentSelectedYear = signal(null);
      this.currentYear = new Date().getFullYear();
      this.years = computed(() => {
        const baseYear = this.baseYear();
        const years = [];
        for (let i = 0; i < 16; i++) {
          const year = baseYear - i;
          years.push({
            year,
            disabled: !this.allowFutureYears() && year > this.currentYear
          });
        }
        return years;
      });
    }
    ngOnInit() {
      this.currentSelectedYear.set(this.baseYear());
    }
    handleKeyboardEvent(event) {
      const years = this.years();
      let index = this.preSelectedYearIndex();
      switch (event.key) {
        case 'ArrowUp':
          event.preventDefault();
          index = Math.max(index - 4, 0);
          break;
        case 'ArrowDown':
          event.preventDefault();
          index = Math.min(index + 4, years.length - 1);
          break;
        case 'ArrowLeft':
          event.preventDefault();
          index = Math.max(index - 1, 0);
          break;
        case 'ArrowRight':
          event.preventDefault();
          index = Math.min(index + 1, years.length - 1);
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          this.yearSelected.emit(years[index].year);
          return;
        default:
          return;
      }
      this.preSelectedYearIndex.set(index);
      this.focusButton(index);
    }
    focusButton(index) {
      const buttons = document.querySelectorAll('.year-btn');
      buttons[index]?.focus();
    }
    static {
      this.ɵfac = function HmfYearMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfYearMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfYearMenuComponent,
        selectors: [["hmf-year-component"]],
        hostBindings: function HmfYearMenuComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function HmfYearMenuComponent_keydown_HostBindingHandler($event) {
              return ctx.handleKeyboardEvent($event);
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          baseYear: [1, "baseYear"],
          allowFutureYears: [1, "allowFutureYears"]
        },
        outputs: {
          yearSelected: "yearSelected"
        },
        decls: 3,
        vars: 0,
        consts: [["role", "grid", "aria-label", "year-menu", "aria-describedby", "grid-desc", 1, "year-grid"], ["type", "button", 1, "year-btn", "btn-date", "hmf-body-l", 3, "focused", "selected", "disabled"], ["type", "button", 1, "year-btn", "btn-date", "hmf-body-l", 3, "mouseenter", "mouseleave", "click", "disabled"]],
        template: function HmfYearMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵrepeaterCreate(1, HmfYearMenuComponent_For_2_Template, 2, 8, "button", 1, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.years());
          }
        },
        styles: [_c67]
      });
    }
  }
  return HmfYearMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HmfDateMenuComponent = /*#__PURE__*/(() => {
  class HmfDateMenuComponent {
    constructor(eRef, homefieldIconsLibraryService) {
      this.eRef = eRef;
      this.homefieldIconsLibraryService = homefieldIconsLibraryService;
      // Inputs
      this.size = input('medium');
      this.allowFutureYears = input.required();
      this.currentlySelectedDate = input(null);
      this.pastDatesExcluded = input(false);
      this.invalidDateRange = input(null);
      this.invalidDateList = input([]);
      this.recurringDisabledDates = input([]);
      // Output
      this.dateSelected = output();
      this.isFocused = output();
      this.dateDisplayedInMenu = signal(new Date());
      this.currentYear = signal(new Date().getFullYear());
      this.weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      this.currentMenu = signal('date');
      this.baseYearForYearMenu = signal(this.currentYear());
      this.disabledNavigateLeft = computed(() => {
        if (this.currentMenu() === 'year' && !this.allowFutureYears() && this.baseYearForYearMenu() >= this.currentYear()) {
          return true;
        }
        return false;
      });
      this.displayedYearMonth = computed(() => {
        const date = this.dateDisplayedInMenu();
        const month = date.toLocaleDateString('en-US', {
          month: 'long'
        });
        const year = date.getFullYear();
        return {
          month,
          year
        };
      });
      this.calendarDays = computed(() => {
        const date = this.dateDisplayedInMenu();
        const year = date.getFullYear();
        const month = date.getMonth();
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const days = [];
        let currentWeek = [];
        // Previous month days
        const firstDayOfWeek = firstDay.getDay();
        for (let i = firstDayOfWeek - 1; i >= 0; i--) {
          const prevDate = new Date(year, month, -i);
          currentWeek.push({
            date: prevDate,
            isCurrentMonth: false,
            isDaySelected: false
          });
        }
        // Current month days
        for (let day = 1; day <= lastDay.getDate(); day++) {
          const currentDate = new Date(year, month, day);
          currentWeek.push({
            date: currentDate,
            isCurrentMonth: true,
            isDaySelected: this.isDaySelected(currentDate)
          });
          if (currentWeek.length === 7) {
            days.push(currentWeek);
            currentWeek = [];
          }
        }
        // Next month days
        if (currentWeek.length > 0) {
          const remainingDays = 7 - currentWeek.length;
          for (let i = 1; i <= remainingDays; i++) {
            const nextDate = new Date(year, month + 1, i);
            currentWeek.push({
              date: nextDate,
              isCurrentMonth: false,
              isDaySelected: false
            });
          }
          days.push(currentWeek);
        }
        return days;
      });
      this.homefieldIconsLibraryService.registerIcons([homefieldIconChevronLeft, homefieldIconChevronRight]);
    }
    ngOnInit() {
      const initialDate = this.currentlySelectedDate();
      if (initialDate !== null) {
        this.dateDisplayedInMenu.set(initialDate);
        this.baseYearForYearMenu.set(this.displayedYearMonth().year);
      }
    }
    setDatePickerMenu(menuType) {
      this.currentMenu.set(this.currentMenu() === menuType ? 'date' : menuType);
    }
    onClickOutside(event) {
      if (this.eRef.nativeElement.contains(event.target)) {
        this.isFocused.emit(true);
      } else if (this.currentMenu() === 'month') {
        this.currentMenu.set('date');
      } else {
        this.isFocused.emit(false);
      }
    }
    navigateLeft() {
      if (this.currentMenu() === 'year') {
        this.baseYearForYearMenu.update(currentYear => currentYear + 16);
      } else {
        this.dateDisplayedInMenu.update(date => {
          const newDate = new Date(date);
          newDate.setMonth(date.getMonth() - 1);
          return newDate;
        });
        this.baseYearForYearMenu.set(this.displayedYearMonth().year);
      }
    }
    navigateRight() {
      if (this.currentMenu() === 'year') {
        this.baseYearForYearMenu.update(currentYear => currentYear - 16);
      } else {
        this.dateDisplayedInMenu.update(date => {
          const newDate = new Date(date);
          newDate.setMonth(date.getMonth() + 1);
          return newDate;
        });
        this.baseYearForYearMenu.set(this.displayedYearMonth().year);
      }
    }
    onDateSelect(date) {
      this.dateSelected.emit(date);
    }
    onMonthSelected(month) {
      this.dateDisplayedInMenu.update(date => {
        const newDate = new Date(date);
        newDate.setMonth(month);
        return newDate;
      });
      this.currentMenu.set('date');
    }
    isDaySelected(date) {
      const selectedDate = this.currentlySelectedDate();
      if (!selectedDate) return false;
      return date.getFullYear() === selectedDate.getFullYear() && date.getMonth() === selectedDate.getMonth() && date.getDate() === selectedDate.getDate();
    }
    yearSelected(year) {
      this.dateDisplayedInMenu.update(currentDate => {
        return new Date(year, currentDate.getMonth(), currentDate.getDate());
      });
      this.baseYearForYearMenu.set(year);
      this.currentMenu.set('date');
    }
    isPastDate(inputDate) {
      const currentDay = new Date();
      currentDay.setHours(0, 0, 0, 0);
      return this.pastDatesExcluded() && currentDay > inputDate;
    }
    isInvalidDateRange(inputDate) {
      const invalidDateRange = this.invalidDateRange();
      if (invalidDateRange !== null) {
        const startDate = invalidDateRange.startDate;
        const endDate = invalidDateRange.endDate;
        if (startDate > endDate) {
          return false;
        }
        if (inputDate >= startDate && inputDate <= endDate) {
          return true;
        }
      }
      return false;
    }
    isInvalidDate(inputDate) {
      const invalidDates = this.invalidDateList() || [];
      return invalidDates.some(invalidDate => invalidDate.getFullYear() === inputDate.getFullYear() && invalidDate.getMonth() === inputDate.getMonth() && invalidDate.getDate() === inputDate.getDate());
    }
    isRecurringDisabledDate(inputDate) {
      const disabledDates = this.recurringDisabledDates() || [];
      return disabledDates.some(reccuringRule => {
        if (reccuringRule.startDate && reccuringRule.endDate) {
          if (inputDate >= reccuringRule.endDate || inputDate <= reccuringRule.startDate) {
            return false;
          }
        }
        switch (reccuringRule.frequency) {
          case 'weekly':
            return reccuringRule.daysOfWeek?.includes(inputDate.getDay());
          case 'monthly':
            return reccuringRule.daysOfMonth?.includes(inputDate.getDate());
          case 'yearly':
            return reccuringRule.monthsOfYear?.some((month, index) => {
              return month === inputDate.getMonth() && reccuringRule.daysOfMonth?.[index] === inputDate.getDate();
            });
        }
      });
    }
    isDisabled(inputDate) {
      return this.isPastDate(inputDate) || this.isInvalidDateRange(inputDate) || this.isInvalidDate(inputDate) || this.isRecurringDisabledDate(inputDate);
    }
    static {
      this.ɵfac = function HmfDateMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfDateMenuComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfDateMenuComponent,
        selectors: [["hmf-date-menu"]],
        hostBindings: function HmfDateMenuComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mouseup", function HmfDateMenuComponent_mouseup_HostBindingHandler($event) {
              return ctx.onClickOutside($event);
            }, false, i0.ɵɵresolveDocument);
          }
        },
        inputs: {
          size: [1, "size"],
          allowFutureYears: [1, "allowFutureYears"],
          currentlySelectedDate: [1, "currentlySelectedDate"],
          pastDatesExcluded: [1, "pastDatesExcluded"],
          invalidDateRange: [1, "invalidDateRange"],
          invalidDateList: [1, "invalidDateList"],
          recurringDisabledDates: [1, "recurringDisabledDates"]
        },
        outputs: {
          dateSelected: "dateSelected",
          isFocused: "isFocused"
        },
        decls: 15,
        vars: 7,
        consts: [[1, "calendar", "hmf-body-l", "hmf-p-s", 3, "ngClass"], [1, "hmf-display-flex", "hmf-align-items-center", "hmf-justify-content-between", "hmf-mb-s"], ["type", "button", "aria-label", "Show month menu", 1, "hmf-body-bold-l", "btn-date", 3, "click"], ["type", "button", "aria-label", "Show year menu", 1, "hmf-body-bold-l", "btn-date", 3, "click"], [1, "calendar-controls"], ["type", "button", 1, "hmf-mr-m", "left-arrow", 3, "click", "disabled"], ["height", "24", "width", "24", "name", "chevron-left", "fill", "var(--hmf-label-base)"], ["type", "button", 1, "right-arrow", 3, "click"], ["height", "24", "width", "24", "name", "chevron-right", "fill", "var(--hmf-label-base)"], [1, "calendar-grid"], [3, "allowFutureYears", "baseYear"], [1, "weekdays", "hmf-text-align-center", "hmf-body-s", "label-base-subtle"], [1, "days"], [1, "week"], ["type", "button", "tabindex", "0", 1, "day", "hmf-body-l", "btn-date", 3, "other-month", "selected", "disabled"], ["type", "button", "tabindex", "0", 1, "day", "hmf-body-l", "btn-date", 3, "click", "disabled"], [3, "monthSelected"], [3, "yearSelected", "allowFutureYears", "baseYear"]],
        template: function HmfDateMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div")(3, "button", 2);
            i0.ɵɵlistener("click", function HmfDateMenuComponent_Template_button_click_3_listener() {
              return ctx.setDatePickerMenu("month");
            });
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "button", 3);
            i0.ɵɵlistener("click", function HmfDateMenuComponent_Template_button_click_5_listener() {
              return ctx.setDatePickerMenu("year");
            });
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 4)(8, "button", 5);
            i0.ɵɵlistener("click", function HmfDateMenuComponent_Template_button_click_8_listener() {
              return ctx.navigateLeft();
            });
            i0.ɵɵelement(9, "homefield-icon", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "button", 7);
            i0.ɵɵlistener("click", function HmfDateMenuComponent_Template_button_click_10_listener() {
              return ctx.navigateRight();
            });
            i0.ɵɵelement(11, "homefield-icon", 8);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(12, HmfDateMenuComponent_Case_12_Template, 7, 0, "div", 9)(13, HmfDateMenuComponent_Case_13_Template, 1, 0, "hmf-month-menu")(14, HmfDateMenuComponent_Case_14_Template, 1, 2, "hmf-year-component", 10);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_6_0;
            i0.ɵɵproperty("ngClass", ctx.size());
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", ctx.displayedYearMonth().month, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.displayedYearMonth().year, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.disabledNavigateLeft());
            i0.ɵɵattribute("aria-label", ctx.currentMenu() === "year" ? "Previous month" : "Next years");
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("aria-label", ctx.currentMenu() === "year" ? "Next month" : "Previous years");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional((tmp_6_0 = ctx.currentMenu()) === "date" ? 12 : tmp_6_0 === "month" ? 13 : tmp_6_0 === "year" ? 14 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, HmfMonthMenuComponent, HmfYearMenuComponent, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: [_c67]
      });
    }
  }
  return HmfDateMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfTimeMenuComponent = /*#__PURE__*/(() => {
  class HmfTimeMenuComponent {
    constructor() {
      this.selectedTime = input(new Date());
      this.size = input('medium');
      this.showTimezone = input(false);
      this.timezoneLabel = input('');
      this.intervalMinutes = input(15);
      this.use24HourFormat = input(false);
      this.disabledTimeRanges = input([]);
      this.timeSelected = output();
      this.cdr = inject(ChangeDetectorRef);
      this.timeOptions = computed(() => {
        const interval = this.intervalMinutes();
        const use24Hour = this.use24HourFormat();
        const disabledRanges = this.disabledTimeRanges();
        const options = [];
        for (let minutes = MIN_TIME_VALUE; minutes < TIME_MENU_CONSTANTS.MINUTES_IN_DAY; minutes += interval) {
          const hour = Math.floor(minutes / TIME_MENU_CONSTANTS.MINUTES_IN_HOUR);
          const minute = minutes % TIME_MENU_CONSTANTS.MINUTES_IN_HOUR;
          const date = new Date();
          date.setHours(hour, minute, MIN_TIME_VALUE, MIN_TIME_VALUE);
          const display = use24Hour ? this.formatTime24Hour(hour, minute) : this.formatTime12Hour(hour, minute);
          // Check if this time is disabled
          const disabled = this.isTimeDisabled(date, disabledRanges);
          options.push({
            hour,
            minute,
            display,
            value: date,
            disabled
          });
        }
        return options;
      });
    }
    /**
     * Formats time in 12-hour format using shared constants
     */
    formatTime12Hour(hour, minute) {
      const isPM = hour >= MAX_HOUR_12H_FORMAT;
      let displayHour = hour;
      // Convert to 12-hour format - using shared constants
      if (hour > MAX_HOUR_12H_FORMAT) {
        displayHour = hour - MAX_HOUR_12H_FORMAT;
      }
      if (hour === MIN_TIME_VALUE) {
        displayHour = MAX_HOUR_12H_FORMAT;
      }
      const minuteStr = minute.toString().padStart(TIME_MENU_CONSTANTS.PAD_LENGTH, TIME_MENU_CONSTANTS.PAD_CHARACTER);
      const period = isPM ? 'PM' : 'AM';
      return `${displayHour}:${minuteStr} ${period}`;
    }
    /**
     * Formats time in 24-hour format using shared constants
     */
    formatTime24Hour(hour, minute) {
      const hourStr = hour.toString().padStart(TIME_MENU_CONSTANTS.PAD_LENGTH, TIME_MENU_CONSTANTS.PAD_CHARACTER);
      const minuteStr = minute.toString().padStart(TIME_MENU_CONSTANTS.PAD_LENGTH, TIME_MENU_CONSTANTS.PAD_CHARACTER);
      return `${hourStr}:${minuteStr}`;
    }
    /**
     * Checks if time falls within any disabled range
     */
    isTimeDisabled(time, disabledRanges) {
      if (!disabledRanges?.length) return false;
      return disabledRanges.some(({
        start,
        end
      }) => time >= start && time <= end);
    }
    isSelected(timeOption) {
      const selected = this.selectedTime();
      if (!selected || !(selected instanceof Date) || isNaN(selected.getTime())) return false;
      // Compare hours and minutes, ignoring seconds, milliseconds and date
      const isMatch = selected.getHours() === timeOption.hour && selected.getMinutes() === timeOption.minute;
      // Detect changes if the value matches, to ensure the CSS class is applied
      if (isMatch) {
        this.cdr.markForCheck();
      }
      return isMatch;
    }
    onTimeSelect(timeOption) {
      // Don't allow selection of disabled times
      if (timeOption && !timeOption.disabled) {
        this.timeSelected.emit(timeOption.value);
      }
    }
    static {
      this.ɵfac = function HmfTimeMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfTimeMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfTimeMenuComponent,
        selectors: [["hmf-time-menu"]],
        inputs: {
          selectedTime: [1, "selectedTime"],
          size: [1, "size"],
          showTimezone: [1, "showTimezone"],
          timezoneLabel: [1, "timezoneLabel"],
          intervalMinutes: [1, "intervalMinutes"],
          use24HourFormat: [1, "use24HourFormat"],
          disabledTimeRanges: [1, "disabledTimeRanges"]
        },
        outputs: {
          timeSelected: "timeSelected"
        },
        decls: 4,
        vars: 1,
        consts: [[1, "calendar", "time-menu-container", 3, "ngClass"], [1, "time-menu"], ["type", "button", "role", "menuitem", 1, "btn-time", "btn-date", "hmf-body-l", 3, "selected", "disabled", "hmf-body-m"], ["type", "button", "role", "menuitem", 1, "btn-time", "btn-date", "hmf-body-l", 3, "click", "disabled"], [1, "timezone"]],
        template: function HmfTimeMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵrepeaterCreate(2, HmfTimeMenuComponent_For_3_Template, 3, 10, "button", 2, _forTrack1);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.size());
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.timeOptions());
          }
        },
        dependencies: [CommonModule, i1$1.NgClass],
        styles: [_c67]
      });
    }
  }
  return HmfTimeMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfDatePickerComponent = /*#__PURE__*/(() => {
  class HmfDatePickerComponent {
    get hasErrors() {
      return this.dateControlRef()?.invalid && this.dateControlRef()?.touched || this.dateControl.invalid && this.dateControl.touched;
    }
    constructor() {
      // Accessibility text constants
      this.DATE_PICKER_ARIA_LABELS = DATE_PICKER_ARIA_LABELS;
      // Common inputs
      this.dateControlRef = input(); // To access the parent formControl;
      this.id = input(generateId('date-picker'));
      this.className = input('');
      this.helperText = input('');
      this.label = input('');
      this.placeholder = input('');
      this.size = input(COMPONENT_SIZES.MEDIUM);
      this.activeFloatingLabel = input(false);
      this.type = input('date');
      this.requiredErrorMessage = input('This field is required');
      // Date-related inputs
      this.allowFutureYears = input(true);
      this.pastDatesExcluded = input(false);
      this.invalidDateRange = input(null);
      this.invalidDateList = input([]);
      this.recurringDisabledDates = input([]);
      // Time-related inputs
      this.showTimezone = input(false);
      this.timezoneLabel = input(DEFAULT_TIME_ZONE);
      this.intervalMinutes = input(DEFAULT_INTERVAL_MINUTES);
      this.use24HourFormat = input(false);
      this.disabledTimeRanges = input([]);
      // Outputs
      this.dateChange = output();
      this.hmfFocus = output();
      this.hmfBlur = output();
      this.currentlySelectedDate = signal(null);
      this.showCalendar = signal(false);
      this.isInputFocused = signal(false);
      // ControlValueAccessor methods
      this.onChange = () => {
        /*empty*/
      };
      this.onTouched = () => {
        /*empty*/
      };
      // Form control - validators will be set by strategies
      this.dateControl = new FormControl('', {
        updateOn: FORM_CONTROL_UPDATE_ON.BLUR
      });
      this.hasError = signal(false);
      this.disabled = false;
      this.destroyRef = inject(DestroyRef);
      this.homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);
      this.cdr = inject(ChangeDetectorRef);
      this.computedTimezoneLabel = computed(() => {
        const label = this.timezoneLabel();
        return label || DEFAULT_TIME_ZONE;
      });
      this.errorMessage = computed(() => {
        const control = this.dateControl;
        const externalControl = this.dateControlRef();
        const hasInternalErrors = control?.errors && control.touched;
        const hasExternalErrors = externalControl?.errors && externalControl.touched;
        if (!hasInternalErrors && !hasExternalErrors) return null;
        // Prioritize external control errors (parent form validation)
        const activeControl = hasExternalErrors ? externalControl : control;
        const errors = activeControl?.errors;
        if (!errors) return null;
        if (errors['required']) {
          return this.requiredErrorMessage();
        }
        const currentStrategy = this.getCurrentStrategy();
        if (errors['pattern']) {
          if (typeof currentStrategy.errorText === 'object') {
            return currentStrategy.errorText.pattern;
          }
          return currentStrategy.errorText;
        }
        if (errors['invalidDate'] || errors['invalidTime'] || errors['invalidValue']) {
          if (typeof currentStrategy.errorText === 'object') {
            return currentStrategy.errorText.invalidDate;
          }
          return currentStrategy.errorText;
        }
        if (typeof currentStrategy.errorText === 'object') {
          return currentStrategy.errorText.invalidDate;
        }
        return currentStrategy.errorText;
      });
      // Computed properties for UI components
      this.ariaLabels = DATE_PICKER_ARIA_LABELS;
      this.iconName = computed(() => {
        return this.getCurrentStrategy().iconName;
      });
      this.isDateType = computed(() => {
        return this.type() === 'date';
      });
      this.homefieldIconsLibraryService.registerIcons([homefieldIconCalendarDefault, homefieldIconTimeClockOutlined]);
      // Initialize strategies using the separated strategy files
      this.initializeStrategies();
      // Setup strategy dependencies with reactivity to type input changes
      this.setupStrategyDependencies();
    }
    initializeStrategies() {
      // Create strategies only once and cache them
      this.typeStrategies = {
        date: createDateStrategy(this),
        time: createTimeStrategy()
      };
    }
    /**
     * Setup strategy dependencies with reactivity to type input changes
     * Safe approach to prevent race conditions
     */
    setupStrategyDependencies() {
      if (!this.typeStrategies) {
        return;
      }
      // Get initial strategy and set up immediately
      const defaultStrategy = this.getCurrentStrategy();
      this.parseValueFn = defaultStrategy.parseValue;
      this.normalizeOutputFn = defaultStrategy.normalizeOutput;
      this.dateControl.setValidators(defaultStrategy.validators);
      this.dateControl.updateValueAndValidity();
      // Reaction to type signal changes
      effect(() => {
        const strategy = this.getCurrentStrategy();
        if (this.parseValueFn !== strategy.parseValue) {
          // Update function references
          this.parseValueFn = strategy.parseValue;
          this.normalizeOutputFn = strategy.normalizeOutput;
          // Update validators
          this.dateControl.setValidators(strategy.validators);
          this.dateControl.updateValueAndValidity();
          const currentValue = this.dateControl.value;
          if (currentValue) {
            try {
              const reparsedValue = this.parseValueFn(currentValue);
              this.currentlySelectedDate.set(reparsedValue);
            } catch (error) {
              this.currentlySelectedDate.set(null);
            }
          }
        }
      });
    }
    // Helper method to safely get the currently selected date
    getSafeSelectedDate() {
      return this.currentlySelectedDate() ?? new Date();
    }
    // Obtain the current strategy based on the type input
    getCurrentStrategy() {
      return this.typeStrategies[this.type()];
    }
    /**
     * Normalizes the value for external consumption using the current strategy
     */
    normalizeValueForOutput(value) {
      if (!value || typeof value !== 'string') {
        return '';
      }
      try {
        return this.normalizeOutputFn(value);
      } catch (error) {
        return value;
      }
    }
    ngAfterViewInit() {
      this.dateControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
        if (!value || typeof value !== 'string') {
          this.onChange('');
          this.currentlySelectedDate.set(null);
          this.dateChange.emit('');
          return;
        }
        try {
          const normalizedValue = this.normalizeValueForOutput(value);
          this.onChange(normalizedValue);
          if (this.dateControl.valid) {
            // Use the parsing function from current strategy
            const parsedValue = this.parseValueFn(value);
            this.currentlySelectedDate.set(parsedValue);
            this.dateChange.emit(normalizedValue);
          } else {
            this.currentlySelectedDate.set(null);
            this.dateChange.emit('');
          }
        } catch (error) {
          this.onChange('');
          this.currentlySelectedDate.set(null);
          this.dateChange.emit('');
        }
      });
    }
    dateMenuFocus(isFocused) {
      if (!isFocused) {
        this.showCalendar.set(false);
      }
    }
    onDateMenuSelection(dateSelected) {
      if (!dateSelected || !(dateSelected instanceof Date) || isNaN(dateSelected.getTime())) {
        return;
      }
      try {
        // Use validations from date-strategy
        const parsedDate = DateValidationFunctions.formatDateToString(dateSelected);
        if (parsedDate !== this.dateControl.value) {
          this.dateControl.setValue(parsedDate);
        }
        this.onTouched();
        this.togglePicker(false);
      } catch (error) {
        return;
      }
    }
    onTimeMenuSelection(timeSelected) {
      if (!timeSelected || !(timeSelected instanceof Date) || isNaN(timeSelected.getTime())) {
        return;
      }
      try {
        // Use validations from time-strategy
        const parsedTime = TimeValidationFunctions.formatTimeFromDate(timeSelected, this.use24HourFormat(), this.showTimezone(), this.computedTimezoneLabel());
        this.dateControl.setValue(parsedTime);
        this.onTouched();
        this.togglePicker(false);
      } catch (error) {
        return;
      }
    }
    // ControlValueAccessor methods
    writeValue(value) {
      if (!value || typeof value !== 'string') {
        this.dateControl.setValue('', {
          emitEvent: false
        });
        this.currentlySelectedDate.set(null);
        return;
      }
      const stringValue = value.trim();
      if (!stringValue) {
        this.dateControl.setValue('', {
          emitEvent: false
        });
        this.currentlySelectedDate.set(null);
        return;
      }
      this.dateControl.setValue(stringValue, {
        emitEvent: false
      });
      try {
        const parsedValue = this.parseValueFn(stringValue);
        this.currentlySelectedDate.set(parsedValue);
        // Use markForCheck to notify Angular when change detection
        this.cdr.markForCheck();
      } catch (error) {
        this.currentlySelectedDate.set(null);
      }
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
      if (disabled) {
        this.dateControl.disable({
          emitEvent: false
        });
      } else {
        this.dateControl.enable({
          emitEvent: false
        });
      }
    }
    validate() {
      return this.dateControl.errors;
    }
    togglePicker(state) {
      if (this.disabled) {
        return;
      }
      if (typeof state === 'boolean') {
        this.showCalendar.set(state);
        return;
      }
      try {
        this.showCalendar.update(currentState => !currentState);
      } catch (error) {
        this.showCalendar.set(false);
      }
    }
    onFocus(event) {
      this.isInputFocused.set(true);
      this.hmfFocus.emit(event);
    }
    onBlur(event) {
      this.onTouched();
      this.isInputFocused.set(false);
      this.hmfBlur.emit(event);
    }
    handleEnterKey(event) {
      event.preventDefault();
      this.dateControl.updateValueAndValidity();
      this.onTouched();
    }
    static {
      this.ɵfac = function HmfDatePickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfDatePickerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfDatePickerComponent,
        selectors: [["hmf-date-picker"]],
        inputs: {
          dateControlRef: [1, "dateControlRef"],
          id: [1, "id"],
          className: [1, "className"],
          helperText: [1, "helperText"],
          label: [1, "label"],
          placeholder: [1, "placeholder"],
          size: [1, "size"],
          activeFloatingLabel: [1, "activeFloatingLabel"],
          type: [1, "type"],
          requiredErrorMessage: [1, "requiredErrorMessage"],
          allowFutureYears: [1, "allowFutureYears"],
          pastDatesExcluded: [1, "pastDatesExcluded"],
          invalidDateRange: [1, "invalidDateRange"],
          invalidDateList: [1, "invalidDateList"],
          recurringDisabledDates: [1, "recurringDisabledDates"],
          showTimezone: [1, "showTimezone"],
          timezoneLabel: [1, "timezoneLabel"],
          intervalMinutes: [1, "intervalMinutes"],
          use24HourFormat: [1, "use24HourFormat"],
          disabledTimeRanges: [1, "disabledTimeRanges"]
        },
        outputs: {
          dateChange: "dateChange",
          hmfFocus: "hmfFocus",
          hmfBlur: "hmfBlur"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => HmfDatePickerComponent),
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => HmfDatePickerComponent),
          multi: true
        }])],
        decls: 14,
        vars: 22,
        consts: [["textInput", ""], ["id", "test-date"], [1, "hmf-body-s", "label-secondary-subtle-static", 3, "ngClass"], [1, "date-picker__container", "hmf-position-relative"], [1, "date-picker-input", "hmf-position-relative", "hmf-display-flex", "hmf-flex-column"], [1, "date-picker-input-label", "hmf-position-absolute", "hmf-body-m", "hmf-ml-xxxs", 3, "ngClass"], [1, "date-picker-input-wrapper", "background-base"], [1, "hmf-pl-xs", 3, "focus", "blur", "keydown.enter", "placeholder", "formControl", "ngClass"], ["type", "button", 1, "hmf-pl-xxs", "hmf-pr-xs", 3, "click", "keydown.enter", "keydown.space"], ["width", "16px", "height", "16px", 1, "date-picker-input-icon", 3, "name"], [1, "hmf-mb-0", "hmf-mt-xxxs", "hmf-ml-xs", "hmf-legal-xs"], [1, "date-picker__error", "hmf-legal-xs"], [1, "label-negative"], ["data-testid", "open-modal", 1, "date-picker-menu", "hmf-position-absolute", 3, "ngClass"], [3, "size", "pastDatesExcluded", "invalidDateRange", "invalidDateList", "recurringDisabledDates", "allowFutureYears", "currentlySelectedDate"], [3, "selectedTime", "size", "showTimezone", "timezoneLabel", "intervalMinutes", "use24HourFormat", "disabledTimeRanges"], [3, "dateSelected", "isFocused", "size", "pastDatesExcluded", "invalidDateRange", "invalidDateList", "recurringDisabledDates", "allowFutureYears", "currentlySelectedDate"], [3, "timeSelected", "selectedTime", "size", "showTimezone", "timezoneLabel", "intervalMinutes", "use24HourFormat", "disabledTimeRanges"]],
        template: function HmfDatePickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, HmfDatePickerComponent_Conditional_1_Template, 2, 6, "label", 2);
            i0.ɵɵelementStart(2, "div", 3)(3, "div", 4);
            i0.ɵɵtemplate(4, HmfDatePickerComponent_Conditional_4_Template, 2, 8, "label", 5);
            i0.ɵɵelementStart(5, "div", 6)(6, "input", 7, 0);
            i0.ɵɵlistener("focus", function HmfDatePickerComponent_Template_input_focus_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocus($event));
            })("blur", function HmfDatePickerComponent_Template_input_blur_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onBlur($event));
            })("keydown.enter", function HmfDatePickerComponent_Template_input_keydown_enter_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleEnterKey($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "button", 8);
            i0.ɵɵlistener("click", function HmfDatePickerComponent_Template_button_click_8_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.togglePicker());
            })("keydown.enter", function HmfDatePickerComponent_Template_button_keydown_enter_8_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.togglePicker());
            })("keydown.space", function HmfDatePickerComponent_Template_button_keydown_space_8_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.togglePicker());
            });
            i0.ɵɵelement(9, "homefield-icon", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(10, HmfDatePickerComponent_Conditional_10_Template, 2, 2, "p", 10);
            i0.ɵɵelementStart(11, "div", 11);
            i0.ɵɵtemplate(12, HmfDatePickerComponent_Conditional_12_Template, 3, 1, "div", 12);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(13, HmfDatePickerComponent_Conditional_13_Template, 3, 4, "div", 13);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("date-picker hmf-mt-xs ", ctx.className(), "");
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.activeFloatingLabel() ? 1 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("error", ctx.hasErrors);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.activeFloatingLabel() ? 4 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("error", ctx.hasErrors);
            i0.ɵɵproperty("placeholder", ctx.placeholder())("formControl", ctx.dateControl)("ngClass", i0.ɵɵpureFunction1(20, _c68, !ctx.activeFloatingLabel()));
            i0.ɵɵattribute("id", "datepicker-input-" + ctx.id())("aria-label", "homefield-textinput")("aria-labelledby", "datepicker-input-label-" + ctx.id());
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("aria-label", ctx.isDateType() ? ctx.ariaLabels.DATE : ctx.ariaLabels.TIME);
            i0.ɵɵadvance();
            i0.ɵɵproperty("name", ctx.iconName());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.helperText() ? 10 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.hasErrors ? 12 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showCalendar() ? 13 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, ReactiveFormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.FormControlDirective, HmfDateMenuComponent, HmfTimeMenuComponent, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: [".date-picker-menu[_ngcontent-%COMP%]{left:0;top:45px;width:max-content;z-index:1000}.date-picker-menu.time-picker[_ngcontent-%COMP%], .date-picker-input[_ngcontent-%COMP%]{width:100%}.date-picker-input[_ngcontent-%COMP%]:hover   label.date-picker-input-label[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-subtle-hover)}.date-picker-input[_ngcontent-%COMP%]:hover   .date-picker-input-wrapper[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-subtle-hover);box-shadow:inset 0 0 0 1px var(--hmf-border-secondary-subtle-hover)}.date-picker-input[_ngcontent-%COMP%]:hover   .date-picker-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-subtle-hover)}.date-picker-input[_ngcontent-%COMP%]:hover   .date-picker-input-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-subtle-hover)}.date-picker-input[_ngcontent-%COMP%]:has(input:focus)   label.date-picker-input-label[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-subtle-active)}.date-picker-input[_ngcontent-%COMP%]:has(input:disabled)   label.date-picker-input-label[_ngcontent-%COMP%]{background-color:var(--hmf-fill-disabled-subtle);color:var(--hmf-label-disabled)}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-secondary-subtle-static);border-radius:var(--hmf-sharp-radius);box-sizing:border-box;height:45px;min-width:0;transition:background-color var(--hmf-ease-in-out-fast),border var(--hmf-ease-in-out-fast),box-shadow var(--hmf-ease-in-out-fast);width:100%}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]:has(input:focus){border:1px solid var(--hmf-border-secondary-subtle-active);box-shadow:none}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]:has(input:focus)   input[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-subtle-active)}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]:has(input:focus)   button[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-secondary-subtle-active)}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]:has(input:disabled){background-color:var(--hmf-fill-disabled-subtle);border:1px solid var(--hmf-border-disabled);box-shadow:none}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]:has(input:disabled)   input[_ngcontent-%COMP%]{color:var(--hmf-label-disabled)}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]:has(input:disabled)   button[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-disabled)}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]:has(input:disabled)   button[_ngcontent-%COMP%]{cursor:default}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background-color:transparent;border:none;cursor:pointer;height:100%;width:36px}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-border-secondary-subtle-static)}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]{background-color:transparent;border:none;box-sizing:border-box;color:var(--hmf-label-secondary-subtle-active);font-family:var(--hmf-text-input-font-family);font-size:var(--hmf-text-input-font-size);font-weight:var(--hmf-text-input-font-weight);height:100%;letter-spacing:var(--hmf-text-input-letter-spacing);line-height:var(--hmf-text-input-line-height);width:calc(100% - 36px)}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]::placeholder{color:transparent;transition:color var(--hmf-ease-out-fast)}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%] > input.fixed-label[_ngcontent-%COMP%]::placeholder{color:var(--hmf-label-secondary-subtle-static)}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]:focus::placeholder{color:var(--hmf-label-secondary-subtle-static)}.date-picker-input[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]:focus-visible{outline:none}.date-picker-input[_ngcontent-%COMP%] > label.date-picker-input-label[_ngcontent-%COMP%]{color:var(--hmf-label-secondary-subtle-static);cursor:text;left:1rem;margin-bottom:var(--hmf-xxxs);overflow:hidden;text-overflow:ellipsis;top:.85em;transition:top .3s ease,font-size .3s ease,color .3s ease;white-space:nowrap}.date-picker-input[_ngcontent-%COMP%]   label.shrink[_ngcontent-%COMP%]{color:var(--hmf-label-base);left:.75rem;top:0!important;transform:translateY(-50%)}.date-picker-input[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{color:var(--hmf-label-base);font-size:11px;line-height:14px;margin-top:var(--hmf-xxxs)}.date-picker-input.error[_ngcontent-%COMP%]:has(input:focus)   label.date-picker-input-label[_ngcontent-%COMP%], .date-picker-input.error[_ngcontent-%COMP%]   label.date-picker-input-label[_ngcontent-%COMP%]{color:var(--hmf-text-input-error-label-color)}.date-picker-input.error[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{color:var(--hmf-label-negative)}.date-picker-input.error[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]{background-color:var(--hmf-fill-negative-subtle);border:1px solid var(--hmf-border-negative);box-shadow:none}.date-picker-input.error[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-border-negative)}.date-picker-input.error[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]:has(input:focus){border:1px solid var(--hmf-border-negative)}.date-picker-input.error[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]:has(input:focus)   button[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--hmf-label-negative)}.date-picker-input.error[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .date-picker-input.error[_ngcontent-%COMP%]   .date-picker-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{color:var(--hmf-label-negative)}label.default-background[_ngcontent-%COMP%]{background-color:var(--hmf-background-base)}label.error[_ngcontent-%COMP%]{color:var(--hmf-text-input-error-label-color)}label.error-background[_ngcontent-%COMP%]{background-color:var(--hmf-fill-negative-subtle)}"]
      });
    }
  }
  return HmfDatePickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
var QuantityStepperVariant = /*#__PURE__*/function (QuantityStepperVariant) {
  QuantityStepperVariant["SMALL"] = "small";
  QuantityStepperVariant["MEDIUM"] = "medium";
  return QuantityStepperVariant;
}(QuantityStepperVariant || {});
let HmfQuantityStepperComponent = /*#__PURE__*/(() => {
  class HmfQuantityStepperComponent {
    constructor(homefieldIconsLibraryService) {
      this.size = input(QuantityStepperVariant.MEDIUM);
      this.minCount = input(1);
      this.maxCount = input(99);
      this.initialCount = input(0);
      this.isTrashIconEnabled = input(false);
      this.isDecrementButtonDisabled = input(false);
      this.isIncrementButtonDisabled = input(false);
      this.disabled = input(false);
      this.hmfIconSize = '16px';
      this.countChange = output();
      this.openConfirmationModal = output();
      this.count = signal(1);
      this.isInputFocused = signal(false);
      this.disableDecrementButton = signal(false);
      this.clampedCount = computed(() => {
        return this.count();
      });
      this.decrementButtonName = computed(() => {
        return this.isTrashIconEnabled() && this.count() === this.minCount() ? homefieldIconDeleteOutlined.name : homefieldIconSignSubtract.name;
      });
      this.isDecrementButtonDisabledComputed = computed(() => {
        return this.isDecrementButtonDisabled() || this.disableDecrementButton() || this.isDisabled() || this.count() < this.minCount();
      });
      this.isIncrementButtonDisabledComputed = computed(() => {
        return this.isIncrementButtonDisabled() || this.isDisabled() || this.count() >= this.maxCount();
      });
      this.isDisabled = computed(() => this.disabled() || this.formDisabled());
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      this.onChange = () => {};
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      this.onTouched = () => {};
      this.formDisabled = signal(false);
      homefieldIconsLibraryService.registerIcons([homefieldIconDeleteOutlined, homefieldIconSignSubtract, homefieldIconSignAdd]);
      this.initializeParams();
      effect(() => {
        this.countChange.emit(this.clampedCount());
      });
    }
    onInputChange(event) {
      const inputElement = event.target;
      let raw = inputElement.value;
      raw = raw.replace(/^0+(?=\d)/, '');
      inputElement.value = raw;
      const num = raw === '' ? null : +raw;
      if (num !== null) {
        this.count.set(num);
        this.emitValue();
      }
    }
    onFocus() {
      this.isInputFocused.set(true);
    }
    onBlur() {
      this.isInputFocused.set(false);
      this.onTouched();
    }
    increment(event) {
      event.stopPropagation();
      event.preventDefault();
      if (this.isIncrementButtonDisabledComputed()) {
        return;
      }
      if (this.count() < this.maxCount()) {
        this.updateCount(this.count() + 1);
      }
      this.disableDecrementButton.set(false);
    }
    decrement(event) {
      event.stopPropagation();
      event.preventDefault();
      if (this.isDecrementButtonDisabledComputed()) {
        return;
      }
      const clampedCount = this.clampedCount();
      if (this.shouldOpenConfirmationModal(clampedCount)) {
        this.openConfirmationModal.emit();
        this.disableDecrementButton.set(true);
        return;
      }
      this.updateCount(clampedCount - 1);
    }
    filterKey(event) {
      const ctrlKeys = ['Escape', 'Home', 'End', '+', '-', ',', '.'];
      if (ctrlKeys.includes(event.key)) {
        event.stopPropagation();
        event.preventDefault();
      }
    }
    filterPaste(event) {
      const text = event.clipboardData?.getData('text') ?? '';
      if (!/^\d+$/.test(text)) {
        event.preventDefault();
        return;
      }
      const value = +text;
      if (value < this.minCount()) {
        event.preventDefault();
      }
    }
    writeValue(value) {
      if (value !== undefined) {
        this.count.set(value);
      }
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    validate(control) {
      if (control.value < this.minCount()) {
        return {
          outOfRange: true
        };
      }
      return null;
    }
    setDisabledDecrementButtonState(isDisabled) {
      this.disableDecrementButton.set(isDisabled);
    }
    setDisabledState(isDisabled) {
      this.formDisabled.set(isDisabled);
      if (this.ngModel?.control) {
        isDisabled ? this.ngModel.control.disable({
          emitEvent: false,
          onlySelf: true
        }) : this.ngModel.control.enable({
          emitEvent: false,
          onlySelf: true
        });
      }
    }
    checkIsDisabled() {
      return {
        disabled: this.isDisabled()
      };
    }
    fillOutDecrementButton() {
      return this.isDecrementButtonDisabledComputed() ? 'var(--hmf-gray300)' : 'var(--hmf-button-tertiary-text-color)';
    }
    fillOutIncrementButton() {
      return this.isIncrementButtonDisabledComputed() ? 'var(--hmf-gray300)' : 'var(--hmf-button-tertiary-text-color)';
    }
    emitValue() {
      this.onChange(this.clampedCount());
      this.onTouched();
    }
    updateCount(value) {
      if (value < 0) {
        this.count.set(0);
        return;
      }
      if (this.isTrashIconEnabled() && value < Math.min(1, this.minCount())) {
        this.count.set(Math.min(1, this.minCount()));
        return;
      }
      if (!this.isTrashIconEnabled() && value === 0) {
        this.disableDecrementButton.set(true);
        this.openConfirmationModal.emit();
      }
      this.count.set(value);
      this.emitValue();
    }
    initializeParams() {
      const init = this.initialCount();
      this.count.set(init <= 1 ? 1 : init);
      this.emitValue();
    }
    shouldOpenConfirmationModal(value) {
      return !this.isTrashIconEnabled() && value === 0 || this.isTrashIconEnabled() && value === 1;
    }
    static {
      this.ɵfac = function HmfQuantityStepperComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfQuantityStepperComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfQuantityStepperComponent,
        selectors: [["hmf-quantity-stepper"]],
        viewQuery: function HmfQuantityStepperComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c72, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ngModel = _t.first);
          }
        },
        inputs: {
          size: [1, "size"],
          minCount: [1, "minCount"],
          maxCount: [1, "maxCount"],
          initialCount: [1, "initialCount"],
          isTrashIconEnabled: [1, "isTrashIconEnabled"],
          isDecrementButtonDisabled: [1, "isDecrementButtonDisabled"],
          isIncrementButtonDisabled: [1, "isIncrementButtonDisabled"],
          disabled: [1, "disabled"]
        },
        outputs: {
          countChange: "countChange",
          openConfirmationModal: "openConfirmationModal"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: HmfQuantityStepperComponent,
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: HmfQuantityStepperComponent,
          multi: true
        }])],
        decls: 7,
        vars: 26,
        consts: [["quantityInput", "ngModel"], [1, "hmf-display-flex", "hmf-justify-content-evenly", "hmf-align-items-center", "quantity-stepper__container", 3, "ngClass"], ["tabindex", "0", 1, "hmf-display-flex", "hmf-justify-content-center", "hmf-align-items-center", "decrement-button", 3, "click", "disabled", "ngClass"], [1, "hmf-icon", 3, "width", "height", "name", "fill"], ["name", "quantityInput", "type", "number", 1, "hmf-display-flex", "hmf-justify-content-center", "hmf-align-items-center", "quantity-input", 3, "blur", "focus", "keyup", "keydown", "paste", "change", "disabled", "ngModel", "ngClass"], ["tabindex", "0", 1, "hmf-display-flex", "hmf-justify-content-center", "hmf-align-items-center", "increment-button", 3, "click", "disabled", "ngClass"], ["name", "sign-add", 1, "hmf-icon", 3, "width", "height", "fill"]],
        template: function HmfQuantityStepperComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "fieldset", 1)(1, "button", 2);
            i0.ɵɵlistener("click", function HmfQuantityStepperComponent_Template_button_click_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.decrement($event));
            });
            i0.ɵɵelement(2, "homefield-icon", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "input", 4, 0);
            i0.ɵɵlistener("blur", function HmfQuantityStepperComponent_Template_input_blur_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onBlur());
            })("focus", function HmfQuantityStepperComponent_Template_input_focus_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocus());
            })("keyup", function HmfQuantityStepperComponent_Template_input_keyup_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.filterKey($event));
            })("keydown", function HmfQuantityStepperComponent_Template_input_keydown_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.filterKey($event));
            })("paste", function HmfQuantityStepperComponent_Template_input_paste_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.filterPaste($event));
            })("change", function HmfQuantityStepperComponent_Template_input_change_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onInputChange($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "button", 5);
            i0.ɵɵlistener("click", function HmfQuantityStepperComponent_Template_button_click_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.increment($event));
            });
            i0.ɵɵelement(6, "homefield-icon", 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("input-focused", ctx.isInputFocused());
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(23, _c73, ctx.size() === "medium", ctx.size() === "small"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.isDecrementButtonDisabledComputed())("ngClass", ctx.checkIsDisabled());
            i0.ɵɵattribute("aria-label", "Decrement Quantity")("aria-disabled", ctx.isDecrementButtonDisabledComputed());
            i0.ɵɵadvance();
            i0.ɵɵproperty("width", ctx.hmfIconSize)("height", ctx.hmfIconSize)("name", ctx.decrementButtonName())("fill", ctx.fillOutDecrementButton());
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.isDisabled())("ngModel", ctx.count())("ngClass", ctx.checkIsDisabled());
            i0.ɵɵattribute("aria-label", "Quantity input")("min", ctx.minCount());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.isIncrementButtonDisabledComputed())("ngClass", ctx.checkIsDisabled());
            i0.ɵɵattribute("aria-label", "Increment Quantity")("aria-disabled", ctx.isIncrementButtonDisabledComputed());
            i0.ɵɵadvance();
            i0.ɵɵproperty("width", ctx.hmfIconSize)("height", ctx.hmfIconSize)("fill", ctx.fillOutIncrementButton());
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent, FormsModule, i2.DefaultValueAccessor, i2.NumberValueAccessor, i2.NgControlStatus, i2.NgModel],
        styles: [".quantity-stepper__container[_ngcontent-%COMP%]{align-items:center!important;background:var(--hmf-fill-secondary-static);border:1px solid var(--hmf-border-secondary-subtle-static);border-radius:var(--hmf-round-radius);display:flex!important;max-height:none!important;min-width:auto!important;padding:var(--hmf-xxxxs) var(--hmf-xxs)}.quantity-stepper__container[_ngcontent-%COMP%]:hover{background:var(--hmf-fill-base);border:1px solid var(--hmf-border-secondary-subtle-hover)}.quantity-stepper__container[_ngcontent-%COMP%]:active{background:var(--hmf-fill-base);border:1px solid var(--hmf-border-secondary-subtle-active)}.quantity-stepper__container.input-focused[_ngcontent-%COMP%]{background:var(--hmf-fill-base);border:2px solid var(--hmf-border-secondary-subtle-active)}.quantity-stepper__container[_ngcontent-%COMP%]   .decrement-button[_ngcontent-%COMP%], .quantity-stepper__container[_ngcontent-%COMP%]   .increment-button[_ngcontent-%COMP%]{border-radius:var(--hmf-round-radius);background-color:var(--hmf-fill-base);border:none}.quantity-stepper__container[_ngcontent-%COMP%]   .decrement-button[_ngcontent-%COMP%]:focus, .quantity-stepper__container[_ngcontent-%COMP%]   .increment-button[_ngcontent-%COMP%]:focus{outline:none;outline-offset:0}.quantity-stepper__container[_ngcontent-%COMP%]   .decrement-button[_ngcontent-%COMP%]:focus-visible, .quantity-stepper__container[_ngcontent-%COMP%]   .increment-button[_ngcontent-%COMP%]:focus-visible{background-color:var(--hmf-fill-secondary-active)}.quantity-stepper__container[_ngcontent-%COMP%]   .decrement-button[_ngcontent-%COMP%]:hover, .quantity-stepper__container[_ngcontent-%COMP%]   .increment-button[_ngcontent-%COMP%]:hover{background-color:var(--hmf-fill-secondary-hover);border-radius:var(--hmf-round-radius)}.quantity-stepper__container[_ngcontent-%COMP%]   .decrement-button[_ngcontent-%COMP%]:active, .quantity-stepper__container[_ngcontent-%COMP%]   .increment-button[_ngcontent-%COMP%]:active{background-color:var(--hmf-fill-secondary-active);border-radius:var(--hmf-round-radius)}.quantity-stepper__container[_ngcontent-%COMP%]   .decrement-button.disabled[_ngcontent-%COMP%], .quantity-stepper__container[_ngcontent-%COMP%]   .increment-button.disabled[_ngcontent-%COMP%]{background:var(--hmf-fill-base)}.quantity-stepper__container[_ngcontent-%COMP%]   .decrement-button[_ngcontent-%COMP%]   .hmf-icon[_ngcontent-%COMP%], .quantity-stepper__container[_ngcontent-%COMP%]   .decrement-button[_ngcontent-%COMP%]   homefield-icon[_ngcontent-%COMP%], .quantity-stepper__container[_ngcontent-%COMP%]   .increment-button[_ngcontent-%COMP%]   .hmf-icon[_ngcontent-%COMP%], .quantity-stepper__container[_ngcontent-%COMP%]   .increment-button[_ngcontent-%COMP%]   homefield-icon[_ngcontent-%COMP%]{align-items:center!important;display:flex!important;height:16px;justify-content:center!important;width:16px}.quantity-stepper__container[_ngcontent-%COMP%]   input[type=number][_ngcontent-%COMP%]{appearance:textfield}.quantity-stepper__container[_ngcontent-%COMP%]   input[type=number][_ngcontent-%COMP%]::-webkit-inner-spin-button, .quantity-stepper__container[_ngcontent-%COMP%]   input[type=number][_ngcontent-%COMP%]::-webkit-outer-spin-button{appearance:none;margin:0}.quantity-stepper__container[_ngcontent-%COMP%]   .quantity-input[_ngcontent-%COMP%]{border:none;flex-shrink:0;outline:none;padding:0 var(--hmf-xxxs);text-align:center;height:40px;max-height:40px;max-width:54px;min-height:40px;min-width:54px;width:54px}.quantity-stepper__container[_ngcontent-%COMP%]   .quantity-input.focus[_ngcontent-%COMP%]{font-size:var(--body-font-size-l)}.quantity-stepper__container[_ngcontent-%COMP%]   .quantity-input.disabled[_ngcontent-%COMP%]{background-color:var(--hmf-fill-base);color:var(--hmf-label-disabled-subtle);cursor:not-allowed}.quantity-stepper__container--small[_ngcontent-%COMP%]{height:28px;max-height:28px;max-width:102px;min-height:28px;min-width:102px;width:102px;height:28px!important;max-height:28px!important;min-height:28px!important}.quantity-stepper__container--small[_ngcontent-%COMP%]   .decrement-button[_ngcontent-%COMP%], .quantity-stepper__container--small[_ngcontent-%COMP%]   .increment-button[_ngcontent-%COMP%]{gap:10px;height:24px!important;padding:var(--hmf-0);width:28px}.quantity-stepper__container--small[_ngcontent-%COMP%]   .quantity-input[_ngcontent-%COMP%]{height:24px;max-height:24px;max-width:30px;min-height:24px;min-width:30px;width:30px;height:24px!important;max-height:24px!important;min-height:24px!important}.quantity-stepper__container--medium[_ngcontent-%COMP%]{height:40px;max-height:40px;max-width:142px;min-height:40px;min-width:142px;width:142px}.quantity-stepper__container--medium[_ngcontent-%COMP%]   .decrement-button[_ngcontent-%COMP%], .quantity-stepper__container--medium[_ngcontent-%COMP%]   .increment-button[_ngcontent-%COMP%]{height:40px;max-height:40px;max-width:40px;min-height:40px;min-width:40px;width:40px;font-size:var(--hmf-s)}"],
        changeDetection: 0
      });
    }
  }
  return HmfQuantityStepperComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */

/** @format */

/** @format */

/** @format */

/** @format */

/** @format */
let HmfScrollbarComponent = /*#__PURE__*/(() => {
  class HmfScrollbarComponent {
    constructor(cd) {
      this.cd = cd;
      this.isDragging = false;
      this.dragStart = 0; // Initial Drag Position
    }
    /**
     * @description Lifecycle hook that is called after a component's view has been fully initialized.
     * Sets up event listeners for scroll and drag events.
     */
    ngAfterViewInit() {
      // Scroll Event Listener For Scrollable Content
      this.scrollContent.addEventListener('scroll', this.onContentScroll.bind(this));
      // Add mouse and touch event listeners for dragging the scrollbar thumb
      // Desktop
      // Start drag on scrollbar thumb
      this.scrollbarThumbRef.nativeElement.addEventListener('mousedown', this.onThumbDragStart.bind(this));
      // Move scrollbar thumb position
      window.addEventListener('mousemove', this.onThumbDrag.bind(this));
      // End Drag
      window.addEventListener('mouseup', this.onThumbDragEnd.bind(this));
      // Mobile
      // Start drag on scrollbar thumb
      this.scrollbarThumbRef.nativeElement.addEventListener('touchstart', this.onThumbDragStart.bind(this), {
        passive: true
      });
      // Move scrollbar thumb position
      window.addEventListener('touchmove', this.onThumbDrag.bind(this));
      // End drag
      window.addEventListener('touchend', this.onThumbDragEnd.bind(this));
    }
    ngOnDestroy() {
      // Remove event listeners when the component is destroyed
      this.scrollContent.removeEventListener('scroll', this.onContentScroll.bind(this));
      window.removeEventListener('mousemove', this.onThumbDrag.bind(this));
      window.removeEventListener('mouseup', this.onThumbDragEnd.bind(this));
      window.removeEventListener('touchmove', this.onThumbDrag.bind(this));
      window.removeEventListener('touchend', this.onThumbDragEnd.bind(this));
    }
    /**
     * @description Handles click events on the scrollbar track.
     * Moves the scrollbar thumb to the clicked position.
     *
     * @param event MouseEvent - The click event.
     */
    onScrollbarTrackClick(event) {
      // Get the click position relative to the track
      const clickPosition = event.offsetX - this.scrollbarTrackRef.nativeElement.offsetLeft;
      // Get the thumb width and track width
      const thumbWidth = this.scrollbarThumbRef.nativeElement.clientWidth;
      const trackWidth = this.scrollbarTrackRef.nativeElement.clientWidth;
      // Calculate the movement of the click relative to the thumb width
      const clickMovement = clickPosition - thumbWidth / 2;
      // Calculate the maximum thumb position based on the track and thumb width
      const maxThumbPosition = trackWidth - thumbWidth;
      // Calculate the new thumb position based on the click position
      const newThumbPosition = Math.min(clickMovement, maxThumbPosition);
      // Updating the content carousel position will automatically update the thumb position
      this.updateCarouselPosition(newThumbPosition);
    }
    /**
     * @description Handles the start of a drag event on the scrollbar thumb.
     *
     * @param event MouseEvent | TouchEvent - The drag start event.
     */
    onThumbDragStart(event) {
      event.preventDefault();
      // Set the dragging flag to true when the drag event starts
      this.isDragging = true;
      // Get the initial drag position relative to the thumb
      this.dragStart = this.getClientX(event) - this.scrollbarThumbRef.nativeElement.offsetLeft;
      this.cd.detectChanges();
    }
    /**
     * @description Moves the scrollbar thumb based on the drag movement.
     * @param event MouseEvent | TouchEvent - The drag event.
     */
    onThumbDrag(event) {
      if (this.isDragging) {
        event.preventDefault();
        this.scrollContent.style.scrollSnapType = 'none';
        // Get the new mouse position relative to the track
        const newMousePosition = this.getClientX(event) - this.scrollbarTrackRef.nativeElement.offsetLeft;
        // Calculate the movement of the mouse relative to the initial drag position
        const mouseMovement = newMousePosition - this.dragStart;
        // Get the thumb width and track width
        const thumbWidth = this.scrollbarThumbRef.nativeElement.clientWidth;
        const trackWidth = this.scrollbarTrackRef.nativeElement.clientWidth;
        // Calculate the maximum thumb position based on the track and thumb width
        const maxThumbPosition = trackWidth - thumbWidth;
        // Calculate the new thumb position based on the mouse movement
        const newThumbPosition = Math.max(0, Math.min(mouseMovement, maxThumbPosition));
        // Update the carousel position based on the new thumb position
        this.updateCarouselPosition(newThumbPosition);
      }
    }
    /**
     * @description Handles the end of a drag event on the scrollbar thumb.
     */
    onThumbDragEnd() {
      // Reset the dragging flag to false when the drag event ends
      this.isDragging = false;
      this.scrollContent.style.scrollSnapType = 'x mandatory'; // Snap to the nearest child element
      this.cd.detectChanges();
    }
    /**
     * @description Handles the scroll event on the scrollable content.
     * Updates the position of the scrollbar thumb.
     */
    onContentScroll() {
      // Update the thumb position when the content is scrolled
      this.updateThumbPosition();
    }
    /**
     * @description Updates the position of the scrollable content based on the thumb position.
     * @param thumbPosition number - The new position of the scrollbar thumb.
     */
    updateCarouselPosition(thumbPosition) {
      // Get the content carousel, scrollbar track, and scrollbar thumb elements
      const carousel = this.scrollContent;
      const scrollbarTrack = this.scrollbarTrackRef.nativeElement;
      const scrollbarThumb = this.scrollbarThumbRef.nativeElement;
      // Calculate the maximum thumb position based on the track and thumb width
      const maxThumbPosition = scrollbarTrack.clientWidth - scrollbarThumb.clientWidth;
      // Calculate the scroll percentage based on the thumb position and the maximum thumb position
      const scrollPercentage = thumbPosition / maxThumbPosition;
      // Calculate the maximum scroll position based on the content width and the viewport width
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      // Get the current scroll behavior
      const scrollBehavior = carousel.style.scrollBehavior;
      // Disable smooth scrolling while updating the scroll position
      carousel.style.scrollBehavior = 'auto';
      // Update the scroll position based on the scroll percentage and the maximum scroll position
      carousel.scrollLeft = scrollPercentage * maxScroll;
      // Re-enable smooth scrolling after updating the scroll position
      carousel.style.scrollBehavior = scrollBehavior;
    }
    /**
     * @description Updates the position of the scrollbar thumb based on the scroll position of the content.
     */
    updateThumbPosition() {
      // Get the content carousel, scrollbar track, and scrollbar thumb elements
      const carousel = this.scrollContent;
      const scrollbarTrack = this.scrollbarTrackRef.nativeElement;
      const scrollbarThumb = this.scrollbarThumbRef.nativeElement;
      // Get the current scroll position of the content carousel
      const scrollPosition = carousel.scrollLeft;
      // Calculate the scroll percentage based on the scroll position and the maximum scroll position
      const scrollPercentage = scrollPosition / (carousel.scrollWidth - carousel.clientWidth);
      // Calculate the maximum thumb position based on the track and thumb width
      const maxThumbPosition = scrollbarTrack.clientWidth - scrollbarThumb.clientWidth;
      // Update the thumb position based on the scroll percentage and the maximum thumb position
      this.thumbPosition = scrollPercentage * maxThumbPosition;
      this.cd.detectChanges();
    }
    /**
     * @description Get the clientX position of the event (mouse or touch)
     * Mouse: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/clientX
     * Touch: https://developer.mozilla.org/en-US/docs/Web/API/Touch/clientX
     * @param event MouseEvent | TouchEvent
     * @returns number The clientX position of the event
     */
    getClientX(event) {
      // Get the clientX position of the event (mouse or touch)
      return event?.clientX || event?.touches[0]?.clientX || 0;
    }
    static {
      this.ɵfac = function HmfScrollbarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfScrollbarComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfScrollbarComponent,
        selectors: [["hmf-scrollbar"]],
        viewQuery: function HmfScrollbarComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c74, 5);
            i0.ɵɵviewQuery(_c75, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollbarTrackRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollbarThumbRef = _t.first);
          }
        },
        inputs: {
          scrollContent: "scrollContent"
        },
        decls: 5,
        vars: 6,
        consts: [["scrollbarTrack", ""], ["scrollbarThumb", ""], [1, "hmf-carousel-progress", "hmf-display-flex", "hmf-align-items-center", "hmf-py-xs", "hmf-px-s", 3, "click"], [1, "hmf-carousel-progress-indicator", "hmf-position-absolute"], [1, "hmf-carousel-progress-indicator-bar", 3, "ngClass", "ngStyle"]],
        template: function HmfScrollbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵlistener("click", function HmfScrollbarComponent_Template_div_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onScrollbarTrackClick($event));
            });
            i0.ɵɵelementStart(1, "div", 3, 0);
            i0.ɵɵelement(3, "div", 4, 1);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c76, ctx.isDragging))("ngStyle", i0.ɵɵpureFunction1(4, _c77, ctx.thumbPosition + "px"));
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgStyle],
        styles: [".hmf-carousel-progress-indicator[_ngcontent-%COMP%]{background-color:var(--hmf-gray200);border-radius:100vh;height:2px;top:50%;transform:translateY(-50%);width:100%}.hmf-carousel-progress-indicator-bar[_ngcontent-%COMP%]{background-color:var(--hmf-background-inverse);border-radius:100vh;cursor:grab;height:100%;position:relative;transition:transform .3s ease;width:40%}.hmf-carousel-progress[_ngcontent-%COMP%]{cursor:pointer;pointer-events:all;position:relative;width:100%}.hmf-carousel-progress[_ngcontent-%COMP%]:hover   .hmf-carousel-progress-indicator[_ngcontent-%COMP%]{height:4px}.hmf-carousel-progress[_ngcontent-%COMP%]:active   .hmf-carousel-progress-indicator[_ngcontent-%COMP%]{height:6px}.hmf-carousel-progress[_ngcontent-%COMP%]:focus   .hmf-carousel-progress-indicator-bar[_ngcontent-%COMP%]{height:8px;outline:dashed var(--hmf-border-negative)}.hmf-carousel-progress-indicator-bar-dragging[_ngcontent-%COMP%]{cursor:grabbing}"]
      });
    }
  }
  return HmfScrollbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfCarouselComponent = /*#__PURE__*/(() => {
  class HmfCarouselComponent {
    constructor(homefieldIconsLibraryService, cd) {
      this.cd = cd;
      this.showHeader = true;
      this.showTitle = true;
      this.showSubtitle = true;
      this.showActionButton = true;
      this.showScrollButtons = true;
      this.showScrollbar = false;
      this.showScrollButtonsOnMobile = false;
      this.title = '';
      this.subtitle = '';
      this.actionButtonTitle = '';
      this.gapSize = 'xs'; // Default: 12px
      this.horizontalPadding = 'xs'; // Default: 12px
      this.actionButtonClicked = new EventEmitter();
      this.showScrollRight = true;
      this.showScrollLeft = false;
      this.skipListing = false;
      this.pixelBuffer = 20; // 20px buffer
      homefieldIconsLibraryService.registerIcons([homefieldIconChevronLeft, homefieldIconChevronRight]);
    }
    /**
     * @description Gets the CSS custom property value for the gap size.
     * @returns The complete CSS custom property value for the gap.
     */
    get gapValue() {
      return `var(--hmf-${this.gapSize})`;
    }
    /**
     * @description Gets the CSS class name for horizontal padding.
     * @returns The complete CSS class name for horizontal padding.
     */
    get horizontalPaddingClass() {
      return `hmf-px-${this.horizontalPadding}`;
    }
    /**
     * @description Lifecycle hook that is called after a component's view has been fully initialized.
     * Sets up event listeners for scroll and resize events.
     */
    ngAfterViewInit() {
      this.handleShowOverflow();
      this.listenForCarouselContentChanges();
      // Add event listeners for scroll and resize events
      window.addEventListener('resize', this.handleShowOverflow.bind(this));
      this.carouselContent.nativeElement.addEventListener('scroll', this.checkScrollPositions.bind(this));
      // Detect changes to the carousel content
      this.cd.detectChanges();
    }
    ngOnDestroy() {
      // Remove event listeners when the component is destroyed
      window.removeEventListener('resize', this.handleShowOverflow.bind(this));
      this.carouselContent.nativeElement.removeEventListener('scroll', this.checkScrollPositions.bind(this));
      // Disconnect the observer
      this.observer.disconnect();
    }
    /**
     * @description Scrolls the carousel content to the right by 200px.
     */
    scrollRight() {
      // Get the leftmost visible carousel child element and scroll its width to the right
      const cards = this.carouselContent.nativeElement.children;
      const currentCardIndex = Array.from(cards).findIndex(el => el.getBoundingClientRect().x >= 0);
      const cardWidth = cards[currentCardIndex].getBoundingClientRect().width;
      this.carouselContent.nativeElement.scrollLeft += cardWidth;
      // If you can scroll right, you can scroll left
      this.showScrollLeft = true;
      this.cd.markForCheck();
    }
    /**
     * @description Scrolls the carousel content to the left by 200px.
     */
    scrollLeft() {
      // Get the leftmost visible carousel child element and scroll its width to the right
      const cards = this.carouselContent.nativeElement.children;
      const currentCardIndex = Array.from(cards).findIndex(el => el.getBoundingClientRect().x >= 0);
      const cardWidth = cards[currentCardIndex > 0 ? currentCardIndex - 1 : 0].getBoundingClientRect().width;
      this.carouselContent.nativeElement.scrollLeft -= cardWidth;
      // If you can scroll left, you can scroll right
      this.showScrollRight = true;
      this.cd.detectChanges();
    }
    /**
     * @description Handles showing the overflow of the carousel content.
     * If the content is wider than the container, show the scrollbar and the scroll buttons.
     */
    handleShowOverflow() {
      // Get the width of the content and the container
      const contentWidth = this.carouselContent.nativeElement.clientWidth;
      const containerWidth = this.carouselContent.nativeElement.scrollWidth;
      // Show scrollbar if content is wider than container by 20px
      this.showScrollbar = containerWidth - contentWidth > this.pixelBuffer; // 20px buffer
      // If scrollbar is shown, check if it's at the end
      this.showScrollRight = this.showScrollbar && this.carouselContent.nativeElement.scrollLeft < this.carouselContent.nativeElement.scrollWidth - this.carouselContent.nativeElement.clientWidth;
      this.showScrollLeft = this.showScrollbar && this.carouselContent.nativeElement.scrollLeft > 0;
      // Set overflow style based on showScrollbar
      this.carouselContent.nativeElement.style.overflowX = this.showScrollbar ? 'scroll' : 'hidden';
      // Set scroll snap end for each child if scrollbar is shown
      if (this.showScrollbar) {
        // Get carousel content children
        for (const child of this.carouselContent.nativeElement.children) {
          // Add scroll snap start to each child
          child.style.scrollSnapAlign = 'start';
          child.style.scrollMarginLeft = this.pixelBuffer + 'px'; // 20px buffer
        }
      }
      this.cd.detectChanges();
    }
    listenForCarouselContentChanges() {
      // Set up a MutationObserver to detect changes to the carousel content
      this.observer = new MutationObserver(() => {
        // Check if the carousel content is overflowing
        this.handleShowOverflow();
      });
      // Observe the carousel content for changes
      this.observer.observe(this.carouselContent.nativeElement, {
        childList: true,
        subtree: true
      });
    }
    /**
     * @description Checks the scroll positions of the carousel content.
     * If the scroll position is at the end of the content, hide the scroll button for that direction.
     */
    checkScrollPositions() {
      // Check if the scroll position is at the end of the carousel content
      this.showScrollLeft = this.carouselContent.nativeElement.scrollLeft - this.pixelBuffer > 0; // 20px buffer
      // Check if the scroll position is at the beginning of the carousel content
      this.showScrollRight = this.carouselContent.nativeElement.scrollLeft < this.carouselContent.nativeElement.scrollWidth - this.carouselContent.nativeElement.clientWidth - this.pixelBuffer; // 20px buffer;
      this.cd.detectChanges();
    }
    onSkipLink(event) {
      event.preventDefault();
      this.skipListing = true;
      this.endOfListing.nativeElement.focus();
      this.skipListing = false;
    }
    static {
      this.ɵfac = function HmfCarouselComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfCarouselComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfCarouselComponent,
        selectors: [["hmf-carousel"]],
        viewQuery: function HmfCarouselComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c78, 5);
            i0.ɵɵviewQuery(_c79, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.carouselContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.endOfListing = _t.first);
          }
        },
        inputs: {
          showHeader: "showHeader",
          showTitle: "showTitle",
          showSubtitle: "showSubtitle",
          showActionButton: "showActionButton",
          showScrollButtons: "showScrollButtons",
          showScrollbar: "showScrollbar",
          showScrollButtonsOnMobile: "showScrollButtonsOnMobile",
          title: "title",
          subtitle: "subtitle",
          actionButtonTitle: "actionButtonTitle",
          gapSize: "gapSize",
          horizontalPadding: "horizontalPadding"
        },
        outputs: {
          actionButtonClicked: "actionButtonClicked"
        },
        ngContentSelectors: _c6,
        decls: 13,
        vars: 8,
        consts: [["carouselContent", ""], ["endOfListing", ""], [1, "hmf-carousel"], ["class", "hmf-carousel-header hmf-pb-m", 4, "ngIf"], ["href", "javascript:void(0)", "tabindex", "0", 1, "hmf-skip-link", "background-base", "label-base", "hmf-subheader-bold-l", "hmf-text-decoration-none", "hmf-position-absolute", "hmf-py-s", "hmf-px-l", "hmf-m-xxs", 3, "click", "keyup.enter"], [1, "hmf-carousel-body"], [1, "hmf-carousel-content", "hmf-carousel-content-scroll", "hmf-position-relative", "hmf-display-flex", "hmf-align-items-center", "hmf-py-xxs", 3, "ngClass"], ["hmf-button", "", "class", "hmf-carousel-scroll-button hmf-carousel-scroll-button-left hmf-position-absolute hmf-p-xxs background-base", "variant", "secondary", "size", "small", "shape", "circular", "icon", "chevron-left", 3, "label", "ngClass", "click", 4, "ngIf"], ["hmf-button", "", "class", "hmf-carousel-scroll-button hmf-carousel-scroll-button-right hmf-position-absolute hmf-p-xxs background-base", "variant", "secondary", "size", "small", "shape", "circular", "icon", "chevron-right", 3, "label", "ngClass", "click", 4, "ngIf"], [3, "scrollContent", 4, "ngIf"], ["href", "javascript:void(0)", "tabindex", "0", "aria-label", "End of listing"], [1, "hmf-carousel-header", "hmf-pb-m"], ["class", "hmf-carousel-header-title hmf-header-bold-m", 3, "ngClass", 4, "ngIf"], ["class", "hmf-carousel-header-subtitle hmf-body-m", 3, "ngClass", 4, "ngIf"], ["class", "hmf-carousel-header-action-button hmf-body-m hmf-ml-m hmf-display-flex hmf-align-items-center hmf-justify-content-flex-end", "role", "button", "tabindex", "0", 3, "click", 4, "ngIf"], [1, "hmf-carousel-header-title", "hmf-header-bold-m", 3, "ngClass"], [1, "hmf-carousel-header-subtitle", "hmf-body-m", 3, "ngClass"], ["role", "button", "tabindex", "0", 1, "hmf-carousel-header-action-button", "hmf-body-m", "hmf-ml-m", "hmf-display-flex", "hmf-align-items-center", "hmf-justify-content-flex-end", 3, "click"], ["hmf-button", "", "variant", "secondary", "size", "small", "shape", "circular", "icon", "chevron-left", 1, "hmf-carousel-scroll-button", "hmf-carousel-scroll-button-left", "hmf-position-absolute", "hmf-p-xxs", "background-base", 3, "click", "label", "ngClass"], ["hmf-button", "", "variant", "secondary", "size", "small", "shape", "circular", "icon", "chevron-right", 1, "hmf-carousel-scroll-button", "hmf-carousel-scroll-button-right", "hmf-position-absolute", "hmf-p-xxs", "background-base", 3, "click", "label", "ngClass"], [3, "scrollContent"]],
        template: function HmfCarouselComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵtemplate(1, HmfCarouselComponent_div_1_Template, 4, 3, "div", 3);
            i0.ɵɵelementStart(2, "a", 4);
            i0.ɵɵlistener("click", function HmfCarouselComponent_Template_a_click_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSkipLink($event));
            })("keyup.enter", function HmfCarouselComponent_Template_a_keyup_enter_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSkipLink($event));
            });
            i0.ɵɵtext(3, " Skip Listing ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 5)(5, "div", 6, 0);
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, HmfCarouselComponent_button_8_Template, 1, 5, "button", 7)(9, HmfCarouselComponent_button_9_Template, 1, 5, "button", 8)(10, HmfCarouselComponent_hmf_scrollbar_10_Template, 1, 1, "hmf-scrollbar", 9);
            i0.ɵɵelement(11, "a", 10, 1);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showHeader);
            i0.ɵɵadvance(4);
            i0.ɵɵstyleProp("gap", ctx.gapValue);
            i0.ɵɵproperty("ngClass", ctx.horizontalPaddingClass);
            i0.ɵɵattribute("inert", ctx.skipListing ? "" : null);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.showScrollLeft && ctx.showScrollButtons);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showScrollRight && ctx.showScrollButtons);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showScrollbar);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgIf, HmfScrollbarComponent, HomefieldIconLibraryModule, HmfButtonComponent],
        styles: [".hmf-carousel[_ngcontent-%COMP%]{box-sizing:border-box;max-width:100vw;touch-action:pan-y;width:100%}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-header[_ngcontent-%COMP%]{box-sizing:border-box;display:grid;grid-gap:0;grid-template-columns:auto min-content;grid-template-rows:min-content min-content;max-height:132px;width:100%}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-header[_ngcontent-%COMP%]   .hmf-carousel-header-title[_ngcontent-%COMP%]{grid-area:1/1/2/2}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-header[_ngcontent-%COMP%]   .hmf-carousel-header-subtitle[_ngcontent-%COMP%]{grid-area:2/1/3/3}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-header[_ngcontent-%COMP%]   .hmf-carousel-header-subtitle.hmf-notitle[_ngcontent-%COMP%]{grid-area:1/1/2/3}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-header[_ngcontent-%COMP%]   .hmf-carousel-header-action-button[_ngcontent-%COMP%]{cursor:pointer;grid-area:1/2/2/3;white-space:nowrap}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-header[_ngcontent-%COMP%]   .hmf-carousel-header-action-button[_ngcontent-%COMP%]:hover{text-decoration:underline}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-header[_ngcontent-%COMP%]   .hmf-carousel-header-title[_ngcontent-%COMP%], .hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-header[_ngcontent-%COMP%]   .hmf-carousel-header-subtitle[_ngcontent-%COMP%]{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:2;line-clamp:2;overflow:hidden;text-overflow:ellipsis;word-wrap:break-word}@media (min-width: 768px){.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-header[_ngcontent-%COMP%]{max-height:101px}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-header[_ngcontent-%COMP%]   .hmf-carousel-header-subtitle[_ngcontent-%COMP%]{grid-area:2/1/3/2}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-header[_ngcontent-%COMP%]   .hmf-carousel-header-action-button[_ngcontent-%COMP%]{grid-area:1/2/3/3}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-header[_ngcontent-%COMP%]   .hmf-carousel-header-title[_ngcontent-%COMP%]{-webkit-line-clamp:1;line-clamp:1}}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-body[_ngcontent-%COMP%]{box-sizing:border-box;overflow:hidden;position:relative;width:100%}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-content[_ngcontent-%COMP%]{transition:transform .3s ease}@media (min-width: 768px){.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-content[_ngcontent-%COMP%]:hover   .hmf-carousel-scroll-button[_ngcontent-%COMP%]{display:block}}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-content-scroll[_ngcontent-%COMP%]{overflow:hidden;-ms-overflow-style:none;scroll-behavior:smooth;scroll-snap-type:x mandatory;scrollbar-width:none}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-content-scroll[_ngcontent-%COMP%]::-webkit-scrollbar{display:none;width:0}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-content-scroll[_ngcontent-%COMP%]::-webkit-scrollbar-track{background:none}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-content-scroll[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background:none}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-scroll-button[_ngcontent-%COMP%]{border:1px solid var(--hmf-gray900);top:calc(50% - 22px)}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-scroll-button-right[_ngcontent-%COMP%]{margin-left:-60px;right:var(--hmf-xs)}.hmf-carousel[_ngcontent-%COMP%]   .hmf-carousel-scroll-button-left[_ngcontent-%COMP%]{left:var(--hmf-xs)}.hmf-carousel[_ngcontent-%COMP%]   .hmf-skip-link[_ngcontent-%COMP%]{border:1px solid var(--hmf-border-inverse);height:1px;left:-1000px;width:1px}.hmf-carousel[_ngcontent-%COMP%]   .hmf-skip-link[_ngcontent-%COMP%]:focus{display:block;height:unset;left:unset;width:fit-content;z-index:1}.hmf-carousel[_ngcontent-%COMP%]   .hmf-skip-link[_ngcontent-%COMP%]:focus-visible{box-sizing:border-box;outline:1px dashed var(--hmf-border-focused)}"]
      });
    }
  }
  return HmfCarouselComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ImagesLoadedService = /*#__PURE__*/(() => {
  class ImagesLoadedService {
    constructor() {
      this.onLoadObservables = [];
      this.imagesLoaded = new BehaviorSubject('');
      this.imagesLoaded$ = this.imagesLoaded.asObservable();
    }
    subscribeToEvents() {
      this.eventsSubscription = zip(this.onLoadObservables).subscribe(() => {
        this.imagesLoaded.next('loaded');
      });
    }
    registerImages(images) {
      if (images.length === 0) {
        this.imagesLoaded.next('loaded');
      } else {
        images.forEach(img => {
          const newOnLoadObservable = fromEvent(img, 'load');
          this.onLoadObservables.push(newOnLoadObservable);
        });
        this.subscribeToEvents();
      }
    }
    destroyEvents() {
      if (this.onLoadObservables.length > 0) {
        this.eventsSubscription.unsubscribe();
        this.onLoadObservables = [];
      }
    }
    static {
      this.ɵfac = function ImagesLoadedService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ImagesLoadedService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ImagesLoadedService,
        factory: ImagesLoadedService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ImagesLoadedService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfPaginationCarouselComponent = /*#__PURE__*/(() => {
  class HmfPaginationCarouselComponent {
    constructor(homefieldIconsLibraryService, imagesLoadedService, cd) {
      this.imagesLoadedService = imagesLoadedService;
      this.cd = cd;
      this.showHeader = true;
      this.showTitle = true;
      this.showSubtitle = true;
      this.showActionButton = true;
      this.autoPlay = true;
      this.gap = 12;
      this.arrowCentered = false;
      this.scrollable = false;
      this.actionButtonClicked = new EventEmitter();
      this.elementsPerPage = 1;
      this.totalElements = 1;
      this.totalPages = 1;
      this.currentPage = 0;
      this.autoPlayProgress = 0;
      this.autoPlayPaused = false;
      this.scrollIn = false;
      this.scrollOut = false;
      homefieldIconsLibraryService.registerIcons([homefieldIconChevronLeft, homefieldIconChevronRight, homefieldIconMediaPlay, homefieldIconMediaPause]);
    }
    ngAfterViewInit() {
      const carouselContainer = this.paginationCarouselContent.nativeElement;
      const carouselElements = Array.from(carouselContainer.children);
      const imagesInCarousel = Array.from(carouselContainer.getElementsByTagName('img'));
      // If there are images not loaded inside the carousel content that affect the width of each element, the scroll calculation is not correct
      // This service is implemented to ensure the images are loaded and then calculate the scroll and pagination properly
      this.imagesLoadedService.registerImages(imagesInCarousel);
      this.imagesLoadedListener$ = this.imagesLoadedService.imagesLoaded$.subscribe(() => {
        this.initPaginationSettings(carouselContainer, carouselElements);
        this.cd.detectChanges();
      });
      if (this.autoPlay) {
        this.initTimer();
      }
    }
    next() {
      this.scrollIn = false;
      this.scrollOut = false;
      this.currentPage++;
      if (this.currentPage + 1 > this.totalPages) {
        // scroll back to first page
        this.currentPage = 0;
        this.scrollIn = true;
        this.paginationCarouselContent.nativeElement.scrollLeft = 0;
      } else {
        this.scroll();
      }
    }
    previous() {
      this.scrollIn = false;
      this.scrollOut = false;
      this.currentPage--;
      if (this.currentPage < 0) {
        // scroll forward to last page
        this.currentPage = this.totalPages - 1;
        this.scrollOut = true;
        this.paginationCarouselContent.nativeElement.scrollLeft = this.paginationCarouselContent.nativeElement.scrollWidth / this.totalElements * this.totalElements - 1;
      } else {
        this.scroll();
      }
    }
    selectPage(pageIndex) {
      this.currentPage = pageIndex;
      this.scroll();
    }
    // Example found in: https://stackblitz.com/edit/detect-mobile-swipe-in-angular?file=src%2Fapp%2Fapp.component.ts,src%2Fapp%2Fapp.component.html
    swipe(e, when) {
      e.preventDefault(); //prevent default touch scroll
      if (this.autoPlay) {
        this.pause();
      }
      const coord = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
      const time = new Date().getTime();
      if (when === 'start') {
        this.swipeCoord$ = coord;
        this.swipeTime$ = time;
      } else if (when === 'end') {
        const direction = [coord[0] - this.swipeCoord$[0], coord[1] - this.swipeCoord$[1]];
        const duration = time - this.swipeTime$;
        if (duration < 1000 && Math.abs(direction[0]) > 30 &&
        // Long enough
        Math.abs(direction[0]) > Math.abs(direction[1] * 3)) {
          // Horizontal enough
          direction[0] < 0 ? this.next() : this.previous();
        }
      }
    }
    play() {
      this.autoPlayPaused = false;
      this.initTimer();
    }
    pause() {
      this.autoPlayPaused = true;
      this.autoPlayProgress = 50;
      this.destroyTimer();
    }
    onResize() {
      if (this.autoPlay) {
        this.pause();
      }
      const carouselContainer = this.paginationCarouselContent.nativeElement;
      const carouselElements = Array.from(carouselContainer.children);
      this.initPaginationSettings(carouselContainer, carouselElements);
      this.paginationCarouselContent.nativeElement.scroll({
        left: 0,
        behavior: 'smooth'
      });
    }
    ngOnDestroy() {
      this.imagesLoadedListener$.unsubscribe();
      this.imagesLoadedService.destroyEvents();
      if (this.autoPlay) {
        this.destroyTimer();
      }
    }
    initTimer() {
      this.autoPlayTimer$ = interval(40).subscribe(() => {
        this.autoPlayProgress++;
        if (this.autoPlayProgress % 100 === 0) {
          this.autoPlayProgress = 0;
          this.next();
        }
      });
    }
    destroyTimer() {
      this.autoPlayTimer$.unsubscribe();
    }
    // doing the actual scroll animation
    scroll() {
      const currentElementIndex = this.elementsPerPage * this.currentPage;
      this.paginationCarouselContent.nativeElement.scroll({
        left: this.paginationCarouselContent.nativeElement.scrollWidth / this.totalElements * currentElementIndex,
        behavior: 'smooth'
      });
    }
    initPaginationSettings(carouselContainer, carouselElements) {
      const containerRect = carouselContainer.getBoundingClientRect();
      let elementCounter = 0;
      carouselElements.forEach(el => {
        const elementRect = el.getBoundingClientRect();
        if (this.isElementVisible(elementRect, containerRect)) {
          elementCounter++;
        }
      });
      this.totalElements = carouselElements.length;
      this.elementsPerPage = elementCounter || 1;
      this.totalPages = Math.ceil(this.totalElements / this.elementsPerPage);
      this.currentPage = 0;
    }
    isElementVisible(elementRect, containerRect) {
      return elementRect.left >= containerRect.left - this.gap && elementRect.right <= containerRect.right + this.gap;
    }
    static {
      this.ɵfac = function HmfPaginationCarouselComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfPaginationCarouselComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService), i0.ɵɵdirectiveInject(ImagesLoadedService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfPaginationCarouselComponent,
        selectors: [["hmf-pagination-carousel"]],
        viewQuery: function HmfPaginationCarouselComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c83, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginationCarouselContent = _t.first);
          }
        },
        hostBindings: function HmfPaginationCarouselComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("resize", function HmfPaginationCarouselComponent_resize_HostBindingHandler() {
              return ctx.onResize();
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          showHeader: "showHeader",
          showTitle: "showTitle",
          showSubtitle: "showSubtitle",
          showActionButton: "showActionButton",
          title: "title",
          subtitle: "subtitle",
          actionButtonTitle: "actionButtonTitle",
          autoPlay: "autoPlay",
          gap: "gap",
          arrowCentered: "arrowCentered",
          scrollable: "scrollable"
        },
        outputs: {
          actionButtonClicked: "actionButtonClicked"
        },
        ngContentSelectors: _c6,
        decls: 10,
        vars: 18,
        consts: [["paginationCarouselContent", ""], [1, "hmf-pagination-carousel"], ["class", "hmf-pagination-carousel-header hmf-p-xs", 4, "ngIf"], [1, "hmf-pagination-carousel-body", "hmf-p-xxs", "hmf-px-xs", 3, "ngClass"], [1, "hmf-pagination-carousel-content", "hmf-display-flex", "hmf-position-relative", 3, "touchstart", "touchend", "ngClass"], [3, "ngClass"], [1, "hmf-pagination-carousel-controls", "hmf-display-flex", "hmf-justify-content-between", "hmf-p-xs", 3, "ngClass"], [1, "pagination-dots", "hmf-display-flex", "hmf-align-items-center"], [1, "pagination-buttons", "hmf-display-flex"], [1, "hmf-pagination-carousel-header", "hmf-p-xs"], ["class", "hmf-pagination-carousel-header-title hmf-header-bold-m", 3, "ngClass", 4, "ngIf"], ["class", "hmf-pagination-carousel-header-subtitle hmf-body-m", 3, "ngClass", 4, "ngIf"], ["class", "hmf-pagination-carousel-header-action-button hmf-text-decoration-underline hmf-body-m hmf-ml-m hmf-display-flex hmf-align-items-center hmf-justify-content-flex-end", 3, "click", 4, "ngIf"], [1, "hmf-pagination-carousel-header-title", "hmf-header-bold-m", 3, "ngClass"], [1, "hmf-pagination-carousel-header-subtitle", "hmf-body-m", 3, "ngClass"], [1, "hmf-pagination-carousel-header-action-button", "hmf-text-decoration-underline", "hmf-body-m", "hmf-ml-m", "hmf-display-flex", "hmf-align-items-center", "hmf-justify-content-flex-end", 3, "click"], [1, "pagination-buttons", "hmf-display-flex", "hmf-justify-content-between", "hmf-px-s"], ["data-testid", "previous", "aria-label", "Previous", 3, "click"], ["width", "16px", "height", "16px", "name", "chevron-left"], ["data-testid", "next", "aria-label", "Next", 3, "click"], ["width", "16px", "height", "16px", "name", "chevron-right"], ["class", "pagination-dot-box", 3, "ngClass", "click", "keydown.enter", "keydown.space", 4, "ngFor", "ngForOf"], [1, "pagination-dot-box", 3, "click", "keydown.enter", "keydown.space", "ngClass"]],
        template: function HmfPaginationCarouselComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, HmfPaginationCarouselComponent_div_1_Template, 4, 3, "div", 2);
            i0.ɵɵelementStart(2, "div", 3)(3, "div", 4, 0);
            i0.ɵɵlistener("touchstart", function HmfPaginationCarouselComponent_Template_div_touchstart_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.swipe($event, "start"));
            })("touchend", function HmfPaginationCarouselComponent_Template_div_touchend_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.swipe($event, "end"));
            });
            i0.ɵɵprojection(5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, HmfPaginationCarouselComponent_Conditional_6_Template, 6, 3, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 6);
            i0.ɵɵtemplate(8, HmfPaginationCarouselComponent_Conditional_8_Template, 2, 2, "div", 7)(9, HmfPaginationCarouselComponent_Conditional_9_Template, 5, 0, "div", 8);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showHeader);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c84, ctx.arrowCentered));
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("gap", ctx.gap, "px");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(11, _c85, ctx.scrollIn, ctx.scrollOut, ctx.scrollable));
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.arrowCentered ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(15, _c86, ctx.arrowCentered, !ctx.arrowCentered));
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.scrollable ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.arrowCentered ? 9 : -1);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: [".hmf-pagination-carousel[_ngcontent-%COMP%]{box-sizing:border-box;max-width:100vw;width:100%}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-header[_ngcontent-%COMP%]{box-sizing:border-box;display:grid;grid-gap:0;grid-template-columns:auto min-content;grid-template-rows:min-content min-content;max-height:132px;width:100%}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-header[_ngcontent-%COMP%]   .hmf-pagination-carousel-header-title[_ngcontent-%COMP%]{grid-area:1/1/2/2}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-header[_ngcontent-%COMP%]   .hmf-pagination-carousel-header-subtitle[_ngcontent-%COMP%]{grid-area:2/1/3/3}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-header[_ngcontent-%COMP%]   .hmf-pagination-carousel-header-subtitle.hmf-notitle[_ngcontent-%COMP%]{grid-area:1/1/2/3}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-header[_ngcontent-%COMP%]   .hmf-pagination-carousel-header-action-button[_ngcontent-%COMP%]{background-color:transparent;border:none;cursor:pointer;grid-area:1/2/2/3;white-space:nowrap}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-header[_ngcontent-%COMP%]   .hmf-pagination-carousel-header-action-button[_ngcontent-%COMP%]:hover{text-decoration:underline}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-header[_ngcontent-%COMP%]   .hmf-pagination-carousel-header-title[_ngcontent-%COMP%], .hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-header[_ngcontent-%COMP%]   .hmf-pagination-carousel-header-subtitle[_ngcontent-%COMP%]{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:2;line-clamp:2;overflow:hidden;text-overflow:ellipsis;word-wrap:break-word}@media (min-width: 768px){.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-header[_ngcontent-%COMP%]{max-height:101px}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-header[_ngcontent-%COMP%]   .hmf-pagination-carousel-header-subtitle[_ngcontent-%COMP%]{grid-area:2/1/3/2}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-header[_ngcontent-%COMP%]   .hmf-pagination-carousel-header-action-button[_ngcontent-%COMP%]{grid-area:1/2/3/3}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-header[_ngcontent-%COMP%]   .hmf-pagination-carousel-header-title[_ngcontent-%COMP%]{-webkit-line-clamp:1;line-clamp:1}}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]{box-sizing:border-box}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]   .hmf-pagination-buttons[_ngcontent-%COMP%]{position:absolute;top:50%;transform:translateY(-50%);width:100%}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]   .hmf-pagination-carousel-content[_ngcontent-%COMP%]{max-height:600px;overflow-x:auto;scroll-behavior:smooth}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]   .hmf-pagination-carousel-content[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex-shrink:0}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]   .hmf-pagination-carousel-content[_ngcontent-%COMP%] >*{flex-shrink:0}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]   .hmf-pagination-carousel-content[_ngcontent-%COMP%]:not(.scrollable){overflow-x:auto;scrollbar-width:none}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]   .hmf-pagination-carousel-content[_ngcontent-%COMP%]:not(.scrollable)::-webkit-scrollbar{display:none}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]   .hmf-pagination-carousel-content.scroll-in[_ngcontent-%COMP%] >*{animation:_ngcontent-%COMP%_scroll-in .6s ease}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]   .hmf-pagination-carousel-content.scroll-in[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_scroll-in .6s ease}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]   .hmf-pagination-carousel-content.scroll-out[_ngcontent-%COMP%] >*{animation:_ngcontent-%COMP%_scroll-out .6s ease}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]   .hmf-pagination-carousel-content.scroll-out[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_scroll-out .6s ease}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]   .hmf-pagination-carousel-content.scrollable[_ngcontent-%COMP%]{overflow-x:scroll;padding-bottom:16px;position:relative}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]   .hmf-pagination-carousel-content.scrollable[_ngcontent-%COMP%]::-webkit-scrollbar{height:6px}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]   .hmf-pagination-carousel-content.scrollable[_ngcontent-%COMP%]::-webkit-scrollbar-track{background:var(--hmf-gray200);border-radius:10px}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-body[_ngcontent-%COMP%]   .hmf-pagination-carousel-content.scrollable[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:var(--hmf-gray800);border-radius:10px}@keyframes _ngcontent-%COMP%_scroll-in{0%{transform:translate(100%)}to{transform:translate(0)}}@keyframes _ngcontent-%COMP%_scroll-out{0%{transform:translate(-100%)}to{transform:translate(0)}}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-controls[_ngcontent-%COMP%]   .pagination-dots[_ngcontent-%COMP%]{gap:var(--hmf-xxxs)}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-controls[_ngcontent-%COMP%]   .pagination-dots[_ngcontent-%COMP%]   .pagination-dot-box[_ngcontent-%COMP%]{background-color:var(--hmf-gray200);border:none;border-radius:var(--hmf-xs);cursor:pointer;height:var(--hmf-xs);width:var(--hmf-xs)}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-controls[_ngcontent-%COMP%]   .pagination-dots[_ngcontent-%COMP%]   .pagination-dot-box.active[_ngcontent-%COMP%]{background-color:var(--hmf-secondary500)}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-controls[_ngcontent-%COMP%]   .pagination-dots[_ngcontent-%COMP%]   .pagination-dot-box[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{background-color:var(--hmf-secondary500);border-radius:var(--hmf-xs);height:var(--hmf-xs)}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-controls[_ngcontent-%COMP%]   .pagination-dots[_ngcontent-%COMP%]   .pagination-dot-box[_ngcontent-%COMP%]   .progress-bar.expanded[_ngcontent-%COMP%], .hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-controls[_ngcontent-%COMP%]   .pagination-dots[_ngcontent-%COMP%]   .pagination-dot-box.expanded[_ngcontent-%COMP%]{width:var(--hmf-xl)}.hmf-pagination-carousel[_ngcontent-%COMP%]   .hmf-pagination-carousel-controls[_ngcontent-%COMP%]   .pagination-dots[_ngcontent-%COMP%]   .pause-play-button[_ngcontent-%COMP%]{background-color:transparent;border:1px solid var(--hmf-gray900);border-radius:var(--hmf-xxxs);cursor:pointer;height:var(--hmf-m);padding-top:3px;width:var(--hmf-l)}.hmf-pagination-carousel[_ngcontent-%COMP%]   .pagination-buttons[_ngcontent-%COMP%]{gap:var(--hmf-xxxs)}.hmf-pagination-carousel[_ngcontent-%COMP%]   .pagination-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background-color:var(--hmf-gray50);border:1px solid var(--hmf-gray900);border-radius:22px;cursor:pointer;line-height:0px;padding:13px}"]
      });
    }
  }
  return HmfPaginationCarouselComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfAddToCartComponent = /*#__PURE__*/(() => {
  class HmfAddToCartComponent {
    constructor(homefieldIconsLibraryService) {
      this.homefieldIconsLibraryService = homefieldIconsLibraryService;
      this.text = 'Add To Cart';
      this.buttonStyle = 'tertiary';
      this.showATCIcon = true;
      this.addToCartClicked = new EventEmitter();
      this.homefieldIconsLibraryService.registerIcons([homefieldIconOrderCartStandard]);
    }
    onAddToCartClick(event) {
      this.addToCartClicked.emit(event);
    }
    static {
      this.ɵfac = function HmfAddToCartComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfAddToCartComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfAddToCartComponent,
        selectors: [["hmf-add-to-cart"]],
        inputs: {
          text: "text",
          buttonStyle: "buttonStyle",
          showATCIcon: "showATCIcon"
        },
        outputs: {
          addToCartClicked: "addToCartClicked"
        },
        decls: 1,
        vars: 5,
        consts: [["hmf-button", "", "id", "add-to-cart-button", 1, "hmf-px-xxs", "hmf-add-to-cart-button-styles", 3, "click", "variant", "text", "size", "icon"]],
        template: function HmfAddToCartComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function HmfAddToCartComponent_Template_button_click_0_listener($event) {
              return ctx.onAddToCartClick($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("variant", ctx.buttonStyle)("text", ctx.text)("size", "medium")("icon", ctx.showATCIcon ? "order-cart-standard" : "");
            i0.ɵɵattribute("aria-label", ctx.text);
          }
        },
        dependencies: [CommonModule, HmfButtonComponent, HomefieldIconLibraryModule],
        styles: [".hmf-add-to-cart-button-styles[_ngcontent-%COMP%]{width:100%}"],
        changeDetection: 0
      });
    }
  }
  return HmfAddToCartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SHIPPING_MESSAGES = {
  OutOfStock: {
    text: 'Not Available to Ship',
    icon: 'availability-dot-filled',
    class: 'red'
  },
  LowStock: {
    text: 'Limited Stock to Ship',
    icon: 'availability-dot-filled',
    class: 'yellow'
  },
  InStock: {
    text: 'Shipping Available',
    icon: 'availability-dot-filled',
    class: 'green'
  }
};
const PICKUP_MESSAGES = {
  OutOfStock: {
    text: 'Not Available to Pickup',
    icon: 'availability-dot-filled',
    class: 'red'
  },
  LowStock: {
    text: 'Limited Stock to Pickup',
    icon: 'availability-dot-filled',
    class: 'yellow'
  },
  AvailableNearby: {
    text: 'In Nearby Stores',
    icon: 'availability-dot-filled',
    class: 'yellow'
  },
  InStock: {
    text: 'Free Pickup Available',
    icon: 'availability-dot-filled',
    class: 'green'
  },
  ShipToStore: {
    text: 'Free Ship to Store',
    icon: 'availability-dot-filled',
    class: 'green'
  }
};

/** @format */
let HmfProductAvailabilityComponent = /*#__PURE__*/(() => {
  class HmfProductAvailabilityComponent {
    constructor(homefieldIconsLibraryService) {
      this.homefieldIconsLibraryService = homefieldIconsLibraryService;
      this.selectedStoreId = '';
      this.isOOS = false;
      this.homefieldIconsLibraryService.registerIcons([homefieldIconAvailabilityDotFilled]);
    }
    ngOnChanges() {
      if (this.productAvailabilityData) {
        this.updateAvailabilityMessaging(this.productAvailabilityData);
      }
    }
    updateAvailabilityMessaging(messaging) {
      this.shippingMessage = SHIPPING_MESSAGES[messaging.onlineInventoryMessage];
      this.pickupMessage = PICKUP_MESSAGES[messaging.inStoreInventoryMessage];
    }
    static {
      this.ɵfac = function HmfProductAvailabilityComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfProductAvailabilityComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfProductAvailabilityComponent,
        selectors: [["hmf-product-availability"]],
        inputs: {
          productAvailabilityData: "productAvailabilityData",
          selectedStoreId: "selectedStoreId",
          isOOS: "isOOS"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 3,
        vars: 2,
        consts: [["loading", ""], ["class", "availability hmf-subheader-bold-s hmf-py-xxs", 3, "ngClass", 4, "ngIf", "ngIfElse"], [1, "availability", "hmf-subheader-bold-s", "hmf-py-xxs", 3, "ngClass"], [1, "shipping-availability", "hmf-display-flex", "hmf-align-items-center", "hmf-pb-xxxs", 3, "ngClass"], ["class", "hmf-mr-xxxs", "height", "8px", "width", "8px", 3, "class", "name", 4, "ngIf"], ["class", "store-availability hmf-display-flex hmf-align-items-center", 3, "ngClass", 4, "ngIf"], ["height", "8px", "width", "8px", 1, "hmf-mr-xxxs", 3, "name"], [1, "store-availability", "hmf-display-flex", "hmf-align-items-center", 3, "ngClass"], [1, "availability"], [1, "skeleton-loader", "loading-availability", "hmf-my-0", "hmf-mb-xxxs"], [1, "skeleton-loader", "loading-availability", "hmf-my-0"]],
        template: function HmfProductAvailabilityComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HmfProductAvailabilityComponent_div_0_Template, 5, 9, "div", 1)(1, HmfProductAvailabilityComponent_ng_template_1_Template, 3, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const loading_r2 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.productAvailabilityData)("ngIfElse", loading_r2);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgIf, HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent],
        styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]   .shipping-availability[_ngcontent-%COMP%], [_nghost-%COMP%]   .store-availability[_ngcontent-%COMP%]{font-size:var(--legal-font-size-xs);letter-spacing:var(--body-letter-spacing);line-height:var(--subhead-line-height-s)}@media (min-width: 768px){[_nghost-%COMP%]   .shipping-availability[_ngcontent-%COMP%], [_nghost-%COMP%]   .store-availability[_ngcontent-%COMP%]{font-size:var(--body-font-size-s)}}[_nghost-%COMP%]   .availability[_ngcontent-%COMP%]{height:36px;width:100%}[_nghost-%COMP%]   .centered[_ngcontent-%COMP%]{justify-content:center}[_nghost-%COMP%]     homefield-icon{display:inline-flex}[_nghost-%COMP%]     .red svg{margin-top:-1px}[_nghost-%COMP%]     .red svg circle{fill:var(--hmf-product-availability-cancel-icon-color)}[_nghost-%COMP%]     .yellow svg{margin-top:-1px}[_nghost-%COMP%]     .yellow svg circle{fill:var(--hmf-product-availability-warning-icon-color)}[_nghost-%COMP%]     .green svg{margin-top:-1px}[_nghost-%COMP%]     .green svg circle{fill:var(--hmf-product-availability-success-icon-color)}[_nghost-%COMP%]     .out-of-stock{color:var(--hmf-label-disabled)}[_nghost-%COMP%]     .out-of-stock svg circle{fill:var(--hmf-label-disabled)}[_nghost-%COMP%]   .loading-availability[_ngcontent-%COMP%]{height:16px;width:60%}[_nghost-%COMP%]   .skeleton-loader[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_gradient 6s ease infinite;background:var(--hmf-gray300) linear-gradient(-45deg,var(--hmf-gray300),var(--hmf-gray200),var(--hmf-gray100),var(--hmf-gray200),var(--hmf-gray300));background-size:800% 34px}@keyframes _ngcontent-%COMP%_gradient{0%,to{background-position:0 50%}50%{background-position:100% 50%}}"],
        changeDetection: 0
      });
    }
  }
  return HmfProductAvailabilityComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfProductCardComponent = /*#__PURE__*/(() => {
  class HmfProductCardComponent {
    constructor() {
      this.variant = 'vertical';
      this.availability = undefined;
      this.showATC = true;
      this.size = 'medium';
      this.buttonStyle = 'tertiary';
      this.showReviewsStars = true;
      this.buttonText = undefined;
      this.showATCIcon = true;
      this.isSponsored = false;
      this.showLinkToProduct = input(false);
      this.linkToProductText = input('View Product');
      /** @description Event triggered when the Add To Cart button is clicked */
      this.addToCartClicked = new EventEmitter();
      /** @description Event triggered when the product image is clicked */
      this.imageClicked = new EventEmitter();
      /** @description Event triggered when the product name is clicked */
      this.nameClicked = new EventEmitter();
      /** @description Event triggered when the product display attributes (shown in the FBT variant) are clicked */
      this.attributesClicked = new EventEmitter();
      /** @description Emits the newly selected color when the selected color swatch is updated */
      this.colorSwatchChanged = new EventEmitter();
      /** @description Emits the selected product when the Product-Card is clicked */
      this.cardClicked = new EventEmitter();
      /** @description Event triggered when the View Product button is clicked */
      this.viewProductClick = output();
      // The component will initialize with the default color
      // This property updates whenever a color swatch change emits
      this.selectedSwatchColor = '';
      this.imageClickable = false;
      this.nameClickable = false;
      this.attributesClickable = false;
    }
    get isCarouselVariant() {
      return this.variant === 'recommendation' || this.variant === 'fbt';
    }
    get priceVariant() {
      if (this.isCarouselVariant) {
        return 'carousel';
      }
      if (this.variant === 'vertical') {
        if (this.size === 'small' && this.productData?.pricing?.isSeePriceInCart && this.productData?.pricing?.prices?.listPrice && this.productData?.pricing?.prices?.offerPrice) {
          return 'strikethrough';
        }
        return 'vertical';
      }
      if (this.variant === 'horizontal') {
        if (this.shouldShowOnlyStrikethrough()) {
          return 'strikethrough';
        }
        return 'wrapped';
      }
      return 'wrapped';
    }
    get displayButtonText() {
      if (this.buttonText) {
        return this.buttonText;
      }
      if (this.size === 'small') {
        return 'Add';
      }
      return 'Add to cart';
    }
    get displayAttributesText() {
      if (!this.productData?.definingAttributes) {
        return '';
      }
      return this.productData.definingAttributes.map(attr => attr.value).join(' | ');
    }
    get containerPaddings() {
      const size = this.size ?? 'medium';
      const useXs = this.isCarouselVariant || size === 'small';
      return {
        'hmf-px-xs': useXs,
        'hmf-px-s': !useXs,
        'hmf-flex-row': this.variant === 'horizontal'
      };
    }
    ngOnInit() {
      this.selectedSwatchColor = this.productData?.imageData?.defaultColor || this.selectedSwatchColor;
      this.imageClickable = this.imageClicked.observed;
      this.nameClickable = this.nameClicked.observed;
      this.attributesClickable = this.attributesClicked.observed;
    }
    ngOnChanges() {
      if (this.productData?.imageData) {
        if (this.variant != 'horizontal') {
          switch (this.size) {
            case 'small':
              this.productData.imageData.width = '120';
              this.productData.imageData.height = '120';
              break;
            case 'medium':
              this.productData.imageData.width = '176';
              this.productData.imageData.height = '176';
              break;
            case 'large':
              this.productData.imageData.width = '248';
              this.productData.imageData.height = '248';
              break;
          }
          // This reassignment to trigger change detection for the product image
          this.productData.imageData = Object.assign({}, this.productData.imageData);
        } else {
          this.productData.imageData.width = '176';
          this.productData.imageData.height = '176';
        }
      }
    }
    setSelectedSwatchColor(color) {
      this.selectedSwatchColor = color;
      this.colorSwatchChanged.emit(color);
    }
    addToCart(event) {
      event.stopPropagation(); // Prevent the event from bubbling up
      this.addToCartClicked.emit();
    }
    onCardClick() {
      this.cardClicked.emit(this.productData);
    }
    onImageClick() {
      this.imageClicked.emit();
    }
    onNameClick() {
      this.nameClicked.emit();
    }
    onAttributesClick() {
      this.attributesClicked.emit();
    }
    onViewProductClick() {
      this.viewProductClick.emit();
    }
    onCardKeyPress($event) {
      if ($event.key == 'Enter' || $event.key == ' ') {
        $event.preventDefault();
        this.onCardClick();
      }
    }
    /**
     * Determines when to show only the strikethrough price vs when to show the wrapped price
     */
    shouldShowOnlyStrikethrough() {
      if (!this.productData?.pricing) {
        return false;
      }
      const hasStrikethroughCondition = !!(this.productData.pricing.isClearance || this.productData.pricing.isSeePriceInCart);
      const hasAppropriateLayout = this.variant === 'horizontal' || this.size === 'small' || this.size === 'medium';
      if (hasStrikethroughCondition && hasAppropriateLayout) {
        const hasListPrice = !!(this.productData.pricing.prices?.minListPrice || this.productData.pricing.prices?.maxListPrice || this.productData.pricing.prices?.listPrice);
        const hasOfferPrice = !!(this.productData.pricing.prices?.minOfferPrice || this.productData.pricing.prices?.maxOfferPrice || this.productData.pricing.prices?.offerPrice);
        // Only show strikethrough variant if we have the necessary price data
        return hasListPrice && hasOfferPrice;
      }
      return false;
    }
    static {
      this.ɵfac = function HmfProductCardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfProductCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HmfProductCardComponent,
        selectors: [["hmf-product-card"]],
        inputs: {
          variant: "variant",
          availability: "availability",
          productData: "productData",
          showATC: "showATC",
          size: "size",
          buttonStyle: "buttonStyle",
          showReviewsStars: "showReviewsStars",
          buttonText: "buttonText",
          showATCIcon: "showATCIcon",
          isSponsored: "isSponsored",
          showLinkToProduct: [1, "showLinkToProduct"],
          linkToProductText: [1, "linkToProductText"]
        },
        outputs: {
          addToCartClicked: "addToCartClicked",
          imageClicked: "imageClicked",
          nameClicked: "nameClicked",
          attributesClicked: "attributesClicked",
          colorSwatchChanged: "colorSwatchChanged",
          cardClicked: "cardClicked",
          viewProductClick: "viewProductClick"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 3,
        vars: 2,
        consts: [["tabindex", "0", 1, "hmf-product-card-container", 3, "ngClass"], ["tabindex", "0", 1, "hmf-product-card-container", 3, "click", "keydown", "ngClass"], [3, "ngClass"], ["onkeyup", "", 1, "hmf-product-card-image-wrapper", "hmf-pb-xxs", "hmf-my-0", "hmf-mx-auto", 3, "click", "keyup.space", "keyup.enter", "ecode", "imageData", "productName", "selectedSwatchColor"], [1, "hmf-swatch-container", "hmf-display-flex", "hmf-justify-content-center", "hmf-align-items-center", "hmf-gap-4"], ["onkeyup", "", 1, "hmf-mt-0", "hmf-product-card-name", "hmf-header-xs", 3, "click", "keyup.space", "keyup.enter", "ngClass"], [1, "hmf-product-card-prices", "hmf-pb-xxs", "hmf-body-bold-l", 3, "isClearance", "isSeePriceInCart", "prices", "variant", "isSkuRecommendation"], [1, "hmf-product-card-star-ratings", 3, "ngClass", "ratingCount", "ratingValue", "showRating", "showReviewCount"], [1, "label-sku-container", "hmf-mb-xs"], [1, "hmf-product-card-promo", "hmf-pb-xxs", "label-sale", "hmf-subheader-s", "hmf-mb-0", "hmf-pb-xxs"], [1, "hmf-promo-availability-divider", "hmf-m-0"], [1, "hmf-product-card-availability", 3, "productAvailabilityData", "selectedStoreId", "isOOS"], [1, "hmf-display-flex", "hmf-justify-content-center"], ["hmf-action-text", "", 1, "hmf-textlink-sponsored", "hmf-mt-xxxs", 3, "variant", "disabled"], [3, "badgeName"], ["spaceBetween", "--hmf-0", 3, "options", "multipleSelection", "contained", "shape", "variant"], ["hmf-text-link", "", 1, "hmf-swatches-more-colors", "hmf-body-s", "hmf-m-xxxs", "hmf-mb-xxs", 3, "linkURL"], ["spaceBetween", "--hmf-0", 3, "mouseover", "selectionChange", "focus", "options", "multipleSelection", "contained", "shape", "variant"], ["onkeyup", "", 1, "hmf-product-card-attributes", "hmf-body-m", "hmf-display-block", "label-base-subtle", "hmf-text-decoration-underline", "label-sku", 3, "click", "keyup.space", "keyup.enter"], [1, "hmf-add-to-cart-styles", "hmf-display-flex", "hmf-justify-content-center", 3, "addToCartClicked", "text", "buttonStyle", "showATCIcon"], ["hmf-button", "", 3, "click", "variant", "text", "size"], [1, "hmf-product-card-skeleton-image", "skeleton-loader", 3, "ngClass"], [1, "hmf-display-flex", "hmf-justify-content-center", "hmf-align-items-center", "hmf-mb-xxs", "hmf-mx-xxxs", "hmf-gap-4", "hmf-product-card-skeleton-swatches"], [1, "loading-swatch", "skeleton-loader", "hmf-mx-xxxs"], [1, "hmf-product-card-skeleton-1", "skeleton-loader", 3, "ngClass"], [1, "hmf-product-card-skeleton-2", "skeleton-loader", "hmf-mt-0"], [1, "hmf-product-card-skeleton-3", "skeleton-loader", "hmf-mt-xxs"], [1, "empty-space"], [1, "hmf-promo-availability-divider"], [1, "hmf-product-card-availability", 3, "ngClass"], [1, "hmf-product-card-skeleton-4", "loading-availability", "skeleton-loader", "hmf-mt-xxs", "hmf-mb-xxxs"], [1, "hmf-product-card-skeleton-4", "loading-availability", "skeleton-loader", "hmf-mt-0"], [1, "hmf-product-card-skeleton-3", "skeleton-loader", "hmf-mb-xxxs"], [1, "hmf-product-card-skeleton-button", "skeleton-loader", "hmf-display-block", "hmf-sharp-radius", 3, "text"]],
        template: function HmfProductCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵdeclareLet(0);
            i0.ɵɵtemplate(1, HmfProductCardComponent_Conditional_1_Template, 20, 38, "hmf-card", 0)(2, HmfProductCardComponent_Conditional_2_Template, 22, 27, "hmf-card");
          }
          if (rf & 2) {
            let tmp_1_0;
            i0.ɵɵstoreLet(ctx.variant === "horizontal");
            i0.ɵɵadvance();
            i0.ɵɵconditional((tmp_1_0 = ctx.productData) ? 1 : 2, tmp_1_0);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.SlicePipe, HmfAddToCartComponent, HmfBadgeComponent, HmfCardComponent, HmfSelectableComponent, HmfPriceComponent, HmfProductAvailabilityComponent, HmfProductImageComponent, HmfStarRatingsComponent, HmfTextLinkComponent, HmfActionTextComponent, HmfButtonComponent],
        styles: ["[_nghost-%COMP%]{box-sizing:border-box;display:block;height:fit-content;width:fit-content}.hmf-product-card-container[_ngcontent-%COMP%]:focus, .hmf-product-card-container[_ngcontent-%COMP%]:focus-visible{border:1px dashed var(--hmf-border-focused);border-radius:var(--hmf-sharp-radius);outline:none}.hmf-product-card[_ngcontent-%COMP%]{background:var(--hmf-background-base);border:1px solid transparent;box-sizing:border-box;max-height:656px}.hmf-product-card.hmf-product-card-horizontal[_ngcontent-%COMP%]{max-height:none;min-height:200px;width:390px}.hmf-product-card.hmf-product-card-horizontal[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%]{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:2;overflow:hidden;text-overflow:ellipsis;white-space:normal}.hmf-product-card.hmf-product-card-horizontal[_ngcontent-%COMP%]   .hmf-product-card-image-wrapper[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-horizontal[_ngcontent-%COMP%]   .hmf-product-card-skeleton-image[_ngcontent-%COMP%]{height:176px;width:176px}@media (max-width: 480px){.hmf-product-card.hmf-product-card-horizontal[_ngcontent-%COMP%]{width:100%}.hmf-product-card.hmf-product-card-horizontal[_ngcontent-%COMP%]   .hmf-product-card-skeleton-image[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-horizontal[_ngcontent-%COMP%]   .hmf-product-card-image-wrapper[_ngcontent-%COMP%]{width:124px}}.hmf-product-card[_ngcontent-%COMP%]:visited:not(.loading){color:var(--hmf-label-base)}.hmf-product-card[_ngcontent-%COMP%]:hover:not(.hmf-product-card-skeleton), .hmf-product-card[_ngcontent-%COMP%]:active:not(.hmf-product-card-skeleton){box-shadow:var(--hmf-elevated-shadow)}.hmf-product-card[_ngcontent-%COMP%]:focus, .hmf-product-card[_ngcontent-%COMP%]:focus-visible{border:1px dashed var(--hmf-border-focused);border-radius:var(--hmf-sharp-radius);outline:none}.hmf-product-card[_ngcontent-%COMP%]   .hmf-promo-availability-divider[_ngcontent-%COMP%]{border:none;border-bottom:1px solid var(--hmf-border-base);width:100%}.hmf-product-card[_ngcontent-%COMP%]   .hmf-product-card-availability[_ngcontent-%COMP%]{height:52px}.hmf-product-card[_ngcontent-%COMP%]   .hmf-gap-4[_ngcontent-%COMP%]{gap:4px}.hmf-product-card[_ngcontent-%COMP%]   .hmf-swatch-container[_ngcontent-%COMP%]{height:var(--hmf-xl)}.hmf-product-card[_ngcontent-%COMP%]   .hmf-swatches-more-colors[_ngcontent-%COMP%]{color:var(--hmf-label-base-subtle)}.hmf-product-card[_ngcontent-%COMP%]   .hmf-product-card-promo[_ngcontent-%COMP%]{-webkit-box-orient:vertical;display:-webkit-box;height:32px;-webkit-line-clamp:2;min-height:32px;overflow:hidden;text-overflow:ellipsis}.hmf-product-card[_ngcontent-%COMP%]   .hmf-product-card-star-ratings[_ngcontent-%COMP%]{height:16px}.hmf-product-card[_ngcontent-%COMP%]   .hmf-product-card-image-wrapper[role=button][_ngcontent-%COMP%], .hmf-product-card[_ngcontent-%COMP%]   .hmf-product-card-name[role=button][_ngcontent-%COMP%], .hmf-product-card[_ngcontent-%COMP%]   .hmf-product-card-attributes[role=button][_ngcontent-%COMP%]{cursor:pointer}.hmf-product-card[_ngcontent-%COMP%]   .skeleton-loader[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_gradient 6s ease infinite;background:var(--hmf-gray300) linear-gradient(-45deg,var(--hmf-gray300),var(--hmf-gray200),var(--hmf-gray100),var(--hmf-gray200),var(--hmf-gray300));background-size:800% 34px;height:inherit}@keyframes _ngcontent-%COMP%_gradient{0%,to{background-position:0 50%}50%{background-position:100% 50%}}.hmf-product-card[_ngcontent-%COMP%]   .hmf-product-card-skeleton-1[_ngcontent-%COMP%]{height:var(--hmf-s);margin-bottom:2px;width:80%}.hmf-product-card[_ngcontent-%COMP%]   .hmf-product-card-skeleton-2[_ngcontent-%COMP%]{height:var(--hmf-s);width:60%}.hmf-product-card[_ngcontent-%COMP%]   .hmf-product-card-skeleton-3[_ngcontent-%COMP%]{height:var(--hmf-s);width:50%}.hmf-product-card[_ngcontent-%COMP%]   .hmf-product-card-skeleton-4[_ngcontent-%COMP%]{height:var(--subhead-line-height-s);width:60%}.hmf-product-card[_ngcontent-%COMP%]   .hmf-product-card-skeleton-button[_ngcontent-%COMP%]{height:44px;pointer-events:none}.hmf-product-card[_ngcontent-%COMP%]   .hmf-product-card-skeleton-button[_ngcontent-%COMP%]     .hmf-button.tertiary-btn{background-color:transparent;color:var(--hmf-label-disabled);width:100%}.hmf-product-card.hmf-product-card-vertical[_ngcontent-%COMP%]{flex-direction:column;width:200px}.hmf-product-card.hmf-product-card-vertical[_ngcontent-%COMP%]   .hmf-product-card-image-wrapper[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-vertical[_ngcontent-%COMP%]   .hmf-product-card-skeleton-image[_ngcontent-%COMP%]{height:168px;width:100%}.hmf-product-card.hmf-product-card-vertical[_ngcontent-%COMP%]   .hmf-product-card-skeleton-image[_ngcontent-%COMP%]{margin-top:-2px}.hmf-product-card.hmf-product-card-vertical[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%]{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:3;overflow:hidden;text-overflow:ellipsis;white-space:normal}.hmf-product-card.hmf-product-card-vertical[_ngcontent-%COMP%]   .hmf-product-card-prices[_ngcontent-%COMP%]{height:37px}.hmf-product-card.hmf-product-card-vertical[_ngcontent-%COMP%]   .loading-swatch[_ngcontent-%COMP%]{border:1px solid transparent;border-radius:var(--hmf-round-radius);height:36px;width:36px}.hmf-product-card.hmf-product-card-vertical[_ngcontent-%COMP%]   .empty-space[_ngcontent-%COMP%]{height:109px}.hmf-product-card.hmf-product-card-vertical.hmf-product-card-skeleton[_ngcontent-%COMP%]{margin-top:20px}@media (min-width: 1280px){.hmf-product-card.hmf-product-card-vertical[_ngcontent-%COMP%]{width:288px}.hmf-product-card.hmf-product-card-vertical[_ngcontent-%COMP%]   .hmf-product-card-image-wrapper[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-vertical[_ngcontent-%COMP%]   .hmf-product-card-skeleton-image[_ngcontent-%COMP%]{height:256px}.hmf-product-card.hmf-product-card-vertical[_ngcontent-%COMP%]   .loading-swatch[_ngcontent-%COMP%]{height:20px;width:20px}}.hmf-product-card.hmf-product-card-recommendation[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt[_ngcontent-%COMP%]{flex-direction:column}.hmf-product-card.hmf-product-card-recommendation[_ngcontent-%COMP%]   .hmf-product-card-image-wrapper[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt[_ngcontent-%COMP%]   .hmf-product-card-image-wrapper[_ngcontent-%COMP%]{height:auto;width:100%}.hmf-product-card.hmf-product-card-recommendation[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%]{-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden;text-overflow:ellipsis;white-space:normal}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-small[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-small[_ngcontent-%COMP%]{width:144px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-small.hmf-product-card-recommendation[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-small.hmf-product-card-recommendation[_ngcontent-%COMP%]{max-height:327px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-small.hmf-product-card-fbt[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-small.hmf-product-card-fbt[_ngcontent-%COMP%]{max-height:340px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-small[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-small[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%]{height:32px;-webkit-line-clamp:2}@supports (height: 2lh){.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-small[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-small[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%]{height:2lh}}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-small[_ngcontent-%COMP%]   .hmf-product-card-prices[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-small[_ngcontent-%COMP%]   .hmf-product-card-prices[_ngcontent-%COMP%]{height:40px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-small.hmf-product-card-skeleton.hmf-product-card-recommendation[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-small.hmf-product-card-skeleton.hmf-product-card-recommendation[_ngcontent-%COMP%]{height:308px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-small.hmf-product-card-skeleton.hmf-product-card-fbt[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-small.hmf-product-card-skeleton.hmf-product-card-fbt[_ngcontent-%COMP%]{height:322px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-small[_ngcontent-%COMP%]   .hmf-product-card-skeleton-image[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-small[_ngcontent-%COMP%]   .hmf-product-card-skeleton-image[_ngcontent-%COMP%]{height:120px;width:120px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-small[_ngcontent-%COMP%]   .empty-space[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-small[_ngcontent-%COMP%]   .empty-space[_ngcontent-%COMP%]{height:46px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-medium[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-medium[_ngcontent-%COMP%]{width:200px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-medium.hmf-product-card-recommendation[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-medium.hmf-product-card-recommendation[_ngcontent-%COMP%]{max-height:353px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-medium.hmf-product-card-fbt[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-medium.hmf-product-card-fbt[_ngcontent-%COMP%]{max-height:390px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-medium[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-medium[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%]{height:32px;-webkit-line-clamp:2}@supports (height: 2lh){.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-medium[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-medium[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%]{height:2lh}}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-medium[_ngcontent-%COMP%]   .hmf-product-card-prices[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-medium[_ngcontent-%COMP%]   .hmf-product-card-prices[_ngcontent-%COMP%]{height:32px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-medium.hmf-product-card-skeleton.hmf-product-card-recommendation[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-medium.hmf-product-card-skeleton.hmf-product-card-recommendation[_ngcontent-%COMP%]{height:340px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-medium.hmf-product-card-skeleton.hmf-product-card-fbt[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-medium.hmf-product-card-skeleton.hmf-product-card-fbt[_ngcontent-%COMP%]{height:354px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-medium[_ngcontent-%COMP%]   .hmf-product-card-skeleton-image[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-medium[_ngcontent-%COMP%]   .hmf-product-card-skeleton-image[_ngcontent-%COMP%]{height:176px;width:176px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-medium[_ngcontent-%COMP%]   .empty-space[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-medium[_ngcontent-%COMP%]   .empty-space[_ngcontent-%COMP%]{height:22px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-large[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-large[_ngcontent-%COMP%]{width:272px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-large.hmf-product-card-recommendation[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-large.hmf-product-card-recommendation[_ngcontent-%COMP%]{max-height:425px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-large.hmf-product-card-fbt[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-large.hmf-product-card-fbt[_ngcontent-%COMP%]{max-height:471px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-large[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-large[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%]{height:32px;-webkit-line-clamp:2}@supports (height: 2lh){.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-large[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-large[_ngcontent-%COMP%]   .hmf-product-card-name[_ngcontent-%COMP%]{height:2lh}}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-large[_ngcontent-%COMP%]   .hmf-product-card-prices[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-large[_ngcontent-%COMP%]   .hmf-product-card-prices[_ngcontent-%COMP%]{min-height:32px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-large.hmf-product-card-skeleton.hmf-product-card-recommendation[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-large.hmf-product-card-skeleton.hmf-product-card-recommendation[_ngcontent-%COMP%]{height:412px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-large.hmf-product-card-skeleton.hmf-product-card-fbt[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-large.hmf-product-card-skeleton.hmf-product-card-fbt[_ngcontent-%COMP%]{height:426px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-large[_ngcontent-%COMP%]   .hmf-product-card-skeleton-image[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-large[_ngcontent-%COMP%]   .hmf-product-card-skeleton-image[_ngcontent-%COMP%]{height:248px;width:248px}.hmf-product-card.hmf-product-card-recommendation.hmf-product-card-container-large[_ngcontent-%COMP%]   .empty-space[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt.hmf-product-card-container-large[_ngcontent-%COMP%]   .empty-space[_ngcontent-%COMP%]{height:22px}.hmf-product-card.hmf-product-card-recommendation[_ngcontent-%COMP%]   .empty-space[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt[_ngcontent-%COMP%]   .empty-space[_ngcontent-%COMP%]{height:53px}.hmf-product-card.hmf-product-card-recommendation[_ngcontent-%COMP%]   .hmf-promo-availability-divider[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-recommendation[_ngcontent-%COMP%]   .hmf-product-card-promo[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-recommendation[_ngcontent-%COMP%]   .hmf-product-card-skeleton-swatches[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt[_ngcontent-%COMP%]   .hmf-promo-availability-divider[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt[_ngcontent-%COMP%]   .hmf-product-card-promo[_ngcontent-%COMP%], .hmf-product-card.hmf-product-card-fbt[_ngcontent-%COMP%]   .hmf-product-card-skeleton-swatches[_ngcontent-%COMP%]{display:none}.hmf-product-card[_ngcontent-%COMP%]   .label-sku-container[_ngcontent-%COMP%]{max-width:100%;min-width:0}.hmf-product-card[_ngcontent-%COMP%]   .label-sku[_ngcontent-%COMP%]{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sponsored[_ngcontent-%COMP%]{height:0;width:100%}[_nghost-%COMP%]   .badge[_ngcontent-%COMP%]{height:20px;position:relative;top:var(--hmf-xxs);z-index:3}[_nghost-%COMP%]   .badge-carousel[_ngcontent-%COMP%]{left:0;position:absolute;top:0;transform:translateY(-50%);z-index:3}[_nghost-%COMP%]   .clickable[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]   .hmf-product-card-container[_ngcontent-%COMP%]:active{border:none}[_nghost-%COMP%]   .hmf-add-to-cart-styles[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   .hmf-textlink-sponsored[_ngcontent-%COMP%]{float:right}[_nghost-%COMP%]     button img{border-radius:50%;height:32px;width:32px}@media (min-width: 1280px){[_nghost-%COMP%]     button img{height:24px;width:24px}}"],
        changeDetection: 0
      });
    }
  }
  return HmfProductCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */
let HmfModalFactoryService = /*#__PURE__*/(() => {
  class HmfModalFactoryService {
    constructor(applicationRef) {
      this.applicationRef = applicationRef;
      this.ready$ = new BehaviorSubject(false);
      this.checkRootRef();
    }
    /**
     * When the service is created, check if the application has been bootstrapped yet.
     * If not, manually insert a provider into the application that adds a trigger for when the app has been bootstrapped.
     */
    checkRootRef() {
      if (this.applicationRef.components.length) {
        this.setRootRef();
      } else {
        const newProvider = {
          provide: APP_BOOTSTRAP_LISTENER,
          multi: true,
          useFactory: factoryService => () => factoryService.setRootRef(),
          deps: [HmfModalFactoryService]
        };
        this.applicationRef.injector.processProvider(newProvider);
      }
    }
    setRootRef() {
      this.rootRef = this.applicationRef.components[0].injector.get(ViewContainerRef);
      this.ready$.next(true);
    }
    create(type, inputs, content) {
      if (!this.rootRef) {
        throw new Error("App is not bootstrapped yet. If you need to create a modal/drawer on page load, wait for the service's ready$ to emit `true`.");
      }
      const view = content.createEmbeddedView(null);
      view.detectChanges();
      // Needed to ensure change detection fires (otherwise, modal content isn't within the app's "view")
      this.applicationRef.attachView(view);
      const componentRef = this.rootRef.createComponent(type, {
        projectableNodes: [view.rootNodes]
      });
      for (const [input, value] of Object.entries(inputs)) {
        componentRef.setInput(input, value);
      }
      componentRef.changeDetectorRef.detectChanges();
      return componentRef;
    }
    static {
      this.ɵfac = function HmfModalFactoryService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HmfModalFactoryService)(i0.ɵɵinject(i0.ApplicationRef));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: HmfModalFactoryService,
        factory: HmfModalFactoryService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return HmfModalFactoryService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @format */

/** @format */
// Components

/**
 * Generated bundle index. Do not edit.
 */

export { CircleVariantEnum, ClickHandlerDirective, HmfAccordionComponent, HmfActionTextComponent, HmfAlertBannerComponent, HmfBadgeComponent, HmfBreadcrumbsComponent, HmfBubblesComponent, HmfButtonComponent, HmfCardComponent, HmfCarouselComponent, HmfCheckboxComponent, HmfDatePickerComponent, HmfDividerComponent, HmfDrawerComponent, HmfGlobalChipsComponent, HmfHeroBannerComponent, HmfModalComponent, HmfModalFactoryService, HmfNotificationBadgeComponent, HmfPaginationCarouselComponent, HmfPaginationComponent, HmfPopoverComponent, HmfPriceComponent, HmfProductCardComponent, HmfProductImageComponent, HmfProductImageService, HmfProgressBarComponent, HmfProgressRingComponent, HmfProgressStepperComponent, HmfQuantityStepperComponent, HmfRadioComponent, HmfRadioGroupComponent, HmfSelectComponent, HmfSelectableComponent, HmfSelectorComponent, HmfSidePanelComponent, HmfSingleFeatureSpotComponent, HmfSkeletonComponent, HmfSnackbarComponent, HmfStarRatingsComponent, HmfTabbedContainerComponent, HmfTextInputComponent, HmfTextLinkComponent, ImagesLoadedService, InputValidatorDirective, InsideViewportDirective, OptionDesignVariant, QuantityStepperVariant, RADIO_CONTROL_GROUP_VALUE_ACCESSOR, RADIO_CONTROL_VALUE_ACCESSOR, SelectionChangeDispatcher, SelectorVariant, SizeVariant, Spacing, ThemeVariant, sizeClasses };
